/* tslint:disable */
/* eslint-disable */
/**
 * Distributor API
 * The Cashlink Distributor API enables you to distribute crypto securities and digital securities. It contains all building blocks from investor registration and KYC/AML to brokerage, clearing and settlement processes. While you are in full control of the frontends served to your investors you can use the Cashlink Studio to monitor and manage the activity on your platform.   Note: You cannot access data of investors or investments if they haven\'t been created via the API with your provided API credentials. Also, it\'s not possible to access data of investors that have registered via the Cashlink Signing Module, if you are using this as well.  ### Authentication  Every call to the API must be authenticated via OAuth client credentials. During setup, your point of contact will provide you with your client ID and client secret.   ### Idempotency  For certain POST endpoints, the API uses client-supplied idempotency keys to ensure that requests can be retried safely without performing the same operation twice. Repeated calls to those endpoints with the same idempotency key will return the cached response from the first call. Keys are expected to be set as header parameters with *X-Idempotency-Key*. The recommended approach for interacting with such endpoints is as follows:   - Create a unique, random key, such as a UUIDv4.   - Store the intent to call an endpoint along with the generated key in the client database.   - Flush to disk (e.g. commit an SQL transaction).   - Perform the call to the endpoint.   This ensures that even if the response from the API to a client gets lost, or the client experiences any sort of outage between steps 3 and 4, the client can always safely retry the same action.   If you already have objects corresponding to tasks in the API in your client-side database, you can use their internal IDs as idempotency keys!   ### Monetary values   Monetary values are represented as a combination of amount, decimals & currency. For example, ```{\'amount\': \'40000000\', \'decimals\': 3, \'currency\': \'EUR\'} means \'EUR 40,000.000\'```.   ### Handling documents  The document endpoint can be used to upload documents. Files are uploaded via HTTP multipart. The endpoint will return a document ID that can be used in other requests to refer to that document.   ### Webhooks  You can also register webhooks so that we can notify your application about events with regards to investments. To use that, please provide your point of contact at Cashlink with the following data:   - URL to be used as the target for webhooks  - OAuth client credentials or bearer authentication token so that we can authenticate at your server.  Webhooks are sent every time the status of an investment changes.  **POST <customer-provided URL>**  Webhooks are retried until the called endpoint returns a 2xx.  **Request**  {  \'investment_id\': \'3fa85f64-5717-4562-b3fc-2c963f66afa6\',  \'status\': \'ACCEPTED\',  \'changed_at\': \'2020-12-11T14:59:46.716Z\'  }  ### Concepts  The Cashlink Distributor API is based on the following concepts:  - Persons (legal or natural) that are users on your platform willing to invest are called investors.  - These investors will be able to invest into different financial products issued by different entities. In the API they are called products.  - The purchase of units of such a product takes place within your application and ends with a signed investment contract.  - Now you can create an investment, which contains the investor, the units, the signed investment contract and the accepted date of the investment by the issuer.   - At some point, parts of the investments are returned to the issuer because the outstanding amount has been paid back for example. Such a transaction is called a redemption.    
 *
 * The version of the OpenAPI document: v2
 * Contact: support@cashlink.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminApiConnectionCreation,
  AdminApiConnectionCreationRequest,
  AdminApiConnectionUpdate,
  AdminBulkInvestmentDocumentCreation,
  AdminBulkInvestmentDocumentCreationRequest,
  AdminBundesbankSettlementInstruction,
  AdminBundesbankSettlementInstructionRequest,
  AdminCampaign,
  AdminDistributorProductDistributionInformation,
  AdminDistributorProductDistributionInformationRequest,
  AdminGenericWalletCreation,
  AdminGenericWalletCreationRequest,
  AdminGroup,
  AdminGroupPermission,
  AdminGroupPermissionRequest,
  AdminGroupRequest,
  AdminIncompleteInvestor,
  AdminInvestment,
  AdminInvestmentCreation,
  AdminInvestmentCreationRequest,
  AdminInvestmentDetails,
  AdminInvestmentDetailsRequest,
  AdminInvestmentDocument,
  AdminInvestor,
  AdminInvestorCreation,
  AdminInvestorCreationRequest,
  AdminInvitation,
  AdminIssuerCreationRequest,
  AdminIssuerDetail,
  AdminLegalPersonUpdate,
  AdminLegalPersonUpdateRequest,
  AdminMail,
  AdminOrganization,
  AdminOrganizationDetails,
  AdminOrganizationRequest,
  AdminPayoutEvent,
  AdminPayoutEventCreationOrUpdate,
  AdminPayoutEventCreationOrUpdateRequest,
  AdminPendingInvestorDeletion,
  AdminPendingInvestorDeletionRequest,
  AdminPermissionProduct,
  AdminProductCreationRequest,
  AdminProductDetail,
  AdminProductDistributionPlatformListing,
  AdminProductDistributionPlatformListingCreation,
  AdminProductDistributionPlatformListingCreationRequest,
  AdminProductGlobalOverview,
  AdminProductInvestmentCreationRequest,
  AdminProductOverview,
  AdminProductPrice,
  AdminProductPriceCSVUploadResponse,
  AdminRedemption,
  AdminServiceContract,
  AdminUserCreation,
  AdminUserCreationRequest,
  AdminUserPartialUpdate,
  AdminUserPermission,
  AdminUserPermissionRequest,
  AdminUserRetrieve,
  AdminVersionedIssuanceDocument,
  AdminVersionedIssuanceDocumentRequest,
  AdminVoucherCreation,
  AdminVoucherCreationRequest,
  AdminVoucherDetail,
  AdminVoucherRequest,
  AdminVoucherStep,
  AdminVoucherStepBulkCreateRequest,
  AdminVoucherValidator,
  AdminVoucherValidatorRequest,
  AdminWallet,
  BenefitingPerson,
  BenefitingPersonRequest,
  Campaign,
  CampaignActivationRequest,
  CampaignRequest,
  CreateRegistryStatementRequest,
  DistributionPlatform,
  Identification,
  IdentificationRequest,
  InvestmentCalculation,
  InvestmentCancellationRequest,
  InvestmentInvitation,
  InvestmentInvitationCreationRequest,
  InvestmentIssuingAnnouncementRequest,
  IssuerInvestmentRules,
  KycInformation,
  PaginatedAdminApiConnectionList,
  PaginatedAdminBundesbankSettlementInstructionList,
  PaginatedAdminCampaignList,
  PaginatedAdminGroupList,
  PaginatedAdminGroupPermissionList,
  PaginatedAdminInvestmentListList,
  PaginatedAdminInvestorListList,
  PaginatedAdminIssuerListList,
  PaginatedAdminMailList,
  PaginatedAdminOrganizationList,
  PaginatedAdminPayoutEventList,
  PaginatedAdminProductDistributionPlatformListingList,
  PaginatedAdminProductListingList,
  PaginatedAdminProductPriceList,
  PaginatedAdminServiceContractList,
  PaginatedAdminTokenTransferList,
  PaginatedAdminUserListList,
  PaginatedAdminUserPermissionList,
  PaginatedAdminVoucherList,
  PaginatedDistributionPlatformList,
  PaginatedDropdownElementList,
  PaginatedInvitationList,
  PaginatedRedemptionListList,
  PatchedAdminApiConnectionUpdateRequest,
  PatchedAdminDistributorProductDistributionInformationRequest,
  PatchedAdminInvestmentDetailsRequest,
  PatchedAdminInvestorUpdateRequest,
  PatchedAdminIssuerUpdateRequest,
  PatchedAdminOrganizationRequest,
  PatchedAdminPayoutEventCreationOrUpdateRequest,
  PatchedAdminProductDetailRequest,
  PatchedAdminUserPartialUpdateRequest,
  PatchedAdminVoucherUpdateRequest,
  PatchedBenefitingPersonRequest,
  PatchedWalletUpdateRequest,
  RedemptionRequest,
  Statistics,
  WalletUpdate,
} from '../models/index';
import {
    AdminApiConnectionCreationFromJSON,
    AdminApiConnectionCreationToJSON,
    AdminApiConnectionCreationRequestFromJSON,
    AdminApiConnectionCreationRequestToJSON,
    AdminApiConnectionUpdateFromJSON,
    AdminApiConnectionUpdateToJSON,
    AdminBulkInvestmentDocumentCreationFromJSON,
    AdminBulkInvestmentDocumentCreationToJSON,
    AdminBulkInvestmentDocumentCreationRequestFromJSON,
    AdminBulkInvestmentDocumentCreationRequestToJSON,
    AdminBundesbankSettlementInstructionFromJSON,
    AdminBundesbankSettlementInstructionToJSON,
    AdminBundesbankSettlementInstructionRequestFromJSON,
    AdminBundesbankSettlementInstructionRequestToJSON,
    AdminCampaignFromJSON,
    AdminCampaignToJSON,
    AdminDistributorProductDistributionInformationFromJSON,
    AdminDistributorProductDistributionInformationToJSON,
    AdminDistributorProductDistributionInformationRequestFromJSON,
    AdminDistributorProductDistributionInformationRequestToJSON,
    AdminGenericWalletCreationFromJSON,
    AdminGenericWalletCreationToJSON,
    AdminGenericWalletCreationRequestFromJSON,
    AdminGenericWalletCreationRequestToJSON,
    AdminGroupFromJSON,
    AdminGroupToJSON,
    AdminGroupPermissionFromJSON,
    AdminGroupPermissionToJSON,
    AdminGroupPermissionRequestFromJSON,
    AdminGroupPermissionRequestToJSON,
    AdminGroupRequestFromJSON,
    AdminGroupRequestToJSON,
    AdminIncompleteInvestorFromJSON,
    AdminIncompleteInvestorToJSON,
    AdminInvestmentFromJSON,
    AdminInvestmentToJSON,
    AdminInvestmentCreationFromJSON,
    AdminInvestmentCreationToJSON,
    AdminInvestmentCreationRequestFromJSON,
    AdminInvestmentCreationRequestToJSON,
    AdminInvestmentDetailsFromJSON,
    AdminInvestmentDetailsToJSON,
    AdminInvestmentDetailsRequestFromJSON,
    AdminInvestmentDetailsRequestToJSON,
    AdminInvestmentDocumentFromJSON,
    AdminInvestmentDocumentToJSON,
    AdminInvestorFromJSON,
    AdminInvestorToJSON,
    AdminInvestorCreationFromJSON,
    AdminInvestorCreationToJSON,
    AdminInvestorCreationRequestFromJSON,
    AdminInvestorCreationRequestToJSON,
    AdminInvitationFromJSON,
    AdminInvitationToJSON,
    AdminIssuerCreationRequestFromJSON,
    AdminIssuerCreationRequestToJSON,
    AdminIssuerDetailFromJSON,
    AdminIssuerDetailToJSON,
    AdminLegalPersonUpdateFromJSON,
    AdminLegalPersonUpdateToJSON,
    AdminLegalPersonUpdateRequestFromJSON,
    AdminLegalPersonUpdateRequestToJSON,
    AdminMailFromJSON,
    AdminMailToJSON,
    AdminOrganizationFromJSON,
    AdminOrganizationToJSON,
    AdminOrganizationDetailsFromJSON,
    AdminOrganizationDetailsToJSON,
    AdminOrganizationRequestFromJSON,
    AdminOrganizationRequestToJSON,
    AdminPayoutEventFromJSON,
    AdminPayoutEventToJSON,
    AdminPayoutEventCreationOrUpdateFromJSON,
    AdminPayoutEventCreationOrUpdateToJSON,
    AdminPayoutEventCreationOrUpdateRequestFromJSON,
    AdminPayoutEventCreationOrUpdateRequestToJSON,
    AdminPendingInvestorDeletionFromJSON,
    AdminPendingInvestorDeletionToJSON,
    AdminPendingInvestorDeletionRequestFromJSON,
    AdminPendingInvestorDeletionRequestToJSON,
    AdminPermissionProductFromJSON,
    AdminPermissionProductToJSON,
    AdminProductCreationRequestFromJSON,
    AdminProductCreationRequestToJSON,
    AdminProductDetailFromJSON,
    AdminProductDetailToJSON,
    AdminProductDistributionPlatformListingFromJSON,
    AdminProductDistributionPlatformListingToJSON,
    AdminProductDistributionPlatformListingCreationFromJSON,
    AdminProductDistributionPlatformListingCreationToJSON,
    AdminProductDistributionPlatformListingCreationRequestFromJSON,
    AdminProductDistributionPlatformListingCreationRequestToJSON,
    AdminProductGlobalOverviewFromJSON,
    AdminProductGlobalOverviewToJSON,
    AdminProductInvestmentCreationRequestFromJSON,
    AdminProductInvestmentCreationRequestToJSON,
    AdminProductOverviewFromJSON,
    AdminProductOverviewToJSON,
    AdminProductPriceFromJSON,
    AdminProductPriceToJSON,
    AdminProductPriceCSVUploadResponseFromJSON,
    AdminProductPriceCSVUploadResponseToJSON,
    AdminRedemptionFromJSON,
    AdminRedemptionToJSON,
    AdminServiceContractFromJSON,
    AdminServiceContractToJSON,
    AdminUserCreationFromJSON,
    AdminUserCreationToJSON,
    AdminUserCreationRequestFromJSON,
    AdminUserCreationRequestToJSON,
    AdminUserPartialUpdateFromJSON,
    AdminUserPartialUpdateToJSON,
    AdminUserPermissionFromJSON,
    AdminUserPermissionToJSON,
    AdminUserPermissionRequestFromJSON,
    AdminUserPermissionRequestToJSON,
    AdminUserRetrieveFromJSON,
    AdminUserRetrieveToJSON,
    AdminVersionedIssuanceDocumentFromJSON,
    AdminVersionedIssuanceDocumentToJSON,
    AdminVersionedIssuanceDocumentRequestFromJSON,
    AdminVersionedIssuanceDocumentRequestToJSON,
    AdminVoucherCreationFromJSON,
    AdminVoucherCreationToJSON,
    AdminVoucherCreationRequestFromJSON,
    AdminVoucherCreationRequestToJSON,
    AdminVoucherDetailFromJSON,
    AdminVoucherDetailToJSON,
    AdminVoucherRequestFromJSON,
    AdminVoucherRequestToJSON,
    AdminVoucherStepFromJSON,
    AdminVoucherStepToJSON,
    AdminVoucherStepBulkCreateRequestFromJSON,
    AdminVoucherStepBulkCreateRequestToJSON,
    AdminVoucherValidatorFromJSON,
    AdminVoucherValidatorToJSON,
    AdminVoucherValidatorRequestFromJSON,
    AdminVoucherValidatorRequestToJSON,
    AdminWalletFromJSON,
    AdminWalletToJSON,
    BenefitingPersonFromJSON,
    BenefitingPersonToJSON,
    BenefitingPersonRequestFromJSON,
    BenefitingPersonRequestToJSON,
    CampaignFromJSON,
    CampaignToJSON,
    CampaignActivationRequestFromJSON,
    CampaignActivationRequestToJSON,
    CampaignRequestFromJSON,
    CampaignRequestToJSON,
    CreateRegistryStatementRequestFromJSON,
    CreateRegistryStatementRequestToJSON,
    DistributionPlatformFromJSON,
    DistributionPlatformToJSON,
    IdentificationFromJSON,
    IdentificationToJSON,
    IdentificationRequestFromJSON,
    IdentificationRequestToJSON,
    InvestmentCalculationFromJSON,
    InvestmentCalculationToJSON,
    InvestmentCancellationRequestFromJSON,
    InvestmentCancellationRequestToJSON,
    InvestmentInvitationFromJSON,
    InvestmentInvitationToJSON,
    InvestmentInvitationCreationRequestFromJSON,
    InvestmentInvitationCreationRequestToJSON,
    InvestmentIssuingAnnouncementRequestFromJSON,
    InvestmentIssuingAnnouncementRequestToJSON,
    IssuerInvestmentRulesFromJSON,
    IssuerInvestmentRulesToJSON,
    KycInformationFromJSON,
    KycInformationToJSON,
    PaginatedAdminApiConnectionListFromJSON,
    PaginatedAdminApiConnectionListToJSON,
    PaginatedAdminBundesbankSettlementInstructionListFromJSON,
    PaginatedAdminBundesbankSettlementInstructionListToJSON,
    PaginatedAdminCampaignListFromJSON,
    PaginatedAdminCampaignListToJSON,
    PaginatedAdminGroupListFromJSON,
    PaginatedAdminGroupListToJSON,
    PaginatedAdminGroupPermissionListFromJSON,
    PaginatedAdminGroupPermissionListToJSON,
    PaginatedAdminInvestmentListListFromJSON,
    PaginatedAdminInvestmentListListToJSON,
    PaginatedAdminInvestorListListFromJSON,
    PaginatedAdminInvestorListListToJSON,
    PaginatedAdminIssuerListListFromJSON,
    PaginatedAdminIssuerListListToJSON,
    PaginatedAdminMailListFromJSON,
    PaginatedAdminMailListToJSON,
    PaginatedAdminOrganizationListFromJSON,
    PaginatedAdminOrganizationListToJSON,
    PaginatedAdminPayoutEventListFromJSON,
    PaginatedAdminPayoutEventListToJSON,
    PaginatedAdminProductDistributionPlatformListingListFromJSON,
    PaginatedAdminProductDistributionPlatformListingListToJSON,
    PaginatedAdminProductListingListFromJSON,
    PaginatedAdminProductListingListToJSON,
    PaginatedAdminProductPriceListFromJSON,
    PaginatedAdminProductPriceListToJSON,
    PaginatedAdminServiceContractListFromJSON,
    PaginatedAdminServiceContractListToJSON,
    PaginatedAdminTokenTransferListFromJSON,
    PaginatedAdminTokenTransferListToJSON,
    PaginatedAdminUserListListFromJSON,
    PaginatedAdminUserListListToJSON,
    PaginatedAdminUserPermissionListFromJSON,
    PaginatedAdminUserPermissionListToJSON,
    PaginatedAdminVoucherListFromJSON,
    PaginatedAdminVoucherListToJSON,
    PaginatedDistributionPlatformListFromJSON,
    PaginatedDistributionPlatformListToJSON,
    PaginatedDropdownElementListFromJSON,
    PaginatedDropdownElementListToJSON,
    PaginatedInvitationListFromJSON,
    PaginatedInvitationListToJSON,
    PaginatedRedemptionListListFromJSON,
    PaginatedRedemptionListListToJSON,
    PatchedAdminApiConnectionUpdateRequestFromJSON,
    PatchedAdminApiConnectionUpdateRequestToJSON,
    PatchedAdminDistributorProductDistributionInformationRequestFromJSON,
    PatchedAdminDistributorProductDistributionInformationRequestToJSON,
    PatchedAdminInvestmentDetailsRequestFromJSON,
    PatchedAdminInvestmentDetailsRequestToJSON,
    PatchedAdminInvestorUpdateRequestFromJSON,
    PatchedAdminInvestorUpdateRequestToJSON,
    PatchedAdminIssuerUpdateRequestFromJSON,
    PatchedAdminIssuerUpdateRequestToJSON,
    PatchedAdminOrganizationRequestFromJSON,
    PatchedAdminOrganizationRequestToJSON,
    PatchedAdminPayoutEventCreationOrUpdateRequestFromJSON,
    PatchedAdminPayoutEventCreationOrUpdateRequestToJSON,
    PatchedAdminProductDetailRequestFromJSON,
    PatchedAdminProductDetailRequestToJSON,
    PatchedAdminUserPartialUpdateRequestFromJSON,
    PatchedAdminUserPartialUpdateRequestToJSON,
    PatchedAdminVoucherUpdateRequestFromJSON,
    PatchedAdminVoucherUpdateRequestToJSON,
    PatchedBenefitingPersonRequestFromJSON,
    PatchedBenefitingPersonRequestToJSON,
    PatchedWalletUpdateRequestFromJSON,
    PatchedWalletUpdateRequestToJSON,
    RedemptionRequestFromJSON,
    RedemptionRequestToJSON,
    StatisticsFromJSON,
    StatisticsToJSON,
    WalletUpdateFromJSON,
    WalletUpdateToJSON,
} from '../models/index';

export interface AdminApiConnectionsCreateRequest {
    adminApiConnectionCreationRequest: AdminApiConnectionCreationRequest;
}

export interface AdminApiConnectionsDestroyRequest {
    id: string;
}

export interface AdminApiConnectionsDropdownListRequest {
    apiType?: AdminApiConnectionsDropdownListApiTypeEnum;
    clientId?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatform?: string;
    field?: AdminApiConnectionsDropdownListFieldEnum;
    id?: string;
    limit?: number;
    name?: string;
    offset?: number;
    ordering?: AdminApiConnectionsDropdownListOrderingEnum;
    organization?: string;
    search?: string;
    type?: AdminApiConnectionsDropdownListTypeEnum;
    userId?: string;
}

export interface AdminApiConnectionsListRequest {
    apiType?: Array<AdminApiConnectionsListApiTypeEnum>;
    clientId?: Array<string>;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatform?: string;
    id?: Array<string>;
    limit?: number;
    name?: Array<string>;
    offset?: number;
    ordering?: AdminApiConnectionsListOrderingEnum;
    organization?: string;
    search?: string;
    type?: Array<AdminApiConnectionsListTypeEnum>;
    userId?: Array<string>;
}

export interface AdminApiConnectionsPartialUpdateRequest {
    id: string;
    patchedAdminApiConnectionUpdateRequest?: PatchedAdminApiConnectionUpdateRequest;
}

export interface AdminApiConnectionsValuesRetrieveRequest {
    field: AdminApiConnectionsValuesRetrieveFieldEnum;
    apiType?: AdminApiConnectionsValuesRetrieveApiTypeEnum;
    clientId?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatform?: string;
    icontains?: string;
    id?: string;
    name?: string;
    ordering?: AdminApiConnectionsValuesRetrieveOrderingEnum;
    organization?: string;
    search?: string;
    type?: AdminApiConnectionsValuesRetrieveTypeEnum;
    userId?: string;
}

export interface AdminBundesbankSettlementInstructionsDropdownListRequest {
    correlationId?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    field?: AdminBundesbankSettlementInstructionsDropdownListFieldEnum;
    id?: string;
    limit?: number;
    offset?: number;
    ordering?: AdminBundesbankSettlementInstructionsDropdownListOrderingEnum;
    paymentAmountMax?: number;
    paymentAmountMin?: number;
    productAmountMax?: number;
    productAmountMin?: number;
    search?: string;
    status?: string;
}

export interface AdminBundesbankSettlementInstructionsListRequest {
    correlationId?: Array<string>;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    id?: Array<string>;
    limit?: number;
    offset?: number;
    ordering?: AdminBundesbankSettlementInstructionsListOrderingEnum;
    paymentAmountMax?: number;
    paymentAmountMin?: number;
    productAmountMax?: number;
    productAmountMin?: number;
    search?: string;
    status?: Array<string>;
}

export interface AdminBundesbankSettlementInstructionsRetrieveRequest {
    id: string;
}

export interface AdminBundesbankSettlementInstructionsValuesRetrieveRequest {
    field: AdminBundesbankSettlementInstructionsValuesRetrieveFieldEnum;
    correlationId?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    icontains?: string;
    id?: string;
    ordering?: AdminBundesbankSettlementInstructionsValuesRetrieveOrderingEnum;
    paymentAmountMax?: number;
    paymentAmountMin?: number;
    productAmountMax?: number;
    productAmountMin?: number;
    search?: string;
    status?: string;
}

export interface AdminCampaignsActivationCreateRequest {
    id: string;
    campaignActivationRequest?: CampaignActivationRequest;
}

export interface AdminCampaignsDropdownListRequest {
    active?: boolean;
    allocationAvailableMax?: number;
    allocationAvailableMin?: number;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: string;
    distributionPlatformId?: string;
    field?: AdminCampaignsDropdownListFieldEnum;
    id?: string;
    limit?: number;
    name?: string;
    offset?: number;
    ordering?: AdminCampaignsDropdownListOrderingEnum;
    pricePerUnitMax?: number;
    pricePerUnitMin?: number;
    productId?: string;
    search?: string;
    signedPercentageMax?: number;
    signedPercentageMin?: number;
}

export interface AdminCampaignsInvestmentsCreateRequest {
    id: string;
    adminInvestmentCreationRequest: AdminInvestmentCreationRequest;
}

export interface AdminCampaignsListRequest {
    active?: boolean;
    allocationAvailableMax?: number;
    allocationAvailableMin?: number;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: Array<string>;
    distributionPlatformId?: Array<string>;
    id?: Array<string>;
    limit?: number;
    name?: Array<string>;
    offset?: number;
    ordering?: AdminCampaignsListOrderingEnum;
    pricePerUnitMax?: number;
    pricePerUnitMin?: number;
    productId?: Array<string>;
    search?: string;
    signedPercentageMax?: number;
    signedPercentageMin?: number;
}

export interface AdminCampaignsRetrieveRequest {
    id: string;
}

export interface AdminCampaignsValuesRetrieveRequest {
    field: AdminCampaignsValuesRetrieveFieldEnum;
    active?: boolean;
    allocationAvailableMax?: number;
    allocationAvailableMin?: number;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: string;
    distributionPlatformId?: string;
    icontains?: string;
    id?: string;
    name?: string;
    ordering?: AdminCampaignsValuesRetrieveOrderingEnum;
    pricePerUnitMax?: number;
    pricePerUnitMin?: number;
    productId?: string;
    search?: string;
    signedPercentageMax?: number;
    signedPercentageMin?: number;
}

export interface AdminDistributionPlatformsDropdownListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    displayName?: string;
    distributionPlatformPermissions?: AdminDistributionPlatformsDropdownListDistributionPlatformPermissionsEnum;
    field?: AdminDistributionPlatformsDropdownListFieldEnum;
    hasFrontend?: boolean;
    id?: string;
    limit?: number;
    offset?: number;
    ordering?: AdminDistributionPlatformsDropdownListOrderingEnum;
    organization?: string;
    permissions?: AdminDistributionPlatformsDropdownListPermissionsEnum;
    search?: string;
    usesEffecta?: boolean;
}

export interface AdminDistributionPlatformsListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    displayName?: Array<string>;
    distributionPlatformPermissions?: Array<AdminDistributionPlatformsListDistributionPlatformPermissionsEnum>;
    hasFrontend?: boolean;
    id?: Array<string>;
    limit?: number;
    offset?: number;
    ordering?: AdminDistributionPlatformsListOrderingEnum;
    organization?: Array<string>;
    permissions?: Array<AdminDistributionPlatformsListPermissionsEnum>;
    search?: string;
    usesEffecta?: boolean;
}

export interface AdminDistributionPlatformsRetrieveRequest {
    id: string;
}

export interface AdminDistributionPlatformsValuesRetrieveRequest {
    field: AdminDistributionPlatformsValuesRetrieveFieldEnum;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    displayName?: string;
    distributionPlatformPermissions?: AdminDistributionPlatformsValuesRetrieveDistributionPlatformPermissionsEnum;
    hasFrontend?: boolean;
    icontains?: string;
    id?: string;
    ordering?: AdminDistributionPlatformsValuesRetrieveOrderingEnum;
    organization?: string;
    permissions?: AdminDistributionPlatformsValuesRetrievePermissionsEnum;
    search?: string;
    usesEffecta?: boolean;
}

export interface AdminFriendVouchersDropdownListRequest {
    active?: boolean;
    alreadyUsedMax?: number;
    alreadyUsedMin?: number;
    code?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    field?: AdminFriendVouchersDropdownListFieldEnum;
    id?: string;
    limit?: number;
    name?: string;
    offset?: number;
    ordering?: AdminFriendVouchersDropdownListOrderingEnum;
    owningInvestorName?: string;
    search?: string;
}

export interface AdminFriendVouchersListRequest {
    active?: boolean;
    alreadyUsedMax?: number;
    alreadyUsedMin?: number;
    code?: Array<string>;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    id?: Array<string>;
    limit?: number;
    name?: Array<string>;
    offset?: number;
    ordering?: AdminFriendVouchersListOrderingEnum;
    owningInvestorName?: Array<string>;
    search?: string;
}

export interface AdminFriendVouchersRetrieveRequest {
    id: string;
}

export interface AdminFriendVouchersValuesRetrieveRequest {
    field: AdminFriendVouchersValuesRetrieveFieldEnum;
    active?: boolean;
    alreadyUsedMax?: number;
    alreadyUsedMin?: number;
    code?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    icontains?: string;
    id?: string;
    name?: string;
    ordering?: AdminFriendVouchersValuesRetrieveOrderingEnum;
    owningInvestorName?: string;
    search?: string;
}

export interface AdminGroupPermissionsCreateRequest {
    adminGroupPermissionRequest: AdminGroupPermissionRequest;
}

export interface AdminGroupPermissionsDestroyRequest {
    id: string;
}

export interface AdminGroupPermissionsDropdownListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    field?: AdminGroupPermissionsDropdownListFieldEnum;
    groupId?: string;
    groupName?: string;
    id?: string;
    limit?: number;
    objectId?: string;
    offset?: number;
    ordering?: AdminGroupPermissionsDropdownListOrderingEnum;
    permissionCode?: AdminGroupPermissionsDropdownListPermissionCodeEnum;
    permissionType?: AdminGroupPermissionsDropdownListPermissionTypeEnum;
    search?: string;
    userId?: string;
    validForName?: string;
}

export interface AdminGroupPermissionsListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    groupId?: Array<string>;
    groupName?: Array<string>;
    id?: Array<string>;
    limit?: number;
    objectId?: Array<string>;
    offset?: number;
    ordering?: AdminGroupPermissionsListOrderingEnum;
    permissionCode?: Array<AdminGroupPermissionsListPermissionCodeEnum>;
    permissionType?: Array<AdminGroupPermissionsListPermissionTypeEnum>;
    search?: string;
    userId?: Array<string>;
    validForName?: Array<string>;
}

export interface AdminGroupPermissionsValuesRetrieveRequest {
    field: AdminGroupPermissionsValuesRetrieveFieldEnum;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    groupId?: string;
    groupName?: string;
    icontains?: string;
    id?: string;
    objectId?: string;
    ordering?: AdminGroupPermissionsValuesRetrieveOrderingEnum;
    permissionCode?: AdminGroupPermissionsValuesRetrievePermissionCodeEnum;
    permissionType?: AdminGroupPermissionsValuesRetrievePermissionTypeEnum;
    search?: string;
    userId?: string;
    validForName?: string;
}

export interface AdminGroupsCreateRequest {
    adminGroupRequest: AdminGroupRequest;
}

export interface AdminGroupsDestroyRequest {
    id: string;
}

export interface AdminGroupsDropdownListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    field?: AdminGroupsDropdownListFieldEnum;
    id?: string;
    limit?: number;
    name?: string;
    offset?: number;
    ordering?: AdminGroupsDropdownListOrderingEnum;
    organizationId?: string;
    organizationName?: string;
    search?: string;
    userId?: string;
}

export interface AdminGroupsListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    id?: Array<string>;
    limit?: number;
    name?: Array<string>;
    offset?: number;
    ordering?: AdminGroupsListOrderingEnum;
    organizationId?: Array<string>;
    organizationName?: Array<string>;
    search?: string;
    userId?: Array<string>;
}

export interface AdminGroupsRetrieveRequest {
    id: string;
}

export interface AdminGroupsUsersDestroyRequest {
    id: string;
    userId: string;
}

export interface AdminGroupsUsersUpdateRequest {
    id: string;
    userId: string;
}

export interface AdminGroupsValuesRetrieveRequest {
    field: AdminGroupsValuesRetrieveFieldEnum;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    icontains?: string;
    id?: string;
    name?: string;
    ordering?: AdminGroupsValuesRetrieveOrderingEnum;
    organizationId?: string;
    organizationName?: string;
    search?: string;
    userId?: string;
}

export interface AdminInvestmentTransfersDropdownListRequest {
    investment: string;
    amountMax?: string;
    amountMin?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    field?: AdminInvestmentTransfersDropdownListFieldEnum;
    id?: string;
    investorNameRecipient?: string;
    investorNameSender?: string;
    limit?: number;
    offset?: number;
    ordering?: AdminInvestmentTransfersDropdownListOrderingEnum;
    recipient?: string;
    recipientColumn?: string;
    sender?: string;
    senderColumn?: string;
    status?: AdminInvestmentTransfersDropdownListStatusEnum;
}

export interface AdminInvestmentTransfersListRequest {
    investment: string;
    amountMax?: string;
    amountMin?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    id?: Array<string>;
    investorNameRecipient?: Array<string>;
    investorNameSender?: Array<string>;
    limit?: number;
    offset?: number;
    ordering?: AdminInvestmentTransfersListOrderingEnum;
    recipient?: Array<string>;
    recipientColumn?: Array<string>;
    sender?: Array<string>;
    senderColumn?: Array<string>;
    status?: Array<AdminInvestmentTransfersListStatusEnum>;
}

export interface AdminInvestmentTransfersValuesRetrieveRequest {
    field: AdminInvestmentTransfersValuesRetrieveFieldEnum;
    investment: string;
    amountMax?: string;
    amountMin?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    icontains?: string;
    id?: string;
    investorNameRecipient?: string;
    investorNameSender?: string;
    ordering?: AdminInvestmentTransfersValuesRetrieveOrderingEnum;
    recipient?: string;
    recipientColumn?: string;
    sender?: string;
    senderColumn?: string;
    status?: AdminInvestmentTransfersValuesRetrieveStatusEnum;
}

export interface AdminInvestmentsCancellationCreateRequest {
    id: string;
    investmentCancellationRequest: InvestmentCancellationRequest;
}

export interface AdminInvestmentsCreateRequest {
    adminProductInvestmentCreationRequest: AdminProductInvestmentCreationRequest;
}

export interface AdminInvestmentsDropdownListRequest {
    acceptedAtAfter?: Date;
    acceptedAtBefore?: Date;
    acquisitionType?: AdminInvestmentsDropdownListAcquisitionTypeEnum;
    addWalletLater?: AdminInvestmentsDropdownListAddWalletLaterEnum;
    campaign?: string;
    cancellationDateAfter?: Date;
    cancellationDateBefore?: Date;
    cancellationReason?: AdminInvestmentsDropdownListCancellationReasonEnum;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: string;
    distributionPlatformId?: string;
    exemptionOrderDateAfter?: Date;
    exemptionOrderDateBefore?: Date;
    field?: AdminInvestmentsDropdownListFieldEnum;
    frontendStatus?: AdminInvestmentsDropdownListFrontendStatusEnum;
    fulfilledAmountMax?: string;
    fulfilledAmountMin?: string;
    id?: string;
    initiatedIdentification?: boolean;
    investmentTotalFulfilledMax?: number;
    investmentTotalFulfilledMin?: number;
    investmentTotalMax?: number;
    investmentTotalMin?: number;
    investorId?: string;
    investorName?: string;
    lastSettledPayoutAmountMax?: number;
    lastSettledPayoutAmountMin?: number;
    limit?: number;
    maxAmountMax?: number;
    maxAmountMin?: number;
    nextScheduledPayoutAfter?: Date;
    nextScheduledPayoutBefore?: Date;
    offset?: number;
    ordering?: AdminInvestmentsDropdownListOrderingEnum;
    paidAtAfter?: Date;
    paidAtBefore?: Date;
    paymentCode?: string;
    paymentDeadlineAfter?: Date;
    paymentDeadlineBefore?: Date;
    paymentTotalMax?: number;
    paymentTotalMin?: number;
    productId?: string;
    productName?: string;
    remainingAmountMax?: number;
    remainingAmountMin?: number;
    search?: string;
    signedAtAfter?: Date;
    signedAtBefore?: Date;
    status?: AdminInvestmentsDropdownListStatusEnum;
    step?: AdminInvestmentsDropdownListStepEnum;
    sumSettledPayoutsMax?: number;
    sumSettledPayoutsMin?: number;
    surveyValid?: boolean;
    surveyWaiverType?: AdminInvestmentsDropdownListSurveyWaiverTypeEnum;
    tokenDeliveredAtAfter?: Date;
    tokenDeliveredAtBefore?: Date;
    tokenTransactionHash?: string;
    voucherId?: string;
}

export interface AdminInvestmentsIssueCreateRequest {
    id: string;
}

export interface AdminInvestmentsIssuingAnnouncementCreateRequest {
    id: string;
    investmentIssuingAnnouncementRequest: InvestmentIssuingAnnouncementRequest;
}

export interface AdminInvestmentsListRequest {
    acceptedAtAfter?: Date;
    acceptedAtBefore?: Date;
    acquisitionType?: Array<AdminInvestmentsListAcquisitionTypeEnum>;
    addWalletLater?: Array<AdminInvestmentsListAddWalletLaterEnum | null>;
    campaign?: string;
    cancellationDateAfter?: Date;
    cancellationDateBefore?: Date;
    cancellationReason?: Array<AdminInvestmentsListCancellationReasonEnum | null>;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: Array<string>;
    distributionPlatformId?: Array<string>;
    exemptionOrderDateAfter?: Date;
    exemptionOrderDateBefore?: Date;
    frontendStatus?: AdminInvestmentsListFrontendStatusEnum;
    fulfilledAmountMax?: string;
    fulfilledAmountMin?: string;
    id?: Array<string>;
    initiatedIdentification?: boolean;
    investmentTotalFulfilledMax?: number;
    investmentTotalFulfilledMin?: number;
    investmentTotalMax?: number;
    investmentTotalMin?: number;
    investor?: string;
    investorId?: Array<string>;
    investorName?: Array<string>;
    lastSettledPayoutAmountMax?: number;
    lastSettledPayoutAmountMin?: number;
    limit?: number;
    maxAmountMax?: number;
    maxAmountMin?: number;
    nextScheduledPayoutAfter?: Date;
    nextScheduledPayoutBefore?: Date;
    offset?: number;
    ordering?: AdminInvestmentsListOrderingEnum;
    paidAtAfter?: Date;
    paidAtBefore?: Date;
    paymentCode?: Array<string>;
    paymentDeadlineAfter?: Date;
    paymentDeadlineBefore?: Date;
    paymentTotalMax?: number;
    paymentTotalMin?: number;
    productId?: Array<string>;
    productName?: Array<string>;
    remainingAmountMax?: number;
    remainingAmountMin?: number;
    search?: string;
    signedAtAfter?: Date;
    signedAtBefore?: Date;
    status?: AdminInvestmentsListStatusEnum;
    step?: AdminInvestmentsListStepEnum;
    sumSettledPayoutsMax?: number;
    sumSettledPayoutsMin?: number;
    surveyValid?: boolean;
    surveyWaiverType?: Array<AdminInvestmentsListSurveyWaiverTypeEnum>;
    tokenDeliveredAtAfter?: Date;
    tokenDeliveredAtBefore?: Date;
    tokenTransactionHash?: string;
    voucherId?: Array<string>;
}

export interface AdminInvestmentsOfferApprovalCreateRequest {
    id: string;
}

export interface AdminInvestmentsPartialUpdateRequest {
    id: string;
    patchedAdminInvestmentDetailsRequest?: PatchedAdminInvestmentDetailsRequest;
}

export interface AdminInvestmentsPaymentConfirmationCreateRequest {
    id: string;
}

export interface AdminInvestmentsRegistryStatementsCreateRequest {
    id: string;
    createRegistryStatementRequest?: CreateRegistryStatementRequest;
}

export interface AdminInvestmentsRequestIdentificationCreateRequest {
    id: string;
}

export interface AdminInvestmentsRetrieveRequest {
    id: string;
}

export interface AdminInvestmentsUpdateRequest {
    id: string;
    adminInvestmentDetailsRequest: AdminInvestmentDetailsRequest;
}

export interface AdminInvestmentsValuesRetrieveRequest {
    field: AdminInvestmentsValuesRetrieveFieldEnum;
    acceptedAtAfter?: Date;
    acceptedAtBefore?: Date;
    acquisitionType?: AdminInvestmentsValuesRetrieveAcquisitionTypeEnum;
    addWalletLater?: AdminInvestmentsValuesRetrieveAddWalletLaterEnum;
    campaign?: string;
    cancellationDateAfter?: Date;
    cancellationDateBefore?: Date;
    cancellationReason?: AdminInvestmentsValuesRetrieveCancellationReasonEnum;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: string;
    distributionPlatformId?: string;
    exemptionOrderDateAfter?: Date;
    exemptionOrderDateBefore?: Date;
    frontendStatus?: AdminInvestmentsValuesRetrieveFrontendStatusEnum;
    fulfilledAmountMax?: string;
    fulfilledAmountMin?: string;
    icontains?: string;
    id?: string;
    initiatedIdentification?: boolean;
    investmentTotalFulfilledMax?: number;
    investmentTotalFulfilledMin?: number;
    investmentTotalMax?: number;
    investmentTotalMin?: number;
    investorId?: string;
    investorName?: string;
    lastSettledPayoutAmountMax?: number;
    lastSettledPayoutAmountMin?: number;
    maxAmountMax?: number;
    maxAmountMin?: number;
    nextScheduledPayoutAfter?: Date;
    nextScheduledPayoutBefore?: Date;
    ordering?: AdminInvestmentsValuesRetrieveOrderingEnum;
    paidAtAfter?: Date;
    paidAtBefore?: Date;
    paymentCode?: string;
    paymentDeadlineAfter?: Date;
    paymentDeadlineBefore?: Date;
    paymentTotalMax?: number;
    paymentTotalMin?: number;
    productId?: string;
    productName?: string;
    remainingAmountMax?: number;
    remainingAmountMin?: number;
    search?: string;
    signedAtAfter?: Date;
    signedAtBefore?: Date;
    status?: AdminInvestmentsValuesRetrieveStatusEnum;
    step?: AdminInvestmentsValuesRetrieveStepEnum;
    sumSettledPayoutsMax?: number;
    sumSettledPayoutsMin?: number;
    surveyValid?: boolean;
    surveyWaiverType?: AdminInvestmentsValuesRetrieveSurveyWaiverTypeEnum;
    tokenDeliveredAtAfter?: Date;
    tokenDeliveredAtBefore?: Date;
    tokenTransactionHash?: string;
    voucherId?: string;
}

export interface AdminInvestorsBenefitingPersonConfirmationCreateRequest {
    id: string;
}

export interface AdminInvestorsBenefitingPersonsCreateRequest {
    id: string;
    benefitingPersonRequest: BenefitingPersonRequest;
}

export interface AdminInvestorsBenefitingPersonsDestroyRequest {
    id: string;
    personId: string;
}

export interface AdminInvestorsBenefitingPersonsListRequest {
    id: string;
    ordering?: AdminInvestorsBenefitingPersonsListOrderingEnum;
    search?: string;
}

export interface AdminInvestorsBenefitingPersonsPartialUpdateRequest {
    id: string;
    personId: string;
    patchedBenefitingPersonRequest?: PatchedBenefitingPersonRequest;
}

export interface AdminInvestorsCreateRequest {
    adminInvestorCreationRequest: AdminInvestorCreationRequest;
}

export interface AdminInvestorsDestroyRequest {
    id: string;
}

export interface AdminInvestorsDropdownListRequest {
    activeInvestmentsNoMax?: number;
    activeInvestmentsNoMin?: number;
    activeInvestmentsSumMax?: number;
    activeInvestmentsSumMin?: number;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: string;
    distributionPlatformId?: string;
    email?: string;
    field?: AdminInvestorsDropdownListFieldEnum;
    id?: string;
    investedIntoCampaign?: string;
    investorName?: string;
    isKycSuccessful?: boolean;
    lastName?: string;
    limit?: number;
    name?: string;
    offset?: number;
    ordering?: AdminInvestorsDropdownListOrderingEnum;
    productId?: string;
    productIdIsnull?: boolean;
    registeredAtAfter?: Date;
    registeredAtBefore?: Date;
    search?: string;
}

export interface AdminInvestorsIdentificationsBestCurrentRetrieveRequest {
    id: string;
}

export interface AdminInvestorsIdentificationsCreateRequest {
    id: string;
    identificationRequest: IdentificationRequest;
}

export interface AdminInvestorsIdentificationsRestartCreateRequest {
    id: string;
    identificationRequest: IdentificationRequest;
}

export interface AdminInvestorsIncompleteListRequest {
    activeInvestmentsNoMax?: number;
    activeInvestmentsNoMin?: number;
    activeInvestmentsSumMax?: number;
    activeInvestmentsSumMin?: number;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: Array<string>;
    distributionPlatformId?: Array<string>;
    email?: Array<string>;
    id?: Array<string>;
    investedIntoCampaign?: Array<string>;
    investorName?: Array<string>;
    isKycSuccessful?: boolean;
    lastName?: Array<string>;
    name?: Array<string>;
    ordering?: AdminInvestorsIncompleteListOrderingEnum;
    productId?: Array<string>;
    productIdIsnull?: boolean;
    registeredAtAfter?: Date;
    registeredAtBefore?: Date;
    search?: string;
}

export interface AdminInvestorsLegalPersonCreateRequest {
    id: string;
    adminLegalPersonUpdateRequest: AdminLegalPersonUpdateRequest;
}

export interface AdminInvestorsListRequest {
    activeInvestmentsNoMax?: number;
    activeInvestmentsNoMin?: number;
    activeInvestmentsSumMax?: number;
    activeInvestmentsSumMin?: number;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: Array<string>;
    distributionPlatformId?: Array<string>;
    email?: Array<string>;
    id?: Array<string>;
    investedIntoCampaign?: Array<string>;
    investorName?: Array<string>;
    isKycSuccessful?: boolean;
    lastName?: Array<string>;
    limit?: number;
    name?: Array<string>;
    offset?: number;
    ordering?: AdminInvestorsListOrderingEnum;
    productId?: Array<string>;
    productIdIsnull?: boolean;
    registeredAtAfter?: Date;
    registeredAtBefore?: Date;
    search?: string;
}

export interface AdminInvestorsPartialUpdateRequest {
    id: string;
    patchedAdminInvestorUpdateRequest?: PatchedAdminInvestorUpdateRequest;
}

export interface AdminInvestorsPendingDeletionCreateRequest {
    id: string;
    adminPendingInvestorDeletionRequest: AdminPendingInvestorDeletionRequest;
}

export interface AdminInvestorsPendingDeletionRetrieveRequest {
    id: string;
}

export interface AdminInvestorsReactivateCreateRequest {
    id: string;
}

export interface AdminInvestorsRetrieveRequest {
    id: string;
}

export interface AdminInvestorsValuesRetrieveRequest {
    field: AdminInvestorsValuesRetrieveFieldEnum;
    activeInvestmentsNoMax?: number;
    activeInvestmentsNoMin?: number;
    activeInvestmentsSumMax?: number;
    activeInvestmentsSumMin?: number;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: string;
    distributionPlatformId?: string;
    email?: string;
    icontains?: string;
    id?: string;
    investedIntoCampaign?: string;
    investorName?: string;
    isKycSuccessful?: boolean;
    lastName?: string;
    name?: string;
    ordering?: AdminInvestorsValuesRetrieveOrderingEnum;
    productId?: string;
    productIdIsnull?: boolean;
    registeredAtAfter?: Date;
    registeredAtBefore?: Date;
    search?: string;
}

export interface AdminInvestorsWalletsGenericCreateRequest {
    id: string;
    adminGenericWalletCreationRequest: AdminGenericWalletCreationRequest;
}

export interface AdminInvestorsWalletsPartialUpdateRequest {
    id: string;
    walletId: string;
    patchedWalletUpdateRequest?: PatchedWalletUpdateRequest;
}

export interface AdminInvitationsDestroyRequest {
    id: string;
    tokenId?: string;
}

export interface AdminInvitationsDropdownListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: string;
    field?: AdminInvitationsDropdownListFieldEnum;
    hasInvestment?: boolean;
    id?: string;
    investment?: string;
    limit?: number;
    maxNumberOfTokensMax?: number;
    maxNumberOfTokensMin?: number;
    name?: string;
    offset?: number;
    ordering?: AdminInvitationsDropdownListOrderingEnum;
    pricePerUnitMax?: number;
    pricePerUnitMin?: number;
    productName?: string;
    signedPercentageMax?: number;
    signedPercentageMin?: number;
    tokenId?: string;
}

export interface AdminInvitationsIdentificationRetrieveRequest {
    id: string;
    tokenId?: string;
}

export interface AdminInvitationsIdentificationStartNotificationCreateRequest {
    id: string;
    tokenId?: string;
}

export interface AdminInvitationsListRequest {
    campaignId?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: Array<string>;
    hasInvestment?: boolean;
    id?: Array<string>;
    investment?: Array<string>;
    invitationType?: string;
    isEcsp?: boolean;
    limit?: number;
    maxNumberOfTokensMax?: number;
    maxNumberOfTokensMin?: number;
    name?: Array<string>;
    offset?: number;
    ordering?: AdminInvitationsListOrderingEnum;
    pricePerUnitMax?: number;
    pricePerUnitMin?: number;
    productName?: Array<string>;
    signedPercentageMax?: number;
    signedPercentageMin?: number;
    status?: string;
    tokenId?: string;
}

export interface AdminInvitationsRetrieveRequest {
    id: string;
    tokenId?: string;
}

export interface AdminInvitationsValuesRetrieveRequest {
    field: AdminInvitationsValuesRetrieveFieldEnum;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: string;
    hasInvestment?: boolean;
    icontains?: string;
    id?: string;
    investment?: string;
    maxNumberOfTokensMax?: number;
    maxNumberOfTokensMin?: number;
    name?: string;
    ordering?: AdminInvitationsValuesRetrieveOrderingEnum;
    pricePerUnitMax?: number;
    pricePerUnitMin?: number;
    productName?: string;
    signedPercentageMax?: number;
    signedPercentageMin?: number;
    tokenId?: string;
}

export interface AdminIssuersCreateRequest {
    adminIssuerCreationRequest: AdminIssuerCreationRequest;
}

export interface AdminIssuersDropdownListRequest {
    canCreateProduct?: boolean;
    companyName?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    field?: AdminIssuersDropdownListFieldEnum;
    id?: string;
    limit?: number;
    numberOfProductsMax?: number;
    numberOfProductsMin?: number;
    offset?: number;
    ordering?: AdminIssuersDropdownListOrderingEnum;
    organizationId?: string;
    organizationName?: string;
    permissions?: AdminIssuersDropdownListPermissionsEnum;
    search?: string;
}

export interface AdminIssuersDropdownOrganizationForIssuerCreationListRequest {
    limit?: number;
    offset?: number;
    ordering?: AdminIssuersDropdownOrganizationForIssuerCreationListOrderingEnum;
    search?: string;
}

export interface AdminIssuersListRequest {
    canCreateProduct?: boolean;
    companyName?: Array<string>;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    id?: Array<string>;
    issuerId?: string;
    limit?: number;
    numberOfProductsMax?: number;
    numberOfProductsMin?: number;
    offset?: number;
    ordering?: AdminIssuersListOrderingEnum;
    organizationId?: Array<string>;
    organizationName?: Array<string>;
    permissions?: Array<AdminIssuersListPermissionsEnum>;
    search?: string;
}

export interface AdminIssuersPartialUpdateRequest {
    id: string;
    patchedAdminIssuerUpdateRequest?: PatchedAdminIssuerUpdateRequest;
}

export interface AdminIssuersRetrieveRequest {
    id: string;
}

export interface AdminIssuersValuesRetrieveRequest {
    field: AdminIssuersValuesRetrieveFieldEnum;
    canCreateProduct?: boolean;
    companyName?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    icontains?: string;
    id?: string;
    numberOfProductsMax?: number;
    numberOfProductsMin?: number;
    ordering?: AdminIssuersValuesRetrieveOrderingEnum;
    organizationId?: string;
    organizationName?: string;
    permissions?: AdminIssuersValuesRetrievePermissionsEnum;
    search?: string;
}

export interface AdminListingsCreateRequest {
    adminProductDistributionPlatformListingCreationRequest: AdminProductDistributionPlatformListingCreationRequest;
}

export interface AdminListingsDistributionInformationCreateRequest {
    id: string;
    adminDistributorProductDistributionInformationRequest: AdminDistributorProductDistributionInformationRequest;
}

export interface AdminListingsDistributionInformationPartialUpdateRequest {
    id: string;
    patchedAdminDistributorProductDistributionInformationRequest?: PatchedAdminDistributorProductDistributionInformationRequest;
}

export interface AdminListingsDistributionInformationRetrieveRequest {
    id: string;
}

export interface AdminListingsDropdownListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: string;
    distributionPlatformId?: string;
    field?: AdminListingsDropdownListFieldEnum;
    id?: string;
    limit?: number;
    offset?: number;
    ordering?: AdminListingsDropdownListOrderingEnum;
    productId?: string;
    search?: string;
}

export interface AdminListingsInvestmentDocumentsCreateRequest {
    id: string;
    adminBulkInvestmentDocumentCreationRequest: AdminBulkInvestmentDocumentCreationRequest;
}

export interface AdminListingsInvestmentDocumentsRetrieveRequest {
    id: string;
}

export interface AdminListingsListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: Array<string>;
    distributionPlatformId?: Array<string>;
    id?: Array<string>;
    limit?: number;
    offset?: number;
    ordering?: AdminListingsListOrderingEnum;
    productId?: Array<string>;
    search?: string;
}

export interface AdminListingsRetrieveRequest {
    id: string;
}

export interface AdminListingsValuesRetrieveRequest {
    field: AdminListingsValuesRetrieveFieldEnum;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformDisplayName?: string;
    distributionPlatformId?: string;
    icontains?: string;
    id?: string;
    ordering?: AdminListingsValuesRetrieveOrderingEnum;
    productId?: string;
    search?: string;
}

export interface AdminMailsDropdownListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    deliveredAfter?: Date;
    deliveredBefore?: Date;
    field?: AdminMailsDropdownListFieldEnum;
    id?: string;
    investor?: string;
    limit?: number;
    offset?: number;
    ordering?: AdminMailsDropdownListOrderingEnum;
    productId?: string;
    productName?: string;
    search?: string;
    sendAtAfter?: Date;
    sendAtBefore?: Date;
    subject?: string;
    type?: AdminMailsDropdownListTypeEnum;
}

export interface AdminMailsListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    deliveredAfter?: Date;
    deliveredBefore?: Date;
    id?: Array<string>;
    investor?: Array<string>;
    limit?: number;
    offset?: number;
    ordering?: AdminMailsListOrderingEnum;
    productId?: Array<string>;
    productName?: Array<string>;
    search?: string;
    sendAtAfter?: Date;
    sendAtBefore?: Date;
    subject?: Array<string>;
    type?: Array<AdminMailsListTypeEnum>;
}

export interface AdminMailsResendCreateRequest {
    id: string;
}

export interface AdminMailsRetrieveRequest {
    id: string;
}

export interface AdminMailsValuesRetrieveRequest {
    field: AdminMailsValuesRetrieveFieldEnum;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    deliveredAfter?: Date;
    deliveredBefore?: Date;
    icontains?: string;
    id?: string;
    investor?: string;
    ordering?: AdminMailsValuesRetrieveOrderingEnum;
    productId?: string;
    productName?: string;
    search?: string;
    sendAtAfter?: Date;
    sendAtBefore?: Date;
    subject?: string;
    type?: AdminMailsValuesRetrieveTypeEnum;
}

export interface AdminOrganizationsCreateRequest {
    adminOrganizationRequest: AdminOrganizationRequest;
}

export interface AdminOrganizationsDestroyRequest {
    id: string;
}

export interface AdminOrganizationsDropdownListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    field?: AdminOrganizationsDropdownListFieldEnum;
    hasScBanking?: boolean;
    hasScCore?: boolean;
    hasScDistributionHub?: boolean;
    hasScLaunchpad?: boolean;
    id?: string;
    limit?: number;
    loginType?: AdminOrganizationsDropdownListLoginTypeEnum;
    name?: string;
    offset?: number;
    ordering?: AdminOrganizationsDropdownListOrderingEnum;
    permissions?: AdminOrganizationsDropdownListPermissionsEnum;
    search?: string;
}

export interface AdminOrganizationsListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    hasScBanking?: boolean;
    hasScCore?: boolean;
    hasScDistributionHub?: boolean;
    hasScLaunchpad?: boolean;
    id?: Array<string>;
    limit?: number;
    loginType?: Array<AdminOrganizationsListLoginTypeEnum>;
    name?: Array<string>;
    offset?: number;
    ordering?: AdminOrganizationsListOrderingEnum;
    permissions?: Array<AdminOrganizationsListPermissionsEnum>;
    search?: string;
}

export interface AdminOrganizationsPartialUpdateRequest {
    id: string;
    patchedAdminOrganizationRequest?: PatchedAdminOrganizationRequest;
}

export interface AdminOrganizationsRetrieveRequest {
    id: string;
}

export interface AdminOrganizationsServiceContractsDestroyRequest {
    id: string;
    techName: string;
}

export interface AdminOrganizationsServiceContractsUpdateRequest {
    id: string;
    techName: string;
    adminOrganizationRequest: AdminOrganizationRequest;
}

export interface AdminOrganizationsUpdateRequest {
    id: string;
    adminOrganizationRequest: AdminOrganizationRequest;
}

export interface AdminOrganizationsValuesRetrieveRequest {
    field: AdminOrganizationsValuesRetrieveFieldEnum;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    hasScBanking?: boolean;
    hasScCore?: boolean;
    hasScDistributionHub?: boolean;
    hasScLaunchpad?: boolean;
    icontains?: string;
    id?: string;
    loginType?: AdminOrganizationsValuesRetrieveLoginTypeEnum;
    name?: string;
    ordering?: AdminOrganizationsValuesRetrieveOrderingEnum;
    permissions?: AdminOrganizationsValuesRetrievePermissionsEnum;
    search?: string;
}

export interface AdminPayoutEventsCreateRequest {
    adminPayoutEventCreationOrUpdateRequest: AdminPayoutEventCreationOrUpdateRequest;
}

export interface AdminPayoutEventsDestroyRequest {
    id: string;
}

export interface AdminPayoutEventsDropdownListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    field?: AdminPayoutEventsDropdownListFieldEnum;
    id?: string;
    issuerId?: string;
    issuerName?: string;
    limit?: number;
    offset?: number;
    ordering?: AdminPayoutEventsDropdownListOrderingEnum;
    paymentDateAfter?: Date;
    paymentDateBefore?: Date;
    payoutEventType?: AdminPayoutEventsDropdownListPayoutEventTypeEnum;
    productId?: string;
    productName?: string;
}

export interface AdminPayoutEventsListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    id?: Array<string>;
    issuerId?: Array<string>;
    issuerName?: Array<string>;
    limit?: number;
    offset?: number;
    ordering?: AdminPayoutEventsListOrderingEnum;
    paymentDateAfter?: Date;
    paymentDateBefore?: Date;
    payoutEventType?: Array<AdminPayoutEventsListPayoutEventTypeEnum>;
    productId?: Array<string>;
    productName?: Array<string>;
}

export interface AdminPayoutEventsPartialUpdateRequest {
    id: string;
    patchedAdminPayoutEventCreationOrUpdateRequest?: PatchedAdminPayoutEventCreationOrUpdateRequest;
}

export interface AdminPayoutEventsRetrieveRequest {
    id: string;
}

export interface AdminPayoutEventsValuesRetrieveRequest {
    field: AdminPayoutEventsValuesRetrieveFieldEnum;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    icontains?: string;
    id?: string;
    issuerId?: string;
    issuerName?: string;
    ordering?: AdminPayoutEventsValuesRetrieveOrderingEnum;
    paymentDateAfter?: Date;
    paymentDateBefore?: Date;
    payoutEventType?: AdminPayoutEventsValuesRetrievePayoutEventTypeEnum;
    productId?: string;
    productName?: string;
}

export interface AdminPermissionsListRequest {
    permission: string;
}

export interface AdminProductPricesDestroyRequest {
    id: string;
}

export interface AdminProductPricesListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    id?: Array<string>;
    limit?: number;
    offset?: number;
    ordering?: AdminProductPricesListOrderingEnum;
    priceAtAfter?: Date;
    priceAtBefore?: Date;
    priceMax?: string;
    priceMin?: string;
    productId?: Array<string>;
}

export interface AdminProductPricesRetrieveRequest {
    id: string;
}

export interface AdminProductPricesUploadCsvCreateRequest {
    file: Blob;
    product: string;
}

export interface AdminProductsBundesbankSettlementInstructionsCreateRequest {
    id: string;
    adminBundesbankSettlementInstructionRequest: AdminBundesbankSettlementInstructionRequest;
}

export interface AdminProductsCalculationsRetrieveRequest {
    id: string;
    pricePerToken?: number;
    requestedTokens?: number;
}

export interface AdminProductsCampaignsCreateRequest {
    id: string;
    campaignRequest: CampaignRequest;
}

export interface AdminProductsCreateRequest {
    adminProductCreationRequest: AdminProductCreationRequest;
}

export interface AdminProductsDropdownListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformId?: string;
    field?: AdminProductsDropdownListFieldEnum;
    id?: string;
    issuerId?: string;
    issuerName?: string;
    limit?: number;
    maxIssuableAmountMax?: number;
    maxIssuableAmountMin?: number;
    name?: string;
    offset?: number;
    ordering?: AdminProductsDropdownListOrderingEnum;
    permission?: AdminProductsDropdownListPermissionEnum;
    permissionOnIssuer?: AdminProductsDropdownListPermissionOnIssuerEnum;
    permissionOnOrganization?: AdminProductsDropdownListPermissionOnOrganizationEnum;
    productType?: AdminProductsDropdownListProductTypeEnum;
    publicationValid?: boolean;
    search?: string;
    status?: AdminProductsDropdownListStatusEnum;
    totalVolumeMax?: number;
    totalVolumeMin?: number;
}

export interface AdminProductsInvitationCreateRequest {
    id: string;
    investmentInvitationCreationRequest: InvestmentInvitationCreationRequest;
}

export interface AdminProductsInvitationRulesListRequest {
    id: string;
    ordering?: AdminProductsInvitationRulesListOrderingEnum;
    search?: string;
}

export interface AdminProductsIssuanceDocumentCreateRequest {
    id: string;
    adminVersionedIssuanceDocumentRequest: AdminVersionedIssuanceDocumentRequest;
}

export interface AdminProductsListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformId?: Array<string>;
    id?: string;
    issuerId?: Array<string>;
    issuerName?: Array<string>;
    limit?: number;
    maxIssuableAmountMax?: number;
    maxIssuableAmountMin?: number;
    name?: Array<string>;
    offset?: number;
    ordering?: AdminProductsListOrderingEnum;
    permission?: AdminProductsListPermissionEnum;
    permissionOnIssuer?: Array<AdminProductsListPermissionOnIssuerEnum>;
    permissionOnOrganization?: Array<AdminProductsListPermissionOnOrganizationEnum>;
    productType?: Array<AdminProductsListProductTypeEnum>;
    publicationValid?: boolean;
    search?: string;
    status?: Array<AdminProductsListStatusEnum>;
    totalVolumeMax?: number;
    totalVolumeMin?: number;
}

export interface AdminProductsOverviewRetrieveRequest {
    id: string;
}

export interface AdminProductsPartialUpdateRequest {
    id: string;
    patchedAdminProductDetailRequest?: PatchedAdminProductDetailRequest;
}

export interface AdminProductsRetrieveRequest {
    id: string;
}

export interface AdminProductsValuesRetrieveRequest {
    field: AdminProductsValuesRetrieveFieldEnum;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    distributionPlatformId?: string;
    icontains?: string;
    id?: string;
    issuerId?: string;
    issuerName?: string;
    maxIssuableAmountMax?: number;
    maxIssuableAmountMin?: number;
    name?: string;
    ordering?: AdminProductsValuesRetrieveOrderingEnum;
    permission?: AdminProductsValuesRetrievePermissionEnum;
    permissionOnIssuer?: AdminProductsValuesRetrievePermissionOnIssuerEnum;
    permissionOnOrganization?: AdminProductsValuesRetrievePermissionOnOrganizationEnum;
    productType?: AdminProductsValuesRetrieveProductTypeEnum;
    publicationValid?: boolean;
    search?: string;
    status?: AdminProductsValuesRetrieveStatusEnum;
    totalVolumeMax?: number;
    totalVolumeMin?: number;
}

export interface AdminRedemptionsCreateRequest {
    redemptionRequest: RedemptionRequest;
}

export interface AdminRedemptionsDropdownListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    field?: AdminRedemptionsDropdownListFieldEnum;
    id?: string;
    limit?: number;
    offset?: number;
    ordering?: AdminRedemptionsDropdownListOrderingEnum;
    productId?: string;
    productName?: string;
    search?: string;
    status?: AdminRedemptionsDropdownListStatusEnum;
    transactionTimestampAfter?: Date;
    transactionTimestampBefore?: Date;
    unitsMax?: number;
    unitsMin?: number;
    walletAddress?: string;
}

export interface AdminRedemptionsListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    id?: Array<string>;
    limit?: number;
    offset?: number;
    ordering?: AdminRedemptionsListOrderingEnum;
    productId?: Array<string>;
    productName?: Array<string>;
    search?: string;
    status?: Array<AdminRedemptionsListStatusEnum>;
    transactionTimestampAfter?: Date;
    transactionTimestampBefore?: Date;
    unitsMax?: number;
    unitsMin?: number;
    walletAddress?: Array<string>;
}

export interface AdminRedemptionsRetrieveRequest {
    id: string;
}

export interface AdminRedemptionsValuesRetrieveRequest {
    field: AdminRedemptionsValuesRetrieveFieldEnum;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    icontains?: string;
    id?: string;
    ordering?: AdminRedemptionsValuesRetrieveOrderingEnum;
    productId?: string;
    productName?: string;
    search?: string;
    status?: AdminRedemptionsValuesRetrieveStatusEnum;
    transactionTimestampAfter?: Date;
    transactionTimestampBefore?: Date;
    unitsMax?: number;
    unitsMin?: number;
    walletAddress?: string;
}

export interface AdminServiceContractsDropdownListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    displayName?: string;
    field?: AdminServiceContractsDropdownListFieldEnum;
    id?: string;
    limit?: number;
    offset?: number;
    ordering?: AdminServiceContractsDropdownListOrderingEnum;
    technicalName?: string;
}

export interface AdminServiceContractsListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    displayName?: string;
    id?: Array<string>;
    limit?: number;
    offset?: number;
    ordering?: AdminServiceContractsListOrderingEnum;
    technicalName?: string;
}

export interface AdminServiceContractsRetrieveRequest {
    technicalName: string;
}

export interface AdminServiceContractsValuesRetrieveRequest {
    field: AdminServiceContractsValuesRetrieveFieldEnum;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    displayName?: string;
    icontains?: string;
    id?: string;
    ordering?: AdminServiceContractsValuesRetrieveOrderingEnum;
    technicalName?: string;
}

export interface AdminStatisticsReportRetrieveRequest {
    reportType: AdminStatisticsReportRetrieveReportTypeEnum;
}

export interface AdminUserPermissionsCreateRequest {
    adminUserPermissionRequest: AdminUserPermissionRequest;
}

export interface AdminUserPermissionsDestroyRequest {
    id: string;
}

export interface AdminUserPermissionsDropdownListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    field?: AdminUserPermissionsDropdownListFieldEnum;
    id?: string;
    limit?: number;
    objectId?: string;
    offset?: number;
    ordering?: AdminUserPermissionsDropdownListOrderingEnum;
    permissionCode?: AdminUserPermissionsDropdownListPermissionCodeEnum;
    permissionType?: AdminUserPermissionsDropdownListPermissionTypeEnum;
    search?: string;
    userId?: string;
    validForName?: string;
}

export interface AdminUserPermissionsListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    id?: Array<string>;
    limit?: number;
    objectId?: Array<string>;
    offset?: number;
    ordering?: AdminUserPermissionsListOrderingEnum;
    permissionCode?: Array<AdminUserPermissionsListPermissionCodeEnum>;
    permissionType?: Array<AdminUserPermissionsListPermissionTypeEnum>;
    search?: string;
    userId?: Array<string>;
    validForName?: Array<string>;
}

export interface AdminUserPermissionsValuesRetrieveRequest {
    field: AdminUserPermissionsValuesRetrieveFieldEnum;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    icontains?: string;
    id?: string;
    objectId?: string;
    ordering?: AdminUserPermissionsValuesRetrieveOrderingEnum;
    permissionCode?: AdminUserPermissionsValuesRetrievePermissionCodeEnum;
    permissionType?: AdminUserPermissionsValuesRetrievePermissionTypeEnum;
    search?: string;
    userId?: string;
    validForName?: string;
}

export interface AdminUsersCreateRequest {
    adminUserCreationRequest: AdminUserCreationRequest;
}

export interface AdminUsersDropdownListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dateJoinedAfter?: Date;
    dateJoinedBefore?: Date;
    email?: string;
    field?: AdminUsersDropdownListFieldEnum;
    groups?: string;
    groupsExclude?: string;
    id?: string;
    isActive?: boolean;
    lastLoginAfter?: Date;
    lastLoginBefore?: Date;
    limit?: number;
    offset?: number;
    ordering?: AdminUsersDropdownListOrderingEnum;
    organization?: string;
    organizationName?: string;
    search?: string;
    status?: AdminUsersDropdownListStatusEnum;
}

export interface AdminUsersListRequest {
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dateJoinedAfter?: Date;
    dateJoinedBefore?: Date;
    email?: Array<string>;
    groups?: Array<string>;
    groupsExclude?: Array<string>;
    id?: Array<string>;
    isActive?: boolean;
    lastLoginAfter?: Date;
    lastLoginBefore?: Date;
    limit?: number;
    offset?: number;
    ordering?: AdminUsersListOrderingEnum;
    organization?: Array<string>;
    organizationName?: Array<string>;
    search?: string;
    status?: Array<AdminUsersListStatusEnum>;
}

export interface AdminUsersPartialUpdateRequest {
    id: string;
    patchedAdminUserPartialUpdateRequest?: PatchedAdminUserPartialUpdateRequest;
}

export interface AdminUsersResendInvitationCreateRequest {
    id: string;
}

export interface AdminUsersRetrieveRequest {
    id: string;
}

export interface AdminUsersValuesRetrieveRequest {
    field: AdminUsersValuesRetrieveFieldEnum;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dateJoinedAfter?: Date;
    dateJoinedBefore?: Date;
    email?: string;
    groups?: string;
    groupsExclude?: string;
    icontains?: string;
    id?: string;
    isActive?: boolean;
    lastLoginAfter?: Date;
    lastLoginBefore?: Date;
    ordering?: AdminUsersValuesRetrieveOrderingEnum;
    organization?: string;
    organizationName?: string;
    search?: string;
    status?: AdminUsersValuesRetrieveStatusEnum;
}

export interface AdminVouchersActivationCreateRequest {
    id: string;
    adminVoucherRequest: AdminVoucherRequest;
}

export interface AdminVouchersCreateRequest {
    adminVoucherCreationRequest: AdminVoucherCreationRequest;
}

export interface AdminVouchersDropdownListRequest {
    active?: boolean;
    alreadyUsedMax?: number;
    alreadyUsedMin?: number;
    code?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    field?: AdminVouchersDropdownListFieldEnum;
    id?: string;
    limit?: number;
    name?: string;
    offset?: number;
    ordering?: AdminVouchersDropdownListOrderingEnum;
    owningInvestorName?: string;
    search?: string;
}

export interface AdminVouchersListRequest {
    active?: boolean;
    alreadyUsedMax?: number;
    alreadyUsedMin?: number;
    code?: Array<string>;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    id?: Array<string>;
    limit?: number;
    name?: Array<string>;
    offset?: number;
    ordering?: AdminVouchersListOrderingEnum;
    owningInvestorName?: Array<string>;
    search?: string;
}

export interface AdminVouchersPartialUpdateRequest {
    id: string;
    patchedAdminVoucherUpdateRequest?: PatchedAdminVoucherUpdateRequest;
}

export interface AdminVouchersRetrieveRequest {
    id: string;
}

export interface AdminVouchersValidatorCreateRequest {
    adminVoucherValidatorRequest: AdminVoucherValidatorRequest;
}

export interface AdminVouchersValuesRetrieveRequest {
    field: AdminVouchersValuesRetrieveFieldEnum;
    active?: boolean;
    alreadyUsedMax?: number;
    alreadyUsedMin?: number;
    code?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    icontains?: string;
    id?: string;
    name?: string;
    ordering?: AdminVouchersValuesRetrieveOrderingEnum;
    owningInvestorName?: string;
    search?: string;
}

export interface AdminVouchersVoucherStepsCreateRequest {
    id: string;
    adminVoucherStepBulkCreateRequest: AdminVoucherStepBulkCreateRequest;
    search?: string;
}

export interface AdminVouchersVoucherStepsListRequest {
    id: string;
    search?: string;
}

export interface AdminWalletsRetrieveRequest {
    address: string;
}

/**
 * 
 */
export class AdminApi extends runtime.BaseAPI {

    /**
     * Create an Api connection.
     */
    async adminApiConnectionsCreateRaw(requestParameters: AdminApiConnectionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminApiConnectionCreation>> {
        if (requestParameters['adminApiConnectionCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminApiConnectionCreationRequest',
                'Required parameter "adminApiConnectionCreationRequest" was null or undefined when calling adminApiConnectionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/api-connections/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminApiConnectionCreationRequestToJSON(requestParameters['adminApiConnectionCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminApiConnectionCreationFromJSON(jsonValue));
    }

    /**
     * Create an Api connection.
     */
    async adminApiConnectionsCreate(requestParameters: AdminApiConnectionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminApiConnectionCreation> {
        const response = await this.adminApiConnectionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft-delete the given ApiConnection object.
     */
    async adminApiConnectionsDestroyRaw(requestParameters: AdminApiConnectionsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminApiConnectionsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/api-connections/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft-delete the given ApiConnection object.
     */
    async adminApiConnectionsDestroy(requestParameters: AdminApiConnectionsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminApiConnectionsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminApiConnectionsDropdownListRaw(requestParameters: AdminApiConnectionsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['apiType'] != null) {
            queryParameters['api_type'] = requestParameters['apiType'];
        }

        if (requestParameters['clientId'] != null) {
            queryParameters['client_id'] = requestParameters['clientId'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatform'] != null) {
            queryParameters['distribution_platform'] = requestParameters['distributionPlatform'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['organization'] != null) {
            queryParameters['organization'] = requestParameters['organization'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/api-connections/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminApiConnectionsDropdownList(requestParameters: AdminApiConnectionsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminApiConnectionsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List ApiConnections.
     */
    async adminApiConnectionsListRaw(requestParameters: AdminApiConnectionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminApiConnectionList>> {
        const queryParameters: any = {};

        if (requestParameters['apiType'] != null) {
            queryParameters['api_type'] = requestParameters['apiType'];
        }

        if (requestParameters['clientId'] != null) {
            queryParameters['client_id'] = requestParameters['clientId'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatform'] != null) {
            queryParameters['distribution_platform'] = requestParameters['distributionPlatform'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['organization'] != null) {
            queryParameters['organization'] = requestParameters['organization'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/api-connections/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminApiConnectionListFromJSON(jsonValue));
    }

    /**
     * List ApiConnections.
     */
    async adminApiConnectionsList(requestParameters: AdminApiConnectionsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminApiConnectionList> {
        const response = await this.adminApiConnectionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an ApiConnection.
     */
    async adminApiConnectionsPartialUpdateRaw(requestParameters: AdminApiConnectionsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminApiConnectionUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminApiConnectionsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/api-connections/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminApiConnectionUpdateRequestToJSON(requestParameters['patchedAdminApiConnectionUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminApiConnectionUpdateFromJSON(jsonValue));
    }

    /**
     * Update an ApiConnection.
     */
    async adminApiConnectionsPartialUpdate(requestParameters: AdminApiConnectionsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminApiConnectionUpdate> {
        const response = await this.adminApiConnectionsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminApiConnectionsValuesRetrieveRaw(requestParameters: AdminApiConnectionsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminApiConnectionsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['apiType'] != null) {
            queryParameters['api_type'] = requestParameters['apiType'];
        }

        if (requestParameters['clientId'] != null) {
            queryParameters['client_id'] = requestParameters['clientId'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatform'] != null) {
            queryParameters['distribution_platform'] = requestParameters['distributionPlatform'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['organization'] != null) {
            queryParameters['organization'] = requestParameters['organization'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/api-connections/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminApiConnectionsValuesRetrieve(requestParameters: AdminApiConnectionsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminApiConnectionsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminBundesbankSettlementInstructionsDropdownListRaw(requestParameters: AdminBundesbankSettlementInstructionsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['correlationId'] != null) {
            queryParameters['correlation_id'] = requestParameters['correlationId'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['paymentAmountMax'] != null) {
            queryParameters['payment_amount_max'] = requestParameters['paymentAmountMax'];
        }

        if (requestParameters['paymentAmountMin'] != null) {
            queryParameters['payment_amount_min'] = requestParameters['paymentAmountMin'];
        }

        if (requestParameters['productAmountMax'] != null) {
            queryParameters['product_amount_max'] = requestParameters['productAmountMax'];
        }

        if (requestParameters['productAmountMin'] != null) {
            queryParameters['product_amount_min'] = requestParameters['productAmountMin'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/bundesbank-settlement-instructions/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminBundesbankSettlementInstructionsDropdownList(requestParameters: AdminBundesbankSettlementInstructionsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminBundesbankSettlementInstructionsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List BundesbankSettlementInstructions.
     */
    async adminBundesbankSettlementInstructionsListRaw(requestParameters: AdminBundesbankSettlementInstructionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminBundesbankSettlementInstructionList>> {
        const queryParameters: any = {};

        if (requestParameters['correlationId'] != null) {
            queryParameters['correlation_id'] = requestParameters['correlationId'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['paymentAmountMax'] != null) {
            queryParameters['payment_amount_max'] = requestParameters['paymentAmountMax'];
        }

        if (requestParameters['paymentAmountMin'] != null) {
            queryParameters['payment_amount_min'] = requestParameters['paymentAmountMin'];
        }

        if (requestParameters['productAmountMax'] != null) {
            queryParameters['product_amount_max'] = requestParameters['productAmountMax'];
        }

        if (requestParameters['productAmountMin'] != null) {
            queryParameters['product_amount_min'] = requestParameters['productAmountMin'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/bundesbank-settlement-instructions/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminBundesbankSettlementInstructionListFromJSON(jsonValue));
    }

    /**
     * List BundesbankSettlementInstructions.
     */
    async adminBundesbankSettlementInstructionsList(requestParameters: AdminBundesbankSettlementInstructionsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminBundesbankSettlementInstructionList> {
        const response = await this.adminBundesbankSettlementInstructionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a BundesbankSettlementInstruction.
     */
    async adminBundesbankSettlementInstructionsRetrieveRaw(requestParameters: AdminBundesbankSettlementInstructionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminBundesbankSettlementInstruction>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminBundesbankSettlementInstructionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/bundesbank-settlement-instructions/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminBundesbankSettlementInstructionFromJSON(jsonValue));
    }

    /**
     * Retrieve a BundesbankSettlementInstruction.
     */
    async adminBundesbankSettlementInstructionsRetrieve(requestParameters: AdminBundesbankSettlementInstructionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminBundesbankSettlementInstruction> {
        const response = await this.adminBundesbankSettlementInstructionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminBundesbankSettlementInstructionsValuesRetrieveRaw(requestParameters: AdminBundesbankSettlementInstructionsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminBundesbankSettlementInstructionsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['correlationId'] != null) {
            queryParameters['correlation_id'] = requestParameters['correlationId'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['paymentAmountMax'] != null) {
            queryParameters['payment_amount_max'] = requestParameters['paymentAmountMax'];
        }

        if (requestParameters['paymentAmountMin'] != null) {
            queryParameters['payment_amount_min'] = requestParameters['paymentAmountMin'];
        }

        if (requestParameters['productAmountMax'] != null) {
            queryParameters['product_amount_max'] = requestParameters['productAmountMax'];
        }

        if (requestParameters['productAmountMin'] != null) {
            queryParameters['product_amount_min'] = requestParameters['productAmountMin'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/bundesbank-settlement-instructions/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminBundesbankSettlementInstructionsValuesRetrieve(requestParameters: AdminBundesbankSettlementInstructionsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminBundesbankSettlementInstructionsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Activate the campaign.
     */
    async adminCampaignsActivationCreateRaw(requestParameters: AdminCampaignsActivationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminCampaignsActivationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/campaigns/{id}/activation/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CampaignActivationRequestToJSON(requestParameters['campaignActivationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Activate the campaign.
     */
    async adminCampaignsActivationCreate(requestParameters: AdminCampaignsActivationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminCampaignsActivationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminCampaignsDropdownListRaw(requestParameters: AdminCampaignsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['allocationAvailableMax'] != null) {
            queryParameters['allocation_available_max'] = requestParameters['allocationAvailableMax'];
        }

        if (requestParameters['allocationAvailableMin'] != null) {
            queryParameters['allocation_available_min'] = requestParameters['allocationAvailableMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['pricePerUnitMax'] != null) {
            queryParameters['price_per_unit_max'] = requestParameters['pricePerUnitMax'];
        }

        if (requestParameters['pricePerUnitMin'] != null) {
            queryParameters['price_per_unit_min'] = requestParameters['pricePerUnitMin'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['signedPercentageMax'] != null) {
            queryParameters['signed_percentage_max'] = requestParameters['signedPercentageMax'];
        }

        if (requestParameters['signedPercentageMin'] != null) {
            queryParameters['signed_percentage_min'] = requestParameters['signedPercentageMin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/campaigns/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminCampaignsDropdownList(requestParameters: AdminCampaignsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminCampaignsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Allows an admin to create an investment for a specific investor on their behalf.  Usually, these investors were created userless through Cashlink Studio.
     */
    async adminCampaignsInvestmentsCreateRaw(requestParameters: AdminCampaignsInvestmentsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvestmentCreation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminCampaignsInvestmentsCreate().'
            );
        }

        if (requestParameters['adminInvestmentCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminInvestmentCreationRequest',
                'Required parameter "adminInvestmentCreationRequest" was null or undefined when calling adminCampaignsInvestmentsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/campaigns/{id}/investments/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminInvestmentCreationRequestToJSON(requestParameters['adminInvestmentCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvestmentCreationFromJSON(jsonValue));
    }

    /**
     * Allows an admin to create an investment for a specific investor on their behalf.  Usually, these investors were created userless through Cashlink Studio.
     */
    async adminCampaignsInvestmentsCreate(requestParameters: AdminCampaignsInvestmentsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvestmentCreation> {
        const response = await this.adminCampaignsInvestmentsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminCampaignsListRaw(requestParameters: AdminCampaignsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminCampaignList>> {
        const queryParameters: any = {};

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['allocationAvailableMax'] != null) {
            queryParameters['allocation_available_max'] = requestParameters['allocationAvailableMax'];
        }

        if (requestParameters['allocationAvailableMin'] != null) {
            queryParameters['allocation_available_min'] = requestParameters['allocationAvailableMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['pricePerUnitMax'] != null) {
            queryParameters['price_per_unit_max'] = requestParameters['pricePerUnitMax'];
        }

        if (requestParameters['pricePerUnitMin'] != null) {
            queryParameters['price_per_unit_min'] = requestParameters['pricePerUnitMin'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['signedPercentageMax'] != null) {
            queryParameters['signed_percentage_max'] = requestParameters['signedPercentageMax'];
        }

        if (requestParameters['signedPercentageMin'] != null) {
            queryParameters['signed_percentage_min'] = requestParameters['signedPercentageMin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/campaigns/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminCampaignListFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminCampaignsList(requestParameters: AdminCampaignsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminCampaignList> {
        const response = await this.adminCampaignsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a campaign.
     */
    async adminCampaignsRetrieveRaw(requestParameters: AdminCampaignsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminCampaign>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminCampaignsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/campaigns/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminCampaignFromJSON(jsonValue));
    }

    /**
     * Retrieve a campaign.
     */
    async adminCampaignsRetrieve(requestParameters: AdminCampaignsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminCampaign> {
        const response = await this.adminCampaignsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminCampaignsValuesRetrieveRaw(requestParameters: AdminCampaignsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminCampaignsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['allocationAvailableMax'] != null) {
            queryParameters['allocation_available_max'] = requestParameters['allocationAvailableMax'];
        }

        if (requestParameters['allocationAvailableMin'] != null) {
            queryParameters['allocation_available_min'] = requestParameters['allocationAvailableMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['pricePerUnitMax'] != null) {
            queryParameters['price_per_unit_max'] = requestParameters['pricePerUnitMax'];
        }

        if (requestParameters['pricePerUnitMin'] != null) {
            queryParameters['price_per_unit_min'] = requestParameters['pricePerUnitMin'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['signedPercentageMax'] != null) {
            queryParameters['signed_percentage_max'] = requestParameters['signedPercentageMax'];
        }

        if (requestParameters['signedPercentageMin'] != null) {
            queryParameters['signed_percentage_min'] = requestParameters['signedPercentageMin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/campaigns/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminCampaignsValuesRetrieve(requestParameters: AdminCampaignsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminCampaignsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminDistributionPlatformsDropdownListRaw(requestParameters: AdminDistributionPlatformsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['displayName'] != null) {
            queryParameters['display_name'] = requestParameters['displayName'];
        }

        if (requestParameters['distributionPlatformPermissions'] != null) {
            queryParameters['distribution_platform_permissions'] = requestParameters['distributionPlatformPermissions'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['hasFrontend'] != null) {
            queryParameters['has_frontend'] = requestParameters['hasFrontend'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['organization'] != null) {
            queryParameters['organization'] = requestParameters['organization'];
        }

        if (requestParameters['permissions'] != null) {
            queryParameters['permissions'] = requestParameters['permissions'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['usesEffecta'] != null) {
            queryParameters['uses_effecta'] = requestParameters['usesEffecta'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/distribution-platforms/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminDistributionPlatformsDropdownList(requestParameters: AdminDistributionPlatformsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminDistributionPlatformsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List DistributionPlatforms.
     */
    async adminDistributionPlatformsListRaw(requestParameters: AdminDistributionPlatformsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDistributionPlatformList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['displayName'] != null) {
            queryParameters['display_name'] = requestParameters['displayName'];
        }

        if (requestParameters['distributionPlatformPermissions'] != null) {
            queryParameters['distribution_platform_permissions'] = requestParameters['distributionPlatformPermissions'];
        }

        if (requestParameters['hasFrontend'] != null) {
            queryParameters['has_frontend'] = requestParameters['hasFrontend'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['organization'] != null) {
            queryParameters['organization'] = requestParameters['organization'];
        }

        if (requestParameters['permissions'] != null) {
            queryParameters['permissions'] = requestParameters['permissions'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['usesEffecta'] != null) {
            queryParameters['uses_effecta'] = requestParameters['usesEffecta'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/distribution-platforms/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDistributionPlatformListFromJSON(jsonValue));
    }

    /**
     * List DistributionPlatforms.
     */
    async adminDistributionPlatformsList(requestParameters: AdminDistributionPlatformsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDistributionPlatformList> {
        const response = await this.adminDistributionPlatformsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a distribution platform.
     */
    async adminDistributionPlatformsRetrieveRaw(requestParameters: AdminDistributionPlatformsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DistributionPlatform>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminDistributionPlatformsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/distribution-platforms/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DistributionPlatformFromJSON(jsonValue));
    }

    /**
     * Retrieve a distribution platform.
     */
    async adminDistributionPlatformsRetrieve(requestParameters: AdminDistributionPlatformsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DistributionPlatform> {
        const response = await this.adminDistributionPlatformsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminDistributionPlatformsValuesRetrieveRaw(requestParameters: AdminDistributionPlatformsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminDistributionPlatformsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['displayName'] != null) {
            queryParameters['display_name'] = requestParameters['displayName'];
        }

        if (requestParameters['distributionPlatformPermissions'] != null) {
            queryParameters['distribution_platform_permissions'] = requestParameters['distributionPlatformPermissions'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['hasFrontend'] != null) {
            queryParameters['has_frontend'] = requestParameters['hasFrontend'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['organization'] != null) {
            queryParameters['organization'] = requestParameters['organization'];
        }

        if (requestParameters['permissions'] != null) {
            queryParameters['permissions'] = requestParameters['permissions'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['usesEffecta'] != null) {
            queryParameters['uses_effecta'] = requestParameters['usesEffecta'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/distribution-platforms/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminDistributionPlatformsValuesRetrieve(requestParameters: AdminDistributionPlatformsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminDistributionPlatformsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminFriendVouchersDropdownListRaw(requestParameters: AdminFriendVouchersDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['alreadyUsedMax'] != null) {
            queryParameters['already_used_max'] = requestParameters['alreadyUsedMax'];
        }

        if (requestParameters['alreadyUsedMin'] != null) {
            queryParameters['already_used_min'] = requestParameters['alreadyUsedMin'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['owningInvestorName'] != null) {
            queryParameters['owning_investor_name'] = requestParameters['owningInvestorName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/friend-vouchers/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminFriendVouchersDropdownList(requestParameters: AdminFriendVouchersDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminFriendVouchersDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminFriendVouchersListRaw(requestParameters: AdminFriendVouchersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminVoucherList>> {
        const queryParameters: any = {};

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['alreadyUsedMax'] != null) {
            queryParameters['already_used_max'] = requestParameters['alreadyUsedMax'];
        }

        if (requestParameters['alreadyUsedMin'] != null) {
            queryParameters['already_used_min'] = requestParameters['alreadyUsedMin'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['owningInvestorName'] != null) {
            queryParameters['owning_investor_name'] = requestParameters['owningInvestorName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/friend-vouchers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminVoucherListFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminFriendVouchersList(requestParameters: AdminFriendVouchersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminVoucherList> {
        const response = await this.adminFriendVouchersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a friend voucher.
     */
    async adminFriendVouchersRetrieveRaw(requestParameters: AdminFriendVouchersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminVoucherDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminFriendVouchersRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/friend-vouchers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminVoucherDetailFromJSON(jsonValue));
    }

    /**
     * Retrieve a friend voucher.
     */
    async adminFriendVouchersRetrieve(requestParameters: AdminFriendVouchersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminVoucherDetail> {
        const response = await this.adminFriendVouchersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminFriendVouchersValuesRetrieveRaw(requestParameters: AdminFriendVouchersValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminFriendVouchersValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['alreadyUsedMax'] != null) {
            queryParameters['already_used_max'] = requestParameters['alreadyUsedMax'];
        }

        if (requestParameters['alreadyUsedMin'] != null) {
            queryParameters['already_used_min'] = requestParameters['alreadyUsedMin'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['owningInvestorName'] != null) {
            queryParameters['owning_investor_name'] = requestParameters['owningInvestorName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/friend-vouchers/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminFriendVouchersValuesRetrieve(requestParameters: AdminFriendVouchersValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminFriendVouchersValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a Group Permission
     */
    async adminGroupPermissionsCreateRaw(requestParameters: AdminGroupPermissionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminGroupPermission>> {
        if (requestParameters['adminGroupPermissionRequest'] == null) {
            throw new runtime.RequiredError(
                'adminGroupPermissionRequest',
                'Required parameter "adminGroupPermissionRequest" was null or undefined when calling adminGroupPermissionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/group-permissions/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminGroupPermissionRequestToJSON(requestParameters['adminGroupPermissionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminGroupPermissionFromJSON(jsonValue));
    }

    /**
     * Create a Group Permission
     */
    async adminGroupPermissionsCreate(requestParameters: AdminGroupPermissionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminGroupPermission> {
        const response = await this.adminGroupPermissionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete the given Group Permission.
     */
    async adminGroupPermissionsDestroyRaw(requestParameters: AdminGroupPermissionsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminGroupPermissionsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/group-permissions/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the given Group Permission.
     */
    async adminGroupPermissionsDestroy(requestParameters: AdminGroupPermissionsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminGroupPermissionsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminGroupPermissionsDropdownListRaw(requestParameters: AdminGroupPermissionsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['groupId'] != null) {
            queryParameters['group_id'] = requestParameters['groupId'];
        }

        if (requestParameters['groupName'] != null) {
            queryParameters['group_name'] = requestParameters['groupName'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['objectId'] != null) {
            queryParameters['object_id'] = requestParameters['objectId'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['permissionCode'] != null) {
            queryParameters['permission_code'] = requestParameters['permissionCode'];
        }

        if (requestParameters['permissionType'] != null) {
            queryParameters['permission_type'] = requestParameters['permissionType'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        if (requestParameters['validForName'] != null) {
            queryParameters['valid_for_name'] = requestParameters['validForName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/group-permissions/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminGroupPermissionsDropdownList(requestParameters: AdminGroupPermissionsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminGroupPermissionsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all explicitly given permissions a given group has.
     */
    async adminGroupPermissionsListRaw(requestParameters: AdminGroupPermissionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminGroupPermissionList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['groupId'] != null) {
            queryParameters['group_id'] = requestParameters['groupId'];
        }

        if (requestParameters['groupName'] != null) {
            queryParameters['group_name'] = requestParameters['groupName'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['objectId'] != null) {
            queryParameters['object_id'] = requestParameters['objectId'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['permissionCode'] != null) {
            queryParameters['permission_code'] = requestParameters['permissionCode'];
        }

        if (requestParameters['permissionType'] != null) {
            queryParameters['permission_type'] = requestParameters['permissionType'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        if (requestParameters['validForName'] != null) {
            queryParameters['valid_for_name'] = requestParameters['validForName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/group-permissions/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminGroupPermissionListFromJSON(jsonValue));
    }

    /**
     * List all explicitly given permissions a given group has.
     */
    async adminGroupPermissionsList(requestParameters: AdminGroupPermissionsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminGroupPermissionList> {
        const response = await this.adminGroupPermissionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminGroupPermissionsValuesRetrieveRaw(requestParameters: AdminGroupPermissionsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminGroupPermissionsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['groupId'] != null) {
            queryParameters['group_id'] = requestParameters['groupId'];
        }

        if (requestParameters['groupName'] != null) {
            queryParameters['group_name'] = requestParameters['groupName'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['objectId'] != null) {
            queryParameters['object_id'] = requestParameters['objectId'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['permissionCode'] != null) {
            queryParameters['permission_code'] = requestParameters['permissionCode'];
        }

        if (requestParameters['permissionType'] != null) {
            queryParameters['permission_type'] = requestParameters['permissionType'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        if (requestParameters['validForName'] != null) {
            queryParameters['valid_for_name'] = requestParameters['validForName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/group-permissions/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminGroupPermissionsValuesRetrieve(requestParameters: AdminGroupPermissionsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminGroupPermissionsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a Group.
     */
    async adminGroupsCreateRaw(requestParameters: AdminGroupsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminGroup>> {
        if (requestParameters['adminGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'adminGroupRequest',
                'Required parameter "adminGroupRequest" was null or undefined when calling adminGroupsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/groups/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminGroupRequestToJSON(requestParameters['adminGroupRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminGroupFromJSON(jsonValue));
    }

    /**
     * Create a Group.
     */
    async adminGroupsCreate(requestParameters: AdminGroupsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminGroup> {
        const response = await this.adminGroupsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete the given Group.
     */
    async adminGroupsDestroyRaw(requestParameters: AdminGroupsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminGroupsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/groups/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the given Group.
     */
    async adminGroupsDestroy(requestParameters: AdminGroupsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminGroupsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminGroupsDropdownListRaw(requestParameters: AdminGroupsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['organizationName'] != null) {
            queryParameters['organization_name'] = requestParameters['organizationName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/groups/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminGroupsDropdownList(requestParameters: AdminGroupsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminGroupsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List Groups.
     */
    async adminGroupsListRaw(requestParameters: AdminGroupsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminGroupList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['organizationName'] != null) {
            queryParameters['organization_name'] = requestParameters['organizationName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/groups/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminGroupListFromJSON(jsonValue));
    }

    /**
     * List Groups.
     */
    async adminGroupsList(requestParameters: AdminGroupsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminGroupList> {
        const response = await this.adminGroupsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a group.
     */
    async adminGroupsRetrieveRaw(requestParameters: AdminGroupsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminGroup>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminGroupsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/groups/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminGroupFromJSON(jsonValue));
    }

    /**
     * Retrieve a group.
     */
    async adminGroupsRetrieve(requestParameters: AdminGroupsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminGroup> {
        const response = await this.adminGroupsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove user from group. This endpoint is inherently idempotent.
     * Remove user from group
     */
    async adminGroupsUsersDestroyRaw(requestParameters: AdminGroupsUsersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminGroupsUsersDestroy().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling adminGroupsUsersDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/groups/{id}/users/{user_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove user from group. This endpoint is inherently idempotent.
     * Remove user from group
     */
    async adminGroupsUsersDestroy(requestParameters: AdminGroupsUsersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminGroupsUsersDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Add user to group. This endpoint is inherently idempotent.
     * Add user to group
     */
    async adminGroupsUsersUpdateRaw(requestParameters: AdminGroupsUsersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminGroupsUsersUpdate().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling adminGroupsUsersUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/groups/{id}/users/{user_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add user to group. This endpoint is inherently idempotent.
     * Add user to group
     */
    async adminGroupsUsersUpdate(requestParameters: AdminGroupsUsersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminGroupsUsersUpdateRaw(requestParameters, initOverrides);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminGroupsValuesRetrieveRaw(requestParameters: AdminGroupsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminGroupsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['organizationName'] != null) {
            queryParameters['organization_name'] = requestParameters['organizationName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/groups/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminGroupsValuesRetrieve(requestParameters: AdminGroupsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminGroupsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dropdown elements with IDs and investor names.
     * Get dropdown elements
     */
    async adminInvestmentTransfersDropdownListRaw(requestParameters: AdminInvestmentTransfersDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        if (requestParameters['investment'] == null) {
            throw new runtime.RequiredError(
                'investment',
                'Required parameter "investment" was null or undefined when calling adminInvestmentTransfersDropdownList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['amountMax'] != null) {
            queryParameters['amount_max'] = requestParameters['amountMax'];
        }

        if (requestParameters['amountMin'] != null) {
            queryParameters['amount_min'] = requestParameters['amountMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['investment'] != null) {
            queryParameters['investment'] = requestParameters['investment'];
        }

        if (requestParameters['investorNameRecipient'] != null) {
            queryParameters['investor_name_recipient'] = requestParameters['investorNameRecipient'];
        }

        if (requestParameters['investorNameSender'] != null) {
            queryParameters['investor_name_sender'] = requestParameters['investorNameSender'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['recipient'] != null) {
            queryParameters['recipient'] = requestParameters['recipient'];
        }

        if (requestParameters['recipientColumn'] != null) {
            queryParameters['recipient_column'] = requestParameters['recipientColumn'];
        }

        if (requestParameters['sender'] != null) {
            queryParameters['sender'] = requestParameters['sender'];
        }

        if (requestParameters['senderColumn'] != null) {
            queryParameters['sender_column'] = requestParameters['senderColumn'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investment-transfers/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and investor names.
     * Get dropdown elements
     */
    async adminInvestmentTransfersDropdownList(requestParameters: AdminInvestmentTransfersDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminInvestmentTransfersDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all investment transfers, issuances and redemptions that have `investment_id` as source or recipient Investment.
     */
    async adminInvestmentTransfersListRaw(requestParameters: AdminInvestmentTransfersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminTokenTransferList>> {
        if (requestParameters['investment'] == null) {
            throw new runtime.RequiredError(
                'investment',
                'Required parameter "investment" was null or undefined when calling adminInvestmentTransfersList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['amountMax'] != null) {
            queryParameters['amount_max'] = requestParameters['amountMax'];
        }

        if (requestParameters['amountMin'] != null) {
            queryParameters['amount_min'] = requestParameters['amountMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['investment'] != null) {
            queryParameters['investment'] = requestParameters['investment'];
        }

        if (requestParameters['investorNameRecipient'] != null) {
            queryParameters['investor_name_recipient'] = requestParameters['investorNameRecipient'];
        }

        if (requestParameters['investorNameSender'] != null) {
            queryParameters['investor_name_sender'] = requestParameters['investorNameSender'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['recipient'] != null) {
            queryParameters['recipient'] = requestParameters['recipient'];
        }

        if (requestParameters['recipientColumn'] != null) {
            queryParameters['recipient_column'] = requestParameters['recipientColumn'];
        }

        if (requestParameters['sender'] != null) {
            queryParameters['sender'] = requestParameters['sender'];
        }

        if (requestParameters['senderColumn'] != null) {
            queryParameters['sender_column'] = requestParameters['senderColumn'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investment-transfers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminTokenTransferListFromJSON(jsonValue));
    }

    /**
     * List all investment transfers, issuances and redemptions that have `investment_id` as source or recipient Investment.
     */
    async adminInvestmentTransfersList(requestParameters: AdminInvestmentTransfersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminTokenTransferList> {
        const response = await this.adminInvestmentTransfersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminInvestmentTransfersValuesRetrieveRaw(requestParameters: AdminInvestmentTransfersValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminInvestmentTransfersValuesRetrieve().'
            );
        }

        if (requestParameters['investment'] == null) {
            throw new runtime.RequiredError(
                'investment',
                'Required parameter "investment" was null or undefined when calling adminInvestmentTransfersValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['amountMax'] != null) {
            queryParameters['amount_max'] = requestParameters['amountMax'];
        }

        if (requestParameters['amountMin'] != null) {
            queryParameters['amount_min'] = requestParameters['amountMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['investment'] != null) {
            queryParameters['investment'] = requestParameters['investment'];
        }

        if (requestParameters['investorNameRecipient'] != null) {
            queryParameters['investor_name_recipient'] = requestParameters['investorNameRecipient'];
        }

        if (requestParameters['investorNameSender'] != null) {
            queryParameters['investor_name_sender'] = requestParameters['investorNameSender'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['recipient'] != null) {
            queryParameters['recipient'] = requestParameters['recipient'];
        }

        if (requestParameters['recipientColumn'] != null) {
            queryParameters['recipient_column'] = requestParameters['recipientColumn'];
        }

        if (requestParameters['sender'] != null) {
            queryParameters['sender'] = requestParameters['sender'];
        }

        if (requestParameters['senderColumn'] != null) {
            queryParameters['sender_column'] = requestParameters['senderColumn'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investment-transfers/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminInvestmentTransfersValuesRetrieve(requestParameters: AdminInvestmentTransfersValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminInvestmentTransfersValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel/reject specified investment by giving date and cancellation reason.
     */
    async adminInvestmentsCancellationCreateRaw(requestParameters: AdminInvestmentsCancellationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsCancellationCreate().'
            );
        }

        if (requestParameters['investmentCancellationRequest'] == null) {
            throw new runtime.RequiredError(
                'investmentCancellationRequest',
                'Required parameter "investmentCancellationRequest" was null or undefined when calling adminInvestmentsCancellationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investments/{id}/cancellation/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvestmentCancellationRequestToJSON(requestParameters['investmentCancellationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel/reject specified investment by giving date and cancellation reason.
     */
    async adminInvestmentsCancellationCreate(requestParameters: AdminInvestmentsCancellationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestmentsCancellationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Create an investment for a given product and investor.
     */
    async adminInvestmentsCreateRaw(requestParameters: AdminInvestmentsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvestment>> {
        if (requestParameters['adminProductInvestmentCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductInvestmentCreationRequest',
                'Required parameter "adminProductInvestmentCreationRequest" was null or undefined when calling adminInvestmentsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investments/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminProductInvestmentCreationRequestToJSON(requestParameters['adminProductInvestmentCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvestmentFromJSON(jsonValue));
    }

    /**
     * Create an investment for a given product and investor.
     */
    async adminInvestmentsCreate(requestParameters: AdminInvestmentsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvestment> {
        const response = await this.adminInvestmentsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminInvestmentsDropdownListRaw(requestParameters: AdminInvestmentsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['acceptedAtAfter'] != null) {
            queryParameters['accepted_at_after'] = (requestParameters['acceptedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['acceptedAtBefore'] != null) {
            queryParameters['accepted_at_before'] = (requestParameters['acceptedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['acquisitionType'] != null) {
            queryParameters['acquisition_type'] = requestParameters['acquisitionType'];
        }

        if (requestParameters['addWalletLater'] != null) {
            queryParameters['add_wallet_later'] = requestParameters['addWalletLater'];
        }

        if (requestParameters['campaign'] != null) {
            queryParameters['campaign'] = requestParameters['campaign'];
        }

        if (requestParameters['cancellationDateAfter'] != null) {
            queryParameters['cancellation_date_after'] = (requestParameters['cancellationDateAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['cancellationDateBefore'] != null) {
            queryParameters['cancellation_date_before'] = (requestParameters['cancellationDateBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['cancellationReason'] != null) {
            queryParameters['cancellation_reason'] = requestParameters['cancellationReason'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['exemptionOrderDateAfter'] != null) {
            queryParameters['exemption_order_date_after'] = (requestParameters['exemptionOrderDateAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['exemptionOrderDateBefore'] != null) {
            queryParameters['exemption_order_date_before'] = (requestParameters['exemptionOrderDateBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['frontendStatus'] != null) {
            queryParameters['frontend_status'] = requestParameters['frontendStatus'];
        }

        if (requestParameters['fulfilledAmountMax'] != null) {
            queryParameters['fulfilled_amount_max'] = requestParameters['fulfilledAmountMax'];
        }

        if (requestParameters['fulfilledAmountMin'] != null) {
            queryParameters['fulfilled_amount_min'] = requestParameters['fulfilledAmountMin'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['initiatedIdentification'] != null) {
            queryParameters['initiated_identification'] = requestParameters['initiatedIdentification'];
        }

        if (requestParameters['investmentTotalFulfilledMax'] != null) {
            queryParameters['investment_total_fulfilled_max'] = requestParameters['investmentTotalFulfilledMax'];
        }

        if (requestParameters['investmentTotalFulfilledMin'] != null) {
            queryParameters['investment_total_fulfilled_min'] = requestParameters['investmentTotalFulfilledMin'];
        }

        if (requestParameters['investmentTotalMax'] != null) {
            queryParameters['investment_total_max'] = requestParameters['investmentTotalMax'];
        }

        if (requestParameters['investmentTotalMin'] != null) {
            queryParameters['investment_total_min'] = requestParameters['investmentTotalMin'];
        }

        if (requestParameters['investorId'] != null) {
            queryParameters['investor_id'] = requestParameters['investorId'];
        }

        if (requestParameters['investorName'] != null) {
            queryParameters['investor_name'] = requestParameters['investorName'];
        }

        if (requestParameters['lastSettledPayoutAmountMax'] != null) {
            queryParameters['last_settled_payout_amount_max'] = requestParameters['lastSettledPayoutAmountMax'];
        }

        if (requestParameters['lastSettledPayoutAmountMin'] != null) {
            queryParameters['last_settled_payout_amount_min'] = requestParameters['lastSettledPayoutAmountMin'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['maxAmountMax'] != null) {
            queryParameters['max_amount_max'] = requestParameters['maxAmountMax'];
        }

        if (requestParameters['maxAmountMin'] != null) {
            queryParameters['max_amount_min'] = requestParameters['maxAmountMin'];
        }

        if (requestParameters['nextScheduledPayoutAfter'] != null) {
            queryParameters['next_scheduled_payout_after'] = (requestParameters['nextScheduledPayoutAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['nextScheduledPayoutBefore'] != null) {
            queryParameters['next_scheduled_payout_before'] = (requestParameters['nextScheduledPayoutBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['paidAtAfter'] != null) {
            queryParameters['paid_at_after'] = (requestParameters['paidAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paidAtBefore'] != null) {
            queryParameters['paid_at_before'] = (requestParameters['paidAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paymentCode'] != null) {
            queryParameters['payment_code'] = requestParameters['paymentCode'];
        }

        if (requestParameters['paymentDeadlineAfter'] != null) {
            queryParameters['payment_deadline_after'] = (requestParameters['paymentDeadlineAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paymentDeadlineBefore'] != null) {
            queryParameters['payment_deadline_before'] = (requestParameters['paymentDeadlineBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paymentTotalMax'] != null) {
            queryParameters['payment_total_max'] = requestParameters['paymentTotalMax'];
        }

        if (requestParameters['paymentTotalMin'] != null) {
            queryParameters['payment_total_min'] = requestParameters['paymentTotalMin'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['remainingAmountMax'] != null) {
            queryParameters['remaining_amount_max'] = requestParameters['remainingAmountMax'];
        }

        if (requestParameters['remainingAmountMin'] != null) {
            queryParameters['remaining_amount_min'] = requestParameters['remainingAmountMin'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['signedAtAfter'] != null) {
            queryParameters['signed_at_after'] = (requestParameters['signedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['signedAtBefore'] != null) {
            queryParameters['signed_at_before'] = (requestParameters['signedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['step'] != null) {
            queryParameters['step'] = requestParameters['step'];
        }

        if (requestParameters['sumSettledPayoutsMax'] != null) {
            queryParameters['sum_settled_payouts_max'] = requestParameters['sumSettledPayoutsMax'];
        }

        if (requestParameters['sumSettledPayoutsMin'] != null) {
            queryParameters['sum_settled_payouts_min'] = requestParameters['sumSettledPayoutsMin'];
        }

        if (requestParameters['surveyValid'] != null) {
            queryParameters['survey_valid'] = requestParameters['surveyValid'];
        }

        if (requestParameters['surveyWaiverType'] != null) {
            queryParameters['survey_waiver_type'] = requestParameters['surveyWaiverType'];
        }

        if (requestParameters['tokenDeliveredAtAfter'] != null) {
            queryParameters['token_delivered_at_after'] = (requestParameters['tokenDeliveredAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['tokenDeliveredAtBefore'] != null) {
            queryParameters['token_delivered_at_before'] = (requestParameters['tokenDeliveredAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['tokenTransactionHash'] != null) {
            queryParameters['token_transaction_hash'] = requestParameters['tokenTransactionHash'];
        }

        if (requestParameters['voucherId'] != null) {
            queryParameters['voucher_id'] = requestParameters['voucherId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investments/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminInvestmentsDropdownList(requestParameters: AdminInvestmentsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminInvestmentsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Credit assets.
     */
    async adminInvestmentsIssueCreateRaw(requestParameters: AdminInvestmentsIssueCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsIssueCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investments/{id}/issue/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Credit assets.
     */
    async adminInvestmentsIssueCreate(requestParameters: AdminInvestmentsIssueCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestmentsIssueCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Announce issuance.
     */
    async adminInvestmentsIssuingAnnouncementCreateRaw(requestParameters: AdminInvestmentsIssuingAnnouncementCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsIssuingAnnouncementCreate().'
            );
        }

        if (requestParameters['investmentIssuingAnnouncementRequest'] == null) {
            throw new runtime.RequiredError(
                'investmentIssuingAnnouncementRequest',
                'Required parameter "investmentIssuingAnnouncementRequest" was null or undefined when calling adminInvestmentsIssuingAnnouncementCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investments/{id}/issuing-announcement/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvestmentIssuingAnnouncementRequestToJSON(requestParameters['investmentIssuingAnnouncementRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Announce issuance.
     */
    async adminInvestmentsIssuingAnnouncementCreate(requestParameters: AdminInvestmentsIssuingAnnouncementCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestmentsIssuingAnnouncementCreateRaw(requestParameters, initOverrides);
    }

    /**
     * List Investments.
     */
    async adminInvestmentsListRaw(requestParameters: AdminInvestmentsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminInvestmentListList>> {
        const queryParameters: any = {};

        if (requestParameters['acceptedAtAfter'] != null) {
            queryParameters['accepted_at_after'] = (requestParameters['acceptedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['acceptedAtBefore'] != null) {
            queryParameters['accepted_at_before'] = (requestParameters['acceptedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['acquisitionType'] != null) {
            queryParameters['acquisition_type'] = requestParameters['acquisitionType'];
        }

        if (requestParameters['addWalletLater'] != null) {
            queryParameters['add_wallet_later'] = requestParameters['addWalletLater'];
        }

        if (requestParameters['campaign'] != null) {
            queryParameters['campaign'] = requestParameters['campaign'];
        }

        if (requestParameters['cancellationDateAfter'] != null) {
            queryParameters['cancellation_date_after'] = (requestParameters['cancellationDateAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['cancellationDateBefore'] != null) {
            queryParameters['cancellation_date_before'] = (requestParameters['cancellationDateBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['cancellationReason'] != null) {
            queryParameters['cancellation_reason'] = requestParameters['cancellationReason'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['exemptionOrderDateAfter'] != null) {
            queryParameters['exemption_order_date_after'] = (requestParameters['exemptionOrderDateAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['exemptionOrderDateBefore'] != null) {
            queryParameters['exemption_order_date_before'] = (requestParameters['exemptionOrderDateBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['frontendStatus'] != null) {
            queryParameters['frontend_status'] = requestParameters['frontendStatus'];
        }

        if (requestParameters['fulfilledAmountMax'] != null) {
            queryParameters['fulfilled_amount_max'] = requestParameters['fulfilledAmountMax'];
        }

        if (requestParameters['fulfilledAmountMin'] != null) {
            queryParameters['fulfilled_amount_min'] = requestParameters['fulfilledAmountMin'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['initiatedIdentification'] != null) {
            queryParameters['initiated_identification'] = requestParameters['initiatedIdentification'];
        }

        if (requestParameters['investmentTotalFulfilledMax'] != null) {
            queryParameters['investment_total_fulfilled_max'] = requestParameters['investmentTotalFulfilledMax'];
        }

        if (requestParameters['investmentTotalFulfilledMin'] != null) {
            queryParameters['investment_total_fulfilled_min'] = requestParameters['investmentTotalFulfilledMin'];
        }

        if (requestParameters['investmentTotalMax'] != null) {
            queryParameters['investment_total_max'] = requestParameters['investmentTotalMax'];
        }

        if (requestParameters['investmentTotalMin'] != null) {
            queryParameters['investment_total_min'] = requestParameters['investmentTotalMin'];
        }

        if (requestParameters['investor'] != null) {
            queryParameters['investor'] = requestParameters['investor'];
        }

        if (requestParameters['investorId'] != null) {
            queryParameters['investor_id'] = requestParameters['investorId'];
        }

        if (requestParameters['investorName'] != null) {
            queryParameters['investor_name'] = requestParameters['investorName'];
        }

        if (requestParameters['lastSettledPayoutAmountMax'] != null) {
            queryParameters['last_settled_payout_amount_max'] = requestParameters['lastSettledPayoutAmountMax'];
        }

        if (requestParameters['lastSettledPayoutAmountMin'] != null) {
            queryParameters['last_settled_payout_amount_min'] = requestParameters['lastSettledPayoutAmountMin'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['maxAmountMax'] != null) {
            queryParameters['max_amount_max'] = requestParameters['maxAmountMax'];
        }

        if (requestParameters['maxAmountMin'] != null) {
            queryParameters['max_amount_min'] = requestParameters['maxAmountMin'];
        }

        if (requestParameters['nextScheduledPayoutAfter'] != null) {
            queryParameters['next_scheduled_payout_after'] = (requestParameters['nextScheduledPayoutAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['nextScheduledPayoutBefore'] != null) {
            queryParameters['next_scheduled_payout_before'] = (requestParameters['nextScheduledPayoutBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['paidAtAfter'] != null) {
            queryParameters['paid_at_after'] = (requestParameters['paidAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paidAtBefore'] != null) {
            queryParameters['paid_at_before'] = (requestParameters['paidAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paymentCode'] != null) {
            queryParameters['payment_code'] = requestParameters['paymentCode'];
        }

        if (requestParameters['paymentDeadlineAfter'] != null) {
            queryParameters['payment_deadline_after'] = (requestParameters['paymentDeadlineAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paymentDeadlineBefore'] != null) {
            queryParameters['payment_deadline_before'] = (requestParameters['paymentDeadlineBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paymentTotalMax'] != null) {
            queryParameters['payment_total_max'] = requestParameters['paymentTotalMax'];
        }

        if (requestParameters['paymentTotalMin'] != null) {
            queryParameters['payment_total_min'] = requestParameters['paymentTotalMin'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['remainingAmountMax'] != null) {
            queryParameters['remaining_amount_max'] = requestParameters['remainingAmountMax'];
        }

        if (requestParameters['remainingAmountMin'] != null) {
            queryParameters['remaining_amount_min'] = requestParameters['remainingAmountMin'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['signedAtAfter'] != null) {
            queryParameters['signed_at_after'] = (requestParameters['signedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['signedAtBefore'] != null) {
            queryParameters['signed_at_before'] = (requestParameters['signedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['step'] != null) {
            queryParameters['step'] = requestParameters['step'];
        }

        if (requestParameters['sumSettledPayoutsMax'] != null) {
            queryParameters['sum_settled_payouts_max'] = requestParameters['sumSettledPayoutsMax'];
        }

        if (requestParameters['sumSettledPayoutsMin'] != null) {
            queryParameters['sum_settled_payouts_min'] = requestParameters['sumSettledPayoutsMin'];
        }

        if (requestParameters['surveyValid'] != null) {
            queryParameters['survey_valid'] = requestParameters['surveyValid'];
        }

        if (requestParameters['surveyWaiverType'] != null) {
            queryParameters['survey_waiver_type'] = requestParameters['surveyWaiverType'];
        }

        if (requestParameters['tokenDeliveredAtAfter'] != null) {
            queryParameters['token_delivered_at_after'] = (requestParameters['tokenDeliveredAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['tokenDeliveredAtBefore'] != null) {
            queryParameters['token_delivered_at_before'] = (requestParameters['tokenDeliveredAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['tokenTransactionHash'] != null) {
            queryParameters['token_transaction_hash'] = requestParameters['tokenTransactionHash'];
        }

        if (requestParameters['voucherId'] != null) {
            queryParameters['voucher_id'] = requestParameters['voucherId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investments/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminInvestmentListListFromJSON(jsonValue));
    }

    /**
     * List Investments.
     */
    async adminInvestmentsList(requestParameters: AdminInvestmentsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminInvestmentListList> {
        const response = await this.adminInvestmentsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Approve specified investment offer.
     */
    async adminInvestmentsOfferApprovalCreateRaw(requestParameters: AdminInvestmentsOfferApprovalCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsOfferApprovalCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investments/{id}/offer-approval/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Approve specified investment offer.
     */
    async adminInvestmentsOfferApprovalCreate(requestParameters: AdminInvestmentsOfferApprovalCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestmentsOfferApprovalCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsPartialUpdateRaw(requestParameters: AdminInvestmentsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvestmentDetails>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investments/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminInvestmentDetailsRequestToJSON(requestParameters['patchedAdminInvestmentDetailsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvestmentDetailsFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsPartialUpdate(requestParameters: AdminInvestmentsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvestmentDetails> {
        const response = await this.adminInvestmentsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirm payment.
     */
    async adminInvestmentsPaymentConfirmationCreateRaw(requestParameters: AdminInvestmentsPaymentConfirmationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsPaymentConfirmationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investments/{id}/payment-confirmation/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Confirm payment.
     */
    async adminInvestmentsPaymentConfirmationCreate(requestParameters: AdminInvestmentsPaymentConfirmationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestmentsPaymentConfirmationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a new registry statement for this investment.
     */
    async adminInvestmentsRegistryStatementsCreateRaw(requestParameters: AdminInvestmentsRegistryStatementsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsRegistryStatementsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investments/{id}/registry-statements/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRegistryStatementRequestToJSON(requestParameters['createRegistryStatementRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a new registry statement for this investment.
     */
    async adminInvestmentsRegistryStatementsCreate(requestParameters: AdminInvestmentsRegistryStatementsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestmentsRegistryStatementsCreateRaw(requestParameters, initOverrides);
    }

    /**
     * If the status of the latest compliance check is not \"approval\", the admin user can request new identity verification from the investor (same requirements as for the current platform admin action)  The actions can only be performed by admin users with the MANAGE_INVESTOR_AND_INVESTMENT_DATA permission
     */
    async adminInvestmentsRequestIdentificationCreateRaw(requestParameters: AdminInvestmentsRequestIdentificationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsRequestIdentificationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investments/{id}/request-identification/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * If the status of the latest compliance check is not \"approval\", the admin user can request new identity verification from the investor (same requirements as for the current platform admin action)  The actions can only be performed by admin users with the MANAGE_INVESTOR_AND_INVESTMENT_DATA permission
     */
    async adminInvestmentsRequestIdentificationCreate(requestParameters: AdminInvestmentsRequestIdentificationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestmentsRequestIdentificationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve an investment.
     */
    async adminInvestmentsRetrieveRaw(requestParameters: AdminInvestmentsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvestmentDetails>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investments/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvestmentDetailsFromJSON(jsonValue));
    }

    /**
     * Retrieve an investment.
     */
    async adminInvestmentsRetrieve(requestParameters: AdminInvestmentsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvestmentDetails> {
        const response = await this.adminInvestmentsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an Investment.
     */
    async adminInvestmentsUpdateRaw(requestParameters: AdminInvestmentsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvestmentDetails>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsUpdate().'
            );
        }

        if (requestParameters['adminInvestmentDetailsRequest'] == null) {
            throw new runtime.RequiredError(
                'adminInvestmentDetailsRequest',
                'Required parameter "adminInvestmentDetailsRequest" was null or undefined when calling adminInvestmentsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investments/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AdminInvestmentDetailsRequestToJSON(requestParameters['adminInvestmentDetailsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvestmentDetailsFromJSON(jsonValue));
    }

    /**
     * Update an Investment.
     */
    async adminInvestmentsUpdate(requestParameters: AdminInvestmentsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvestmentDetails> {
        const response = await this.adminInvestmentsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminInvestmentsValuesRetrieveRaw(requestParameters: AdminInvestmentsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminInvestmentsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['acceptedAtAfter'] != null) {
            queryParameters['accepted_at_after'] = (requestParameters['acceptedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['acceptedAtBefore'] != null) {
            queryParameters['accepted_at_before'] = (requestParameters['acceptedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['acquisitionType'] != null) {
            queryParameters['acquisition_type'] = requestParameters['acquisitionType'];
        }

        if (requestParameters['addWalletLater'] != null) {
            queryParameters['add_wallet_later'] = requestParameters['addWalletLater'];
        }

        if (requestParameters['campaign'] != null) {
            queryParameters['campaign'] = requestParameters['campaign'];
        }

        if (requestParameters['cancellationDateAfter'] != null) {
            queryParameters['cancellation_date_after'] = (requestParameters['cancellationDateAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['cancellationDateBefore'] != null) {
            queryParameters['cancellation_date_before'] = (requestParameters['cancellationDateBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['cancellationReason'] != null) {
            queryParameters['cancellation_reason'] = requestParameters['cancellationReason'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['exemptionOrderDateAfter'] != null) {
            queryParameters['exemption_order_date_after'] = (requestParameters['exemptionOrderDateAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['exemptionOrderDateBefore'] != null) {
            queryParameters['exemption_order_date_before'] = (requestParameters['exemptionOrderDateBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['frontendStatus'] != null) {
            queryParameters['frontend_status'] = requestParameters['frontendStatus'];
        }

        if (requestParameters['fulfilledAmountMax'] != null) {
            queryParameters['fulfilled_amount_max'] = requestParameters['fulfilledAmountMax'];
        }

        if (requestParameters['fulfilledAmountMin'] != null) {
            queryParameters['fulfilled_amount_min'] = requestParameters['fulfilledAmountMin'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['initiatedIdentification'] != null) {
            queryParameters['initiated_identification'] = requestParameters['initiatedIdentification'];
        }

        if (requestParameters['investmentTotalFulfilledMax'] != null) {
            queryParameters['investment_total_fulfilled_max'] = requestParameters['investmentTotalFulfilledMax'];
        }

        if (requestParameters['investmentTotalFulfilledMin'] != null) {
            queryParameters['investment_total_fulfilled_min'] = requestParameters['investmentTotalFulfilledMin'];
        }

        if (requestParameters['investmentTotalMax'] != null) {
            queryParameters['investment_total_max'] = requestParameters['investmentTotalMax'];
        }

        if (requestParameters['investmentTotalMin'] != null) {
            queryParameters['investment_total_min'] = requestParameters['investmentTotalMin'];
        }

        if (requestParameters['investorId'] != null) {
            queryParameters['investor_id'] = requestParameters['investorId'];
        }

        if (requestParameters['investorName'] != null) {
            queryParameters['investor_name'] = requestParameters['investorName'];
        }

        if (requestParameters['lastSettledPayoutAmountMax'] != null) {
            queryParameters['last_settled_payout_amount_max'] = requestParameters['lastSettledPayoutAmountMax'];
        }

        if (requestParameters['lastSettledPayoutAmountMin'] != null) {
            queryParameters['last_settled_payout_amount_min'] = requestParameters['lastSettledPayoutAmountMin'];
        }

        if (requestParameters['maxAmountMax'] != null) {
            queryParameters['max_amount_max'] = requestParameters['maxAmountMax'];
        }

        if (requestParameters['maxAmountMin'] != null) {
            queryParameters['max_amount_min'] = requestParameters['maxAmountMin'];
        }

        if (requestParameters['nextScheduledPayoutAfter'] != null) {
            queryParameters['next_scheduled_payout_after'] = (requestParameters['nextScheduledPayoutAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['nextScheduledPayoutBefore'] != null) {
            queryParameters['next_scheduled_payout_before'] = (requestParameters['nextScheduledPayoutBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['paidAtAfter'] != null) {
            queryParameters['paid_at_after'] = (requestParameters['paidAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paidAtBefore'] != null) {
            queryParameters['paid_at_before'] = (requestParameters['paidAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paymentCode'] != null) {
            queryParameters['payment_code'] = requestParameters['paymentCode'];
        }

        if (requestParameters['paymentDeadlineAfter'] != null) {
            queryParameters['payment_deadline_after'] = (requestParameters['paymentDeadlineAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paymentDeadlineBefore'] != null) {
            queryParameters['payment_deadline_before'] = (requestParameters['paymentDeadlineBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paymentTotalMax'] != null) {
            queryParameters['payment_total_max'] = requestParameters['paymentTotalMax'];
        }

        if (requestParameters['paymentTotalMin'] != null) {
            queryParameters['payment_total_min'] = requestParameters['paymentTotalMin'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['remainingAmountMax'] != null) {
            queryParameters['remaining_amount_max'] = requestParameters['remainingAmountMax'];
        }

        if (requestParameters['remainingAmountMin'] != null) {
            queryParameters['remaining_amount_min'] = requestParameters['remainingAmountMin'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['signedAtAfter'] != null) {
            queryParameters['signed_at_after'] = (requestParameters['signedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['signedAtBefore'] != null) {
            queryParameters['signed_at_before'] = (requestParameters['signedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['step'] != null) {
            queryParameters['step'] = requestParameters['step'];
        }

        if (requestParameters['sumSettledPayoutsMax'] != null) {
            queryParameters['sum_settled_payouts_max'] = requestParameters['sumSettledPayoutsMax'];
        }

        if (requestParameters['sumSettledPayoutsMin'] != null) {
            queryParameters['sum_settled_payouts_min'] = requestParameters['sumSettledPayoutsMin'];
        }

        if (requestParameters['surveyValid'] != null) {
            queryParameters['survey_valid'] = requestParameters['surveyValid'];
        }

        if (requestParameters['surveyWaiverType'] != null) {
            queryParameters['survey_waiver_type'] = requestParameters['surveyWaiverType'];
        }

        if (requestParameters['tokenDeliveredAtAfter'] != null) {
            queryParameters['token_delivered_at_after'] = (requestParameters['tokenDeliveredAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['tokenDeliveredAtBefore'] != null) {
            queryParameters['token_delivered_at_before'] = (requestParameters['tokenDeliveredAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['tokenTransactionHash'] != null) {
            queryParameters['token_transaction_hash'] = requestParameters['tokenTransactionHash'];
        }

        if (requestParameters['voucherId'] != null) {
            queryParameters['voucher_id'] = requestParameters['voucherId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investments/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminInvestmentsValuesRetrieve(requestParameters: AdminInvestmentsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminInvestmentsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirms that all benefiting persons for of a legal investor are not pep
     */
    async adminInvestorsBenefitingPersonConfirmationCreateRaw(requestParameters: AdminInvestorsBenefitingPersonConfirmationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsBenefitingPersonConfirmationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investors/{id}/benefiting-person-confirmation/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Confirms that all benefiting persons for of a legal investor are not pep
     */
    async adminInvestorsBenefitingPersonConfirmationCreate(requestParameters: AdminInvestorsBenefitingPersonConfirmationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestorsBenefitingPersonConfirmationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * List/add benefiting persons.
     */
    async adminInvestorsBenefitingPersonsCreateRaw(requestParameters: AdminInvestorsBenefitingPersonsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BenefitingPerson>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsBenefitingPersonsCreate().'
            );
        }

        if (requestParameters['benefitingPersonRequest'] == null) {
            throw new runtime.RequiredError(
                'benefitingPersonRequest',
                'Required parameter "benefitingPersonRequest" was null or undefined when calling adminInvestorsBenefitingPersonsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investors/{id}/benefiting-persons/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BenefitingPersonRequestToJSON(requestParameters['benefitingPersonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BenefitingPersonFromJSON(jsonValue));
    }

    /**
     * List/add benefiting persons.
     */
    async adminInvestorsBenefitingPersonsCreate(requestParameters: AdminInvestorsBenefitingPersonsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BenefitingPerson> {
        const response = await this.adminInvestorsBenefitingPersonsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update or delete existing benefiting persons.
     */
    async adminInvestorsBenefitingPersonsDestroyRaw(requestParameters: AdminInvestorsBenefitingPersonsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsBenefitingPersonsDestroy().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling adminInvestorsBenefitingPersonsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investors/{id}/benefiting-persons/{person_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update or delete existing benefiting persons.
     */
    async adminInvestorsBenefitingPersonsDestroy(requestParameters: AdminInvestorsBenefitingPersonsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestorsBenefitingPersonsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * List/add benefiting persons.
     */
    async adminInvestorsBenefitingPersonsListRaw(requestParameters: AdminInvestorsBenefitingPersonsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BenefitingPerson>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsBenefitingPersonsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investors/{id}/benefiting-persons/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BenefitingPersonFromJSON));
    }

    /**
     * List/add benefiting persons.
     */
    async adminInvestorsBenefitingPersonsList(requestParameters: AdminInvestorsBenefitingPersonsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BenefitingPerson>> {
        const response = await this.adminInvestorsBenefitingPersonsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update or delete existing benefiting persons.
     */
    async adminInvestorsBenefitingPersonsPartialUpdateRaw(requestParameters: AdminInvestorsBenefitingPersonsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BenefitingPerson>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsBenefitingPersonsPartialUpdate().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling adminInvestorsBenefitingPersonsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investors/{id}/benefiting-persons/{person_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedBenefitingPersonRequestToJSON(requestParameters['patchedBenefitingPersonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BenefitingPersonFromJSON(jsonValue));
    }

    /**
     * Update or delete existing benefiting persons.
     */
    async adminInvestorsBenefitingPersonsPartialUpdate(requestParameters: AdminInvestorsBenefitingPersonsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BenefitingPerson> {
        const response = await this.adminInvestorsBenefitingPersonsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a basic investor to be later completed through the update endpoint. If `company_name` is sent, we assume it\'s a legal person.
     */
    async adminInvestorsCreateRaw(requestParameters: AdminInvestorsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvestorCreation>> {
        if (requestParameters['adminInvestorCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminInvestorCreationRequest',
                'Required parameter "adminInvestorCreationRequest" was null or undefined when calling adminInvestorsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investors/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminInvestorCreationRequestToJSON(requestParameters['adminInvestorCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvestorCreationFromJSON(jsonValue));
    }

    /**
     * Create a basic investor to be later completed through the update endpoint. If `company_name` is sent, we assume it\'s a legal person.
     */
    async adminInvestorsCreate(requestParameters: AdminInvestorsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvestorCreation> {
        const response = await this.adminInvestorsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Execute a GDPR deletion of the investor.
     */
    async adminInvestorsDestroyRaw(requestParameters: AdminInvestorsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investors/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Execute a GDPR deletion of the investor.
     */
    async adminInvestorsDestroy(requestParameters: AdminInvestorsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestorsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminInvestorsDropdownListRaw(requestParameters: AdminInvestorsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['activeInvestmentsNoMax'] != null) {
            queryParameters['active_investments_no_max'] = requestParameters['activeInvestmentsNoMax'];
        }

        if (requestParameters['activeInvestmentsNoMin'] != null) {
            queryParameters['active_investments_no_min'] = requestParameters['activeInvestmentsNoMin'];
        }

        if (requestParameters['activeInvestmentsSumMax'] != null) {
            queryParameters['active_investments_sum_max'] = requestParameters['activeInvestmentsSumMax'];
        }

        if (requestParameters['activeInvestmentsSumMin'] != null) {
            queryParameters['active_investments_sum_min'] = requestParameters['activeInvestmentsSumMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['investedIntoCampaign'] != null) {
            queryParameters['invested_into_campaign'] = requestParameters['investedIntoCampaign'];
        }

        if (requestParameters['investorName'] != null) {
            queryParameters['investor_name'] = requestParameters['investorName'];
        }

        if (requestParameters['isKycSuccessful'] != null) {
            queryParameters['is_kyc_successful'] = requestParameters['isKycSuccessful'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productIdIsnull'] != null) {
            queryParameters['product_id_isnull'] = requestParameters['productIdIsnull'];
        }

        if (requestParameters['registeredAtAfter'] != null) {
            queryParameters['registered_at_after'] = (requestParameters['registeredAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['registeredAtBefore'] != null) {
            queryParameters['registered_at_before'] = (requestParameters['registeredAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investors/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminInvestorsDropdownList(requestParameters: AdminInvestorsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminInvestorsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Give the best current identification for given investor
     * Give the best current identification for given investor
     */
    async adminInvestorsIdentificationsBestCurrentRetrieveRaw(requestParameters: AdminInvestorsIdentificationsBestCurrentRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Identification>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsIdentificationsBestCurrentRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investors/{id}/identifications/best-current/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentificationFromJSON(jsonValue));
    }

    /**
     * Give the best current identification for given investor
     * Give the best current identification for given investor
     */
    async adminInvestorsIdentificationsBestCurrentRetrieve(requestParameters: AdminInvestorsIdentificationsBestCurrentRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Identification> {
        const response = await this.adminInvestorsIdentificationsBestCurrentRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an identification instance for given investor.  Note: legitimation protocol document needs to be uploaded beforehand.
     * Create identification for investor
     */
    async adminInvestorsIdentificationsCreateRaw(requestParameters: AdminInvestorsIdentificationsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Identification>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsIdentificationsCreate().'
            );
        }

        if (requestParameters['identificationRequest'] == null) {
            throw new runtime.RequiredError(
                'identificationRequest',
                'Required parameter "identificationRequest" was null or undefined when calling adminInvestorsIdentificationsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investors/{id}/identifications/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentificationRequestToJSON(requestParameters['identificationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentificationFromJSON(jsonValue));
    }

    /**
     * Create an identification instance for given investor.  Note: legitimation protocol document needs to be uploaded beforehand.
     * Create identification for investor
     */
    async adminInvestorsIdentificationsCreate(requestParameters: AdminInvestorsIdentificationsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Identification> {
        const response = await this.adminInvestorsIdentificationsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Restart all invalid associated identifications.
     * Abort all existing identifications and create a new one
     */
    async adminInvestorsIdentificationsRestartCreateRaw(requestParameters: AdminInvestorsIdentificationsRestartCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Identification>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsIdentificationsRestartCreate().'
            );
        }

        if (requestParameters['identificationRequest'] == null) {
            throw new runtime.RequiredError(
                'identificationRequest',
                'Required parameter "identificationRequest" was null or undefined when calling adminInvestorsIdentificationsRestartCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investors/{id}/identifications/restart/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentificationRequestToJSON(requestParameters['identificationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentificationFromJSON(jsonValue));
    }

    /**
     * Restart all invalid associated identifications.
     * Abort all existing identifications and create a new one
     */
    async adminInvestorsIdentificationsRestartCreate(requestParameters: AdminInvestorsIdentificationsRestartCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Identification> {
        const response = await this.adminInvestorsIdentificationsRestartCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List investors who are incomplete.  In this case incomplete means that they don\'t have all the necessary data and therefor don\'t have a valid manual KYC approved, so they can\'t have investments yet.
     */
    async adminInvestorsIncompleteListRaw(requestParameters: AdminInvestorsIncompleteListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdminIncompleteInvestor>>> {
        const queryParameters: any = {};

        if (requestParameters['activeInvestmentsNoMax'] != null) {
            queryParameters['active_investments_no_max'] = requestParameters['activeInvestmentsNoMax'];
        }

        if (requestParameters['activeInvestmentsNoMin'] != null) {
            queryParameters['active_investments_no_min'] = requestParameters['activeInvestmentsNoMin'];
        }

        if (requestParameters['activeInvestmentsSumMax'] != null) {
            queryParameters['active_investments_sum_max'] = requestParameters['activeInvestmentsSumMax'];
        }

        if (requestParameters['activeInvestmentsSumMin'] != null) {
            queryParameters['active_investments_sum_min'] = requestParameters['activeInvestmentsSumMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['investedIntoCampaign'] != null) {
            queryParameters['invested_into_campaign'] = requestParameters['investedIntoCampaign'];
        }

        if (requestParameters['investorName'] != null) {
            queryParameters['investor_name'] = requestParameters['investorName'];
        }

        if (requestParameters['isKycSuccessful'] != null) {
            queryParameters['is_kyc_successful'] = requestParameters['isKycSuccessful'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productIdIsnull'] != null) {
            queryParameters['product_id_isnull'] = requestParameters['productIdIsnull'];
        }

        if (requestParameters['registeredAtAfter'] != null) {
            queryParameters['registered_at_after'] = (requestParameters['registeredAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['registeredAtBefore'] != null) {
            queryParameters['registered_at_before'] = (requestParameters['registeredAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investors/incomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminIncompleteInvestorFromJSON));
    }

    /**
     * List investors who are incomplete.  In this case incomplete means that they don\'t have all the necessary data and therefor don\'t have a valid manual KYC approved, so they can\'t have investments yet.
     */
    async adminInvestorsIncompleteList(requestParameters: AdminInvestorsIncompleteListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdminIncompleteInvestor>> {
        const response = await this.adminInvestorsIncompleteListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a legal person.
     */
    async adminInvestorsLegalPersonCreateRaw(requestParameters: AdminInvestorsLegalPersonCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminLegalPersonUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsLegalPersonCreate().'
            );
        }

        if (requestParameters['adminLegalPersonUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'adminLegalPersonUpdateRequest',
                'Required parameter "adminLegalPersonUpdateRequest" was null or undefined when calling adminInvestorsLegalPersonCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investors/{id}/legal-person/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminLegalPersonUpdateRequestToJSON(requestParameters['adminLegalPersonUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminLegalPersonUpdateFromJSON(jsonValue));
    }

    /**
     * Update a legal person.
     */
    async adminInvestorsLegalPersonCreate(requestParameters: AdminInvestorsLegalPersonCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminLegalPersonUpdate> {
        const response = await this.adminInvestorsLegalPersonCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List Investors.
     */
    async adminInvestorsListRaw(requestParameters: AdminInvestorsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminInvestorListList>> {
        const queryParameters: any = {};

        if (requestParameters['activeInvestmentsNoMax'] != null) {
            queryParameters['active_investments_no_max'] = requestParameters['activeInvestmentsNoMax'];
        }

        if (requestParameters['activeInvestmentsNoMin'] != null) {
            queryParameters['active_investments_no_min'] = requestParameters['activeInvestmentsNoMin'];
        }

        if (requestParameters['activeInvestmentsSumMax'] != null) {
            queryParameters['active_investments_sum_max'] = requestParameters['activeInvestmentsSumMax'];
        }

        if (requestParameters['activeInvestmentsSumMin'] != null) {
            queryParameters['active_investments_sum_min'] = requestParameters['activeInvestmentsSumMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['investedIntoCampaign'] != null) {
            queryParameters['invested_into_campaign'] = requestParameters['investedIntoCampaign'];
        }

        if (requestParameters['investorName'] != null) {
            queryParameters['investor_name'] = requestParameters['investorName'];
        }

        if (requestParameters['isKycSuccessful'] != null) {
            queryParameters['is_kyc_successful'] = requestParameters['isKycSuccessful'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productIdIsnull'] != null) {
            queryParameters['product_id_isnull'] = requestParameters['productIdIsnull'];
        }

        if (requestParameters['registeredAtAfter'] != null) {
            queryParameters['registered_at_after'] = (requestParameters['registeredAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['registeredAtBefore'] != null) {
            queryParameters['registered_at_before'] = (requestParameters['registeredAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investors/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminInvestorListListFromJSON(jsonValue));
    }

    /**
     * List Investors.
     */
    async adminInvestorsList(requestParameters: AdminInvestorsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminInvestorListList> {
        const response = await this.adminInvestorsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an investor.
     */
    async adminInvestorsPartialUpdateRaw(requestParameters: AdminInvestorsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investors/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminInvestorUpdateRequestToJSON(requestParameters['patchedAdminInvestorUpdateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update an investor.
     */
    async adminInvestorsPartialUpdate(requestParameters: AdminInvestorsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestorsPartialUpdateRaw(requestParameters, initOverrides);
    }

    /**
     * Add/retrieve a pending deletion request that gets executed as soon as legally possible.
     */
    async adminInvestorsPendingDeletionCreateRaw(requestParameters: AdminInvestorsPendingDeletionCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminPendingInvestorDeletion>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsPendingDeletionCreate().'
            );
        }

        if (requestParameters['adminPendingInvestorDeletionRequest'] == null) {
            throw new runtime.RequiredError(
                'adminPendingInvestorDeletionRequest',
                'Required parameter "adminPendingInvestorDeletionRequest" was null or undefined when calling adminInvestorsPendingDeletionCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investors/{id}/pending-deletion/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminPendingInvestorDeletionRequestToJSON(requestParameters['adminPendingInvestorDeletionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminPendingInvestorDeletionFromJSON(jsonValue));
    }

    /**
     * Add/retrieve a pending deletion request that gets executed as soon as legally possible.
     */
    async adminInvestorsPendingDeletionCreate(requestParameters: AdminInvestorsPendingDeletionCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminPendingInvestorDeletion | null | undefined > {
        const response = await this.adminInvestorsPendingDeletionCreateRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 201:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Add/retrieve a pending deletion request that gets executed as soon as legally possible.
     */
    async adminInvestorsPendingDeletionRetrieveRaw(requestParameters: AdminInvestorsPendingDeletionRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminPendingInvestorDeletion>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsPendingDeletionRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investors/{id}/pending-deletion/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminPendingInvestorDeletionFromJSON(jsonValue));
    }

    /**
     * Add/retrieve a pending deletion request that gets executed as soon as legally possible.
     */
    async adminInvestorsPendingDeletionRetrieve(requestParameters: AdminInvestorsPendingDeletionRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminPendingInvestorDeletion | null | undefined > {
        const response = await this.adminInvestorsPendingDeletionRetrieveRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 201:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Reactivate an investor which has a pending deletion.
     */
    async adminInvestorsReactivateCreateRaw(requestParameters: AdminInvestorsReactivateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsReactivateCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investors/{id}/reactivate/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reactivate an investor which has a pending deletion.
     */
    async adminInvestorsReactivateCreate(requestParameters: AdminInvestorsReactivateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestorsReactivateCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve an investor.
     */
    async adminInvestorsRetrieveRaw(requestParameters: AdminInvestorsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvestor>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investors/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvestorFromJSON(jsonValue));
    }

    /**
     * Retrieve an investor.
     */
    async adminInvestorsRetrieve(requestParameters: AdminInvestorsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvestor> {
        const response = await this.adminInvestorsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminInvestorsValuesRetrieveRaw(requestParameters: AdminInvestorsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminInvestorsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['activeInvestmentsNoMax'] != null) {
            queryParameters['active_investments_no_max'] = requestParameters['activeInvestmentsNoMax'];
        }

        if (requestParameters['activeInvestmentsNoMin'] != null) {
            queryParameters['active_investments_no_min'] = requestParameters['activeInvestmentsNoMin'];
        }

        if (requestParameters['activeInvestmentsSumMax'] != null) {
            queryParameters['active_investments_sum_max'] = requestParameters['activeInvestmentsSumMax'];
        }

        if (requestParameters['activeInvestmentsSumMin'] != null) {
            queryParameters['active_investments_sum_min'] = requestParameters['activeInvestmentsSumMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['investedIntoCampaign'] != null) {
            queryParameters['invested_into_campaign'] = requestParameters['investedIntoCampaign'];
        }

        if (requestParameters['investorName'] != null) {
            queryParameters['investor_name'] = requestParameters['investorName'];
        }

        if (requestParameters['isKycSuccessful'] != null) {
            queryParameters['is_kyc_successful'] = requestParameters['isKycSuccessful'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productIdIsnull'] != null) {
            queryParameters['product_id_isnull'] = requestParameters['productIdIsnull'];
        }

        if (requestParameters['registeredAtAfter'] != null) {
            queryParameters['registered_at_after'] = (requestParameters['registeredAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['registeredAtBefore'] != null) {
            queryParameters['registered_at_before'] = (requestParameters['registeredAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/investors/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminInvestorsValuesRetrieve(requestParameters: AdminInvestorsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminInvestorsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a confirmed generic (ERC-20 or Stellar) wallet for a given investor.
     */
    async adminInvestorsWalletsGenericCreateRaw(requestParameters: AdminInvestorsWalletsGenericCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminGenericWalletCreation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsWalletsGenericCreate().'
            );
        }

        if (requestParameters['adminGenericWalletCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminGenericWalletCreationRequest',
                'Required parameter "adminGenericWalletCreationRequest" was null or undefined when calling adminInvestorsWalletsGenericCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investors/{id}/wallets/generic/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminGenericWalletCreationRequestToJSON(requestParameters['adminGenericWalletCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminGenericWalletCreationFromJSON(jsonValue));
    }

    /**
     * Create a confirmed generic (ERC-20 or Stellar) wallet for a given investor.
     */
    async adminInvestorsWalletsGenericCreate(requestParameters: AdminInvestorsWalletsGenericCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminGenericWalletCreation> {
        const response = await this.adminInvestorsWalletsGenericCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a wallet for a given investor.
     */
    async adminInvestorsWalletsPartialUpdateRaw(requestParameters: AdminInvestorsWalletsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WalletUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsWalletsPartialUpdate().'
            );
        }

        if (requestParameters['walletId'] == null) {
            throw new runtime.RequiredError(
                'walletId',
                'Required parameter "walletId" was null or undefined when calling adminInvestorsWalletsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/investors/{id}/wallets/{wallet_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"wallet_id"}}`, encodeURIComponent(String(requestParameters['walletId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedWalletUpdateRequestToJSON(requestParameters['patchedWalletUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WalletUpdateFromJSON(jsonValue));
    }

    /**
     * Update a wallet for a given investor.
     */
    async adminInvestorsWalletsPartialUpdate(requestParameters: AdminInvestorsWalletsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WalletUpdate> {
        const response = await this.adminInvestorsWalletsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revoke an investment invitation.
     */
    async adminInvitationsDestroyRaw(requestParameters: AdminInvitationsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvitationsDestroy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/invitations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Revoke an investment invitation.
     */
    async adminInvitationsDestroy(requestParameters: AdminInvitationsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvitationsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminInvitationsDropdownListRaw(requestParameters: AdminInvitationsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['hasInvestment'] != null) {
            queryParameters['has_investment'] = requestParameters['hasInvestment'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['investment'] != null) {
            queryParameters['investment'] = requestParameters['investment'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['maxNumberOfTokensMax'] != null) {
            queryParameters['max_number_of_tokens_max'] = requestParameters['maxNumberOfTokensMax'];
        }

        if (requestParameters['maxNumberOfTokensMin'] != null) {
            queryParameters['max_number_of_tokens_min'] = requestParameters['maxNumberOfTokensMin'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['pricePerUnitMax'] != null) {
            queryParameters['price_per_unit_max'] = requestParameters['pricePerUnitMax'];
        }

        if (requestParameters['pricePerUnitMin'] != null) {
            queryParameters['price_per_unit_min'] = requestParameters['pricePerUnitMin'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['signedPercentageMax'] != null) {
            queryParameters['signed_percentage_max'] = requestParameters['signedPercentageMax'];
        }

        if (requestParameters['signedPercentageMin'] != null) {
            queryParameters['signed_percentage_min'] = requestParameters['signedPercentageMin'];
        }

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/invitations/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminInvitationsDropdownList(requestParameters: AdminInvitationsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminInvitationsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve an identification. Create it if it does not exists.
     */
    async adminInvitationsIdentificationRetrieveRaw(requestParameters: AdminInvitationsIdentificationRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<KycInformation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvitationsIdentificationRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/invitations/{id}/identification/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => KycInformationFromJSON(jsonValue));
    }

    /**
     * Retrieve an identification. Create it if it does not exists.
     */
    async adminInvitationsIdentificationRetrieve(requestParameters: AdminInvitationsIdentificationRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<KycInformation> {
        const response = await this.adminInvitationsIdentificationRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set the KYC status of an identification to \'started\'.
     */
    async adminInvitationsIdentificationStartNotificationCreateRaw(requestParameters: AdminInvitationsIdentificationStartNotificationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvitationsIdentificationStartNotificationCreate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/invitations/{id}/identification-start-notification/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set the KYC status of an identification to \'started\'.
     */
    async adminInvitationsIdentificationStartNotificationCreate(requestParameters: AdminInvitationsIdentificationStartNotificationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvitationsIdentificationStartNotificationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * List Invitations.
     */
    async adminInvitationsListRaw(requestParameters: AdminInvitationsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedInvitationList>> {
        const queryParameters: any = {};

        if (requestParameters['campaignId'] != null) {
            queryParameters['campaign_id'] = requestParameters['campaignId'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['hasInvestment'] != null) {
            queryParameters['has_investment'] = requestParameters['hasInvestment'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['investment'] != null) {
            queryParameters['investment'] = requestParameters['investment'];
        }

        if (requestParameters['invitationType'] != null) {
            queryParameters['invitation_type'] = requestParameters['invitationType'];
        }

        if (requestParameters['isEcsp'] != null) {
            queryParameters['is_ecsp'] = requestParameters['isEcsp'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['maxNumberOfTokensMax'] != null) {
            queryParameters['max_number_of_tokens_max'] = requestParameters['maxNumberOfTokensMax'];
        }

        if (requestParameters['maxNumberOfTokensMin'] != null) {
            queryParameters['max_number_of_tokens_min'] = requestParameters['maxNumberOfTokensMin'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['pricePerUnitMax'] != null) {
            queryParameters['price_per_unit_max'] = requestParameters['pricePerUnitMax'];
        }

        if (requestParameters['pricePerUnitMin'] != null) {
            queryParameters['price_per_unit_min'] = requestParameters['pricePerUnitMin'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['signedPercentageMax'] != null) {
            queryParameters['signed_percentage_max'] = requestParameters['signedPercentageMax'];
        }

        if (requestParameters['signedPercentageMin'] != null) {
            queryParameters['signed_percentage_min'] = requestParameters['signedPercentageMin'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/invitations/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedInvitationListFromJSON(jsonValue));
    }

    /**
     * List Invitations.
     */
    async adminInvitationsList(requestParameters: AdminInvitationsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedInvitationList> {
        const response = await this.adminInvitationsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve an invitation.
     */
    async adminInvitationsRetrieveRaw(requestParameters: AdminInvitationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvitation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvitationsRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/invitations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvitationFromJSON(jsonValue));
    }

    /**
     * Retrieve an invitation.
     */
    async adminInvitationsRetrieve(requestParameters: AdminInvitationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvitation> {
        const response = await this.adminInvitationsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminInvitationsValuesRetrieveRaw(requestParameters: AdminInvitationsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminInvitationsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['hasInvestment'] != null) {
            queryParameters['has_investment'] = requestParameters['hasInvestment'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['investment'] != null) {
            queryParameters['investment'] = requestParameters['investment'];
        }

        if (requestParameters['maxNumberOfTokensMax'] != null) {
            queryParameters['max_number_of_tokens_max'] = requestParameters['maxNumberOfTokensMax'];
        }

        if (requestParameters['maxNumberOfTokensMin'] != null) {
            queryParameters['max_number_of_tokens_min'] = requestParameters['maxNumberOfTokensMin'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['pricePerUnitMax'] != null) {
            queryParameters['price_per_unit_max'] = requestParameters['pricePerUnitMax'];
        }

        if (requestParameters['pricePerUnitMin'] != null) {
            queryParameters['price_per_unit_min'] = requestParameters['pricePerUnitMin'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['signedPercentageMax'] != null) {
            queryParameters['signed_percentage_max'] = requestParameters['signedPercentageMax'];
        }

        if (requestParameters['signedPercentageMin'] != null) {
            queryParameters['signed_percentage_min'] = requestParameters['signedPercentageMin'];
        }

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/invitations/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminInvitationsValuesRetrieve(requestParameters: AdminInvitationsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminInvitationsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an issuer.
     */
    async adminIssuersCreateRaw(requestParameters: AdminIssuersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminIssuerDetail>> {
        if (requestParameters['adminIssuerCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminIssuerCreationRequest',
                'Required parameter "adminIssuerCreationRequest" was null or undefined when calling adminIssuersCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/issuers/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminIssuerCreationRequestToJSON(requestParameters['adminIssuerCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminIssuerDetailFromJSON(jsonValue));
    }

    /**
     * Create an issuer.
     */
    async adminIssuersCreate(requestParameters: AdminIssuersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminIssuerDetail> {
        const response = await this.adminIssuersCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminIssuersDropdownListRaw(requestParameters: AdminIssuersDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['canCreateProduct'] != null) {
            queryParameters['can_create_product'] = requestParameters['canCreateProduct'];
        }

        if (requestParameters['companyName'] != null) {
            queryParameters['company_name'] = requestParameters['companyName'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['numberOfProductsMax'] != null) {
            queryParameters['number_of_products_max'] = requestParameters['numberOfProductsMax'];
        }

        if (requestParameters['numberOfProductsMin'] != null) {
            queryParameters['number_of_products_min'] = requestParameters['numberOfProductsMin'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['organizationName'] != null) {
            queryParameters['organization_name'] = requestParameters['organizationName'];
        }

        if (requestParameters['permissions'] != null) {
            queryParameters['permissions'] = requestParameters['permissions'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/issuers/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminIssuersDropdownList(requestParameters: AdminIssuersDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminIssuersDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get organizations for dropdowns.
     */
    async adminIssuersDropdownOrganizationForIssuerCreationListRaw(requestParameters: AdminIssuersDropdownOrganizationForIssuerCreationListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/issuers/dropdown-organization-for-issuer-creation/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get organizations for dropdowns.
     */
    async adminIssuersDropdownOrganizationForIssuerCreationList(requestParameters: AdminIssuersDropdownOrganizationForIssuerCreationListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminIssuersDropdownOrganizationForIssuerCreationListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List Issuers.
     */
    async adminIssuersListRaw(requestParameters: AdminIssuersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminIssuerListList>> {
        const queryParameters: any = {};

        if (requestParameters['canCreateProduct'] != null) {
            queryParameters['can_create_product'] = requestParameters['canCreateProduct'];
        }

        if (requestParameters['companyName'] != null) {
            queryParameters['company_name'] = requestParameters['companyName'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['issuerId'] != null) {
            queryParameters['issuer_id'] = requestParameters['issuerId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['numberOfProductsMax'] != null) {
            queryParameters['number_of_products_max'] = requestParameters['numberOfProductsMax'];
        }

        if (requestParameters['numberOfProductsMin'] != null) {
            queryParameters['number_of_products_min'] = requestParameters['numberOfProductsMin'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['organizationName'] != null) {
            queryParameters['organization_name'] = requestParameters['organizationName'];
        }

        if (requestParameters['permissions'] != null) {
            queryParameters['permissions'] = requestParameters['permissions'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/issuers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminIssuerListListFromJSON(jsonValue));
    }

    /**
     * List Issuers.
     */
    async adminIssuersList(requestParameters: AdminIssuersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminIssuerListList> {
        const response = await this.adminIssuersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing issuer.
     */
    async adminIssuersPartialUpdateRaw(requestParameters: AdminIssuersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminIssuerDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminIssuersPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/issuers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminIssuerUpdateRequestToJSON(requestParameters['patchedAdminIssuerUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminIssuerDetailFromJSON(jsonValue));
    }

    /**
     * Update an existing issuer.
     */
    async adminIssuersPartialUpdate(requestParameters: AdminIssuersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminIssuerDetail> {
        const response = await this.adminIssuersPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve an issuer.
     */
    async adminIssuersRetrieveRaw(requestParameters: AdminIssuersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminIssuerDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminIssuersRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/issuers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminIssuerDetailFromJSON(jsonValue));
    }

    /**
     * Retrieve an issuer.
     */
    async adminIssuersRetrieve(requestParameters: AdminIssuersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminIssuerDetail> {
        const response = await this.adminIssuersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminIssuersValuesRetrieveRaw(requestParameters: AdminIssuersValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminIssuersValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['canCreateProduct'] != null) {
            queryParameters['can_create_product'] = requestParameters['canCreateProduct'];
        }

        if (requestParameters['companyName'] != null) {
            queryParameters['company_name'] = requestParameters['companyName'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['numberOfProductsMax'] != null) {
            queryParameters['number_of_products_max'] = requestParameters['numberOfProductsMax'];
        }

        if (requestParameters['numberOfProductsMin'] != null) {
            queryParameters['number_of_products_min'] = requestParameters['numberOfProductsMin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['organizationName'] != null) {
            queryParameters['organization_name'] = requestParameters['organizationName'];
        }

        if (requestParameters['permissions'] != null) {
            queryParameters['permissions'] = requestParameters['permissions'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/issuers/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminIssuersValuesRetrieve(requestParameters: AdminIssuersValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminIssuersValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a ProductDistributionPlatformListing for the current product.
     */
    async adminListingsCreateRaw(requestParameters: AdminListingsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductDistributionPlatformListingCreation>> {
        if (requestParameters['adminProductDistributionPlatformListingCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductDistributionPlatformListingCreationRequest',
                'Required parameter "adminProductDistributionPlatformListingCreationRequest" was null or undefined when calling adminListingsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/listings/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminProductDistributionPlatformListingCreationRequestToJSON(requestParameters['adminProductDistributionPlatformListingCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProductDistributionPlatformListingCreationFromJSON(jsonValue));
    }

    /**
     * Create a ProductDistributionPlatformListing for the current product.
     */
    async adminListingsCreate(requestParameters: AdminListingsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductDistributionPlatformListingCreation> {
        const response = await this.adminListingsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Access or edit the distributor\'s distribution information of this product listing.
     */
    async adminListingsDistributionInformationCreateRaw(requestParameters: AdminListingsDistributionInformationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDistributorProductDistributionInformation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminListingsDistributionInformationCreate().'
            );
        }

        if (requestParameters['adminDistributorProductDistributionInformationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminDistributorProductDistributionInformationRequest',
                'Required parameter "adminDistributorProductDistributionInformationRequest" was null or undefined when calling adminListingsDistributionInformationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/listings/{id}/distribution-information/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminDistributorProductDistributionInformationRequestToJSON(requestParameters['adminDistributorProductDistributionInformationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminDistributorProductDistributionInformationFromJSON(jsonValue));
    }

    /**
     * Access or edit the distributor\'s distribution information of this product listing.
     */
    async adminListingsDistributionInformationCreate(requestParameters: AdminListingsDistributionInformationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDistributorProductDistributionInformation | null | undefined > {
        const response = await this.adminListingsDistributionInformationCreateRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Access or edit the distributor\'s distribution information of this product listing.
     */
    async adminListingsDistributionInformationPartialUpdateRaw(requestParameters: AdminListingsDistributionInformationPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDistributorProductDistributionInformation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminListingsDistributionInformationPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/listings/{id}/distribution-information/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminDistributorProductDistributionInformationRequestToJSON(requestParameters['patchedAdminDistributorProductDistributionInformationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminDistributorProductDistributionInformationFromJSON(jsonValue));
    }

    /**
     * Access or edit the distributor\'s distribution information of this product listing.
     */
    async adminListingsDistributionInformationPartialUpdate(requestParameters: AdminListingsDistributionInformationPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDistributorProductDistributionInformation | null | undefined > {
        const response = await this.adminListingsDistributionInformationPartialUpdateRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Access or edit the distributor\'s distribution information of this product listing.
     */
    async adminListingsDistributionInformationRetrieveRaw(requestParameters: AdminListingsDistributionInformationRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDistributorProductDistributionInformation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminListingsDistributionInformationRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/listings/{id}/distribution-information/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminDistributorProductDistributionInformationFromJSON(jsonValue));
    }

    /**
     * Access or edit the distributor\'s distribution information of this product listing.
     */
    async adminListingsDistributionInformationRetrieve(requestParameters: AdminListingsDistributionInformationRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDistributorProductDistributionInformation | null | undefined > {
        const response = await this.adminListingsDistributionInformationRetrieveRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminListingsDropdownListRaw(requestParameters: AdminListingsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/listings/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminListingsDropdownList(requestParameters: AdminListingsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminListingsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get or add investment documents for a listing.
     */
    async adminListingsInvestmentDocumentsCreateRaw(requestParameters: AdminListingsInvestmentDocumentsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminBulkInvestmentDocumentCreation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminListingsInvestmentDocumentsCreate().'
            );
        }

        if (requestParameters['adminBulkInvestmentDocumentCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminBulkInvestmentDocumentCreationRequest',
                'Required parameter "adminBulkInvestmentDocumentCreationRequest" was null or undefined when calling adminListingsInvestmentDocumentsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/listings/{id}/investment-documents/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminBulkInvestmentDocumentCreationRequestToJSON(requestParameters['adminBulkInvestmentDocumentCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminBulkInvestmentDocumentCreationFromJSON(jsonValue));
    }

    /**
     * Get or add investment documents for a listing.
     */
    async adminListingsInvestmentDocumentsCreate(requestParameters: AdminListingsInvestmentDocumentsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminBulkInvestmentDocumentCreation> {
        const response = await this.adminListingsInvestmentDocumentsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get or add investment documents for a listing.
     */
    async adminListingsInvestmentDocumentsRetrieveRaw(requestParameters: AdminListingsInvestmentDocumentsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvestmentDocument>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminListingsInvestmentDocumentsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/listings/{id}/investment-documents/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvestmentDocumentFromJSON(jsonValue));
    }

    /**
     * Get or add investment documents for a listing.
     */
    async adminListingsInvestmentDocumentsRetrieve(requestParameters: AdminListingsInvestmentDocumentsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvestmentDocument> {
        const response = await this.adminListingsInvestmentDocumentsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List Listings.
     */
    async adminListingsListRaw(requestParameters: AdminListingsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminProductDistributionPlatformListingList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/listings/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminProductDistributionPlatformListingListFromJSON(jsonValue));
    }

    /**
     * List Listings.
     */
    async adminListingsList(requestParameters: AdminListingsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminProductDistributionPlatformListingList> {
        const response = await this.adminListingsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a listing.
     */
    async adminListingsRetrieveRaw(requestParameters: AdminListingsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductDistributionPlatformListing>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminListingsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/listings/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProductDistributionPlatformListingFromJSON(jsonValue));
    }

    /**
     * Retrieve a listing.
     */
    async adminListingsRetrieve(requestParameters: AdminListingsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductDistributionPlatformListing> {
        const response = await this.adminListingsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminListingsValuesRetrieveRaw(requestParameters: AdminListingsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminListingsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformDisplayName'] != null) {
            queryParameters['distribution_platform_display_name'] = requestParameters['distributionPlatformDisplayName'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/listings/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminListingsValuesRetrieve(requestParameters: AdminListingsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminListingsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminMailsDropdownListRaw(requestParameters: AdminMailsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['deliveredAfter'] != null) {
            queryParameters['delivered_after'] = (requestParameters['deliveredAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['deliveredBefore'] != null) {
            queryParameters['delivered_before'] = (requestParameters['deliveredBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['investor'] != null) {
            queryParameters['investor'] = requestParameters['investor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sendAtAfter'] != null) {
            queryParameters['send_at_after'] = (requestParameters['sendAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['sendAtBefore'] != null) {
            queryParameters['send_at_before'] = (requestParameters['sendAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['subject'] != null) {
            queryParameters['subject'] = requestParameters['subject'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/mails/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminMailsDropdownList(requestParameters: AdminMailsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminMailsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List Mails.
     */
    async adminMailsListRaw(requestParameters: AdminMailsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminMailList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['deliveredAfter'] != null) {
            queryParameters['delivered_after'] = (requestParameters['deliveredAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['deliveredBefore'] != null) {
            queryParameters['delivered_before'] = (requestParameters['deliveredBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['investor'] != null) {
            queryParameters['investor'] = requestParameters['investor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sendAtAfter'] != null) {
            queryParameters['send_at_after'] = (requestParameters['sendAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['sendAtBefore'] != null) {
            queryParameters['send_at_before'] = (requestParameters['sendAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['subject'] != null) {
            queryParameters['subject'] = requestParameters['subject'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/mails/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminMailListFromJSON(jsonValue));
    }

    /**
     * List Mails.
     */
    async adminMailsList(requestParameters: AdminMailsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminMailList> {
        const response = await this.adminMailsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resend the current mail
     */
    async adminMailsResendCreateRaw(requestParameters: AdminMailsResendCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminMailsResendCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/mails/{id}/resend/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resend the current mail
     */
    async adminMailsResendCreate(requestParameters: AdminMailsResendCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminMailsResendCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve a mail.
     */
    async adminMailsRetrieveRaw(requestParameters: AdminMailsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminMail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminMailsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/mails/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminMailFromJSON(jsonValue));
    }

    /**
     * Retrieve a mail.
     */
    async adminMailsRetrieve(requestParameters: AdminMailsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminMail> {
        const response = await this.adminMailsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminMailsValuesRetrieveRaw(requestParameters: AdminMailsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminMailsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['deliveredAfter'] != null) {
            queryParameters['delivered_after'] = (requestParameters['deliveredAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['deliveredBefore'] != null) {
            queryParameters['delivered_before'] = (requestParameters['deliveredBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['investor'] != null) {
            queryParameters['investor'] = requestParameters['investor'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sendAtAfter'] != null) {
            queryParameters['send_at_after'] = (requestParameters['sendAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['sendAtBefore'] != null) {
            queryParameters['send_at_before'] = (requestParameters['sendAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['subject'] != null) {
            queryParameters['subject'] = requestParameters['subject'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/mails/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminMailsValuesRetrieve(requestParameters: AdminMailsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminMailsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an Organization
     */
    async adminOrganizationsCreateRaw(requestParameters: AdminOrganizationsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrganization>> {
        if (requestParameters['adminOrganizationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminOrganizationRequest',
                'Required parameter "adminOrganizationRequest" was null or undefined when calling adminOrganizationsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/organizations/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminOrganizationRequestToJSON(requestParameters['adminOrganizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminOrganizationFromJSON(jsonValue));
    }

    /**
     * Create an Organization
     */
    async adminOrganizationsCreate(requestParameters: AdminOrganizationsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrganization> {
        const response = await this.adminOrganizationsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an Organization
     */
    async adminOrganizationsDestroyRaw(requestParameters: AdminOrganizationsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminOrganizationsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/organizations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an Organization
     */
    async adminOrganizationsDestroy(requestParameters: AdminOrganizationsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminOrganizationsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminOrganizationsDropdownListRaw(requestParameters: AdminOrganizationsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['hasScBanking'] != null) {
            queryParameters['has_sc_banking'] = requestParameters['hasScBanking'];
        }

        if (requestParameters['hasScCore'] != null) {
            queryParameters['has_sc_core'] = requestParameters['hasScCore'];
        }

        if (requestParameters['hasScDistributionHub'] != null) {
            queryParameters['has_sc_distribution_hub'] = requestParameters['hasScDistributionHub'];
        }

        if (requestParameters['hasScLaunchpad'] != null) {
            queryParameters['has_sc_launchpad'] = requestParameters['hasScLaunchpad'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['loginType'] != null) {
            queryParameters['login_type'] = requestParameters['loginType'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['permissions'] != null) {
            queryParameters['permissions'] = requestParameters['permissions'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/organizations/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminOrganizationsDropdownList(requestParameters: AdminOrganizationsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminOrganizationsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List Organizations.
     */
    async adminOrganizationsListRaw(requestParameters: AdminOrganizationsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminOrganizationList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['hasScBanking'] != null) {
            queryParameters['has_sc_banking'] = requestParameters['hasScBanking'];
        }

        if (requestParameters['hasScCore'] != null) {
            queryParameters['has_sc_core'] = requestParameters['hasScCore'];
        }

        if (requestParameters['hasScDistributionHub'] != null) {
            queryParameters['has_sc_distribution_hub'] = requestParameters['hasScDistributionHub'];
        }

        if (requestParameters['hasScLaunchpad'] != null) {
            queryParameters['has_sc_launchpad'] = requestParameters['hasScLaunchpad'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['loginType'] != null) {
            queryParameters['login_type'] = requestParameters['loginType'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['permissions'] != null) {
            queryParameters['permissions'] = requestParameters['permissions'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/organizations/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminOrganizationListFromJSON(jsonValue));
    }

    /**
     * List Organizations.
     */
    async adminOrganizationsList(requestParameters: AdminOrganizationsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminOrganizationList> {
        const response = await this.adminOrganizationsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an Organization.
     */
    async adminOrganizationsPartialUpdateRaw(requestParameters: AdminOrganizationsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrganization>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminOrganizationsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/organizations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminOrganizationRequestToJSON(requestParameters['patchedAdminOrganizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminOrganizationFromJSON(jsonValue));
    }

    /**
     * Update an Organization.
     */
    async adminOrganizationsPartialUpdate(requestParameters: AdminOrganizationsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrganization> {
        const response = await this.adminOrganizationsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve an Organization
     */
    async adminOrganizationsRetrieveRaw(requestParameters: AdminOrganizationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrganizationDetails>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminOrganizationsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/organizations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminOrganizationDetailsFromJSON(jsonValue));
    }

    /**
     * Retrieve an Organization
     */
    async adminOrganizationsRetrieve(requestParameters: AdminOrganizationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrganizationDetails> {
        const response = await this.adminOrganizationsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add or remove a service contract from the organization
     */
    async adminOrganizationsServiceContractsDestroyRaw(requestParameters: AdminOrganizationsServiceContractsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrganization>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminOrganizationsServiceContractsDestroy().'
            );
        }

        if (requestParameters['techName'] == null) {
            throw new runtime.RequiredError(
                'techName',
                'Required parameter "techName" was null or undefined when calling adminOrganizationsServiceContractsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/organizations/{id}/service-contracts/{tech_name}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"tech_name"}}`, encodeURIComponent(String(requestParameters['techName']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminOrganizationFromJSON(jsonValue));
    }

    /**
     * Add or remove a service contract from the organization
     */
    async adminOrganizationsServiceContractsDestroy(requestParameters: AdminOrganizationsServiceContractsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrganization> {
        const response = await this.adminOrganizationsServiceContractsDestroyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add or remove a service contract from the organization
     */
    async adminOrganizationsServiceContractsUpdateRaw(requestParameters: AdminOrganizationsServiceContractsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrganization>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminOrganizationsServiceContractsUpdate().'
            );
        }

        if (requestParameters['techName'] == null) {
            throw new runtime.RequiredError(
                'techName',
                'Required parameter "techName" was null or undefined when calling adminOrganizationsServiceContractsUpdate().'
            );
        }

        if (requestParameters['adminOrganizationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminOrganizationRequest',
                'Required parameter "adminOrganizationRequest" was null or undefined when calling adminOrganizationsServiceContractsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/organizations/{id}/service-contracts/{tech_name}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"tech_name"}}`, encodeURIComponent(String(requestParameters['techName']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AdminOrganizationRequestToJSON(requestParameters['adminOrganizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminOrganizationFromJSON(jsonValue));
    }

    /**
     * Add or remove a service contract from the organization
     */
    async adminOrganizationsServiceContractsUpdate(requestParameters: AdminOrganizationsServiceContractsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrganization> {
        const response = await this.adminOrganizationsServiceContractsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an organization.
     */
    async adminOrganizationsUpdateRaw(requestParameters: AdminOrganizationsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrganization>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminOrganizationsUpdate().'
            );
        }

        if (requestParameters['adminOrganizationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminOrganizationRequest',
                'Required parameter "adminOrganizationRequest" was null or undefined when calling adminOrganizationsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/organizations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AdminOrganizationRequestToJSON(requestParameters['adminOrganizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminOrganizationFromJSON(jsonValue));
    }

    /**
     * Update an organization.
     */
    async adminOrganizationsUpdate(requestParameters: AdminOrganizationsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrganization> {
        const response = await this.adminOrganizationsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminOrganizationsValuesRetrieveRaw(requestParameters: AdminOrganizationsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminOrganizationsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['hasScBanking'] != null) {
            queryParameters['has_sc_banking'] = requestParameters['hasScBanking'];
        }

        if (requestParameters['hasScCore'] != null) {
            queryParameters['has_sc_core'] = requestParameters['hasScCore'];
        }

        if (requestParameters['hasScDistributionHub'] != null) {
            queryParameters['has_sc_distribution_hub'] = requestParameters['hasScDistributionHub'];
        }

        if (requestParameters['hasScLaunchpad'] != null) {
            queryParameters['has_sc_launchpad'] = requestParameters['hasScLaunchpad'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['loginType'] != null) {
            queryParameters['login_type'] = requestParameters['loginType'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['permissions'] != null) {
            queryParameters['permissions'] = requestParameters['permissions'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/organizations/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminOrganizationsValuesRetrieve(requestParameters: AdminOrganizationsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminOrganizationsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async adminOverviewRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductGlobalOverview>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/overview/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProductGlobalOverviewFromJSON(jsonValue));
    }

    /**
     */
    async adminOverviewRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductGlobalOverview> {
        const response = await this.adminOverviewRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     * Create a PayoutEvent.
     */
    async adminPayoutEventsCreateRaw(requestParameters: AdminPayoutEventsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminPayoutEvent>> {
        if (requestParameters['adminPayoutEventCreationOrUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'adminPayoutEventCreationOrUpdateRequest',
                'Required parameter "adminPayoutEventCreationOrUpdateRequest" was null or undefined when calling adminPayoutEventsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/payout-events/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminPayoutEventCreationOrUpdateRequestToJSON(requestParameters['adminPayoutEventCreationOrUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminPayoutEventFromJSON(jsonValue));
    }

    /**
     * Create a PayoutEvent.
     */
    async adminPayoutEventsCreate(requestParameters: AdminPayoutEventsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminPayoutEvent> {
        const response = await this.adminPayoutEventsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete the given payout event.
     */
    async adminPayoutEventsDestroyRaw(requestParameters: AdminPayoutEventsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminPayoutEventsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/payout-events/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the given payout event.
     */
    async adminPayoutEventsDestroy(requestParameters: AdminPayoutEventsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminPayoutEventsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminPayoutEventsDropdownListRaw(requestParameters: AdminPayoutEventsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['issuerId'] != null) {
            queryParameters['issuer_id'] = requestParameters['issuerId'];
        }

        if (requestParameters['issuerName'] != null) {
            queryParameters['issuer_name'] = requestParameters['issuerName'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['paymentDateAfter'] != null) {
            queryParameters['payment_date_after'] = (requestParameters['paymentDateAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paymentDateBefore'] != null) {
            queryParameters['payment_date_before'] = (requestParameters['paymentDateBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['payoutEventType'] != null) {
            queryParameters['payout_event_type'] = requestParameters['payoutEventType'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/payout-events/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminPayoutEventsDropdownList(requestParameters: AdminPayoutEventsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminPayoutEventsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List PayoutEvents.
     */
    async adminPayoutEventsListRaw(requestParameters: AdminPayoutEventsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminPayoutEventList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['issuerId'] != null) {
            queryParameters['issuer_id'] = requestParameters['issuerId'];
        }

        if (requestParameters['issuerName'] != null) {
            queryParameters['issuer_name'] = requestParameters['issuerName'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['paymentDateAfter'] != null) {
            queryParameters['payment_date_after'] = (requestParameters['paymentDateAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paymentDateBefore'] != null) {
            queryParameters['payment_date_before'] = (requestParameters['paymentDateBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['payoutEventType'] != null) {
            queryParameters['payout_event_type'] = requestParameters['payoutEventType'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/payout-events/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminPayoutEventListFromJSON(jsonValue));
    }

    /**
     * List PayoutEvents.
     */
    async adminPayoutEventsList(requestParameters: AdminPayoutEventsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminPayoutEventList> {
        const response = await this.adminPayoutEventsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a PayoutEvent.
     * Update a PayoutEvent
     */
    async adminPayoutEventsPartialUpdateRaw(requestParameters: AdminPayoutEventsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminPayoutEventCreationOrUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminPayoutEventsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/payout-events/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminPayoutEventCreationOrUpdateRequestToJSON(requestParameters['patchedAdminPayoutEventCreationOrUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminPayoutEventCreationOrUpdateFromJSON(jsonValue));
    }

    /**
     * Update a PayoutEvent.
     * Update a PayoutEvent
     */
    async adminPayoutEventsPartialUpdate(requestParameters: AdminPayoutEventsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminPayoutEventCreationOrUpdate> {
        const response = await this.adminPayoutEventsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a PayoutEvent.
     */
    async adminPayoutEventsRetrieveRaw(requestParameters: AdminPayoutEventsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminPayoutEvent>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminPayoutEventsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/payout-events/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminPayoutEventFromJSON(jsonValue));
    }

    /**
     * Retrieve a PayoutEvent.
     */
    async adminPayoutEventsRetrieve(requestParameters: AdminPayoutEventsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminPayoutEvent> {
        const response = await this.adminPayoutEventsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminPayoutEventsValuesRetrieveRaw(requestParameters: AdminPayoutEventsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminPayoutEventsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['issuerId'] != null) {
            queryParameters['issuer_id'] = requestParameters['issuerId'];
        }

        if (requestParameters['issuerName'] != null) {
            queryParameters['issuer_name'] = requestParameters['issuerName'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['paymentDateAfter'] != null) {
            queryParameters['payment_date_after'] = (requestParameters['paymentDateAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paymentDateBefore'] != null) {
            queryParameters['payment_date_before'] = (requestParameters['paymentDateBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['payoutEventType'] != null) {
            queryParameters['payout_event_type'] = requestParameters['payoutEventType'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/payout-events/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminPayoutEventsValuesRetrieve(requestParameters: AdminPayoutEventsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminPayoutEventsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of UUIDs for objects the user can access based on the query parameters.
     * Get permitted object UUIDs
     */
    async adminPermissionsListRaw(requestParameters: AdminPermissionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdminPermissionProduct>>> {
        if (requestParameters['permission'] == null) {
            throw new runtime.RequiredError(
                'permission',
                'Required parameter "permission" was null or undefined when calling adminPermissionsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['permission'] != null) {
            queryParameters['permission'] = requestParameters['permission'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/permissions/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminPermissionProductFromJSON));
    }

    /**
     * Returns a list of UUIDs for objects the user can access based on the query parameters.
     * Get permitted object UUIDs
     */
    async adminPermissionsList(requestParameters: AdminPermissionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdminPermissionProduct>> {
        const response = await this.adminPermissionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminProductPricesDestroyRaw(requestParameters: AdminProductPricesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminProductPricesDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/product-prices/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminProductPricesDestroy(requestParameters: AdminProductPricesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminProductPricesDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminProductPricesListRaw(requestParameters: AdminProductPricesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminProductPriceList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['priceAtAfter'] != null) {
            queryParameters['price_at_after'] = (requestParameters['priceAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['priceAtBefore'] != null) {
            queryParameters['price_at_before'] = (requestParameters['priceAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['priceMax'] != null) {
            queryParameters['price_max'] = requestParameters['priceMax'];
        }

        if (requestParameters['priceMin'] != null) {
            queryParameters['price_min'] = requestParameters['priceMin'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/product-prices/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminProductPriceListFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminProductPricesList(requestParameters: AdminProductPricesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminProductPriceList> {
        const response = await this.adminProductPricesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminProductPricesRetrieveRaw(requestParameters: AdminProductPricesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductPrice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminProductPricesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/product-prices/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProductPriceFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminProductPricesRetrieve(requestParameters: AdminProductPricesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductPrice> {
        const response = await this.adminProductPricesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload market prices for a product via CSV using HTTP multipart.
     * Upload market prices via CSV
     */
    async adminProductPricesUploadCsvCreateRaw(requestParameters: AdminProductPricesUploadCsvCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductPriceCSVUploadResponse>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling adminProductPricesUploadCsvCreate().'
            );
        }

        if (requestParameters['product'] == null) {
            throw new runtime.RequiredError(
                'product',
                'Required parameter "product" was null or undefined when calling adminProductPricesUploadCsvCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['product'] != null) {
            formParams.append('product', requestParameters['product'] as any);
        }

        const response = await this.request({
            path: `/api/admin/product-prices/upload-csv/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProductPriceCSVUploadResponseFromJSON(jsonValue));
    }

    /**
     * Upload market prices for a product via CSV using HTTP multipart.
     * Upload market prices via CSV
     */
    async adminProductPricesUploadCsvCreate(requestParameters: AdminProductPricesUploadCsvCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductPriceCSVUploadResponse> {
        const response = await this.adminProductPricesUploadCsvCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a Bundesbank settlement instruction.
     */
    async adminProductsBundesbankSettlementInstructionsCreateRaw(requestParameters: AdminProductsBundesbankSettlementInstructionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminBundesbankSettlementInstruction>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminProductsBundesbankSettlementInstructionsCreate().'
            );
        }

        if (requestParameters['adminBundesbankSettlementInstructionRequest'] == null) {
            throw new runtime.RequiredError(
                'adminBundesbankSettlementInstructionRequest',
                'Required parameter "adminBundesbankSettlementInstructionRequest" was null or undefined when calling adminProductsBundesbankSettlementInstructionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/products/{id}/bundesbank-settlement-instructions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminBundesbankSettlementInstructionRequestToJSON(requestParameters['adminBundesbankSettlementInstructionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminBundesbankSettlementInstructionFromJSON(jsonValue));
    }

    /**
     * Create a Bundesbank settlement instruction.
     */
    async adminProductsBundesbankSettlementInstructionsCreate(requestParameters: AdminProductsBundesbankSettlementInstructionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminBundesbankSettlementInstruction> {
        const response = await this.adminProductsBundesbankSettlementInstructionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get calculations.
     */
    async adminProductsCalculationsRetrieveRaw(requestParameters: AdminProductsCalculationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestmentCalculation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminProductsCalculationsRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pricePerToken'] != null) {
            queryParameters['price_per_token'] = requestParameters['pricePerToken'];
        }

        if (requestParameters['requestedTokens'] != null) {
            queryParameters['requested_tokens'] = requestParameters['requestedTokens'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/products/{id}/calculations/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestmentCalculationFromJSON(jsonValue));
    }

    /**
     * Get calculations.
     */
    async adminProductsCalculationsRetrieve(requestParameters: AdminProductsCalculationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestmentCalculation> {
        const response = await this.adminProductsCalculationsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a campaign for the given product.
     */
    async adminProductsCampaignsCreateRaw(requestParameters: AdminProductsCampaignsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Campaign>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminProductsCampaignsCreate().'
            );
        }

        if (requestParameters['campaignRequest'] == null) {
            throw new runtime.RequiredError(
                'campaignRequest',
                'Required parameter "campaignRequest" was null or undefined when calling adminProductsCampaignsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/products/{id}/campaigns/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CampaignRequestToJSON(requestParameters['campaignRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignFromJSON(jsonValue));
    }

    /**
     * Create a campaign for the given product.
     */
    async adminProductsCampaignsCreate(requestParameters: AdminProductsCampaignsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Campaign> {
        const response = await this.adminProductsCampaignsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create and possibly deploy a product.
     */
    async adminProductsCreateRaw(requestParameters: AdminProductsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductDetail>> {
        if (requestParameters['adminProductCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductCreationRequest',
                'Required parameter "adminProductCreationRequest" was null or undefined when calling adminProductsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/products/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminProductCreationRequestToJSON(requestParameters['adminProductCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProductDetailFromJSON(jsonValue));
    }

    /**
     * Create and possibly deploy a product.
     */
    async adminProductsCreate(requestParameters: AdminProductsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductDetail> {
        const response = await this.adminProductsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminProductsDropdownListRaw(requestParameters: AdminProductsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['issuerId'] != null) {
            queryParameters['issuer_id'] = requestParameters['issuerId'];
        }

        if (requestParameters['issuerName'] != null) {
            queryParameters['issuer_name'] = requestParameters['issuerName'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['maxIssuableAmountMax'] != null) {
            queryParameters['max_issuable_amount_max'] = requestParameters['maxIssuableAmountMax'];
        }

        if (requestParameters['maxIssuableAmountMin'] != null) {
            queryParameters['max_issuable_amount_min'] = requestParameters['maxIssuableAmountMin'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['permission'] != null) {
            queryParameters['permission'] = requestParameters['permission'];
        }

        if (requestParameters['permissionOnIssuer'] != null) {
            queryParameters['permission_on_issuer'] = requestParameters['permissionOnIssuer'];
        }

        if (requestParameters['permissionOnOrganization'] != null) {
            queryParameters['permission_on_organization'] = requestParameters['permissionOnOrganization'];
        }

        if (requestParameters['productType'] != null) {
            queryParameters['product_type'] = requestParameters['productType'];
        }

        if (requestParameters['publicationValid'] != null) {
            queryParameters['publication_valid'] = requestParameters['publicationValid'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['totalVolumeMax'] != null) {
            queryParameters['total_volume_max'] = requestParameters['totalVolumeMax'];
        }

        if (requestParameters['totalVolumeMin'] != null) {
            queryParameters['total_volume_min'] = requestParameters['totalVolumeMin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/products/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminProductsDropdownList(requestParameters: AdminProductsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminProductsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an investment invitation.
     */
    async adminProductsInvitationCreateRaw(requestParameters: AdminProductsInvitationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestmentInvitation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminProductsInvitationCreate().'
            );
        }

        if (requestParameters['investmentInvitationCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'investmentInvitationCreationRequest',
                'Required parameter "investmentInvitationCreationRequest" was null or undefined when calling adminProductsInvitationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/products/{id}/invitation/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvestmentInvitationCreationRequestToJSON(requestParameters['investmentInvitationCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestmentInvitationFromJSON(jsonValue));
    }

    /**
     * Create an investment invitation.
     */
    async adminProductsInvitationCreate(requestParameters: AdminProductsInvitationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestmentInvitation> {
        const response = await this.adminProductsInvitationCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get issuer rules.
     */
    async adminProductsInvitationRulesListRaw(requestParameters: AdminProductsInvitationRulesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IssuerInvestmentRules>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminProductsInvitationRulesList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/products/{id}/invitation-rules/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IssuerInvestmentRulesFromJSON));
    }

    /**
     * Get issuer rules.
     */
    async adminProductsInvitationRulesList(requestParameters: AdminProductsInvitationRulesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IssuerInvestmentRules>> {
        const response = await this.adminProductsInvitationRulesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add new issuance document.  Depending on the product state, this does different things:  1. For non-ewpg products and products in the created/validation_rejected state,    the old issuance document is removed and the new one gets the    version the old one had. You MUST NOT pass a change_type. 2. For ewpg products in the state succeeded, you MUST pass a change_type.    Here we create a new version and upload the new document.
     */
    async adminProductsIssuanceDocumentCreateRaw(requestParameters: AdminProductsIssuanceDocumentCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminVersionedIssuanceDocument>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminProductsIssuanceDocumentCreate().'
            );
        }

        if (requestParameters['adminVersionedIssuanceDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'adminVersionedIssuanceDocumentRequest',
                'Required parameter "adminVersionedIssuanceDocumentRequest" was null or undefined when calling adminProductsIssuanceDocumentCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/products/{id}/issuance-document/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminVersionedIssuanceDocumentRequestToJSON(requestParameters['adminVersionedIssuanceDocumentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminVersionedIssuanceDocumentFromJSON(jsonValue));
    }

    /**
     * Add new issuance document.  Depending on the product state, this does different things:  1. For non-ewpg products and products in the created/validation_rejected state,    the old issuance document is removed and the new one gets the    version the old one had. You MUST NOT pass a change_type. 2. For ewpg products in the state succeeded, you MUST pass a change_type.    Here we create a new version and upload the new document.
     */
    async adminProductsIssuanceDocumentCreate(requestParameters: AdminProductsIssuanceDocumentCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminVersionedIssuanceDocument> {
        const response = await this.adminProductsIssuanceDocumentCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List Products.
     */
    async adminProductsListRaw(requestParameters: AdminProductsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminProductListingList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['issuerId'] != null) {
            queryParameters['issuer_id'] = requestParameters['issuerId'];
        }

        if (requestParameters['issuerName'] != null) {
            queryParameters['issuer_name'] = requestParameters['issuerName'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['maxIssuableAmountMax'] != null) {
            queryParameters['max_issuable_amount_max'] = requestParameters['maxIssuableAmountMax'];
        }

        if (requestParameters['maxIssuableAmountMin'] != null) {
            queryParameters['max_issuable_amount_min'] = requestParameters['maxIssuableAmountMin'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['permission'] != null) {
            queryParameters['permission'] = requestParameters['permission'];
        }

        if (requestParameters['permissionOnIssuer'] != null) {
            queryParameters['permission_on_issuer'] = requestParameters['permissionOnIssuer'];
        }

        if (requestParameters['permissionOnOrganization'] != null) {
            queryParameters['permission_on_organization'] = requestParameters['permissionOnOrganization'];
        }

        if (requestParameters['productType'] != null) {
            queryParameters['product_type'] = requestParameters['productType'];
        }

        if (requestParameters['publicationValid'] != null) {
            queryParameters['publication_valid'] = requestParameters['publicationValid'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['totalVolumeMax'] != null) {
            queryParameters['total_volume_max'] = requestParameters['totalVolumeMax'];
        }

        if (requestParameters['totalVolumeMin'] != null) {
            queryParameters['total_volume_min'] = requestParameters['totalVolumeMin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/products/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminProductListingListFromJSON(jsonValue));
    }

    /**
     * List Products.
     */
    async adminProductsList(requestParameters: AdminProductsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminProductListingList> {
        const response = await this.adminProductsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get overview of token (product).
     */
    async adminProductsOverviewRetrieveRaw(requestParameters: AdminProductsOverviewRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductOverview>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminProductsOverviewRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/products/{id}/overview/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProductOverviewFromJSON(jsonValue));
    }

    /**
     * Get overview of token (product).
     */
    async adminProductsOverviewRetrieve(requestParameters: AdminProductsOverviewRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductOverview> {
        const response = await this.adminProductsOverviewRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a product.  For updating the issuance document, you have to use the /issuance-document/ endpoint.
     * Update a product
     */
    async adminProductsPartialUpdateRaw(requestParameters: AdminProductsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminProductsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/products/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminProductDetailRequestToJSON(requestParameters['patchedAdminProductDetailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProductDetailFromJSON(jsonValue));
    }

    /**
     * Update a product.  For updating the issuance document, you have to use the /issuance-document/ endpoint.
     * Update a product
     */
    async adminProductsPartialUpdate(requestParameters: AdminProductsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductDetail> {
        const response = await this.adminProductsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a product.
     */
    async adminProductsRetrieveRaw(requestParameters: AdminProductsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminProductsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/products/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProductDetailFromJSON(jsonValue));
    }

    /**
     * Retrieve a product.
     */
    async adminProductsRetrieve(requestParameters: AdminProductsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductDetail> {
        const response = await this.adminProductsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminProductsValuesRetrieveRaw(requestParameters: AdminProductsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminProductsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['issuerId'] != null) {
            queryParameters['issuer_id'] = requestParameters['issuerId'];
        }

        if (requestParameters['issuerName'] != null) {
            queryParameters['issuer_name'] = requestParameters['issuerName'];
        }

        if (requestParameters['maxIssuableAmountMax'] != null) {
            queryParameters['max_issuable_amount_max'] = requestParameters['maxIssuableAmountMax'];
        }

        if (requestParameters['maxIssuableAmountMin'] != null) {
            queryParameters['max_issuable_amount_min'] = requestParameters['maxIssuableAmountMin'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['permission'] != null) {
            queryParameters['permission'] = requestParameters['permission'];
        }

        if (requestParameters['permissionOnIssuer'] != null) {
            queryParameters['permission_on_issuer'] = requestParameters['permissionOnIssuer'];
        }

        if (requestParameters['permissionOnOrganization'] != null) {
            queryParameters['permission_on_organization'] = requestParameters['permissionOnOrganization'];
        }

        if (requestParameters['productType'] != null) {
            queryParameters['product_type'] = requestParameters['productType'];
        }

        if (requestParameters['publicationValid'] != null) {
            queryParameters['publication_valid'] = requestParameters['publicationValid'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['totalVolumeMax'] != null) {
            queryParameters['total_volume_max'] = requestParameters['totalVolumeMax'];
        }

        if (requestParameters['totalVolumeMin'] != null) {
            queryParameters['total_volume_min'] = requestParameters['totalVolumeMin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/products/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminProductsValuesRetrieve(requestParameters: AdminProductsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminProductsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a redemption.
     */
    async adminRedemptionsCreateRaw(requestParameters: AdminRedemptionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminRedemption>> {
        if (requestParameters['redemptionRequest'] == null) {
            throw new runtime.RequiredError(
                'redemptionRequest',
                'Required parameter "redemptionRequest" was null or undefined when calling adminRedemptionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/redemptions/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RedemptionRequestToJSON(requestParameters['redemptionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminRedemptionFromJSON(jsonValue));
    }

    /**
     * Create a redemption.
     */
    async adminRedemptionsCreate(requestParameters: AdminRedemptionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminRedemption> {
        const response = await this.adminRedemptionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminRedemptionsDropdownListRaw(requestParameters: AdminRedemptionsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['transactionTimestampAfter'] != null) {
            queryParameters['transaction_timestamp_after'] = (requestParameters['transactionTimestampAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['transactionTimestampBefore'] != null) {
            queryParameters['transaction_timestamp_before'] = (requestParameters['transactionTimestampBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['unitsMax'] != null) {
            queryParameters['units_max'] = requestParameters['unitsMax'];
        }

        if (requestParameters['unitsMin'] != null) {
            queryParameters['units_min'] = requestParameters['unitsMin'];
        }

        if (requestParameters['walletAddress'] != null) {
            queryParameters['wallet_address'] = requestParameters['walletAddress'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/redemptions/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminRedemptionsDropdownList(requestParameters: AdminRedemptionsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminRedemptionsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List Redemptions.
     */
    async adminRedemptionsListRaw(requestParameters: AdminRedemptionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedRedemptionListList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['transactionTimestampAfter'] != null) {
            queryParameters['transaction_timestamp_after'] = (requestParameters['transactionTimestampAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['transactionTimestampBefore'] != null) {
            queryParameters['transaction_timestamp_before'] = (requestParameters['transactionTimestampBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['unitsMax'] != null) {
            queryParameters['units_max'] = requestParameters['unitsMax'];
        }

        if (requestParameters['unitsMin'] != null) {
            queryParameters['units_min'] = requestParameters['unitsMin'];
        }

        if (requestParameters['walletAddress'] != null) {
            queryParameters['wallet_address'] = requestParameters['walletAddress'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/redemptions/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedRedemptionListListFromJSON(jsonValue));
    }

    /**
     * List Redemptions.
     */
    async adminRedemptionsList(requestParameters: AdminRedemptionsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedRedemptionListList> {
        const response = await this.adminRedemptionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a redemption.
     */
    async adminRedemptionsRetrieveRaw(requestParameters: AdminRedemptionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminRedemption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminRedemptionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/redemptions/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminRedemptionFromJSON(jsonValue));
    }

    /**
     * Retrieve a redemption.
     */
    async adminRedemptionsRetrieve(requestParameters: AdminRedemptionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminRedemption> {
        const response = await this.adminRedemptionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminRedemptionsValuesRetrieveRaw(requestParameters: AdminRedemptionsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminRedemptionsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['transactionTimestampAfter'] != null) {
            queryParameters['transaction_timestamp_after'] = (requestParameters['transactionTimestampAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['transactionTimestampBefore'] != null) {
            queryParameters['transaction_timestamp_before'] = (requestParameters['transactionTimestampBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['unitsMax'] != null) {
            queryParameters['units_max'] = requestParameters['unitsMax'];
        }

        if (requestParameters['unitsMin'] != null) {
            queryParameters['units_min'] = requestParameters['unitsMin'];
        }

        if (requestParameters['walletAddress'] != null) {
            queryParameters['wallet_address'] = requestParameters['walletAddress'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/redemptions/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminRedemptionsValuesRetrieve(requestParameters: AdminRedemptionsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminRedemptionsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminServiceContractsDropdownListRaw(requestParameters: AdminServiceContractsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['displayName'] != null) {
            queryParameters['display_name'] = requestParameters['displayName'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['technicalName'] != null) {
            queryParameters['technical_name'] = requestParameters['technicalName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/service-contracts/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminServiceContractsDropdownList(requestParameters: AdminServiceContractsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminServiceContractsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List ServiceContracts.
     */
    async adminServiceContractsListRaw(requestParameters: AdminServiceContractsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminServiceContractList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['displayName'] != null) {
            queryParameters['display_name'] = requestParameters['displayName'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['technicalName'] != null) {
            queryParameters['technical_name'] = requestParameters['technicalName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/service-contracts/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminServiceContractListFromJSON(jsonValue));
    }

    /**
     * List ServiceContracts.
     */
    async adminServiceContractsList(requestParameters: AdminServiceContractsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminServiceContractList> {
        const response = await this.adminServiceContractsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a service contract.
     */
    async adminServiceContractsRetrieveRaw(requestParameters: AdminServiceContractsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminServiceContract>> {
        if (requestParameters['technicalName'] == null) {
            throw new runtime.RequiredError(
                'technicalName',
                'Required parameter "technicalName" was null or undefined when calling adminServiceContractsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/service-contracts/{technical_name}/`.replace(`{${"technical_name"}}`, encodeURIComponent(String(requestParameters['technicalName']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminServiceContractFromJSON(jsonValue));
    }

    /**
     * Retrieve a service contract.
     */
    async adminServiceContractsRetrieve(requestParameters: AdminServiceContractsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminServiceContract> {
        const response = await this.adminServiceContractsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminServiceContractsValuesRetrieveRaw(requestParameters: AdminServiceContractsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminServiceContractsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['displayName'] != null) {
            queryParameters['display_name'] = requestParameters['displayName'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['technicalName'] != null) {
            queryParameters['technical_name'] = requestParameters['technicalName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/service-contracts/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminServiceContractsValuesRetrieve(requestParameters: AdminServiceContractsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminServiceContractsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Only allow one Report to be generated at a time If a report is running longer then settings.STATISTICS_REPORT_TIMEOUT mark it as not succeeded
     */
    async adminStatisticsReportRetrieveRaw(requestParameters: AdminStatisticsReportRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Statistics>> {
        if (requestParameters['reportType'] == null) {
            throw new runtime.RequiredError(
                'reportType',
                'Required parameter "reportType" was null or undefined when calling adminStatisticsReportRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['reportType'] != null) {
            queryParameters['report_type'] = requestParameters['reportType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/statistics-report/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatisticsFromJSON(jsonValue));
    }

    /**
     * Only allow one Report to be generated at a time If a report is running longer then settings.STATISTICS_REPORT_TIMEOUT mark it as not succeeded
     */
    async adminStatisticsReportRetrieve(requestParameters: AdminStatisticsReportRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Statistics> {
        const response = await this.adminStatisticsReportRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a User Permission
     */
    async adminUserPermissionsCreateRaw(requestParameters: AdminUserPermissionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminUserPermission>> {
        if (requestParameters['adminUserPermissionRequest'] == null) {
            throw new runtime.RequiredError(
                'adminUserPermissionRequest',
                'Required parameter "adminUserPermissionRequest" was null or undefined when calling adminUserPermissionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/user-permissions/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminUserPermissionRequestToJSON(requestParameters['adminUserPermissionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminUserPermissionFromJSON(jsonValue));
    }

    /**
     * Create a User Permission
     */
    async adminUserPermissionsCreate(requestParameters: AdminUserPermissionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminUserPermission> {
        const response = await this.adminUserPermissionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete the given User Permission.
     */
    async adminUserPermissionsDestroyRaw(requestParameters: AdminUserPermissionsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminUserPermissionsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/user-permissions/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the given User Permission.
     */
    async adminUserPermissionsDestroy(requestParameters: AdminUserPermissionsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminUserPermissionsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminUserPermissionsDropdownListRaw(requestParameters: AdminUserPermissionsDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['objectId'] != null) {
            queryParameters['object_id'] = requestParameters['objectId'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['permissionCode'] != null) {
            queryParameters['permission_code'] = requestParameters['permissionCode'];
        }

        if (requestParameters['permissionType'] != null) {
            queryParameters['permission_type'] = requestParameters['permissionType'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        if (requestParameters['validForName'] != null) {
            queryParameters['valid_for_name'] = requestParameters['validForName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/user-permissions/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminUserPermissionsDropdownList(requestParameters: AdminUserPermissionsDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminUserPermissionsDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all explicitly given permissions a given user has.  Do not list the permissions the user has through a group.
     */
    async adminUserPermissionsListRaw(requestParameters: AdminUserPermissionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminUserPermissionList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['objectId'] != null) {
            queryParameters['object_id'] = requestParameters['objectId'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['permissionCode'] != null) {
            queryParameters['permission_code'] = requestParameters['permissionCode'];
        }

        if (requestParameters['permissionType'] != null) {
            queryParameters['permission_type'] = requestParameters['permissionType'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        if (requestParameters['validForName'] != null) {
            queryParameters['valid_for_name'] = requestParameters['validForName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/user-permissions/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminUserPermissionListFromJSON(jsonValue));
    }

    /**
     * List all explicitly given permissions a given user has.  Do not list the permissions the user has through a group.
     */
    async adminUserPermissionsList(requestParameters: AdminUserPermissionsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminUserPermissionList> {
        const response = await this.adminUserPermissionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminUserPermissionsValuesRetrieveRaw(requestParameters: AdminUserPermissionsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminUserPermissionsValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['objectId'] != null) {
            queryParameters['object_id'] = requestParameters['objectId'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['permissionCode'] != null) {
            queryParameters['permission_code'] = requestParameters['permissionCode'];
        }

        if (requestParameters['permissionType'] != null) {
            queryParameters['permission_type'] = requestParameters['permissionType'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        if (requestParameters['validForName'] != null) {
            queryParameters['valid_for_name'] = requestParameters['validForName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/user-permissions/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminUserPermissionsValuesRetrieve(requestParameters: AdminUserPermissionsValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminUserPermissionsValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create admin user.
     */
    async adminUsersCreateRaw(requestParameters: AdminUsersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminUserCreation>> {
        if (requestParameters['adminUserCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminUserCreationRequest',
                'Required parameter "adminUserCreationRequest" was null or undefined when calling adminUsersCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/users/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminUserCreationRequestToJSON(requestParameters['adminUserCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminUserCreationFromJSON(jsonValue));
    }

    /**
     * Create admin user.
     */
    async adminUsersCreate(requestParameters: AdminUsersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminUserCreation> {
        const response = await this.adminUsersCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminUsersDropdownListRaw(requestParameters: AdminUsersDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dateJoinedAfter'] != null) {
            queryParameters['date_joined_after'] = (requestParameters['dateJoinedAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dateJoinedBefore'] != null) {
            queryParameters['date_joined_before'] = (requestParameters['dateJoinedBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['groups'] != null) {
            queryParameters['groups'] = requestParameters['groups'];
        }

        if (requestParameters['groupsExclude'] != null) {
            queryParameters['groups_exclude'] = requestParameters['groupsExclude'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['is_active'] = requestParameters['isActive'];
        }

        if (requestParameters['lastLoginAfter'] != null) {
            queryParameters['last_login_after'] = (requestParameters['lastLoginAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['lastLoginBefore'] != null) {
            queryParameters['last_login_before'] = (requestParameters['lastLoginBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['organization'] != null) {
            queryParameters['organization'] = requestParameters['organization'];
        }

        if (requestParameters['organizationName'] != null) {
            queryParameters['organization_name'] = requestParameters['organizationName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/users/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminUsersDropdownList(requestParameters: AdminUsersDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminUsersDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List admin Users.
     */
    async adminUsersListRaw(requestParameters: AdminUsersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminUserListList>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dateJoinedAfter'] != null) {
            queryParameters['date_joined_after'] = (requestParameters['dateJoinedAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dateJoinedBefore'] != null) {
            queryParameters['date_joined_before'] = (requestParameters['dateJoinedBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        if (requestParameters['groups'] != null) {
            queryParameters['groups'] = requestParameters['groups'];
        }

        if (requestParameters['groupsExclude'] != null) {
            queryParameters['groups_exclude'] = requestParameters['groupsExclude'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['is_active'] = requestParameters['isActive'];
        }

        if (requestParameters['lastLoginAfter'] != null) {
            queryParameters['last_login_after'] = (requestParameters['lastLoginAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['lastLoginBefore'] != null) {
            queryParameters['last_login_before'] = (requestParameters['lastLoginBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['organization'] != null) {
            queryParameters['organization'] = requestParameters['organization'];
        }

        if (requestParameters['organizationName'] != null) {
            queryParameters['organization_name'] = requestParameters['organizationName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/users/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminUserListListFromJSON(jsonValue));
    }

    /**
     * List admin Users.
     */
    async adminUsersList(requestParameters: AdminUsersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminUserListList> {
        const response = await this.adminUsersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an User.
     * Update a user
     */
    async adminUsersPartialUpdateRaw(requestParameters: AdminUsersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminUserPartialUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminUsersPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/users/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminUserPartialUpdateRequestToJSON(requestParameters['patchedAdminUserPartialUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminUserPartialUpdateFromJSON(jsonValue));
    }

    /**
     * Update an User.
     * Update a user
     */
    async adminUsersPartialUpdate(requestParameters: AdminUsersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminUserPartialUpdate> {
        const response = await this.adminUsersPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Trigger re-sending the activation email USER_ORGANIZATION_INVITATION.
     */
    async adminUsersResendInvitationCreateRaw(requestParameters: AdminUsersResendInvitationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminUsersResendInvitationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/users/{id}/resend-invitation/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Trigger re-sending the activation email USER_ORGANIZATION_INVITATION.
     */
    async adminUsersResendInvitationCreate(requestParameters: AdminUsersResendInvitationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminUsersResendInvitationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve an admin user.
     */
    async adminUsersRetrieveRaw(requestParameters: AdminUsersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminUserRetrieve>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminUsersRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/users/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminUserRetrieveFromJSON(jsonValue));
    }

    /**
     * Retrieve an admin user.
     */
    async adminUsersRetrieve(requestParameters: AdminUsersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminUserRetrieve> {
        const response = await this.adminUsersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminUsersValuesRetrieveRaw(requestParameters: AdminUsersValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminUsersValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dateJoinedAfter'] != null) {
            queryParameters['date_joined_after'] = (requestParameters['dateJoinedAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dateJoinedBefore'] != null) {
            queryParameters['date_joined_before'] = (requestParameters['dateJoinedBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['groups'] != null) {
            queryParameters['groups'] = requestParameters['groups'];
        }

        if (requestParameters['groupsExclude'] != null) {
            queryParameters['groups_exclude'] = requestParameters['groupsExclude'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['is_active'] = requestParameters['isActive'];
        }

        if (requestParameters['lastLoginAfter'] != null) {
            queryParameters['last_login_after'] = (requestParameters['lastLoginAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['lastLoginBefore'] != null) {
            queryParameters['last_login_before'] = (requestParameters['lastLoginBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['organization'] != null) {
            queryParameters['organization'] = requestParameters['organization'];
        }

        if (requestParameters['organizationName'] != null) {
            queryParameters['organization_name'] = requestParameters['organizationName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/users/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminUsersValuesRetrieve(requestParameters: AdminUsersValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminUsersValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Activate voucher.
     */
    async adminVouchersActivationCreateRaw(requestParameters: AdminVouchersActivationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminVouchersActivationCreate().'
            );
        }

        if (requestParameters['adminVoucherRequest'] == null) {
            throw new runtime.RequiredError(
                'adminVoucherRequest',
                'Required parameter "adminVoucherRequest" was null or undefined when calling adminVouchersActivationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/vouchers/{id}/activation/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminVoucherRequestToJSON(requestParameters['adminVoucherRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Activate voucher.
     */
    async adminVouchersActivationCreate(requestParameters: AdminVouchersActivationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminVouchersActivationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Create voucher.
     */
    async adminVouchersCreateRaw(requestParameters: AdminVouchersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminVoucherCreation>> {
        if (requestParameters['adminVoucherCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminVoucherCreationRequest',
                'Required parameter "adminVoucherCreationRequest" was null or undefined when calling adminVouchersCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/vouchers/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminVoucherCreationRequestToJSON(requestParameters['adminVoucherCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminVoucherCreationFromJSON(jsonValue));
    }

    /**
     * Create voucher.
     */
    async adminVouchersCreate(requestParameters: AdminVouchersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminVoucherCreation> {
        const response = await this.adminVouchersCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminVouchersDropdownListRaw(requestParameters: AdminVouchersDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['alreadyUsedMax'] != null) {
            queryParameters['already_used_max'] = requestParameters['alreadyUsedMax'];
        }

        if (requestParameters['alreadyUsedMin'] != null) {
            queryParameters['already_used_min'] = requestParameters['alreadyUsedMin'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['owningInvestorName'] != null) {
            queryParameters['owning_investor_name'] = requestParameters['owningInvestorName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/vouchers/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async adminVouchersDropdownList(requestParameters: AdminVouchersDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.adminVouchersDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminVouchersListRaw(requestParameters: AdminVouchersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminVoucherList>> {
        const queryParameters: any = {};

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['alreadyUsedMax'] != null) {
            queryParameters['already_used_max'] = requestParameters['alreadyUsedMax'];
        }

        if (requestParameters['alreadyUsedMin'] != null) {
            queryParameters['already_used_min'] = requestParameters['alreadyUsedMin'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['owningInvestorName'] != null) {
            queryParameters['owning_investor_name'] = requestParameters['owningInvestorName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/vouchers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminVoucherListFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminVouchersList(requestParameters: AdminVouchersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminVoucherList> {
        const response = await this.adminVouchersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a voucher.
     */
    async adminVouchersPartialUpdateRaw(requestParameters: AdminVouchersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminVouchersPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/vouchers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminVoucherUpdateRequestToJSON(requestParameters['patchedAdminVoucherUpdateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a voucher.
     */
    async adminVouchersPartialUpdate(requestParameters: AdminVouchersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminVouchersPartialUpdateRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve a voucher.
     */
    async adminVouchersRetrieveRaw(requestParameters: AdminVouchersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminVoucherDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminVouchersRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/vouchers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminVoucherDetailFromJSON(jsonValue));
    }

    /**
     * Retrieve a voucher.
     */
    async adminVouchersRetrieve(requestParameters: AdminVouchersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminVoucherDetail> {
        const response = await this.adminVouchersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Given a voucher\'s code, and investor and a product; it responds whether it is a valid code or not.
     */
    async adminVouchersValidatorCreateRaw(requestParameters: AdminVouchersValidatorCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminVoucherValidator>> {
        if (requestParameters['adminVoucherValidatorRequest'] == null) {
            throw new runtime.RequiredError(
                'adminVoucherValidatorRequest',
                'Required parameter "adminVoucherValidatorRequest" was null or undefined when calling adminVouchersValidatorCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/vouchers/validator/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminVoucherValidatorRequestToJSON(requestParameters['adminVoucherValidatorRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminVoucherValidatorFromJSON(jsonValue));
    }

    /**
     * Given a voucher\'s code, and investor and a product; it responds whether it is a valid code or not.
     */
    async adminVouchersValidatorCreate(requestParameters: AdminVouchersValidatorCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminVoucherValidator> {
        const response = await this.adminVouchersValidatorCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminVouchersValuesRetrieveRaw(requestParameters: AdminVouchersValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling adminVouchersValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['alreadyUsedMax'] != null) {
            queryParameters['already_used_max'] = requestParameters['alreadyUsedMax'];
        }

        if (requestParameters['alreadyUsedMin'] != null) {
            queryParameters['already_used_min'] = requestParameters['alreadyUsedMin'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['owningInvestorName'] != null) {
            queryParameters['owning_investor_name'] = requestParameters['owningInvestorName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/vouchers/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async adminVouchersValuesRetrieve(requestParameters: AdminVouchersValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.adminVouchersValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List voucher steps.
     */
    async adminVouchersVoucherStepsCreateRaw(requestParameters: AdminVouchersVoucherStepsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdminVoucherStep>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminVouchersVoucherStepsCreate().'
            );
        }

        if (requestParameters['adminVoucherStepBulkCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'adminVoucherStepBulkCreateRequest',
                'Required parameter "adminVoucherStepBulkCreateRequest" was null or undefined when calling adminVouchersVoucherStepsCreate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/vouchers/{id}/voucher-steps/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminVoucherStepBulkCreateRequestToJSON(requestParameters['adminVoucherStepBulkCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminVoucherStepFromJSON));
    }

    /**
     * List voucher steps.
     */
    async adminVouchersVoucherStepsCreate(requestParameters: AdminVouchersVoucherStepsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdminVoucherStep>> {
        const response = await this.adminVouchersVoucherStepsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List voucher steps.
     */
    async adminVouchersVoucherStepsListRaw(requestParameters: AdminVouchersVoucherStepsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdminVoucherStep>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminVouchersVoucherStepsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/vouchers/{id}/voucher-steps/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminVoucherStepFromJSON));
    }

    /**
     * List voucher steps.
     */
    async adminVouchersVoucherStepsList(requestParameters: AdminVouchersVoucherStepsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdminVoucherStep>> {
        const response = await this.adminVouchersVoucherStepsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async adminWalletsRetrieveRaw(requestParameters: AdminWalletsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminWallet>> {
        if (requestParameters['address'] == null) {
            throw new runtime.RequiredError(
                'address',
                'Required parameter "address" was null or undefined when calling adminWalletsRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['address'] != null) {
            queryParameters['address'] = requestParameters['address'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/wallets/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminWalletFromJSON(jsonValue));
    }

    /**
     */
    async adminWalletsRetrieve(requestParameters: AdminWalletsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminWallet> {
        const response = await this.adminWalletsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const AdminApiConnectionsDropdownListApiTypeEnum = {
    DISTRIBUTOR_API: 'DISTRIBUTOR_API',
    ISSUER_API: 'ISSUER_API'
} as const;
export type AdminApiConnectionsDropdownListApiTypeEnum = typeof AdminApiConnectionsDropdownListApiTypeEnum[keyof typeof AdminApiConnectionsDropdownListApiTypeEnum];
/**
 * @export
 */
export const AdminApiConnectionsDropdownListFieldEnum = {
    CLIENT_ID: 'client_id',
    NAME: 'name'
} as const;
export type AdminApiConnectionsDropdownListFieldEnum = typeof AdminApiConnectionsDropdownListFieldEnum[keyof typeof AdminApiConnectionsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminApiConnectionsDropdownListOrderingEnum = {
    API_TYPE_DESC: '-api_type',
    API_TYPE_ASC: 'api_type',
    CLIENT_ID_DESC: '-client_id',
    CLIENT_ID_ASC: 'client_id',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NAME_DESC: '-name',
    NAME_ASC: 'name'
} as const;
export type AdminApiConnectionsDropdownListOrderingEnum = typeof AdminApiConnectionsDropdownListOrderingEnum[keyof typeof AdminApiConnectionsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminApiConnectionsDropdownListTypeEnum = {
    DISTRIBUTOR_API: 'DISTRIBUTOR_API',
    ISSUER_API: 'ISSUER_API'
} as const;
export type AdminApiConnectionsDropdownListTypeEnum = typeof AdminApiConnectionsDropdownListTypeEnum[keyof typeof AdminApiConnectionsDropdownListTypeEnum];
/**
 * @export
 */
export const AdminApiConnectionsListApiTypeEnum = {
    DISTRIBUTOR_API: 'DISTRIBUTOR_API',
    ISSUER_API: 'ISSUER_API'
} as const;
export type AdminApiConnectionsListApiTypeEnum = typeof AdminApiConnectionsListApiTypeEnum[keyof typeof AdminApiConnectionsListApiTypeEnum];
/**
 * @export
 */
export const AdminApiConnectionsListOrderingEnum = {
    API_TYPE_DESC: '-api_type',
    API_TYPE_ASC: 'api_type',
    CLIENT_ID_DESC: '-client_id',
    CLIENT_ID_ASC: 'client_id',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NAME_DESC: '-name',
    NAME_ASC: 'name'
} as const;
export type AdminApiConnectionsListOrderingEnum = typeof AdminApiConnectionsListOrderingEnum[keyof typeof AdminApiConnectionsListOrderingEnum];
/**
 * @export
 */
export const AdminApiConnectionsListTypeEnum = {
    DISTRIBUTOR_API: 'DISTRIBUTOR_API',
    ISSUER_API: 'ISSUER_API'
} as const;
export type AdminApiConnectionsListTypeEnum = typeof AdminApiConnectionsListTypeEnum[keyof typeof AdminApiConnectionsListTypeEnum];
/**
 * @export
 */
export const AdminApiConnectionsValuesRetrieveFieldEnum = {
    CLIENT_ID: 'client_id',
    NAME: 'name'
} as const;
export type AdminApiConnectionsValuesRetrieveFieldEnum = typeof AdminApiConnectionsValuesRetrieveFieldEnum[keyof typeof AdminApiConnectionsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminApiConnectionsValuesRetrieveApiTypeEnum = {
    DISTRIBUTOR_API: 'DISTRIBUTOR_API',
    ISSUER_API: 'ISSUER_API'
} as const;
export type AdminApiConnectionsValuesRetrieveApiTypeEnum = typeof AdminApiConnectionsValuesRetrieveApiTypeEnum[keyof typeof AdminApiConnectionsValuesRetrieveApiTypeEnum];
/**
 * @export
 */
export const AdminApiConnectionsValuesRetrieveOrderingEnum = {
    API_TYPE_DESC: '-api_type',
    API_TYPE_ASC: 'api_type',
    CLIENT_ID_DESC: '-client_id',
    CLIENT_ID_ASC: 'client_id',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NAME_DESC: '-name',
    NAME_ASC: 'name'
} as const;
export type AdminApiConnectionsValuesRetrieveOrderingEnum = typeof AdminApiConnectionsValuesRetrieveOrderingEnum[keyof typeof AdminApiConnectionsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminApiConnectionsValuesRetrieveTypeEnum = {
    DISTRIBUTOR_API: 'DISTRIBUTOR_API',
    ISSUER_API: 'ISSUER_API'
} as const;
export type AdminApiConnectionsValuesRetrieveTypeEnum = typeof AdminApiConnectionsValuesRetrieveTypeEnum[keyof typeof AdminApiConnectionsValuesRetrieveTypeEnum];
/**
 * @export
 */
export const AdminBundesbankSettlementInstructionsDropdownListFieldEnum = {
    CORRELATION_ID: 'correlation_id'
} as const;
export type AdminBundesbankSettlementInstructionsDropdownListFieldEnum = typeof AdminBundesbankSettlementInstructionsDropdownListFieldEnum[keyof typeof AdminBundesbankSettlementInstructionsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminBundesbankSettlementInstructionsDropdownListOrderingEnum = {
    CORRELATION_ID_DESC: '-correlation_id',
    CORRELATION_ID_ASC: 'correlation_id',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    PAYMENT_AMOUNT_DESC: '-payment_amount',
    PAYMENT_AMOUNT_ASC: 'payment_amount',
    PRODUCT_AMOUNT_DESC: '-product_amount',
    PRODUCT_AMOUNT_ASC: 'product_amount',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status'
} as const;
export type AdminBundesbankSettlementInstructionsDropdownListOrderingEnum = typeof AdminBundesbankSettlementInstructionsDropdownListOrderingEnum[keyof typeof AdminBundesbankSettlementInstructionsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminBundesbankSettlementInstructionsListOrderingEnum = {
    CORRELATION_ID_DESC: '-correlation_id',
    CORRELATION_ID_ASC: 'correlation_id',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    PAYMENT_AMOUNT_DESC: '-payment_amount',
    PAYMENT_AMOUNT_ASC: 'payment_amount',
    PRODUCT_AMOUNT_DESC: '-product_amount',
    PRODUCT_AMOUNT_ASC: 'product_amount',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status'
} as const;
export type AdminBundesbankSettlementInstructionsListOrderingEnum = typeof AdminBundesbankSettlementInstructionsListOrderingEnum[keyof typeof AdminBundesbankSettlementInstructionsListOrderingEnum];
/**
 * @export
 */
export const AdminBundesbankSettlementInstructionsValuesRetrieveFieldEnum = {
    CORRELATION_ID: 'correlation_id'
} as const;
export type AdminBundesbankSettlementInstructionsValuesRetrieveFieldEnum = typeof AdminBundesbankSettlementInstructionsValuesRetrieveFieldEnum[keyof typeof AdminBundesbankSettlementInstructionsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminBundesbankSettlementInstructionsValuesRetrieveOrderingEnum = {
    CORRELATION_ID_DESC: '-correlation_id',
    CORRELATION_ID_ASC: 'correlation_id',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    PAYMENT_AMOUNT_DESC: '-payment_amount',
    PAYMENT_AMOUNT_ASC: 'payment_amount',
    PRODUCT_AMOUNT_DESC: '-product_amount',
    PRODUCT_AMOUNT_ASC: 'product_amount',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status'
} as const;
export type AdminBundesbankSettlementInstructionsValuesRetrieveOrderingEnum = typeof AdminBundesbankSettlementInstructionsValuesRetrieveOrderingEnum[keyof typeof AdminBundesbankSettlementInstructionsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminCampaignsDropdownListFieldEnum = {
    DISTRIBUTION_PLATFORM: 'distribution_platform',
    NAME: 'name'
} as const;
export type AdminCampaignsDropdownListFieldEnum = typeof AdminCampaignsDropdownListFieldEnum[keyof typeof AdminCampaignsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminCampaignsDropdownListOrderingEnum = {
    ACTIVE_DESC: '-active',
    ACTIVE_ASC: 'active',
    ALLOCATION_AVAILABLE_DESC: '-allocation_available',
    ALLOCATION_AVAILABLE_ASC: 'allocation_available',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DESC: '-distribution_platform',
    DISTRIBUTION_PLATFORM_ASC: 'distribution_platform',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    PRICE_PER_UNIT_DESC: '-price_per_unit',
    PRICE_PER_UNIT_ASC: 'price_per_unit',
    SIGNED_PERCENTAGE_DESC: '-signed_percentage',
    SIGNED_PERCENTAGE_ASC: 'signed_percentage'
} as const;
export type AdminCampaignsDropdownListOrderingEnum = typeof AdminCampaignsDropdownListOrderingEnum[keyof typeof AdminCampaignsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminCampaignsListOrderingEnum = {
    ACTIVE_DESC: '-active',
    ACTIVE_ASC: 'active',
    ALLOCATION_AVAILABLE_DESC: '-allocation_available',
    ALLOCATION_AVAILABLE_ASC: 'allocation_available',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DESC: '-distribution_platform',
    DISTRIBUTION_PLATFORM_ASC: 'distribution_platform',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    PRICE_PER_UNIT_DESC: '-price_per_unit',
    PRICE_PER_UNIT_ASC: 'price_per_unit',
    SIGNED_PERCENTAGE_DESC: '-signed_percentage',
    SIGNED_PERCENTAGE_ASC: 'signed_percentage'
} as const;
export type AdminCampaignsListOrderingEnum = typeof AdminCampaignsListOrderingEnum[keyof typeof AdminCampaignsListOrderingEnum];
/**
 * @export
 */
export const AdminCampaignsValuesRetrieveFieldEnum = {
    DISTRIBUTION_PLATFORM: 'distribution_platform',
    NAME: 'name'
} as const;
export type AdminCampaignsValuesRetrieveFieldEnum = typeof AdminCampaignsValuesRetrieveFieldEnum[keyof typeof AdminCampaignsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminCampaignsValuesRetrieveOrderingEnum = {
    ACTIVE_DESC: '-active',
    ACTIVE_ASC: 'active',
    ALLOCATION_AVAILABLE_DESC: '-allocation_available',
    ALLOCATION_AVAILABLE_ASC: 'allocation_available',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DESC: '-distribution_platform',
    DISTRIBUTION_PLATFORM_ASC: 'distribution_platform',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    PRICE_PER_UNIT_DESC: '-price_per_unit',
    PRICE_PER_UNIT_ASC: 'price_per_unit',
    SIGNED_PERCENTAGE_DESC: '-signed_percentage',
    SIGNED_PERCENTAGE_ASC: 'signed_percentage'
} as const;
export type AdminCampaignsValuesRetrieveOrderingEnum = typeof AdminCampaignsValuesRetrieveOrderingEnum[keyof typeof AdminCampaignsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminDistributionPlatformsDropdownListDistributionPlatformPermissionsEnum = {
    CREATE_INVESTOR_AND_INVESTMENT: 'create_investor_and_investment',
    DOWNLOAD_PLATFORM_STATISTICS: 'download_platform_statistics',
    EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'edit_distribution_information_and_investment_documents',
    MANAGE_IDENTIFICATION_DATA: 'manage_identification_data',
    MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'manage_investor_and_investment_data',
    MANAGE_VOUCHERS: 'manage_vouchers',
    VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'view_distribution_information_and_investment_documents',
    VIEW_FRIEND_REFERRALS: 'view_friend_referrals',
    VIEW_INVESTOR_AND_INVESTMENT_DATA: 'view_investor_and_investment_data'
} as const;
export type AdminDistributionPlatformsDropdownListDistributionPlatformPermissionsEnum = typeof AdminDistributionPlatformsDropdownListDistributionPlatformPermissionsEnum[keyof typeof AdminDistributionPlatformsDropdownListDistributionPlatformPermissionsEnum];
/**
 * @export
 */
export const AdminDistributionPlatformsDropdownListFieldEnum = {
    DISPLAY_NAME: 'display_name'
} as const;
export type AdminDistributionPlatformsDropdownListFieldEnum = typeof AdminDistributionPlatformsDropdownListFieldEnum[keyof typeof AdminDistributionPlatformsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminDistributionPlatformsDropdownListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISPLAY_NAME_DESC: '-display_name',
    DISPLAY_NAME_ASC: 'display_name',
    HAS_FRONTEND_DESC: '-has_frontend',
    HAS_FRONTEND_ASC: 'has_frontend',
    ID_DESC: '-id',
    ID_ASC: 'id',
    USES_EFFECTA_DESC: '-uses_effecta',
    USES_EFFECTA_ASC: 'uses_effecta'
} as const;
export type AdminDistributionPlatformsDropdownListOrderingEnum = typeof AdminDistributionPlatformsDropdownListOrderingEnum[keyof typeof AdminDistributionPlatformsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminDistributionPlatformsDropdownListPermissionsEnum = {
    CAN_USE_ISSUER_API: 'can_use_issuer_api',
    CREATE_ISSUERS_VIA_CASHLINK_STUDIO: 'create_issuers_via_cashlink_studio',
    CREATE_ISSUERS_VIA_ISSUER_API: 'create_issuers_via_issuer_api',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    MANAGE_ORGANIZATION_USERS_AND_GROUPS: 'manage_organization_users_and_groups',
    ORGANIZATION_CREATE_INVESTOR_AND_INVESTMENT: 'organization_create_investor_and_investment',
    ORGANIZATION_CREATE_PRODUCT_CASHLINK_STUDIO: 'organization_create_product_cashlink_studio',
    ORGANIZATION_DOWNLOAD_PLATFORM_STATISTICS: 'organization_download_platform_statistics',
    ORGANIZATION_DOWNLOAD_STATISTICS: 'organization_download_statistics',
    ORGANIZATION_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_edit_distribution_information_and_investment_documents',
    ORGANIZATION_MANAGE_APPROVALS: 'organization_manage_approvals',
    ORGANIZATION_MANAGE_CREDIT_DIGITAL_SECURITIES: 'organization_manage_credit_digital_securities',
    ORGANIZATION_MANAGE_DISTRIBUTION: 'organization_manage_distribution',
    ORGANIZATION_MANAGE_IDENTIFICATION_DATA: 'organization_manage_identification_data',
    ORGANIZATION_MANAGE_INCOMING_PAYMENTS: 'organization_manage_incoming_payments',
    ORGANIZATION_MANAGE_INVESTMENTS: 'organization_manage_investments',
    ORGANIZATION_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'organization_manage_investor_and_investment_data',
    ORGANIZATION_MANAGE_INVESTOR_DOCUMENTS: 'organization_manage_investor_documents',
    ORGANIZATION_MANAGE_ISSUER_CASHLINK_STUDIO: 'organization_manage_issuer_cashlink_studio',
    ORGANIZATION_MANAGE_LISTINGS: 'organization_manage_listings',
    ORGANIZATION_MANAGE_MARKET_PRICES: 'organization_manage_market_prices',
    ORGANIZATION_MANAGE_PAYOUT_EVENTS: 'organization_manage_payout_events',
    ORGANIZATION_MANAGE_PRODUCT_DATA: 'organization_manage_product_data',
    ORGANIZATION_MANAGE_REDEMPTIONS: 'organization_manage_redemptions',
    ORGANIZATION_MANAGE_VOUCHERS: 'organization_manage_vouchers',
    ORGANIZATION_TRIGGER_SOLUTION: 'organization_trigger_solution',
    ORGANIZATION_USE_ISSUER_API: 'organization_use_issuer_api',
    ORGANIZATION_VIEW_DATA: 'organization_view_data',
    ORGANIZATION_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_view_distribution_information_and_investment_documents',
    ORGANIZATION_VIEW_FRIEND_REFERRALS: 'organization_view_friend_referrals',
    ORGANIZATION_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'organization_view_investor_and_investment_data',
    ORGANIZATION_VIEW_ISSUER_CASHLINK_STUDIO: 'organization_view_issuer_cashlink_studio',
    VIEW_ORGANIZATION_DATA: 'view_organization_data'
} as const;
export type AdminDistributionPlatformsDropdownListPermissionsEnum = typeof AdminDistributionPlatformsDropdownListPermissionsEnum[keyof typeof AdminDistributionPlatformsDropdownListPermissionsEnum];
/**
 * @export
 */
export const AdminDistributionPlatformsListDistributionPlatformPermissionsEnum = {
    CREATE_INVESTOR_AND_INVESTMENT: 'create_investor_and_investment',
    DOWNLOAD_PLATFORM_STATISTICS: 'download_platform_statistics',
    EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'edit_distribution_information_and_investment_documents',
    MANAGE_IDENTIFICATION_DATA: 'manage_identification_data',
    MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'manage_investor_and_investment_data',
    MANAGE_VOUCHERS: 'manage_vouchers',
    VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'view_distribution_information_and_investment_documents',
    VIEW_FRIEND_REFERRALS: 'view_friend_referrals',
    VIEW_INVESTOR_AND_INVESTMENT_DATA: 'view_investor_and_investment_data'
} as const;
export type AdminDistributionPlatformsListDistributionPlatformPermissionsEnum = typeof AdminDistributionPlatformsListDistributionPlatformPermissionsEnum[keyof typeof AdminDistributionPlatformsListDistributionPlatformPermissionsEnum];
/**
 * @export
 */
export const AdminDistributionPlatformsListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISPLAY_NAME_DESC: '-display_name',
    DISPLAY_NAME_ASC: 'display_name',
    HAS_FRONTEND_DESC: '-has_frontend',
    HAS_FRONTEND_ASC: 'has_frontend',
    ID_DESC: '-id',
    ID_ASC: 'id',
    USES_EFFECTA_DESC: '-uses_effecta',
    USES_EFFECTA_ASC: 'uses_effecta'
} as const;
export type AdminDistributionPlatformsListOrderingEnum = typeof AdminDistributionPlatformsListOrderingEnum[keyof typeof AdminDistributionPlatformsListOrderingEnum];
/**
 * @export
 */
export const AdminDistributionPlatformsListPermissionsEnum = {
    CAN_USE_ISSUER_API: 'can_use_issuer_api',
    CREATE_ISSUERS_VIA_CASHLINK_STUDIO: 'create_issuers_via_cashlink_studio',
    CREATE_ISSUERS_VIA_ISSUER_API: 'create_issuers_via_issuer_api',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    MANAGE_ORGANIZATION_USERS_AND_GROUPS: 'manage_organization_users_and_groups',
    ORGANIZATION_CREATE_INVESTOR_AND_INVESTMENT: 'organization_create_investor_and_investment',
    ORGANIZATION_CREATE_PRODUCT_CASHLINK_STUDIO: 'organization_create_product_cashlink_studio',
    ORGANIZATION_DOWNLOAD_PLATFORM_STATISTICS: 'organization_download_platform_statistics',
    ORGANIZATION_DOWNLOAD_STATISTICS: 'organization_download_statistics',
    ORGANIZATION_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_edit_distribution_information_and_investment_documents',
    ORGANIZATION_MANAGE_APPROVALS: 'organization_manage_approvals',
    ORGANIZATION_MANAGE_CREDIT_DIGITAL_SECURITIES: 'organization_manage_credit_digital_securities',
    ORGANIZATION_MANAGE_DISTRIBUTION: 'organization_manage_distribution',
    ORGANIZATION_MANAGE_IDENTIFICATION_DATA: 'organization_manage_identification_data',
    ORGANIZATION_MANAGE_INCOMING_PAYMENTS: 'organization_manage_incoming_payments',
    ORGANIZATION_MANAGE_INVESTMENTS: 'organization_manage_investments',
    ORGANIZATION_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'organization_manage_investor_and_investment_data',
    ORGANIZATION_MANAGE_INVESTOR_DOCUMENTS: 'organization_manage_investor_documents',
    ORGANIZATION_MANAGE_ISSUER_CASHLINK_STUDIO: 'organization_manage_issuer_cashlink_studio',
    ORGANIZATION_MANAGE_LISTINGS: 'organization_manage_listings',
    ORGANIZATION_MANAGE_MARKET_PRICES: 'organization_manage_market_prices',
    ORGANIZATION_MANAGE_PAYOUT_EVENTS: 'organization_manage_payout_events',
    ORGANIZATION_MANAGE_PRODUCT_DATA: 'organization_manage_product_data',
    ORGANIZATION_MANAGE_REDEMPTIONS: 'organization_manage_redemptions',
    ORGANIZATION_MANAGE_VOUCHERS: 'organization_manage_vouchers',
    ORGANIZATION_TRIGGER_SOLUTION: 'organization_trigger_solution',
    ORGANIZATION_USE_ISSUER_API: 'organization_use_issuer_api',
    ORGANIZATION_VIEW_DATA: 'organization_view_data',
    ORGANIZATION_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_view_distribution_information_and_investment_documents',
    ORGANIZATION_VIEW_FRIEND_REFERRALS: 'organization_view_friend_referrals',
    ORGANIZATION_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'organization_view_investor_and_investment_data',
    ORGANIZATION_VIEW_ISSUER_CASHLINK_STUDIO: 'organization_view_issuer_cashlink_studio',
    VIEW_ORGANIZATION_DATA: 'view_organization_data'
} as const;
export type AdminDistributionPlatformsListPermissionsEnum = typeof AdminDistributionPlatformsListPermissionsEnum[keyof typeof AdminDistributionPlatformsListPermissionsEnum];
/**
 * @export
 */
export const AdminDistributionPlatformsValuesRetrieveFieldEnum = {
    DISPLAY_NAME: 'display_name'
} as const;
export type AdminDistributionPlatformsValuesRetrieveFieldEnum = typeof AdminDistributionPlatformsValuesRetrieveFieldEnum[keyof typeof AdminDistributionPlatformsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminDistributionPlatformsValuesRetrieveDistributionPlatformPermissionsEnum = {
    CREATE_INVESTOR_AND_INVESTMENT: 'create_investor_and_investment',
    DOWNLOAD_PLATFORM_STATISTICS: 'download_platform_statistics',
    EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'edit_distribution_information_and_investment_documents',
    MANAGE_IDENTIFICATION_DATA: 'manage_identification_data',
    MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'manage_investor_and_investment_data',
    MANAGE_VOUCHERS: 'manage_vouchers',
    VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'view_distribution_information_and_investment_documents',
    VIEW_FRIEND_REFERRALS: 'view_friend_referrals',
    VIEW_INVESTOR_AND_INVESTMENT_DATA: 'view_investor_and_investment_data'
} as const;
export type AdminDistributionPlatformsValuesRetrieveDistributionPlatformPermissionsEnum = typeof AdminDistributionPlatformsValuesRetrieveDistributionPlatformPermissionsEnum[keyof typeof AdminDistributionPlatformsValuesRetrieveDistributionPlatformPermissionsEnum];
/**
 * @export
 */
export const AdminDistributionPlatformsValuesRetrieveOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISPLAY_NAME_DESC: '-display_name',
    DISPLAY_NAME_ASC: 'display_name',
    HAS_FRONTEND_DESC: '-has_frontend',
    HAS_FRONTEND_ASC: 'has_frontend',
    ID_DESC: '-id',
    ID_ASC: 'id',
    USES_EFFECTA_DESC: '-uses_effecta',
    USES_EFFECTA_ASC: 'uses_effecta'
} as const;
export type AdminDistributionPlatformsValuesRetrieveOrderingEnum = typeof AdminDistributionPlatformsValuesRetrieveOrderingEnum[keyof typeof AdminDistributionPlatformsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminDistributionPlatformsValuesRetrievePermissionsEnum = {
    CAN_USE_ISSUER_API: 'can_use_issuer_api',
    CREATE_ISSUERS_VIA_CASHLINK_STUDIO: 'create_issuers_via_cashlink_studio',
    CREATE_ISSUERS_VIA_ISSUER_API: 'create_issuers_via_issuer_api',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    MANAGE_ORGANIZATION_USERS_AND_GROUPS: 'manage_organization_users_and_groups',
    ORGANIZATION_CREATE_INVESTOR_AND_INVESTMENT: 'organization_create_investor_and_investment',
    ORGANIZATION_CREATE_PRODUCT_CASHLINK_STUDIO: 'organization_create_product_cashlink_studio',
    ORGANIZATION_DOWNLOAD_PLATFORM_STATISTICS: 'organization_download_platform_statistics',
    ORGANIZATION_DOWNLOAD_STATISTICS: 'organization_download_statistics',
    ORGANIZATION_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_edit_distribution_information_and_investment_documents',
    ORGANIZATION_MANAGE_APPROVALS: 'organization_manage_approvals',
    ORGANIZATION_MANAGE_CREDIT_DIGITAL_SECURITIES: 'organization_manage_credit_digital_securities',
    ORGANIZATION_MANAGE_DISTRIBUTION: 'organization_manage_distribution',
    ORGANIZATION_MANAGE_IDENTIFICATION_DATA: 'organization_manage_identification_data',
    ORGANIZATION_MANAGE_INCOMING_PAYMENTS: 'organization_manage_incoming_payments',
    ORGANIZATION_MANAGE_INVESTMENTS: 'organization_manage_investments',
    ORGANIZATION_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'organization_manage_investor_and_investment_data',
    ORGANIZATION_MANAGE_INVESTOR_DOCUMENTS: 'organization_manage_investor_documents',
    ORGANIZATION_MANAGE_ISSUER_CASHLINK_STUDIO: 'organization_manage_issuer_cashlink_studio',
    ORGANIZATION_MANAGE_LISTINGS: 'organization_manage_listings',
    ORGANIZATION_MANAGE_MARKET_PRICES: 'organization_manage_market_prices',
    ORGANIZATION_MANAGE_PAYOUT_EVENTS: 'organization_manage_payout_events',
    ORGANIZATION_MANAGE_PRODUCT_DATA: 'organization_manage_product_data',
    ORGANIZATION_MANAGE_REDEMPTIONS: 'organization_manage_redemptions',
    ORGANIZATION_MANAGE_VOUCHERS: 'organization_manage_vouchers',
    ORGANIZATION_TRIGGER_SOLUTION: 'organization_trigger_solution',
    ORGANIZATION_USE_ISSUER_API: 'organization_use_issuer_api',
    ORGANIZATION_VIEW_DATA: 'organization_view_data',
    ORGANIZATION_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_view_distribution_information_and_investment_documents',
    ORGANIZATION_VIEW_FRIEND_REFERRALS: 'organization_view_friend_referrals',
    ORGANIZATION_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'organization_view_investor_and_investment_data',
    ORGANIZATION_VIEW_ISSUER_CASHLINK_STUDIO: 'organization_view_issuer_cashlink_studio',
    VIEW_ORGANIZATION_DATA: 'view_organization_data'
} as const;
export type AdminDistributionPlatformsValuesRetrievePermissionsEnum = typeof AdminDistributionPlatformsValuesRetrievePermissionsEnum[keyof typeof AdminDistributionPlatformsValuesRetrievePermissionsEnum];
/**
 * @export
 */
export const AdminFriendVouchersDropdownListFieldEnum = {
    CODE: 'code',
    OWNING_INVESTOR_NAME: 'owning_investor_name'
} as const;
export type AdminFriendVouchersDropdownListFieldEnum = typeof AdminFriendVouchersDropdownListFieldEnum[keyof typeof AdminFriendVouchersDropdownListFieldEnum];
/**
 * @export
 */
export const AdminFriendVouchersDropdownListOrderingEnum = {
    ACTIVE_DESC: '-active',
    ACTIVE_ASC: 'active',
    ALREADY_USED_DESC: '-already_used',
    ALREADY_USED_ASC: 'already_used',
    CODE_DESC: '-code',
    CODE_ASC: 'code',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    OWNING_INVESTOR_NAME_DESC: '-owning_investor_name',
    OWNING_INVESTOR_NAME_ASC: 'owning_investor_name'
} as const;
export type AdminFriendVouchersDropdownListOrderingEnum = typeof AdminFriendVouchersDropdownListOrderingEnum[keyof typeof AdminFriendVouchersDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminFriendVouchersListOrderingEnum = {
    ACTIVE_DESC: '-active',
    ACTIVE_ASC: 'active',
    ALREADY_USED_DESC: '-already_used',
    ALREADY_USED_ASC: 'already_used',
    CODE_DESC: '-code',
    CODE_ASC: 'code',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    OWNING_INVESTOR_NAME_DESC: '-owning_investor_name',
    OWNING_INVESTOR_NAME_ASC: 'owning_investor_name'
} as const;
export type AdminFriendVouchersListOrderingEnum = typeof AdminFriendVouchersListOrderingEnum[keyof typeof AdminFriendVouchersListOrderingEnum];
/**
 * @export
 */
export const AdminFriendVouchersValuesRetrieveFieldEnum = {
    CODE: 'code',
    OWNING_INVESTOR_NAME: 'owning_investor_name'
} as const;
export type AdminFriendVouchersValuesRetrieveFieldEnum = typeof AdminFriendVouchersValuesRetrieveFieldEnum[keyof typeof AdminFriendVouchersValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminFriendVouchersValuesRetrieveOrderingEnum = {
    ACTIVE_DESC: '-active',
    ACTIVE_ASC: 'active',
    ALREADY_USED_DESC: '-already_used',
    ALREADY_USED_ASC: 'already_used',
    CODE_DESC: '-code',
    CODE_ASC: 'code',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    OWNING_INVESTOR_NAME_DESC: '-owning_investor_name',
    OWNING_INVESTOR_NAME_ASC: 'owning_investor_name'
} as const;
export type AdminFriendVouchersValuesRetrieveOrderingEnum = typeof AdminFriendVouchersValuesRetrieveOrderingEnum[keyof typeof AdminFriendVouchersValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminGroupPermissionsDropdownListFieldEnum = {
    VALID_FOR_NAME: 'valid_for_name'
} as const;
export type AdminGroupPermissionsDropdownListFieldEnum = typeof AdminGroupPermissionsDropdownListFieldEnum[keyof typeof AdminGroupPermissionsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminGroupPermissionsDropdownListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    GROUP_NAME_DESC: '-group_name',
    GROUP_NAME_ASC: 'group_name',
    GROUP_DESC: '-group',
    GROUP_ASC: 'group',
    ID_DESC: '-id',
    ID_ASC: 'id',
    OBJECT_ID_DESC: '-object_id',
    OBJECT_ID_ASC: 'object_id',
    PERMISSION_CODE_DESC: '-permission_code',
    PERMISSION_CODE_ASC: 'permission_code',
    PERMISSION_TYPE_DESC: '-permission_type',
    PERMISSION_TYPE_ASC: 'permission_type',
    VALID_FOR_NAME_DESC: '-valid_for_name',
    VALID_FOR_NAME_ASC: 'valid_for_name'
} as const;
export type AdminGroupPermissionsDropdownListOrderingEnum = typeof AdminGroupPermissionsDropdownListOrderingEnum[keyof typeof AdminGroupPermissionsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminGroupPermissionsDropdownListPermissionCodeEnum = {
    CAN_USE_ISSUER_API: 'can_use_issuer_api',
    CREATE_INVESTOR_AND_INVESTMENT: 'create_investor_and_investment',
    CREATE_ISSUER: 'create_issuer',
    CREATE_ISSUERS_VIA_CASHLINK_STUDIO: 'create_issuers_via_cashlink_studio',
    CREATE_ISSUERS_VIA_ISSUER_API: 'create_issuers_via_issuer_api',
    CREATE_PRODUCT_CASHLINK_STUDIO: 'create_product_cashlink_studio',
    DOWNLOAD_PLATFORM_STATISTICS: 'download_platform_statistics',
    DOWNLOAD_STATISTICS: 'download_statistics',
    EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'edit_distribution_information_and_investment_documents',
    ENVIRONMENT_CREATE_INVESTOR_AND_INVESTMENT: 'environment_create_investor_and_investment',
    ENVIRONMENT_CREATE_PRODUCT_CASHLINK_STUDIO: 'environment_create_product_cashlink_studio',
    ENVIRONMENT_DOWNLOAD_PLATFORM_STATISTICS: 'environment_download_platform_statistics',
    ENVIRONMENT_DOWNLOAD_STATISTICS: 'environment_download_statistics',
    ENVIRONMENT_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'environment_edit_distribution_information_and_investment_documents',
    ENVIRONMENT_MANAGE_APPROVALS: 'environment_manage_approvals',
    ENVIRONMENT_MANAGE_CREDIT_DIGITAL_SECURITIES: 'environment_manage_credit_digital_securities',
    ENVIRONMENT_MANAGE_DISTRIBUTION: 'environment_manage_distribution',
    ENVIRONMENT_MANAGE_IDENTIFICATION_DATA: 'environment_manage_identification_data',
    ENVIRONMENT_MANAGE_INCOMING_PAYMENTS: 'environment_manage_incoming_payments',
    ENVIRONMENT_MANAGE_INVESTMENTS: 'environment_manage_investments',
    ENVIRONMENT_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'environment_manage_investor_and_investment_data',
    ENVIRONMENT_MANAGE_INVESTOR_DOCUMENTS: 'environment_manage_investor_documents',
    ENVIRONMENT_MANAGE_ISSUER_CASHLINK_STUDIO: 'environment_manage_issuer_cashlink_studio',
    ENVIRONMENT_MANAGE_LISTINGS: 'environment_manage_listings',
    ENVIRONMENT_MANAGE_MARKET_PRICES: 'environment_manage_market_prices',
    ENVIRONMENT_MANAGE_PAYOUT_EVENTS: 'environment_manage_payout_events',
    ENVIRONMENT_MANAGE_PRODUCT_DATA: 'environment_manage_product_data',
    ENVIRONMENT_MANAGE_REDEMPTIONS: 'environment_manage_redemptions',
    ENVIRONMENT_MANAGE_VOUCHERS: 'environment_manage_vouchers',
    ENVIRONMENT_TRIGGER_SOLUTION: 'environment_trigger_solution',
    ENVIRONMENT_USE_ISSUER_API: 'environment_use_issuer_api',
    ENVIRONMENT_VIEW_DATA: 'environment_view_data',
    ENVIRONMENT_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'environment_view_distribution_information_and_investment_documents',
    ENVIRONMENT_VIEW_FRIEND_REFERRALS: 'environment_view_friend_referrals',
    ENVIRONMENT_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'environment_view_investor_and_investment_data',
    ENVIRONMENT_VIEW_ISSUER_CASHLINK_STUDIO: 'environment_view_issuer_cashlink_studio',
    MANAGE_APPROVALS: 'manage_approvals',
    MANAGE_CREDIT_DIGITAL_SECURITIES: 'manage_credit_digital_securities',
    MANAGE_DISTRIBUTION: 'manage_distribution',
    MANAGE_ENVIRONMENT_PERMISSIONS: 'manage_environment_permissions',
    MANAGE_ENVIRONMENT_USERS_AND_GROUPS: 'manage_environment_users_and_groups',
    MANAGE_FLAG_FOR_CRYPTO_SECURITY_CREATION_AND_VALIDATE_CRYPTO_SECURITIES: 'manage_flag_for_crypto_security_creation_and_validate_crypto_securities',
    MANAGE_IDENTIFICATION_DATA: 'manage_identification_data',
    MANAGE_INCOMING_PAYMENTS: 'manage_incoming_payments',
    MANAGE_INVESTMENTS: 'manage_investments',
    MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'manage_investor_and_investment_data',
    MANAGE_INVESTOR_DOCUMENTS: 'manage_investor_documents',
    MANAGE_ISSUANCE_DOCUMENTS: 'manage_issuance_documents',
    MANAGE_ISSUER_CASHLINK_STUDIO: 'manage_issuer_cashlink_studio',
    MANAGE_LISTINGS: 'manage_listings',
    MANAGE_MARKET_PRICES: 'manage_market_prices',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    MANAGE_ORGANIZATION_USERS_AND_GROUPS: 'manage_organization_users_and_groups',
    MANAGE_ORGANIZATIONS: 'manage_organizations',
    MANAGE_PAYOUT_EVENTS: 'manage_payout_events',
    MANAGE_PRODUCT_DATA: 'manage_product_data',
    MANAGE_REDEMPTIONS: 'manage_redemptions',
    MANAGE_VOUCHERS: 'manage_vouchers',
    ORGANIZATION_CREATE_INVESTOR_AND_INVESTMENT: 'organization_create_investor_and_investment',
    ORGANIZATION_CREATE_PRODUCT_CASHLINK_STUDIO: 'organization_create_product_cashlink_studio',
    ORGANIZATION_DOWNLOAD_PLATFORM_STATISTICS: 'organization_download_platform_statistics',
    ORGANIZATION_DOWNLOAD_STATISTICS: 'organization_download_statistics',
    ORGANIZATION_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_edit_distribution_information_and_investment_documents',
    ORGANIZATION_MANAGE_APPROVALS: 'organization_manage_approvals',
    ORGANIZATION_MANAGE_CREDIT_DIGITAL_SECURITIES: 'organization_manage_credit_digital_securities',
    ORGANIZATION_MANAGE_DISTRIBUTION: 'organization_manage_distribution',
    ORGANIZATION_MANAGE_IDENTIFICATION_DATA: 'organization_manage_identification_data',
    ORGANIZATION_MANAGE_INCOMING_PAYMENTS: 'organization_manage_incoming_payments',
    ORGANIZATION_MANAGE_INVESTMENTS: 'organization_manage_investments',
    ORGANIZATION_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'organization_manage_investor_and_investment_data',
    ORGANIZATION_MANAGE_INVESTOR_DOCUMENTS: 'organization_manage_investor_documents',
    ORGANIZATION_MANAGE_ISSUER_CASHLINK_STUDIO: 'organization_manage_issuer_cashlink_studio',
    ORGANIZATION_MANAGE_LISTINGS: 'organization_manage_listings',
    ORGANIZATION_MANAGE_MARKET_PRICES: 'organization_manage_market_prices',
    ORGANIZATION_MANAGE_PAYOUT_EVENTS: 'organization_manage_payout_events',
    ORGANIZATION_MANAGE_PRODUCT_DATA: 'organization_manage_product_data',
    ORGANIZATION_MANAGE_REDEMPTIONS: 'organization_manage_redemptions',
    ORGANIZATION_MANAGE_VOUCHERS: 'organization_manage_vouchers',
    ORGANIZATION_TRIGGER_SOLUTION: 'organization_trigger_solution',
    ORGANIZATION_USE_ISSUER_API: 'organization_use_issuer_api',
    ORGANIZATION_VIEW_DATA: 'organization_view_data',
    ORGANIZATION_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_view_distribution_information_and_investment_documents',
    ORGANIZATION_VIEW_FRIEND_REFERRALS: 'organization_view_friend_referrals',
    ORGANIZATION_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'organization_view_investor_and_investment_data',
    ORGANIZATION_VIEW_ISSUER_CASHLINK_STUDIO: 'organization_view_issuer_cashlink_studio',
    TRIGGER_SOLUTION: 'trigger_solution',
    USE_ISSUER_API: 'use_issuer_api',
    VIEW_DATA: 'view_data',
    VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'view_distribution_information_and_investment_documents',
    VIEW_FRIEND_REFERRALS: 'view_friend_referrals',
    VIEW_INVESTOR_AND_INVESTMENT_DATA: 'view_investor_and_investment_data',
    VIEW_ISSUER_CASHLINK_STUDIO: 'view_issuer_cashlink_studio',
    VIEW_ORGANIZATION_DATA: 'view_organization_data'
} as const;
export type AdminGroupPermissionsDropdownListPermissionCodeEnum = typeof AdminGroupPermissionsDropdownListPermissionCodeEnum[keyof typeof AdminGroupPermissionsDropdownListPermissionCodeEnum];
/**
 * @export
 */
export const AdminGroupPermissionsDropdownListPermissionTypeEnum = {
    DISTRIBUTION_PLATFORM: 'DISTRIBUTION_PLATFORM',
    ENVIRONMENT: 'ENVIRONMENT',
    ISSUER: 'ISSUER',
    ORGANIZATION: 'ORGANIZATION',
    PRODUCT: 'PRODUCT'
} as const;
export type AdminGroupPermissionsDropdownListPermissionTypeEnum = typeof AdminGroupPermissionsDropdownListPermissionTypeEnum[keyof typeof AdminGroupPermissionsDropdownListPermissionTypeEnum];
/**
 * @export
 */
export const AdminGroupPermissionsListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    GROUP_NAME_DESC: '-group_name',
    GROUP_NAME_ASC: 'group_name',
    GROUP_DESC: '-group',
    GROUP_ASC: 'group',
    ID_DESC: '-id',
    ID_ASC: 'id',
    OBJECT_ID_DESC: '-object_id',
    OBJECT_ID_ASC: 'object_id',
    PERMISSION_CODE_DESC: '-permission_code',
    PERMISSION_CODE_ASC: 'permission_code',
    PERMISSION_TYPE_DESC: '-permission_type',
    PERMISSION_TYPE_ASC: 'permission_type',
    VALID_FOR_NAME_DESC: '-valid_for_name',
    VALID_FOR_NAME_ASC: 'valid_for_name'
} as const;
export type AdminGroupPermissionsListOrderingEnum = typeof AdminGroupPermissionsListOrderingEnum[keyof typeof AdminGroupPermissionsListOrderingEnum];
/**
 * @export
 */
export const AdminGroupPermissionsListPermissionCodeEnum = {
    CAN_USE_ISSUER_API: 'can_use_issuer_api',
    CREATE_INVESTOR_AND_INVESTMENT: 'create_investor_and_investment',
    CREATE_ISSUER: 'create_issuer',
    CREATE_ISSUERS_VIA_CASHLINK_STUDIO: 'create_issuers_via_cashlink_studio',
    CREATE_ISSUERS_VIA_ISSUER_API: 'create_issuers_via_issuer_api',
    CREATE_PRODUCT_CASHLINK_STUDIO: 'create_product_cashlink_studio',
    DOWNLOAD_PLATFORM_STATISTICS: 'download_platform_statistics',
    DOWNLOAD_STATISTICS: 'download_statistics',
    EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'edit_distribution_information_and_investment_documents',
    ENVIRONMENT_CREATE_INVESTOR_AND_INVESTMENT: 'environment_create_investor_and_investment',
    ENVIRONMENT_CREATE_PRODUCT_CASHLINK_STUDIO: 'environment_create_product_cashlink_studio',
    ENVIRONMENT_DOWNLOAD_PLATFORM_STATISTICS: 'environment_download_platform_statistics',
    ENVIRONMENT_DOWNLOAD_STATISTICS: 'environment_download_statistics',
    ENVIRONMENT_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'environment_edit_distribution_information_and_investment_documents',
    ENVIRONMENT_MANAGE_APPROVALS: 'environment_manage_approvals',
    ENVIRONMENT_MANAGE_CREDIT_DIGITAL_SECURITIES: 'environment_manage_credit_digital_securities',
    ENVIRONMENT_MANAGE_DISTRIBUTION: 'environment_manage_distribution',
    ENVIRONMENT_MANAGE_IDENTIFICATION_DATA: 'environment_manage_identification_data',
    ENVIRONMENT_MANAGE_INCOMING_PAYMENTS: 'environment_manage_incoming_payments',
    ENVIRONMENT_MANAGE_INVESTMENTS: 'environment_manage_investments',
    ENVIRONMENT_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'environment_manage_investor_and_investment_data',
    ENVIRONMENT_MANAGE_INVESTOR_DOCUMENTS: 'environment_manage_investor_documents',
    ENVIRONMENT_MANAGE_ISSUER_CASHLINK_STUDIO: 'environment_manage_issuer_cashlink_studio',
    ENVIRONMENT_MANAGE_LISTINGS: 'environment_manage_listings',
    ENVIRONMENT_MANAGE_MARKET_PRICES: 'environment_manage_market_prices',
    ENVIRONMENT_MANAGE_PAYOUT_EVENTS: 'environment_manage_payout_events',
    ENVIRONMENT_MANAGE_PRODUCT_DATA: 'environment_manage_product_data',
    ENVIRONMENT_MANAGE_REDEMPTIONS: 'environment_manage_redemptions',
    ENVIRONMENT_MANAGE_VOUCHERS: 'environment_manage_vouchers',
    ENVIRONMENT_TRIGGER_SOLUTION: 'environment_trigger_solution',
    ENVIRONMENT_USE_ISSUER_API: 'environment_use_issuer_api',
    ENVIRONMENT_VIEW_DATA: 'environment_view_data',
    ENVIRONMENT_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'environment_view_distribution_information_and_investment_documents',
    ENVIRONMENT_VIEW_FRIEND_REFERRALS: 'environment_view_friend_referrals',
    ENVIRONMENT_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'environment_view_investor_and_investment_data',
    ENVIRONMENT_VIEW_ISSUER_CASHLINK_STUDIO: 'environment_view_issuer_cashlink_studio',
    MANAGE_APPROVALS: 'manage_approvals',
    MANAGE_CREDIT_DIGITAL_SECURITIES: 'manage_credit_digital_securities',
    MANAGE_DISTRIBUTION: 'manage_distribution',
    MANAGE_ENVIRONMENT_PERMISSIONS: 'manage_environment_permissions',
    MANAGE_ENVIRONMENT_USERS_AND_GROUPS: 'manage_environment_users_and_groups',
    MANAGE_FLAG_FOR_CRYPTO_SECURITY_CREATION_AND_VALIDATE_CRYPTO_SECURITIES: 'manage_flag_for_crypto_security_creation_and_validate_crypto_securities',
    MANAGE_IDENTIFICATION_DATA: 'manage_identification_data',
    MANAGE_INCOMING_PAYMENTS: 'manage_incoming_payments',
    MANAGE_INVESTMENTS: 'manage_investments',
    MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'manage_investor_and_investment_data',
    MANAGE_INVESTOR_DOCUMENTS: 'manage_investor_documents',
    MANAGE_ISSUANCE_DOCUMENTS: 'manage_issuance_documents',
    MANAGE_ISSUER_CASHLINK_STUDIO: 'manage_issuer_cashlink_studio',
    MANAGE_LISTINGS: 'manage_listings',
    MANAGE_MARKET_PRICES: 'manage_market_prices',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    MANAGE_ORGANIZATION_USERS_AND_GROUPS: 'manage_organization_users_and_groups',
    MANAGE_ORGANIZATIONS: 'manage_organizations',
    MANAGE_PAYOUT_EVENTS: 'manage_payout_events',
    MANAGE_PRODUCT_DATA: 'manage_product_data',
    MANAGE_REDEMPTIONS: 'manage_redemptions',
    MANAGE_VOUCHERS: 'manage_vouchers',
    ORGANIZATION_CREATE_INVESTOR_AND_INVESTMENT: 'organization_create_investor_and_investment',
    ORGANIZATION_CREATE_PRODUCT_CASHLINK_STUDIO: 'organization_create_product_cashlink_studio',
    ORGANIZATION_DOWNLOAD_PLATFORM_STATISTICS: 'organization_download_platform_statistics',
    ORGANIZATION_DOWNLOAD_STATISTICS: 'organization_download_statistics',
    ORGANIZATION_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_edit_distribution_information_and_investment_documents',
    ORGANIZATION_MANAGE_APPROVALS: 'organization_manage_approvals',
    ORGANIZATION_MANAGE_CREDIT_DIGITAL_SECURITIES: 'organization_manage_credit_digital_securities',
    ORGANIZATION_MANAGE_DISTRIBUTION: 'organization_manage_distribution',
    ORGANIZATION_MANAGE_IDENTIFICATION_DATA: 'organization_manage_identification_data',
    ORGANIZATION_MANAGE_INCOMING_PAYMENTS: 'organization_manage_incoming_payments',
    ORGANIZATION_MANAGE_INVESTMENTS: 'organization_manage_investments',
    ORGANIZATION_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'organization_manage_investor_and_investment_data',
    ORGANIZATION_MANAGE_INVESTOR_DOCUMENTS: 'organization_manage_investor_documents',
    ORGANIZATION_MANAGE_ISSUER_CASHLINK_STUDIO: 'organization_manage_issuer_cashlink_studio',
    ORGANIZATION_MANAGE_LISTINGS: 'organization_manage_listings',
    ORGANIZATION_MANAGE_MARKET_PRICES: 'organization_manage_market_prices',
    ORGANIZATION_MANAGE_PAYOUT_EVENTS: 'organization_manage_payout_events',
    ORGANIZATION_MANAGE_PRODUCT_DATA: 'organization_manage_product_data',
    ORGANIZATION_MANAGE_REDEMPTIONS: 'organization_manage_redemptions',
    ORGANIZATION_MANAGE_VOUCHERS: 'organization_manage_vouchers',
    ORGANIZATION_TRIGGER_SOLUTION: 'organization_trigger_solution',
    ORGANIZATION_USE_ISSUER_API: 'organization_use_issuer_api',
    ORGANIZATION_VIEW_DATA: 'organization_view_data',
    ORGANIZATION_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_view_distribution_information_and_investment_documents',
    ORGANIZATION_VIEW_FRIEND_REFERRALS: 'organization_view_friend_referrals',
    ORGANIZATION_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'organization_view_investor_and_investment_data',
    ORGANIZATION_VIEW_ISSUER_CASHLINK_STUDIO: 'organization_view_issuer_cashlink_studio',
    TRIGGER_SOLUTION: 'trigger_solution',
    USE_ISSUER_API: 'use_issuer_api',
    VIEW_DATA: 'view_data',
    VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'view_distribution_information_and_investment_documents',
    VIEW_FRIEND_REFERRALS: 'view_friend_referrals',
    VIEW_INVESTOR_AND_INVESTMENT_DATA: 'view_investor_and_investment_data',
    VIEW_ISSUER_CASHLINK_STUDIO: 'view_issuer_cashlink_studio',
    VIEW_ORGANIZATION_DATA: 'view_organization_data'
} as const;
export type AdminGroupPermissionsListPermissionCodeEnum = typeof AdminGroupPermissionsListPermissionCodeEnum[keyof typeof AdminGroupPermissionsListPermissionCodeEnum];
/**
 * @export
 */
export const AdminGroupPermissionsListPermissionTypeEnum = {
    DISTRIBUTION_PLATFORM: 'DISTRIBUTION_PLATFORM',
    ENVIRONMENT: 'ENVIRONMENT',
    ISSUER: 'ISSUER',
    ORGANIZATION: 'ORGANIZATION',
    PRODUCT: 'PRODUCT'
} as const;
export type AdminGroupPermissionsListPermissionTypeEnum = typeof AdminGroupPermissionsListPermissionTypeEnum[keyof typeof AdminGroupPermissionsListPermissionTypeEnum];
/**
 * @export
 */
export const AdminGroupPermissionsValuesRetrieveFieldEnum = {
    VALID_FOR_NAME: 'valid_for_name'
} as const;
export type AdminGroupPermissionsValuesRetrieveFieldEnum = typeof AdminGroupPermissionsValuesRetrieveFieldEnum[keyof typeof AdminGroupPermissionsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminGroupPermissionsValuesRetrieveOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    GROUP_NAME_DESC: '-group_name',
    GROUP_NAME_ASC: 'group_name',
    GROUP_DESC: '-group',
    GROUP_ASC: 'group',
    ID_DESC: '-id',
    ID_ASC: 'id',
    OBJECT_ID_DESC: '-object_id',
    OBJECT_ID_ASC: 'object_id',
    PERMISSION_CODE_DESC: '-permission_code',
    PERMISSION_CODE_ASC: 'permission_code',
    PERMISSION_TYPE_DESC: '-permission_type',
    PERMISSION_TYPE_ASC: 'permission_type',
    VALID_FOR_NAME_DESC: '-valid_for_name',
    VALID_FOR_NAME_ASC: 'valid_for_name'
} as const;
export type AdminGroupPermissionsValuesRetrieveOrderingEnum = typeof AdminGroupPermissionsValuesRetrieveOrderingEnum[keyof typeof AdminGroupPermissionsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminGroupPermissionsValuesRetrievePermissionCodeEnum = {
    CAN_USE_ISSUER_API: 'can_use_issuer_api',
    CREATE_INVESTOR_AND_INVESTMENT: 'create_investor_and_investment',
    CREATE_ISSUER: 'create_issuer',
    CREATE_ISSUERS_VIA_CASHLINK_STUDIO: 'create_issuers_via_cashlink_studio',
    CREATE_ISSUERS_VIA_ISSUER_API: 'create_issuers_via_issuer_api',
    CREATE_PRODUCT_CASHLINK_STUDIO: 'create_product_cashlink_studio',
    DOWNLOAD_PLATFORM_STATISTICS: 'download_platform_statistics',
    DOWNLOAD_STATISTICS: 'download_statistics',
    EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'edit_distribution_information_and_investment_documents',
    ENVIRONMENT_CREATE_INVESTOR_AND_INVESTMENT: 'environment_create_investor_and_investment',
    ENVIRONMENT_CREATE_PRODUCT_CASHLINK_STUDIO: 'environment_create_product_cashlink_studio',
    ENVIRONMENT_DOWNLOAD_PLATFORM_STATISTICS: 'environment_download_platform_statistics',
    ENVIRONMENT_DOWNLOAD_STATISTICS: 'environment_download_statistics',
    ENVIRONMENT_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'environment_edit_distribution_information_and_investment_documents',
    ENVIRONMENT_MANAGE_APPROVALS: 'environment_manage_approvals',
    ENVIRONMENT_MANAGE_CREDIT_DIGITAL_SECURITIES: 'environment_manage_credit_digital_securities',
    ENVIRONMENT_MANAGE_DISTRIBUTION: 'environment_manage_distribution',
    ENVIRONMENT_MANAGE_IDENTIFICATION_DATA: 'environment_manage_identification_data',
    ENVIRONMENT_MANAGE_INCOMING_PAYMENTS: 'environment_manage_incoming_payments',
    ENVIRONMENT_MANAGE_INVESTMENTS: 'environment_manage_investments',
    ENVIRONMENT_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'environment_manage_investor_and_investment_data',
    ENVIRONMENT_MANAGE_INVESTOR_DOCUMENTS: 'environment_manage_investor_documents',
    ENVIRONMENT_MANAGE_ISSUER_CASHLINK_STUDIO: 'environment_manage_issuer_cashlink_studio',
    ENVIRONMENT_MANAGE_LISTINGS: 'environment_manage_listings',
    ENVIRONMENT_MANAGE_MARKET_PRICES: 'environment_manage_market_prices',
    ENVIRONMENT_MANAGE_PAYOUT_EVENTS: 'environment_manage_payout_events',
    ENVIRONMENT_MANAGE_PRODUCT_DATA: 'environment_manage_product_data',
    ENVIRONMENT_MANAGE_REDEMPTIONS: 'environment_manage_redemptions',
    ENVIRONMENT_MANAGE_VOUCHERS: 'environment_manage_vouchers',
    ENVIRONMENT_TRIGGER_SOLUTION: 'environment_trigger_solution',
    ENVIRONMENT_USE_ISSUER_API: 'environment_use_issuer_api',
    ENVIRONMENT_VIEW_DATA: 'environment_view_data',
    ENVIRONMENT_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'environment_view_distribution_information_and_investment_documents',
    ENVIRONMENT_VIEW_FRIEND_REFERRALS: 'environment_view_friend_referrals',
    ENVIRONMENT_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'environment_view_investor_and_investment_data',
    ENVIRONMENT_VIEW_ISSUER_CASHLINK_STUDIO: 'environment_view_issuer_cashlink_studio',
    MANAGE_APPROVALS: 'manage_approvals',
    MANAGE_CREDIT_DIGITAL_SECURITIES: 'manage_credit_digital_securities',
    MANAGE_DISTRIBUTION: 'manage_distribution',
    MANAGE_ENVIRONMENT_PERMISSIONS: 'manage_environment_permissions',
    MANAGE_ENVIRONMENT_USERS_AND_GROUPS: 'manage_environment_users_and_groups',
    MANAGE_FLAG_FOR_CRYPTO_SECURITY_CREATION_AND_VALIDATE_CRYPTO_SECURITIES: 'manage_flag_for_crypto_security_creation_and_validate_crypto_securities',
    MANAGE_IDENTIFICATION_DATA: 'manage_identification_data',
    MANAGE_INCOMING_PAYMENTS: 'manage_incoming_payments',
    MANAGE_INVESTMENTS: 'manage_investments',
    MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'manage_investor_and_investment_data',
    MANAGE_INVESTOR_DOCUMENTS: 'manage_investor_documents',
    MANAGE_ISSUANCE_DOCUMENTS: 'manage_issuance_documents',
    MANAGE_ISSUER_CASHLINK_STUDIO: 'manage_issuer_cashlink_studio',
    MANAGE_LISTINGS: 'manage_listings',
    MANAGE_MARKET_PRICES: 'manage_market_prices',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    MANAGE_ORGANIZATION_USERS_AND_GROUPS: 'manage_organization_users_and_groups',
    MANAGE_ORGANIZATIONS: 'manage_organizations',
    MANAGE_PAYOUT_EVENTS: 'manage_payout_events',
    MANAGE_PRODUCT_DATA: 'manage_product_data',
    MANAGE_REDEMPTIONS: 'manage_redemptions',
    MANAGE_VOUCHERS: 'manage_vouchers',
    ORGANIZATION_CREATE_INVESTOR_AND_INVESTMENT: 'organization_create_investor_and_investment',
    ORGANIZATION_CREATE_PRODUCT_CASHLINK_STUDIO: 'organization_create_product_cashlink_studio',
    ORGANIZATION_DOWNLOAD_PLATFORM_STATISTICS: 'organization_download_platform_statistics',
    ORGANIZATION_DOWNLOAD_STATISTICS: 'organization_download_statistics',
    ORGANIZATION_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_edit_distribution_information_and_investment_documents',
    ORGANIZATION_MANAGE_APPROVALS: 'organization_manage_approvals',
    ORGANIZATION_MANAGE_CREDIT_DIGITAL_SECURITIES: 'organization_manage_credit_digital_securities',
    ORGANIZATION_MANAGE_DISTRIBUTION: 'organization_manage_distribution',
    ORGANIZATION_MANAGE_IDENTIFICATION_DATA: 'organization_manage_identification_data',
    ORGANIZATION_MANAGE_INCOMING_PAYMENTS: 'organization_manage_incoming_payments',
    ORGANIZATION_MANAGE_INVESTMENTS: 'organization_manage_investments',
    ORGANIZATION_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'organization_manage_investor_and_investment_data',
    ORGANIZATION_MANAGE_INVESTOR_DOCUMENTS: 'organization_manage_investor_documents',
    ORGANIZATION_MANAGE_ISSUER_CASHLINK_STUDIO: 'organization_manage_issuer_cashlink_studio',
    ORGANIZATION_MANAGE_LISTINGS: 'organization_manage_listings',
    ORGANIZATION_MANAGE_MARKET_PRICES: 'organization_manage_market_prices',
    ORGANIZATION_MANAGE_PAYOUT_EVENTS: 'organization_manage_payout_events',
    ORGANIZATION_MANAGE_PRODUCT_DATA: 'organization_manage_product_data',
    ORGANIZATION_MANAGE_REDEMPTIONS: 'organization_manage_redemptions',
    ORGANIZATION_MANAGE_VOUCHERS: 'organization_manage_vouchers',
    ORGANIZATION_TRIGGER_SOLUTION: 'organization_trigger_solution',
    ORGANIZATION_USE_ISSUER_API: 'organization_use_issuer_api',
    ORGANIZATION_VIEW_DATA: 'organization_view_data',
    ORGANIZATION_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_view_distribution_information_and_investment_documents',
    ORGANIZATION_VIEW_FRIEND_REFERRALS: 'organization_view_friend_referrals',
    ORGANIZATION_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'organization_view_investor_and_investment_data',
    ORGANIZATION_VIEW_ISSUER_CASHLINK_STUDIO: 'organization_view_issuer_cashlink_studio',
    TRIGGER_SOLUTION: 'trigger_solution',
    USE_ISSUER_API: 'use_issuer_api',
    VIEW_DATA: 'view_data',
    VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'view_distribution_information_and_investment_documents',
    VIEW_FRIEND_REFERRALS: 'view_friend_referrals',
    VIEW_INVESTOR_AND_INVESTMENT_DATA: 'view_investor_and_investment_data',
    VIEW_ISSUER_CASHLINK_STUDIO: 'view_issuer_cashlink_studio',
    VIEW_ORGANIZATION_DATA: 'view_organization_data'
} as const;
export type AdminGroupPermissionsValuesRetrievePermissionCodeEnum = typeof AdminGroupPermissionsValuesRetrievePermissionCodeEnum[keyof typeof AdminGroupPermissionsValuesRetrievePermissionCodeEnum];
/**
 * @export
 */
export const AdminGroupPermissionsValuesRetrievePermissionTypeEnum = {
    DISTRIBUTION_PLATFORM: 'DISTRIBUTION_PLATFORM',
    ENVIRONMENT: 'ENVIRONMENT',
    ISSUER: 'ISSUER',
    ORGANIZATION: 'ORGANIZATION',
    PRODUCT: 'PRODUCT'
} as const;
export type AdminGroupPermissionsValuesRetrievePermissionTypeEnum = typeof AdminGroupPermissionsValuesRetrievePermissionTypeEnum[keyof typeof AdminGroupPermissionsValuesRetrievePermissionTypeEnum];
/**
 * @export
 */
export const AdminGroupsDropdownListFieldEnum = {
    NAME: 'name',
    ORGANIZATION_NAME: 'organization_name'
} as const;
export type AdminGroupsDropdownListFieldEnum = typeof AdminGroupsDropdownListFieldEnum[keyof typeof AdminGroupsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminGroupsDropdownListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    ORGANIZATION_NAME_DESC: '-organization_name',
    ORGANIZATION_NAME_ASC: 'organization_name'
} as const;
export type AdminGroupsDropdownListOrderingEnum = typeof AdminGroupsDropdownListOrderingEnum[keyof typeof AdminGroupsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminGroupsListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    ORGANIZATION_NAME_DESC: '-organization_name',
    ORGANIZATION_NAME_ASC: 'organization_name'
} as const;
export type AdminGroupsListOrderingEnum = typeof AdminGroupsListOrderingEnum[keyof typeof AdminGroupsListOrderingEnum];
/**
 * @export
 */
export const AdminGroupsValuesRetrieveFieldEnum = {
    NAME: 'name',
    ORGANIZATION_NAME: 'organization_name'
} as const;
export type AdminGroupsValuesRetrieveFieldEnum = typeof AdminGroupsValuesRetrieveFieldEnum[keyof typeof AdminGroupsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminGroupsValuesRetrieveOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    ORGANIZATION_NAME_DESC: '-organization_name',
    ORGANIZATION_NAME_ASC: 'organization_name'
} as const;
export type AdminGroupsValuesRetrieveOrderingEnum = typeof AdminGroupsValuesRetrieveOrderingEnum[keyof typeof AdminGroupsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminInvestmentTransfersDropdownListFieldEnum = {
    INVESTOR_NAME_RECIPIENT: 'investor_name_recipient',
    INVESTOR_NAME_SENDER: 'investor_name_sender',
    RECIPIENT_COLUMN: 'recipient_column',
    SENDER_COLUMN: 'sender_column'
} as const;
export type AdminInvestmentTransfersDropdownListFieldEnum = typeof AdminInvestmentTransfersDropdownListFieldEnum[keyof typeof AdminInvestmentTransfersDropdownListFieldEnum];
/**
 * @export
 */
export const AdminInvestmentTransfersDropdownListOrderingEnum = {
    AMOUNT_DESC: '-amount',
    AMOUNT_ASC: 'amount',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    INVESTOR_NAME_RECIPIENT_DESC: '-investor_name_recipient',
    INVESTOR_NAME_RECIPIENT_ASC: 'investor_name_recipient',
    INVESTOR_NAME_SENDER_DESC: '-investor_name_sender',
    INVESTOR_NAME_SENDER_ASC: 'investor_name_sender',
    RECIPIENT_COLUMN_DESC: '-recipient_column',
    RECIPIENT_COLUMN_ASC: 'recipient_column',
    SENDER_COLUMN_DESC: '-sender_column',
    SENDER_COLUMN_ASC: 'sender_column',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status'
} as const;
export type AdminInvestmentTransfersDropdownListOrderingEnum = typeof AdminInvestmentTransfersDropdownListOrderingEnum[keyof typeof AdminInvestmentTransfersDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminInvestmentTransfersDropdownListStatusEnum = {
    APPROVER_REJECTED: 'approver_rejected',
    COMPLETED: 'completed',
    FAILED: 'failed',
    PENDING: 'pending',
    PROCESSING: 'processing',
    TFA_CONFIRMED: 'tfa_confirmed',
    TFA_REJECTED: 'tfa_rejected',
    TFA_REQUESTED: 'tfa_requested'
} as const;
export type AdminInvestmentTransfersDropdownListStatusEnum = typeof AdminInvestmentTransfersDropdownListStatusEnum[keyof typeof AdminInvestmentTransfersDropdownListStatusEnum];
/**
 * @export
 */
export const AdminInvestmentTransfersListOrderingEnum = {
    AMOUNT_DESC: '-amount',
    AMOUNT_ASC: 'amount',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    INVESTOR_NAME_RECIPIENT_DESC: '-investor_name_recipient',
    INVESTOR_NAME_RECIPIENT_ASC: 'investor_name_recipient',
    INVESTOR_NAME_SENDER_DESC: '-investor_name_sender',
    INVESTOR_NAME_SENDER_ASC: 'investor_name_sender',
    RECIPIENT_COLUMN_DESC: '-recipient_column',
    RECIPIENT_COLUMN_ASC: 'recipient_column',
    SENDER_COLUMN_DESC: '-sender_column',
    SENDER_COLUMN_ASC: 'sender_column',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status'
} as const;
export type AdminInvestmentTransfersListOrderingEnum = typeof AdminInvestmentTransfersListOrderingEnum[keyof typeof AdminInvestmentTransfersListOrderingEnum];
/**
 * @export
 */
export const AdminInvestmentTransfersListStatusEnum = {
    APPROVER_REJECTED: 'approver_rejected',
    COMPLETED: 'completed',
    FAILED: 'failed',
    PENDING: 'pending',
    PROCESSING: 'processing',
    TFA_CONFIRMED: 'tfa_confirmed',
    TFA_REJECTED: 'tfa_rejected',
    TFA_REQUESTED: 'tfa_requested'
} as const;
export type AdminInvestmentTransfersListStatusEnum = typeof AdminInvestmentTransfersListStatusEnum[keyof typeof AdminInvestmentTransfersListStatusEnum];
/**
 * @export
 */
export const AdminInvestmentTransfersValuesRetrieveFieldEnum = {
    INVESTOR_NAME_RECIPIENT: 'investor_name_recipient',
    INVESTOR_NAME_SENDER: 'investor_name_sender',
    RECIPIENT_COLUMN: 'recipient_column',
    SENDER_COLUMN: 'sender_column'
} as const;
export type AdminInvestmentTransfersValuesRetrieveFieldEnum = typeof AdminInvestmentTransfersValuesRetrieveFieldEnum[keyof typeof AdminInvestmentTransfersValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminInvestmentTransfersValuesRetrieveOrderingEnum = {
    AMOUNT_DESC: '-amount',
    AMOUNT_ASC: 'amount',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    INVESTOR_NAME_RECIPIENT_DESC: '-investor_name_recipient',
    INVESTOR_NAME_RECIPIENT_ASC: 'investor_name_recipient',
    INVESTOR_NAME_SENDER_DESC: '-investor_name_sender',
    INVESTOR_NAME_SENDER_ASC: 'investor_name_sender',
    RECIPIENT_COLUMN_DESC: '-recipient_column',
    RECIPIENT_COLUMN_ASC: 'recipient_column',
    SENDER_COLUMN_DESC: '-sender_column',
    SENDER_COLUMN_ASC: 'sender_column',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status'
} as const;
export type AdminInvestmentTransfersValuesRetrieveOrderingEnum = typeof AdminInvestmentTransfersValuesRetrieveOrderingEnum[keyof typeof AdminInvestmentTransfersValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminInvestmentTransfersValuesRetrieveStatusEnum = {
    APPROVER_REJECTED: 'approver_rejected',
    COMPLETED: 'completed',
    FAILED: 'failed',
    PENDING: 'pending',
    PROCESSING: 'processing',
    TFA_CONFIRMED: 'tfa_confirmed',
    TFA_REJECTED: 'tfa_rejected',
    TFA_REQUESTED: 'tfa_requested'
} as const;
export type AdminInvestmentTransfersValuesRetrieveStatusEnum = typeof AdminInvestmentTransfersValuesRetrieveStatusEnum[keyof typeof AdminInvestmentTransfersValuesRetrieveStatusEnum];
/**
 * @export
 */
export const AdminInvestmentsDropdownListAcquisitionTypeEnum = {
    HANDOVER: 'HANDOVER',
    ISSUANCE: 'ISSUANCE'
} as const;
export type AdminInvestmentsDropdownListAcquisitionTypeEnum = typeof AdminInvestmentsDropdownListAcquisitionTypeEnum[keyof typeof AdminInvestmentsDropdownListAcquisitionTypeEnum];
/**
 * @export
 */
export const AdminInvestmentsDropdownListAddWalletLaterEnum = {
    CASHLINK: 'CASHLINK',
    GENERIC: 'GENERIC',
    MOBILE: 'MOBILE',
    TANGANY: 'TANGANY'
} as const;
export type AdminInvestmentsDropdownListAddWalletLaterEnum = typeof AdminInvestmentsDropdownListAddWalletLaterEnum[keyof typeof AdminInvestmentsDropdownListAddWalletLaterEnum];
/**
 * @export
 */
export const AdminInvestmentsDropdownListCancellationReasonEnum = {
    ABORTION: 'ABORTION',
    CANCELLATION: 'CANCELLATION',
    DISTRIBUTION_INFORMATION_UPDATED: 'DISTRIBUTION_INFORMATION_UPDATED',
    KYC_INSUFFICIENT: 'KYC_INSUFFICIENT',
    PAYMENT_MISSING: 'PAYMENT_MISSING',
    REJECTION: 'REJECTION',
    REJECTION_ECSP: 'REJECTION_ECSP'
} as const;
export type AdminInvestmentsDropdownListCancellationReasonEnum = typeof AdminInvestmentsDropdownListCancellationReasonEnum[keyof typeof AdminInvestmentsDropdownListCancellationReasonEnum];
/**
 * @export
 */
export const AdminInvestmentsDropdownListFieldEnum = {
    DISTRIBUTION_PLATFORM_DISPLAY_NAME: 'distribution_platform_display_name',
    FRONTEND_STATUS: 'frontend_status',
    INVESTOR_NAME: 'investor_name',
    PAYMENT_CODE: 'payment_code',
    PRODUCT_NAME: 'product_name'
} as const;
export type AdminInvestmentsDropdownListFieldEnum = typeof AdminInvestmentsDropdownListFieldEnum[keyof typeof AdminInvestmentsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminInvestmentsDropdownListFrontendStatusEnum = {
    ABORTED: 'Aborted',
    ACCEPTANCE_MISSING: 'AcceptanceMissing',
    ADDITIONAL_INFORMATION_PENDING: 'AdditionalInformationPending',
    CANCELED_KYC_INSUFFICIENT: 'CanceledKycInsufficient',
    CANCELED_PAYMENT_MISSING: 'CanceledPaymentMissing',
    CANCELLATION: 'Cancellation',
    FINISHED: 'Finished',
    HANDOVER: 'Handover',
    IDENTIFICATION_COMPLIANCE_PENDING: 'IdentificationCompliancePending',
    IDENTIFICATION_PENDING: 'IdentificationPending',
    PAYMENT_PENDING: 'PaymentPending',
    REJECTED: 'Rejected',
    SECURITIES_TRANSFERRED: 'SecuritiesTransferred',
    SECURITY_TRANSFER_MISSING: 'SecurityTransferMissing',
    SUCCESS_FULLY_TRANSFERED: 'SuccessFullyTransfered',
    SUCCESS_PARTIALLY_TRANSFERED: 'SuccessPartiallyTransfered',
    SUCCESS_REDEEMED: 'SuccessRedeemed',
    TAX_INFORMATION_MISSING: 'TaxInformationMissing',
    TRANSACTION_FAILED: 'TransactionFailed',
    TRANSACTION_PENDING: 'TransactionPending',
    TRANSACTION_SUCCEEDED: 'TransactionSucceeded',
    WALLET_SETUP_PENDING: 'WalletSetupPending'
} as const;
export type AdminInvestmentsDropdownListFrontendStatusEnum = typeof AdminInvestmentsDropdownListFrontendStatusEnum[keyof typeof AdminInvestmentsDropdownListFrontendStatusEnum];
/**
 * @export
 */
export const AdminInvestmentsDropdownListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_DESC: '-distribution_platform_display_name',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_ASC: 'distribution_platform_display_name',
    FRONTEND_STATUS_DESC: '-frontend_status',
    FRONTEND_STATUS_ASC: 'frontend_status',
    FULFILLED_AMOUNT_DESC: '-fulfilled_amount',
    FULFILLED_AMOUNT_ASC: 'fulfilled_amount',
    ID_DESC: '-id',
    ID_ASC: 'id',
    INVESTMENT_TOTAL_DESC: '-investment_total',
    INVESTMENT_TOTAL_ASC: 'investment_total',
    INVESTOR_NAME_DESC: '-investor_name',
    INVESTOR_NAME_ASC: 'investor_name',
    PAYMENT_CODE_DESC: '-payment_code',
    PAYMENT_CODE_ASC: 'payment_code',
    PAYMENT_DEADLINE_DESC: '-payment_deadline',
    PAYMENT_DEADLINE_ASC: 'payment_deadline',
    PAYMENT_TOTAL_DESC: '-payment_total',
    PAYMENT_TOTAL_ASC: 'payment_total',
    PRODUCT_NAME_DESC: '-product_name',
    PRODUCT_NAME_ASC: 'product_name',
    SIGNED_AT_DESC: '-signed_at',
    SIGNED_AT_ASC: 'signed_at'
} as const;
export type AdminInvestmentsDropdownListOrderingEnum = typeof AdminInvestmentsDropdownListOrderingEnum[keyof typeof AdminInvestmentsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminInvestmentsDropdownListStatusEnum = {
    ACCEPTABLE: 'acceptable',
    ALL: 'all',
    FINISHED: 'finished',
    NOT_DELETED: 'not-deleted',
    OPEN: 'open',
    PAID: 'paid',
    PAYMENT_OUTSTANDING: 'payment-outstanding',
    SECURITIES_OUTSTANDING: 'securities-outstanding'
} as const;
export type AdminInvestmentsDropdownListStatusEnum = typeof AdminInvestmentsDropdownListStatusEnum[keyof typeof AdminInvestmentsDropdownListStatusEnum];
/**
 * @export
 */
export const AdminInvestmentsDropdownListStepEnum = {
    ACCOUNT_SETUP: 'ACCOUNT_SETUP',
    ADDITIONAL_INFORMATION: 'ADDITIONAL_INFORMATION',
    BENEFICIARY: 'BENEFICIARY',
    CANCELED: 'CANCELED',
    CONFIRM_WALLET: 'CONFIRM_WALLET',
    FINAL: 'FINAL',
    IDENTIFICATION: 'IDENTIFICATION',
    IDENTIFICATION_FAILED: 'IDENTIFICATION_FAILED',
    IDENTIFICATION_REJECTED: 'IDENTIFICATION_REJECTED',
    INVESTMENT_AMOUNT: 'INVESTMENT_AMOUNT',
    OFFER_CREATION: 'OFFER_CREATION',
    PAYMENT: 'PAYMENT',
    PREPARE_ASSET: 'PREPARE_ASSET',
    QUESTIONNAIRE: 'QUESTIONNAIRE',
    RESUME_IDENTIFICATION: 'RESUME_IDENTIFICATION',
    SELECT_WALLET: 'SELECT_WALLET',
    SETUP_MOBILE_WALLET: 'SETUP_MOBILE_WALLET',
    TAX_INFORMATION: 'TAX_INFORMATION',
    UNCONFIRMED: 'UNCONFIRMED',
    VIB: 'VIB',
    WAITING_ACCEPTANCE: 'WAITING_ACCEPTANCE',
    WAITING_COMPLIANCE: 'WAITING_COMPLIANCE',
    WAITING_KYC: 'WAITING_KYC'
} as const;
export type AdminInvestmentsDropdownListStepEnum = typeof AdminInvestmentsDropdownListStepEnum[keyof typeof AdminInvestmentsDropdownListStepEnum];
/**
 * @export
 */
export const AdminInvestmentsDropdownListSurveyWaiverTypeEnum = {
    NO_ANSWERS: 'NO_ANSWERS',
    UNSUITABLE: 'UNSUITABLE'
} as const;
export type AdminInvestmentsDropdownListSurveyWaiverTypeEnum = typeof AdminInvestmentsDropdownListSurveyWaiverTypeEnum[keyof typeof AdminInvestmentsDropdownListSurveyWaiverTypeEnum];
/**
 * @export
 */
export const AdminInvestmentsListAcquisitionTypeEnum = {
    HANDOVER: 'HANDOVER',
    ISSUANCE: 'ISSUANCE'
} as const;
export type AdminInvestmentsListAcquisitionTypeEnum = typeof AdminInvestmentsListAcquisitionTypeEnum[keyof typeof AdminInvestmentsListAcquisitionTypeEnum];
/**
 * @export
 */
export const AdminInvestmentsListAddWalletLaterEnum = {
    CASHLINK: 'CASHLINK',
    GENERIC: 'GENERIC',
    MOBILE: 'MOBILE',
    TANGANY: 'TANGANY'
} as const;
export type AdminInvestmentsListAddWalletLaterEnum = typeof AdminInvestmentsListAddWalletLaterEnum[keyof typeof AdminInvestmentsListAddWalletLaterEnum];
/**
 * @export
 */
export const AdminInvestmentsListCancellationReasonEnum = {
    ABORTION: 'ABORTION',
    CANCELLATION: 'CANCELLATION',
    DISTRIBUTION_INFORMATION_UPDATED: 'DISTRIBUTION_INFORMATION_UPDATED',
    KYC_INSUFFICIENT: 'KYC_INSUFFICIENT',
    PAYMENT_MISSING: 'PAYMENT_MISSING',
    REJECTION: 'REJECTION',
    REJECTION_ECSP: 'REJECTION_ECSP'
} as const;
export type AdminInvestmentsListCancellationReasonEnum = typeof AdminInvestmentsListCancellationReasonEnum[keyof typeof AdminInvestmentsListCancellationReasonEnum];
/**
 * @export
 */
export const AdminInvestmentsListFrontendStatusEnum = {
    ABORTED: 'Aborted',
    ACCEPTANCE_MISSING: 'AcceptanceMissing',
    ADDITIONAL_INFORMATION_PENDING: 'AdditionalInformationPending',
    CANCELED_KYC_INSUFFICIENT: 'CanceledKycInsufficient',
    CANCELED_PAYMENT_MISSING: 'CanceledPaymentMissing',
    CANCELLATION: 'Cancellation',
    FINISHED: 'Finished',
    HANDOVER: 'Handover',
    IDENTIFICATION_COMPLIANCE_PENDING: 'IdentificationCompliancePending',
    IDENTIFICATION_PENDING: 'IdentificationPending',
    PAYMENT_PENDING: 'PaymentPending',
    REJECTED: 'Rejected',
    SECURITIES_TRANSFERRED: 'SecuritiesTransferred',
    SECURITY_TRANSFER_MISSING: 'SecurityTransferMissing',
    SUCCESS_FULLY_TRANSFERED: 'SuccessFullyTransfered',
    SUCCESS_PARTIALLY_TRANSFERED: 'SuccessPartiallyTransfered',
    SUCCESS_REDEEMED: 'SuccessRedeemed',
    TAX_INFORMATION_MISSING: 'TaxInformationMissing',
    TRANSACTION_FAILED: 'TransactionFailed',
    TRANSACTION_PENDING: 'TransactionPending',
    TRANSACTION_SUCCEEDED: 'TransactionSucceeded',
    WALLET_SETUP_PENDING: 'WalletSetupPending'
} as const;
export type AdminInvestmentsListFrontendStatusEnum = typeof AdminInvestmentsListFrontendStatusEnum[keyof typeof AdminInvestmentsListFrontendStatusEnum];
/**
 * @export
 */
export const AdminInvestmentsListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_DESC: '-distribution_platform_display_name',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_ASC: 'distribution_platform_display_name',
    FRONTEND_STATUS_DESC: '-frontend_status',
    FRONTEND_STATUS_ASC: 'frontend_status',
    FULFILLED_AMOUNT_DESC: '-fulfilled_amount',
    FULFILLED_AMOUNT_ASC: 'fulfilled_amount',
    ID_DESC: '-id',
    ID_ASC: 'id',
    INVESTMENT_TOTAL_DESC: '-investment_total',
    INVESTMENT_TOTAL_ASC: 'investment_total',
    INVESTOR_NAME_DESC: '-investor_name',
    INVESTOR_NAME_ASC: 'investor_name',
    PAYMENT_CODE_DESC: '-payment_code',
    PAYMENT_CODE_ASC: 'payment_code',
    PAYMENT_DEADLINE_DESC: '-payment_deadline',
    PAYMENT_DEADLINE_ASC: 'payment_deadline',
    PAYMENT_TOTAL_DESC: '-payment_total',
    PAYMENT_TOTAL_ASC: 'payment_total',
    PRODUCT_NAME_DESC: '-product_name',
    PRODUCT_NAME_ASC: 'product_name',
    SIGNED_AT_DESC: '-signed_at',
    SIGNED_AT_ASC: 'signed_at'
} as const;
export type AdminInvestmentsListOrderingEnum = typeof AdminInvestmentsListOrderingEnum[keyof typeof AdminInvestmentsListOrderingEnum];
/**
 * @export
 */
export const AdminInvestmentsListStatusEnum = {
    ACCEPTABLE: 'acceptable',
    ALL: 'all',
    FINISHED: 'finished',
    NOT_DELETED: 'not-deleted',
    OPEN: 'open',
    PAID: 'paid',
    PAYMENT_OUTSTANDING: 'payment-outstanding',
    SECURITIES_OUTSTANDING: 'securities-outstanding'
} as const;
export type AdminInvestmentsListStatusEnum = typeof AdminInvestmentsListStatusEnum[keyof typeof AdminInvestmentsListStatusEnum];
/**
 * @export
 */
export const AdminInvestmentsListStepEnum = {
    ACCOUNT_SETUP: 'ACCOUNT_SETUP',
    ADDITIONAL_INFORMATION: 'ADDITIONAL_INFORMATION',
    BENEFICIARY: 'BENEFICIARY',
    CANCELED: 'CANCELED',
    CONFIRM_WALLET: 'CONFIRM_WALLET',
    FINAL: 'FINAL',
    IDENTIFICATION: 'IDENTIFICATION',
    IDENTIFICATION_FAILED: 'IDENTIFICATION_FAILED',
    IDENTIFICATION_REJECTED: 'IDENTIFICATION_REJECTED',
    INVESTMENT_AMOUNT: 'INVESTMENT_AMOUNT',
    OFFER_CREATION: 'OFFER_CREATION',
    PAYMENT: 'PAYMENT',
    PREPARE_ASSET: 'PREPARE_ASSET',
    QUESTIONNAIRE: 'QUESTIONNAIRE',
    RESUME_IDENTIFICATION: 'RESUME_IDENTIFICATION',
    SELECT_WALLET: 'SELECT_WALLET',
    SETUP_MOBILE_WALLET: 'SETUP_MOBILE_WALLET',
    TAX_INFORMATION: 'TAX_INFORMATION',
    UNCONFIRMED: 'UNCONFIRMED',
    VIB: 'VIB',
    WAITING_ACCEPTANCE: 'WAITING_ACCEPTANCE',
    WAITING_COMPLIANCE: 'WAITING_COMPLIANCE',
    WAITING_KYC: 'WAITING_KYC'
} as const;
export type AdminInvestmentsListStepEnum = typeof AdminInvestmentsListStepEnum[keyof typeof AdminInvestmentsListStepEnum];
/**
 * @export
 */
export const AdminInvestmentsListSurveyWaiverTypeEnum = {
    NO_ANSWERS: 'NO_ANSWERS',
    UNSUITABLE: 'UNSUITABLE'
} as const;
export type AdminInvestmentsListSurveyWaiverTypeEnum = typeof AdminInvestmentsListSurveyWaiverTypeEnum[keyof typeof AdminInvestmentsListSurveyWaiverTypeEnum];
/**
 * @export
 */
export const AdminInvestmentsValuesRetrieveFieldEnum = {
    DISTRIBUTION_PLATFORM_DISPLAY_NAME: 'distribution_platform_display_name',
    FRONTEND_STATUS: 'frontend_status',
    INVESTOR_NAME: 'investor_name',
    PAYMENT_CODE: 'payment_code',
    PRODUCT_NAME: 'product_name'
} as const;
export type AdminInvestmentsValuesRetrieveFieldEnum = typeof AdminInvestmentsValuesRetrieveFieldEnum[keyof typeof AdminInvestmentsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminInvestmentsValuesRetrieveAcquisitionTypeEnum = {
    HANDOVER: 'HANDOVER',
    ISSUANCE: 'ISSUANCE'
} as const;
export type AdminInvestmentsValuesRetrieveAcquisitionTypeEnum = typeof AdminInvestmentsValuesRetrieveAcquisitionTypeEnum[keyof typeof AdminInvestmentsValuesRetrieveAcquisitionTypeEnum];
/**
 * @export
 */
export const AdminInvestmentsValuesRetrieveAddWalletLaterEnum = {
    CASHLINK: 'CASHLINK',
    GENERIC: 'GENERIC',
    MOBILE: 'MOBILE',
    TANGANY: 'TANGANY'
} as const;
export type AdminInvestmentsValuesRetrieveAddWalletLaterEnum = typeof AdminInvestmentsValuesRetrieveAddWalletLaterEnum[keyof typeof AdminInvestmentsValuesRetrieveAddWalletLaterEnum];
/**
 * @export
 */
export const AdminInvestmentsValuesRetrieveCancellationReasonEnum = {
    ABORTION: 'ABORTION',
    CANCELLATION: 'CANCELLATION',
    DISTRIBUTION_INFORMATION_UPDATED: 'DISTRIBUTION_INFORMATION_UPDATED',
    KYC_INSUFFICIENT: 'KYC_INSUFFICIENT',
    PAYMENT_MISSING: 'PAYMENT_MISSING',
    REJECTION: 'REJECTION',
    REJECTION_ECSP: 'REJECTION_ECSP'
} as const;
export type AdminInvestmentsValuesRetrieveCancellationReasonEnum = typeof AdminInvestmentsValuesRetrieveCancellationReasonEnum[keyof typeof AdminInvestmentsValuesRetrieveCancellationReasonEnum];
/**
 * @export
 */
export const AdminInvestmentsValuesRetrieveFrontendStatusEnum = {
    ABORTED: 'Aborted',
    ACCEPTANCE_MISSING: 'AcceptanceMissing',
    ADDITIONAL_INFORMATION_PENDING: 'AdditionalInformationPending',
    CANCELED_KYC_INSUFFICIENT: 'CanceledKycInsufficient',
    CANCELED_PAYMENT_MISSING: 'CanceledPaymentMissing',
    CANCELLATION: 'Cancellation',
    FINISHED: 'Finished',
    HANDOVER: 'Handover',
    IDENTIFICATION_COMPLIANCE_PENDING: 'IdentificationCompliancePending',
    IDENTIFICATION_PENDING: 'IdentificationPending',
    PAYMENT_PENDING: 'PaymentPending',
    REJECTED: 'Rejected',
    SECURITIES_TRANSFERRED: 'SecuritiesTransferred',
    SECURITY_TRANSFER_MISSING: 'SecurityTransferMissing',
    SUCCESS_FULLY_TRANSFERED: 'SuccessFullyTransfered',
    SUCCESS_PARTIALLY_TRANSFERED: 'SuccessPartiallyTransfered',
    SUCCESS_REDEEMED: 'SuccessRedeemed',
    TAX_INFORMATION_MISSING: 'TaxInformationMissing',
    TRANSACTION_FAILED: 'TransactionFailed',
    TRANSACTION_PENDING: 'TransactionPending',
    TRANSACTION_SUCCEEDED: 'TransactionSucceeded',
    WALLET_SETUP_PENDING: 'WalletSetupPending'
} as const;
export type AdminInvestmentsValuesRetrieveFrontendStatusEnum = typeof AdminInvestmentsValuesRetrieveFrontendStatusEnum[keyof typeof AdminInvestmentsValuesRetrieveFrontendStatusEnum];
/**
 * @export
 */
export const AdminInvestmentsValuesRetrieveOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_DESC: '-distribution_platform_display_name',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_ASC: 'distribution_platform_display_name',
    FRONTEND_STATUS_DESC: '-frontend_status',
    FRONTEND_STATUS_ASC: 'frontend_status',
    FULFILLED_AMOUNT_DESC: '-fulfilled_amount',
    FULFILLED_AMOUNT_ASC: 'fulfilled_amount',
    ID_DESC: '-id',
    ID_ASC: 'id',
    INVESTMENT_TOTAL_DESC: '-investment_total',
    INVESTMENT_TOTAL_ASC: 'investment_total',
    INVESTOR_NAME_DESC: '-investor_name',
    INVESTOR_NAME_ASC: 'investor_name',
    PAYMENT_CODE_DESC: '-payment_code',
    PAYMENT_CODE_ASC: 'payment_code',
    PAYMENT_DEADLINE_DESC: '-payment_deadline',
    PAYMENT_DEADLINE_ASC: 'payment_deadline',
    PAYMENT_TOTAL_DESC: '-payment_total',
    PAYMENT_TOTAL_ASC: 'payment_total',
    PRODUCT_NAME_DESC: '-product_name',
    PRODUCT_NAME_ASC: 'product_name',
    SIGNED_AT_DESC: '-signed_at',
    SIGNED_AT_ASC: 'signed_at'
} as const;
export type AdminInvestmentsValuesRetrieveOrderingEnum = typeof AdminInvestmentsValuesRetrieveOrderingEnum[keyof typeof AdminInvestmentsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminInvestmentsValuesRetrieveStatusEnum = {
    ACCEPTABLE: 'acceptable',
    ALL: 'all',
    FINISHED: 'finished',
    NOT_DELETED: 'not-deleted',
    OPEN: 'open',
    PAID: 'paid',
    PAYMENT_OUTSTANDING: 'payment-outstanding',
    SECURITIES_OUTSTANDING: 'securities-outstanding'
} as const;
export type AdminInvestmentsValuesRetrieveStatusEnum = typeof AdminInvestmentsValuesRetrieveStatusEnum[keyof typeof AdminInvestmentsValuesRetrieveStatusEnum];
/**
 * @export
 */
export const AdminInvestmentsValuesRetrieveStepEnum = {
    ACCOUNT_SETUP: 'ACCOUNT_SETUP',
    ADDITIONAL_INFORMATION: 'ADDITIONAL_INFORMATION',
    BENEFICIARY: 'BENEFICIARY',
    CANCELED: 'CANCELED',
    CONFIRM_WALLET: 'CONFIRM_WALLET',
    FINAL: 'FINAL',
    IDENTIFICATION: 'IDENTIFICATION',
    IDENTIFICATION_FAILED: 'IDENTIFICATION_FAILED',
    IDENTIFICATION_REJECTED: 'IDENTIFICATION_REJECTED',
    INVESTMENT_AMOUNT: 'INVESTMENT_AMOUNT',
    OFFER_CREATION: 'OFFER_CREATION',
    PAYMENT: 'PAYMENT',
    PREPARE_ASSET: 'PREPARE_ASSET',
    QUESTIONNAIRE: 'QUESTIONNAIRE',
    RESUME_IDENTIFICATION: 'RESUME_IDENTIFICATION',
    SELECT_WALLET: 'SELECT_WALLET',
    SETUP_MOBILE_WALLET: 'SETUP_MOBILE_WALLET',
    TAX_INFORMATION: 'TAX_INFORMATION',
    UNCONFIRMED: 'UNCONFIRMED',
    VIB: 'VIB',
    WAITING_ACCEPTANCE: 'WAITING_ACCEPTANCE',
    WAITING_COMPLIANCE: 'WAITING_COMPLIANCE',
    WAITING_KYC: 'WAITING_KYC'
} as const;
export type AdminInvestmentsValuesRetrieveStepEnum = typeof AdminInvestmentsValuesRetrieveStepEnum[keyof typeof AdminInvestmentsValuesRetrieveStepEnum];
/**
 * @export
 */
export const AdminInvestmentsValuesRetrieveSurveyWaiverTypeEnum = {
    NO_ANSWERS: 'NO_ANSWERS',
    UNSUITABLE: 'UNSUITABLE'
} as const;
export type AdminInvestmentsValuesRetrieveSurveyWaiverTypeEnum = typeof AdminInvestmentsValuesRetrieveSurveyWaiverTypeEnum[keyof typeof AdminInvestmentsValuesRetrieveSurveyWaiverTypeEnum];
/**
 * @export
 */
export const AdminInvestorsBenefitingPersonsListOrderingEnum = {
    ACTIVE_INVESTMENTS_SUM_DESC: '-active_investments_sum',
    ACTIVE_INVESTMENTS_SUM_ASC: 'active_investments_sum',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_DESC: '-distribution_platform_display_name',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_ASC: 'distribution_platform_display_name',
    EMAIL_DESC: '-email',
    EMAIL_ASC: 'email',
    ID_DESC: '-id',
    ID_ASC: 'id',
    INVESTOR_NAME_DESC: '-investor_name',
    INVESTOR_NAME_ASC: 'investor_name',
    LAST_NAME_DESC: '-last_name',
    LAST_NAME_ASC: 'last_name',
    REGISTERED_AT_DESC: '-registered_at',
    REGISTERED_AT_ASC: 'registered_at'
} as const;
export type AdminInvestorsBenefitingPersonsListOrderingEnum = typeof AdminInvestorsBenefitingPersonsListOrderingEnum[keyof typeof AdminInvestorsBenefitingPersonsListOrderingEnum];
/**
 * @export
 */
export const AdminInvestorsDropdownListFieldEnum = {
    DISTRIBUTION_PLATFORM_DISPLAY_NAME: 'distribution_platform_display_name',
    EMAIL: 'email',
    INVESTOR_NAME: 'investor_name',
    LAST_NAME: 'last_name'
} as const;
export type AdminInvestorsDropdownListFieldEnum = typeof AdminInvestorsDropdownListFieldEnum[keyof typeof AdminInvestorsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminInvestorsDropdownListOrderingEnum = {
    ACTIVE_INVESTMENTS_SUM_DESC: '-active_investments_sum',
    ACTIVE_INVESTMENTS_SUM_ASC: 'active_investments_sum',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_DESC: '-distribution_platform_display_name',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_ASC: 'distribution_platform_display_name',
    EMAIL_DESC: '-email',
    EMAIL_ASC: 'email',
    ID_DESC: '-id',
    ID_ASC: 'id',
    INVESTOR_NAME_DESC: '-investor_name',
    INVESTOR_NAME_ASC: 'investor_name',
    LAST_NAME_DESC: '-last_name',
    LAST_NAME_ASC: 'last_name',
    REGISTERED_AT_DESC: '-registered_at',
    REGISTERED_AT_ASC: 'registered_at'
} as const;
export type AdminInvestorsDropdownListOrderingEnum = typeof AdminInvestorsDropdownListOrderingEnum[keyof typeof AdminInvestorsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminInvestorsIncompleteListOrderingEnum = {
    ACTIVE_INVESTMENTS_SUM_DESC: '-active_investments_sum',
    ACTIVE_INVESTMENTS_SUM_ASC: 'active_investments_sum',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_DESC: '-distribution_platform_display_name',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_ASC: 'distribution_platform_display_name',
    EMAIL_DESC: '-email',
    EMAIL_ASC: 'email',
    ID_DESC: '-id',
    ID_ASC: 'id',
    INVESTOR_NAME_DESC: '-investor_name',
    INVESTOR_NAME_ASC: 'investor_name',
    LAST_NAME_DESC: '-last_name',
    LAST_NAME_ASC: 'last_name',
    REGISTERED_AT_DESC: '-registered_at',
    REGISTERED_AT_ASC: 'registered_at'
} as const;
export type AdminInvestorsIncompleteListOrderingEnum = typeof AdminInvestorsIncompleteListOrderingEnum[keyof typeof AdminInvestorsIncompleteListOrderingEnum];
/**
 * @export
 */
export const AdminInvestorsListOrderingEnum = {
    ACTIVE_INVESTMENTS_SUM_DESC: '-active_investments_sum',
    ACTIVE_INVESTMENTS_SUM_ASC: 'active_investments_sum',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_DESC: '-distribution_platform_display_name',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_ASC: 'distribution_platform_display_name',
    EMAIL_DESC: '-email',
    EMAIL_ASC: 'email',
    ID_DESC: '-id',
    ID_ASC: 'id',
    INVESTOR_NAME_DESC: '-investor_name',
    INVESTOR_NAME_ASC: 'investor_name',
    LAST_NAME_DESC: '-last_name',
    LAST_NAME_ASC: 'last_name',
    REGISTERED_AT_DESC: '-registered_at',
    REGISTERED_AT_ASC: 'registered_at'
} as const;
export type AdminInvestorsListOrderingEnum = typeof AdminInvestorsListOrderingEnum[keyof typeof AdminInvestorsListOrderingEnum];
/**
 * @export
 */
export const AdminInvestorsValuesRetrieveFieldEnum = {
    DISTRIBUTION_PLATFORM_DISPLAY_NAME: 'distribution_platform_display_name',
    EMAIL: 'email',
    INVESTOR_NAME: 'investor_name',
    LAST_NAME: 'last_name'
} as const;
export type AdminInvestorsValuesRetrieveFieldEnum = typeof AdminInvestorsValuesRetrieveFieldEnum[keyof typeof AdminInvestorsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminInvestorsValuesRetrieveOrderingEnum = {
    ACTIVE_INVESTMENTS_SUM_DESC: '-active_investments_sum',
    ACTIVE_INVESTMENTS_SUM_ASC: 'active_investments_sum',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_DESC: '-distribution_platform_display_name',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_ASC: 'distribution_platform_display_name',
    EMAIL_DESC: '-email',
    EMAIL_ASC: 'email',
    ID_DESC: '-id',
    ID_ASC: 'id',
    INVESTOR_NAME_DESC: '-investor_name',
    INVESTOR_NAME_ASC: 'investor_name',
    LAST_NAME_DESC: '-last_name',
    LAST_NAME_ASC: 'last_name',
    REGISTERED_AT_DESC: '-registered_at',
    REGISTERED_AT_ASC: 'registered_at'
} as const;
export type AdminInvestorsValuesRetrieveOrderingEnum = typeof AdminInvestorsValuesRetrieveOrderingEnum[keyof typeof AdminInvestorsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminInvitationsDropdownListFieldEnum = {
    DISTRIBUTION_PLATFORM_DISPLAY_NAME: 'distribution_platform_display_name',
    NAME: 'name',
    PRODUCT_NAME: 'product_name'
} as const;
export type AdminInvitationsDropdownListFieldEnum = typeof AdminInvitationsDropdownListFieldEnum[keyof typeof AdminInvitationsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminInvitationsDropdownListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_DESC: '-distribution_platform_display_name',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_ASC: 'distribution_platform_display_name',
    ID_DESC: '-id',
    ID_ASC: 'id',
    INVESTMENT_DESC: '-investment',
    INVESTMENT_ASC: 'investment',
    MAX_NUMBER_OF_TOKENS_DESC: '-max_number_of_tokens',
    MAX_NUMBER_OF_TOKENS_ASC: 'max_number_of_tokens',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    PRICE_PER_UNIT_DESC: '-price_per_unit',
    PRICE_PER_UNIT_ASC: 'price_per_unit',
    PRODUCT_NAME_DESC: '-product_name',
    PRODUCT_NAME_ASC: 'product_name',
    SIGNED_PERCENTAGE_DESC: '-signed_percentage',
    SIGNED_PERCENTAGE_ASC: 'signed_percentage'
} as const;
export type AdminInvitationsDropdownListOrderingEnum = typeof AdminInvitationsDropdownListOrderingEnum[keyof typeof AdminInvitationsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminInvitationsListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_DESC: '-distribution_platform_display_name',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_ASC: 'distribution_platform_display_name',
    ID_DESC: '-id',
    ID_ASC: 'id',
    INVESTMENT_DESC: '-investment',
    INVESTMENT_ASC: 'investment',
    MAX_NUMBER_OF_TOKENS_DESC: '-max_number_of_tokens',
    MAX_NUMBER_OF_TOKENS_ASC: 'max_number_of_tokens',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    PRICE_PER_UNIT_DESC: '-price_per_unit',
    PRICE_PER_UNIT_ASC: 'price_per_unit',
    PRODUCT_NAME_DESC: '-product_name',
    PRODUCT_NAME_ASC: 'product_name',
    SIGNED_PERCENTAGE_DESC: '-signed_percentage',
    SIGNED_PERCENTAGE_ASC: 'signed_percentage'
} as const;
export type AdminInvitationsListOrderingEnum = typeof AdminInvitationsListOrderingEnum[keyof typeof AdminInvitationsListOrderingEnum];
/**
 * @export
 */
export const AdminInvitationsValuesRetrieveFieldEnum = {
    DISTRIBUTION_PLATFORM_DISPLAY_NAME: 'distribution_platform_display_name',
    NAME: 'name',
    PRODUCT_NAME: 'product_name'
} as const;
export type AdminInvitationsValuesRetrieveFieldEnum = typeof AdminInvitationsValuesRetrieveFieldEnum[keyof typeof AdminInvitationsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminInvitationsValuesRetrieveOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_DESC: '-distribution_platform_display_name',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_ASC: 'distribution_platform_display_name',
    ID_DESC: '-id',
    ID_ASC: 'id',
    INVESTMENT_DESC: '-investment',
    INVESTMENT_ASC: 'investment',
    MAX_NUMBER_OF_TOKENS_DESC: '-max_number_of_tokens',
    MAX_NUMBER_OF_TOKENS_ASC: 'max_number_of_tokens',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    PRICE_PER_UNIT_DESC: '-price_per_unit',
    PRICE_PER_UNIT_ASC: 'price_per_unit',
    PRODUCT_NAME_DESC: '-product_name',
    PRODUCT_NAME_ASC: 'product_name',
    SIGNED_PERCENTAGE_DESC: '-signed_percentage',
    SIGNED_PERCENTAGE_ASC: 'signed_percentage'
} as const;
export type AdminInvitationsValuesRetrieveOrderingEnum = typeof AdminInvitationsValuesRetrieveOrderingEnum[keyof typeof AdminInvitationsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminIssuersDropdownListFieldEnum = {
    COMPANY_NAME: 'company_name',
    ORGANIZATION_NAME: 'organization_name'
} as const;
export type AdminIssuersDropdownListFieldEnum = typeof AdminIssuersDropdownListFieldEnum[keyof typeof AdminIssuersDropdownListFieldEnum];
/**
 * @export
 */
export const AdminIssuersDropdownListOrderingEnum = {
    COMPANY_NAME_DESC: '-company_name',
    COMPANY_NAME_ASC: 'company_name',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NUMBER_OF_PRODUCTS_DESC: '-number_of_products',
    NUMBER_OF_PRODUCTS_ASC: 'number_of_products',
    ORGANIZATION_NAME_DESC: '-organization_name',
    ORGANIZATION_NAME_ASC: 'organization_name'
} as const;
export type AdminIssuersDropdownListOrderingEnum = typeof AdminIssuersDropdownListOrderingEnum[keyof typeof AdminIssuersDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminIssuersDropdownListPermissionsEnum = {
    CREATE_PRODUCT_CASHLINK_STUDIO: 'create_product_cashlink_studio',
    MANAGE_ISSUER_CASHLINK_STUDIO: 'manage_issuer_cashlink_studio',
    MANAGE_LISTINGS: 'manage_listings',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    USE_ISSUER_API: 'use_issuer_api',
    VIEW_ISSUER_CASHLINK_STUDIO: 'view_issuer_cashlink_studio'
} as const;
export type AdminIssuersDropdownListPermissionsEnum = typeof AdminIssuersDropdownListPermissionsEnum[keyof typeof AdminIssuersDropdownListPermissionsEnum];
/**
 * @export
 */
export const AdminIssuersDropdownOrganizationForIssuerCreationListOrderingEnum = {
    COMPANY_NAME_DESC: '-company_name',
    COMPANY_NAME_ASC: 'company_name',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NUMBER_OF_PRODUCTS_DESC: '-number_of_products',
    NUMBER_OF_PRODUCTS_ASC: 'number_of_products',
    ORGANIZATION_NAME_DESC: '-organization_name',
    ORGANIZATION_NAME_ASC: 'organization_name'
} as const;
export type AdminIssuersDropdownOrganizationForIssuerCreationListOrderingEnum = typeof AdminIssuersDropdownOrganizationForIssuerCreationListOrderingEnum[keyof typeof AdminIssuersDropdownOrganizationForIssuerCreationListOrderingEnum];
/**
 * @export
 */
export const AdminIssuersListOrderingEnum = {
    COMPANY_NAME_DESC: '-company_name',
    COMPANY_NAME_ASC: 'company_name',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NUMBER_OF_PRODUCTS_DESC: '-number_of_products',
    NUMBER_OF_PRODUCTS_ASC: 'number_of_products',
    ORGANIZATION_NAME_DESC: '-organization_name',
    ORGANIZATION_NAME_ASC: 'organization_name'
} as const;
export type AdminIssuersListOrderingEnum = typeof AdminIssuersListOrderingEnum[keyof typeof AdminIssuersListOrderingEnum];
/**
 * @export
 */
export const AdminIssuersListPermissionsEnum = {
    CREATE_PRODUCT_CASHLINK_STUDIO: 'create_product_cashlink_studio',
    MANAGE_ISSUER_CASHLINK_STUDIO: 'manage_issuer_cashlink_studio',
    MANAGE_LISTINGS: 'manage_listings',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    USE_ISSUER_API: 'use_issuer_api',
    VIEW_ISSUER_CASHLINK_STUDIO: 'view_issuer_cashlink_studio'
} as const;
export type AdminIssuersListPermissionsEnum = typeof AdminIssuersListPermissionsEnum[keyof typeof AdminIssuersListPermissionsEnum];
/**
 * @export
 */
export const AdminIssuersValuesRetrieveFieldEnum = {
    COMPANY_NAME: 'company_name',
    ORGANIZATION_NAME: 'organization_name'
} as const;
export type AdminIssuersValuesRetrieveFieldEnum = typeof AdminIssuersValuesRetrieveFieldEnum[keyof typeof AdminIssuersValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminIssuersValuesRetrieveOrderingEnum = {
    COMPANY_NAME_DESC: '-company_name',
    COMPANY_NAME_ASC: 'company_name',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NUMBER_OF_PRODUCTS_DESC: '-number_of_products',
    NUMBER_OF_PRODUCTS_ASC: 'number_of_products',
    ORGANIZATION_NAME_DESC: '-organization_name',
    ORGANIZATION_NAME_ASC: 'organization_name'
} as const;
export type AdminIssuersValuesRetrieveOrderingEnum = typeof AdminIssuersValuesRetrieveOrderingEnum[keyof typeof AdminIssuersValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminIssuersValuesRetrievePermissionsEnum = {
    CREATE_PRODUCT_CASHLINK_STUDIO: 'create_product_cashlink_studio',
    MANAGE_ISSUER_CASHLINK_STUDIO: 'manage_issuer_cashlink_studio',
    MANAGE_LISTINGS: 'manage_listings',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    USE_ISSUER_API: 'use_issuer_api',
    VIEW_ISSUER_CASHLINK_STUDIO: 'view_issuer_cashlink_studio'
} as const;
export type AdminIssuersValuesRetrievePermissionsEnum = typeof AdminIssuersValuesRetrievePermissionsEnum[keyof typeof AdminIssuersValuesRetrievePermissionsEnum];
/**
 * @export
 */
export const AdminListingsDropdownListFieldEnum = {
    DISTRIBUTION_PLATFORM_DISPLAY_NAME: 'distribution_platform_display_name'
} as const;
export type AdminListingsDropdownListFieldEnum = typeof AdminListingsDropdownListFieldEnum[keyof typeof AdminListingsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminListingsDropdownListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_DESC: '-distribution_platform_display_name',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_ASC: 'distribution_platform_display_name',
    ID_DESC: '-id',
    ID_ASC: 'id',
    PRODUCT_ID_DESC: '-product_id',
    PRODUCT_ID_ASC: 'product_id'
} as const;
export type AdminListingsDropdownListOrderingEnum = typeof AdminListingsDropdownListOrderingEnum[keyof typeof AdminListingsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminListingsListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_DESC: '-distribution_platform_display_name',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_ASC: 'distribution_platform_display_name',
    ID_DESC: '-id',
    ID_ASC: 'id',
    PRODUCT_ID_DESC: '-product_id',
    PRODUCT_ID_ASC: 'product_id'
} as const;
export type AdminListingsListOrderingEnum = typeof AdminListingsListOrderingEnum[keyof typeof AdminListingsListOrderingEnum];
/**
 * @export
 */
export const AdminListingsValuesRetrieveFieldEnum = {
    DISTRIBUTION_PLATFORM_DISPLAY_NAME: 'distribution_platform_display_name'
} as const;
export type AdminListingsValuesRetrieveFieldEnum = typeof AdminListingsValuesRetrieveFieldEnum[keyof typeof AdminListingsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminListingsValuesRetrieveOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_DESC: '-distribution_platform_display_name',
    DISTRIBUTION_PLATFORM_DISPLAY_NAME_ASC: 'distribution_platform_display_name',
    ID_DESC: '-id',
    ID_ASC: 'id',
    PRODUCT_ID_DESC: '-product_id',
    PRODUCT_ID_ASC: 'product_id'
} as const;
export type AdminListingsValuesRetrieveOrderingEnum = typeof AdminListingsValuesRetrieveOrderingEnum[keyof typeof AdminListingsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminMailsDropdownListFieldEnum = {
    PRODUCT: 'product',
    SUBJECT: 'subject',
    TYPE: 'type'
} as const;
export type AdminMailsDropdownListFieldEnum = typeof AdminMailsDropdownListFieldEnum[keyof typeof AdminMailsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminMailsDropdownListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    PRODUCT_DESC: '-product',
    PRODUCT_ASC: 'product',
    SEND_AT_DESC: '-send_at',
    SEND_AT_ASC: 'send_at',
    SUBJECT_DESC: '-subject',
    SUBJECT_ASC: 'subject',
    TYPE_DESC: '-type',
    TYPE_ASC: 'type'
} as const;
export type AdminMailsDropdownListOrderingEnum = typeof AdminMailsDropdownListOrderingEnum[keyof typeof AdminMailsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminMailsDropdownListTypeEnum = {
    ADMIN: 'ADMIN',
    ADMIN_COMPLIANCE_NEW: 'ADMIN_COMPLIANCE_NEW',
    ADMIN_CRYPTOSECURITY_PUBLICATION_RESTRICTED: 'ADMIN_CRYPTOSECURITY_PUBLICATION_RESTRICTED',
    ADMIN_CRYPTOSECURITY_VALIDATION_REQUIRED: 'ADMIN_CRYPTOSECURITY_VALIDATION_REQUIRED',
    ADMIN_KYC_CALL_FOR_ACTION: 'ADMIN_KYC_CALL_FOR_ACTION',
    ADMIN_PAYOUT_EVENT_OCCURING: 'ADMIN_PAYOUT_EVENT_OCCURING',
    DEMO_INVESTOR_ACTIVATION: 'DEMO_INVESTOR_ACTIVATION',
    DEMO_ISSUER_ACTIVATION: 'DEMO_ISSUER_ACTIVATION',
    DEMO_ISSUER_START: 'DEMO_ISSUER_START',
    DISTRIBUTOR_DISTRIBUTION_INFORMATION_MISSING: 'DISTRIBUTOR_DISTRIBUTION_INFORMATION_MISSING',
    INVESTOR_2_FA_RESET: 'INVESTOR_2FA_RESET',
    INVESTOR_2_FA_SETUP: 'INVESTOR_2FA_SETUP',
    INVESTOR_COSTS: 'INVESTOR_COSTS',
    INVESTOR_DEPOT_ACTIVATION: 'INVESTOR_DEPOT_ACTIVATION',
    INVESTOR_EWPG_DOC: 'INVESTOR_EWPG_DOC',
    INVESTOR_INVESTMENT_CANCELLED_BY_ECSP_SWITCH: 'INVESTOR_INVESTMENT_CANCELLED_BY_ECSP_SWITCH',
    INVESTOR_INVESTMENT_CONSIDERATION_PERIOD: 'INVESTOR_INVESTMENT_CONSIDERATION_PERIOD',
    INVESTOR_INVESTMENT_EXPERIENCE_SUMMARY: 'INVESTOR_INVESTMENT_EXPERIENCE_SUMMARY',
    INVESTOR_KYC_SUCCESSFUL: 'INVESTOR_KYC_SUCCESSFUL',
    INVESTOR_OFFER_ACCEPTED: 'INVESTOR_OFFER_ACCEPTED',
    INVESTOR_OFFER_REJECTED: 'INVESTOR_OFFER_REJECTED',
    INVESTOR_PAYMENT_RECEIVED: 'INVESTOR_PAYMENT_RECEIVED',
    INVESTOR_PENDING_DELETION: 'INVESTOR_PENDING_DELETION',
    INVESTOR_PRODUCT_DOCUMENTS: 'INVESTOR_PRODUCT_DOCUMENTS',
    INVESTOR_REACTIVATED: 'INVESTOR_REACTIVATED',
    INVESTOR_REMINDER_ADDITIONAL_INFORMATION: 'INVESTOR_REMINDER_ADDITIONAL_INFORMATION',
    INVESTOR_REMINDER_COMMITMENT: 'INVESTOR_REMINDER_COMMITMENT',
    INVESTOR_REMINDER_IDENT: 'INVESTOR_REMINDER_IDENT',
    INVESTOR_REMINDER_PAYMENT: 'INVESTOR_REMINDER_PAYMENT',
    INVESTOR_REMINDER_QUESTIONNAIRE: 'INVESTOR_REMINDER_QUESTIONNAIRE',
    INVESTOR_REMINDER_WALLET: 'INVESTOR_REMINDER_WALLET',
    INVESTOR_TOKEN_SENT: 'INVESTOR_TOKEN_SENT',
    INVESTOR_TOKEN_TRANSFER_RECEIVED: 'INVESTOR_TOKEN_TRANSFER_RECEIVED',
    INVESTOR_TOS_UPDATE: 'INVESTOR_TOS_UPDATE',
    ISSUER_CRYPTOSECURITY_REJECTED: 'ISSUER_CRYPTOSECURITY_REJECTED',
    ISSUER_CRYPTOSECURITY_SUCCESSFUL: 'ISSUER_CRYPTOSECURITY_SUCCESSFUL',
    ISSUER_NEW_DOCUMENT: 'ISSUER_NEW_DOCUMENT',
    ISSUER_NEW_OFFER: 'ISSUER_NEW_OFFER',
    ISSUER_PAYMENT_INCOMING: 'ISSUER_PAYMENT_INCOMING',
    ISSUER_PUBLICATION_REMOVAL_IMMINENT: 'ISSUER_PUBLICATION_REMOVAL_IMMINENT',
    ISSUER_TOKEN_READY_TO_SEND: 'ISSUER_TOKEN_READY_TO_SEND',
    OFFBOARDING_HANDOVER_DOCS: 'OFFBOARDING_HANDOVER_DOCS',
    REDO_KYC: 'REDO_KYC',
    STATISTICS: 'STATISTICS',
    TRANSFER_INVITEE_READY: 'TRANSFER_INVITEE_READY',
    USER_EMAIL_CHANGED: 'USER_EMAIL_CHANGED',
    USER_EMAIL_CONFIRMATION: 'USER_EMAIL_CONFIRMATION',
    USER_ORGANIZATION_INVITATION: 'USER_ORGANIZATION_INVITATION',
    USER_RESET_PASSWORD: 'USER_RESET_PASSWORD',
    VOUCHER_FRIEND_REDEMPTION: 'VOUCHER_FRIEND_REDEMPTION'
} as const;
export type AdminMailsDropdownListTypeEnum = typeof AdminMailsDropdownListTypeEnum[keyof typeof AdminMailsDropdownListTypeEnum];
/**
 * @export
 */
export const AdminMailsListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    PRODUCT_DESC: '-product',
    PRODUCT_ASC: 'product',
    SEND_AT_DESC: '-send_at',
    SEND_AT_ASC: 'send_at',
    SUBJECT_DESC: '-subject',
    SUBJECT_ASC: 'subject',
    TYPE_DESC: '-type',
    TYPE_ASC: 'type'
} as const;
export type AdminMailsListOrderingEnum = typeof AdminMailsListOrderingEnum[keyof typeof AdminMailsListOrderingEnum];
/**
 * @export
 */
export const AdminMailsListTypeEnum = {
    ADMIN: 'ADMIN',
    ADMIN_COMPLIANCE_NEW: 'ADMIN_COMPLIANCE_NEW',
    ADMIN_CRYPTOSECURITY_PUBLICATION_RESTRICTED: 'ADMIN_CRYPTOSECURITY_PUBLICATION_RESTRICTED',
    ADMIN_CRYPTOSECURITY_VALIDATION_REQUIRED: 'ADMIN_CRYPTOSECURITY_VALIDATION_REQUIRED',
    ADMIN_KYC_CALL_FOR_ACTION: 'ADMIN_KYC_CALL_FOR_ACTION',
    ADMIN_PAYOUT_EVENT_OCCURING: 'ADMIN_PAYOUT_EVENT_OCCURING',
    DEMO_INVESTOR_ACTIVATION: 'DEMO_INVESTOR_ACTIVATION',
    DEMO_ISSUER_ACTIVATION: 'DEMO_ISSUER_ACTIVATION',
    DEMO_ISSUER_START: 'DEMO_ISSUER_START',
    DISTRIBUTOR_DISTRIBUTION_INFORMATION_MISSING: 'DISTRIBUTOR_DISTRIBUTION_INFORMATION_MISSING',
    INVESTOR_2_FA_RESET: 'INVESTOR_2FA_RESET',
    INVESTOR_2_FA_SETUP: 'INVESTOR_2FA_SETUP',
    INVESTOR_COSTS: 'INVESTOR_COSTS',
    INVESTOR_DEPOT_ACTIVATION: 'INVESTOR_DEPOT_ACTIVATION',
    INVESTOR_EWPG_DOC: 'INVESTOR_EWPG_DOC',
    INVESTOR_INVESTMENT_CANCELLED_BY_ECSP_SWITCH: 'INVESTOR_INVESTMENT_CANCELLED_BY_ECSP_SWITCH',
    INVESTOR_INVESTMENT_CONSIDERATION_PERIOD: 'INVESTOR_INVESTMENT_CONSIDERATION_PERIOD',
    INVESTOR_INVESTMENT_EXPERIENCE_SUMMARY: 'INVESTOR_INVESTMENT_EXPERIENCE_SUMMARY',
    INVESTOR_KYC_SUCCESSFUL: 'INVESTOR_KYC_SUCCESSFUL',
    INVESTOR_OFFER_ACCEPTED: 'INVESTOR_OFFER_ACCEPTED',
    INVESTOR_OFFER_REJECTED: 'INVESTOR_OFFER_REJECTED',
    INVESTOR_PAYMENT_RECEIVED: 'INVESTOR_PAYMENT_RECEIVED',
    INVESTOR_PENDING_DELETION: 'INVESTOR_PENDING_DELETION',
    INVESTOR_PRODUCT_DOCUMENTS: 'INVESTOR_PRODUCT_DOCUMENTS',
    INVESTOR_REACTIVATED: 'INVESTOR_REACTIVATED',
    INVESTOR_REMINDER_ADDITIONAL_INFORMATION: 'INVESTOR_REMINDER_ADDITIONAL_INFORMATION',
    INVESTOR_REMINDER_COMMITMENT: 'INVESTOR_REMINDER_COMMITMENT',
    INVESTOR_REMINDER_IDENT: 'INVESTOR_REMINDER_IDENT',
    INVESTOR_REMINDER_PAYMENT: 'INVESTOR_REMINDER_PAYMENT',
    INVESTOR_REMINDER_QUESTIONNAIRE: 'INVESTOR_REMINDER_QUESTIONNAIRE',
    INVESTOR_REMINDER_WALLET: 'INVESTOR_REMINDER_WALLET',
    INVESTOR_TOKEN_SENT: 'INVESTOR_TOKEN_SENT',
    INVESTOR_TOKEN_TRANSFER_RECEIVED: 'INVESTOR_TOKEN_TRANSFER_RECEIVED',
    INVESTOR_TOS_UPDATE: 'INVESTOR_TOS_UPDATE',
    ISSUER_CRYPTOSECURITY_REJECTED: 'ISSUER_CRYPTOSECURITY_REJECTED',
    ISSUER_CRYPTOSECURITY_SUCCESSFUL: 'ISSUER_CRYPTOSECURITY_SUCCESSFUL',
    ISSUER_NEW_DOCUMENT: 'ISSUER_NEW_DOCUMENT',
    ISSUER_NEW_OFFER: 'ISSUER_NEW_OFFER',
    ISSUER_PAYMENT_INCOMING: 'ISSUER_PAYMENT_INCOMING',
    ISSUER_PUBLICATION_REMOVAL_IMMINENT: 'ISSUER_PUBLICATION_REMOVAL_IMMINENT',
    ISSUER_TOKEN_READY_TO_SEND: 'ISSUER_TOKEN_READY_TO_SEND',
    OFFBOARDING_HANDOVER_DOCS: 'OFFBOARDING_HANDOVER_DOCS',
    REDO_KYC: 'REDO_KYC',
    STATISTICS: 'STATISTICS',
    TRANSFER_INVITEE_READY: 'TRANSFER_INVITEE_READY',
    USER_EMAIL_CHANGED: 'USER_EMAIL_CHANGED',
    USER_EMAIL_CONFIRMATION: 'USER_EMAIL_CONFIRMATION',
    USER_ORGANIZATION_INVITATION: 'USER_ORGANIZATION_INVITATION',
    USER_RESET_PASSWORD: 'USER_RESET_PASSWORD',
    VOUCHER_FRIEND_REDEMPTION: 'VOUCHER_FRIEND_REDEMPTION'
} as const;
export type AdminMailsListTypeEnum = typeof AdminMailsListTypeEnum[keyof typeof AdminMailsListTypeEnum];
/**
 * @export
 */
export const AdminMailsValuesRetrieveFieldEnum = {
    PRODUCT: 'product',
    SUBJECT: 'subject',
    TYPE: 'type'
} as const;
export type AdminMailsValuesRetrieveFieldEnum = typeof AdminMailsValuesRetrieveFieldEnum[keyof typeof AdminMailsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminMailsValuesRetrieveOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    PRODUCT_DESC: '-product',
    PRODUCT_ASC: 'product',
    SEND_AT_DESC: '-send_at',
    SEND_AT_ASC: 'send_at',
    SUBJECT_DESC: '-subject',
    SUBJECT_ASC: 'subject',
    TYPE_DESC: '-type',
    TYPE_ASC: 'type'
} as const;
export type AdminMailsValuesRetrieveOrderingEnum = typeof AdminMailsValuesRetrieveOrderingEnum[keyof typeof AdminMailsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminMailsValuesRetrieveTypeEnum = {
    ADMIN: 'ADMIN',
    ADMIN_COMPLIANCE_NEW: 'ADMIN_COMPLIANCE_NEW',
    ADMIN_CRYPTOSECURITY_PUBLICATION_RESTRICTED: 'ADMIN_CRYPTOSECURITY_PUBLICATION_RESTRICTED',
    ADMIN_CRYPTOSECURITY_VALIDATION_REQUIRED: 'ADMIN_CRYPTOSECURITY_VALIDATION_REQUIRED',
    ADMIN_KYC_CALL_FOR_ACTION: 'ADMIN_KYC_CALL_FOR_ACTION',
    ADMIN_PAYOUT_EVENT_OCCURING: 'ADMIN_PAYOUT_EVENT_OCCURING',
    DEMO_INVESTOR_ACTIVATION: 'DEMO_INVESTOR_ACTIVATION',
    DEMO_ISSUER_ACTIVATION: 'DEMO_ISSUER_ACTIVATION',
    DEMO_ISSUER_START: 'DEMO_ISSUER_START',
    DISTRIBUTOR_DISTRIBUTION_INFORMATION_MISSING: 'DISTRIBUTOR_DISTRIBUTION_INFORMATION_MISSING',
    INVESTOR_2_FA_RESET: 'INVESTOR_2FA_RESET',
    INVESTOR_2_FA_SETUP: 'INVESTOR_2FA_SETUP',
    INVESTOR_COSTS: 'INVESTOR_COSTS',
    INVESTOR_DEPOT_ACTIVATION: 'INVESTOR_DEPOT_ACTIVATION',
    INVESTOR_EWPG_DOC: 'INVESTOR_EWPG_DOC',
    INVESTOR_INVESTMENT_CANCELLED_BY_ECSP_SWITCH: 'INVESTOR_INVESTMENT_CANCELLED_BY_ECSP_SWITCH',
    INVESTOR_INVESTMENT_CONSIDERATION_PERIOD: 'INVESTOR_INVESTMENT_CONSIDERATION_PERIOD',
    INVESTOR_INVESTMENT_EXPERIENCE_SUMMARY: 'INVESTOR_INVESTMENT_EXPERIENCE_SUMMARY',
    INVESTOR_KYC_SUCCESSFUL: 'INVESTOR_KYC_SUCCESSFUL',
    INVESTOR_OFFER_ACCEPTED: 'INVESTOR_OFFER_ACCEPTED',
    INVESTOR_OFFER_REJECTED: 'INVESTOR_OFFER_REJECTED',
    INVESTOR_PAYMENT_RECEIVED: 'INVESTOR_PAYMENT_RECEIVED',
    INVESTOR_PENDING_DELETION: 'INVESTOR_PENDING_DELETION',
    INVESTOR_PRODUCT_DOCUMENTS: 'INVESTOR_PRODUCT_DOCUMENTS',
    INVESTOR_REACTIVATED: 'INVESTOR_REACTIVATED',
    INVESTOR_REMINDER_ADDITIONAL_INFORMATION: 'INVESTOR_REMINDER_ADDITIONAL_INFORMATION',
    INVESTOR_REMINDER_COMMITMENT: 'INVESTOR_REMINDER_COMMITMENT',
    INVESTOR_REMINDER_IDENT: 'INVESTOR_REMINDER_IDENT',
    INVESTOR_REMINDER_PAYMENT: 'INVESTOR_REMINDER_PAYMENT',
    INVESTOR_REMINDER_QUESTIONNAIRE: 'INVESTOR_REMINDER_QUESTIONNAIRE',
    INVESTOR_REMINDER_WALLET: 'INVESTOR_REMINDER_WALLET',
    INVESTOR_TOKEN_SENT: 'INVESTOR_TOKEN_SENT',
    INVESTOR_TOKEN_TRANSFER_RECEIVED: 'INVESTOR_TOKEN_TRANSFER_RECEIVED',
    INVESTOR_TOS_UPDATE: 'INVESTOR_TOS_UPDATE',
    ISSUER_CRYPTOSECURITY_REJECTED: 'ISSUER_CRYPTOSECURITY_REJECTED',
    ISSUER_CRYPTOSECURITY_SUCCESSFUL: 'ISSUER_CRYPTOSECURITY_SUCCESSFUL',
    ISSUER_NEW_DOCUMENT: 'ISSUER_NEW_DOCUMENT',
    ISSUER_NEW_OFFER: 'ISSUER_NEW_OFFER',
    ISSUER_PAYMENT_INCOMING: 'ISSUER_PAYMENT_INCOMING',
    ISSUER_PUBLICATION_REMOVAL_IMMINENT: 'ISSUER_PUBLICATION_REMOVAL_IMMINENT',
    ISSUER_TOKEN_READY_TO_SEND: 'ISSUER_TOKEN_READY_TO_SEND',
    OFFBOARDING_HANDOVER_DOCS: 'OFFBOARDING_HANDOVER_DOCS',
    REDO_KYC: 'REDO_KYC',
    STATISTICS: 'STATISTICS',
    TRANSFER_INVITEE_READY: 'TRANSFER_INVITEE_READY',
    USER_EMAIL_CHANGED: 'USER_EMAIL_CHANGED',
    USER_EMAIL_CONFIRMATION: 'USER_EMAIL_CONFIRMATION',
    USER_ORGANIZATION_INVITATION: 'USER_ORGANIZATION_INVITATION',
    USER_RESET_PASSWORD: 'USER_RESET_PASSWORD',
    VOUCHER_FRIEND_REDEMPTION: 'VOUCHER_FRIEND_REDEMPTION'
} as const;
export type AdminMailsValuesRetrieveTypeEnum = typeof AdminMailsValuesRetrieveTypeEnum[keyof typeof AdminMailsValuesRetrieveTypeEnum];
/**
 * @export
 */
export const AdminOrganizationsDropdownListFieldEnum = {
    NAME: 'name'
} as const;
export type AdminOrganizationsDropdownListFieldEnum = typeof AdminOrganizationsDropdownListFieldEnum[keyof typeof AdminOrganizationsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminOrganizationsDropdownListLoginTypeEnum = {
    GOOGLE_SSO: 'GOOGLE_SSO',
    PASSWORD: 'PASSWORD'
} as const;
export type AdminOrganizationsDropdownListLoginTypeEnum = typeof AdminOrganizationsDropdownListLoginTypeEnum[keyof typeof AdminOrganizationsDropdownListLoginTypeEnum];
/**
 * @export
 */
export const AdminOrganizationsDropdownListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    HAS_SC_BANKING_DESC: '-has_sc_banking',
    HAS_SC_BANKING_ASC: 'has_sc_banking',
    HAS_SC_CORE_DESC: '-has_sc_core',
    HAS_SC_CORE_ASC: 'has_sc_core',
    HAS_SC_LAUNCHPAD_DESC: '-has_sc_launchpad',
    HAS_SC_LAUNCHPAD_ASC: 'has_sc_launchpad',
    HAS_SC_DISTRIBUTION_HUB_DESC: '-has_sc_distribution_hub',
    HAS_SC_DISTRIBUTION_HUB_ASC: 'has_sc_distribution_hub',
    ID_DESC: '-id',
    ID_ASC: 'id',
    LOGIN_TYPE_DESC: '-login_type',
    LOGIN_TYPE_ASC: 'login_type',
    NAME_DESC: '-name',
    NAME_ASC: 'name'
} as const;
export type AdminOrganizationsDropdownListOrderingEnum = typeof AdminOrganizationsDropdownListOrderingEnum[keyof typeof AdminOrganizationsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminOrganizationsDropdownListPermissionsEnum = {
    CAN_USE_ISSUER_API: 'can_use_issuer_api',
    CREATE_ISSUERS_VIA_CASHLINK_STUDIO: 'create_issuers_via_cashlink_studio',
    CREATE_ISSUERS_VIA_ISSUER_API: 'create_issuers_via_issuer_api',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    MANAGE_ORGANIZATION_USERS_AND_GROUPS: 'manage_organization_users_and_groups',
    ORGANIZATION_CREATE_INVESTOR_AND_INVESTMENT: 'organization_create_investor_and_investment',
    ORGANIZATION_CREATE_PRODUCT_CASHLINK_STUDIO: 'organization_create_product_cashlink_studio',
    ORGANIZATION_DOWNLOAD_PLATFORM_STATISTICS: 'organization_download_platform_statistics',
    ORGANIZATION_DOWNLOAD_STATISTICS: 'organization_download_statistics',
    ORGANIZATION_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_edit_distribution_information_and_investment_documents',
    ORGANIZATION_MANAGE_APPROVALS: 'organization_manage_approvals',
    ORGANIZATION_MANAGE_CREDIT_DIGITAL_SECURITIES: 'organization_manage_credit_digital_securities',
    ORGANIZATION_MANAGE_DISTRIBUTION: 'organization_manage_distribution',
    ORGANIZATION_MANAGE_IDENTIFICATION_DATA: 'organization_manage_identification_data',
    ORGANIZATION_MANAGE_INCOMING_PAYMENTS: 'organization_manage_incoming_payments',
    ORGANIZATION_MANAGE_INVESTMENTS: 'organization_manage_investments',
    ORGANIZATION_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'organization_manage_investor_and_investment_data',
    ORGANIZATION_MANAGE_INVESTOR_DOCUMENTS: 'organization_manage_investor_documents',
    ORGANIZATION_MANAGE_ISSUER_CASHLINK_STUDIO: 'organization_manage_issuer_cashlink_studio',
    ORGANIZATION_MANAGE_LISTINGS: 'organization_manage_listings',
    ORGANIZATION_MANAGE_MARKET_PRICES: 'organization_manage_market_prices',
    ORGANIZATION_MANAGE_PAYOUT_EVENTS: 'organization_manage_payout_events',
    ORGANIZATION_MANAGE_PRODUCT_DATA: 'organization_manage_product_data',
    ORGANIZATION_MANAGE_REDEMPTIONS: 'organization_manage_redemptions',
    ORGANIZATION_MANAGE_VOUCHERS: 'organization_manage_vouchers',
    ORGANIZATION_TRIGGER_SOLUTION: 'organization_trigger_solution',
    ORGANIZATION_USE_ISSUER_API: 'organization_use_issuer_api',
    ORGANIZATION_VIEW_DATA: 'organization_view_data',
    ORGANIZATION_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_view_distribution_information_and_investment_documents',
    ORGANIZATION_VIEW_FRIEND_REFERRALS: 'organization_view_friend_referrals',
    ORGANIZATION_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'organization_view_investor_and_investment_data',
    ORGANIZATION_VIEW_ISSUER_CASHLINK_STUDIO: 'organization_view_issuer_cashlink_studio',
    VIEW_ORGANIZATION_DATA: 'view_organization_data'
} as const;
export type AdminOrganizationsDropdownListPermissionsEnum = typeof AdminOrganizationsDropdownListPermissionsEnum[keyof typeof AdminOrganizationsDropdownListPermissionsEnum];
/**
 * @export
 */
export const AdminOrganizationsListLoginTypeEnum = {
    GOOGLE_SSO: 'GOOGLE_SSO',
    PASSWORD: 'PASSWORD'
} as const;
export type AdminOrganizationsListLoginTypeEnum = typeof AdminOrganizationsListLoginTypeEnum[keyof typeof AdminOrganizationsListLoginTypeEnum];
/**
 * @export
 */
export const AdminOrganizationsListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    HAS_SC_BANKING_DESC: '-has_sc_banking',
    HAS_SC_BANKING_ASC: 'has_sc_banking',
    HAS_SC_CORE_DESC: '-has_sc_core',
    HAS_SC_CORE_ASC: 'has_sc_core',
    HAS_SC_LAUNCHPAD_DESC: '-has_sc_launchpad',
    HAS_SC_LAUNCHPAD_ASC: 'has_sc_launchpad',
    HAS_SC_DISTRIBUTION_HUB_DESC: '-has_sc_distribution_hub',
    HAS_SC_DISTRIBUTION_HUB_ASC: 'has_sc_distribution_hub',
    ID_DESC: '-id',
    ID_ASC: 'id',
    LOGIN_TYPE_DESC: '-login_type',
    LOGIN_TYPE_ASC: 'login_type',
    NAME_DESC: '-name',
    NAME_ASC: 'name'
} as const;
export type AdminOrganizationsListOrderingEnum = typeof AdminOrganizationsListOrderingEnum[keyof typeof AdminOrganizationsListOrderingEnum];
/**
 * @export
 */
export const AdminOrganizationsListPermissionsEnum = {
    CAN_USE_ISSUER_API: 'can_use_issuer_api',
    CREATE_ISSUERS_VIA_CASHLINK_STUDIO: 'create_issuers_via_cashlink_studio',
    CREATE_ISSUERS_VIA_ISSUER_API: 'create_issuers_via_issuer_api',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    MANAGE_ORGANIZATION_USERS_AND_GROUPS: 'manage_organization_users_and_groups',
    ORGANIZATION_CREATE_INVESTOR_AND_INVESTMENT: 'organization_create_investor_and_investment',
    ORGANIZATION_CREATE_PRODUCT_CASHLINK_STUDIO: 'organization_create_product_cashlink_studio',
    ORGANIZATION_DOWNLOAD_PLATFORM_STATISTICS: 'organization_download_platform_statistics',
    ORGANIZATION_DOWNLOAD_STATISTICS: 'organization_download_statistics',
    ORGANIZATION_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_edit_distribution_information_and_investment_documents',
    ORGANIZATION_MANAGE_APPROVALS: 'organization_manage_approvals',
    ORGANIZATION_MANAGE_CREDIT_DIGITAL_SECURITIES: 'organization_manage_credit_digital_securities',
    ORGANIZATION_MANAGE_DISTRIBUTION: 'organization_manage_distribution',
    ORGANIZATION_MANAGE_IDENTIFICATION_DATA: 'organization_manage_identification_data',
    ORGANIZATION_MANAGE_INCOMING_PAYMENTS: 'organization_manage_incoming_payments',
    ORGANIZATION_MANAGE_INVESTMENTS: 'organization_manage_investments',
    ORGANIZATION_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'organization_manage_investor_and_investment_data',
    ORGANIZATION_MANAGE_INVESTOR_DOCUMENTS: 'organization_manage_investor_documents',
    ORGANIZATION_MANAGE_ISSUER_CASHLINK_STUDIO: 'organization_manage_issuer_cashlink_studio',
    ORGANIZATION_MANAGE_LISTINGS: 'organization_manage_listings',
    ORGANIZATION_MANAGE_MARKET_PRICES: 'organization_manage_market_prices',
    ORGANIZATION_MANAGE_PAYOUT_EVENTS: 'organization_manage_payout_events',
    ORGANIZATION_MANAGE_PRODUCT_DATA: 'organization_manage_product_data',
    ORGANIZATION_MANAGE_REDEMPTIONS: 'organization_manage_redemptions',
    ORGANIZATION_MANAGE_VOUCHERS: 'organization_manage_vouchers',
    ORGANIZATION_TRIGGER_SOLUTION: 'organization_trigger_solution',
    ORGANIZATION_USE_ISSUER_API: 'organization_use_issuer_api',
    ORGANIZATION_VIEW_DATA: 'organization_view_data',
    ORGANIZATION_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_view_distribution_information_and_investment_documents',
    ORGANIZATION_VIEW_FRIEND_REFERRALS: 'organization_view_friend_referrals',
    ORGANIZATION_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'organization_view_investor_and_investment_data',
    ORGANIZATION_VIEW_ISSUER_CASHLINK_STUDIO: 'organization_view_issuer_cashlink_studio',
    VIEW_ORGANIZATION_DATA: 'view_organization_data'
} as const;
export type AdminOrganizationsListPermissionsEnum = typeof AdminOrganizationsListPermissionsEnum[keyof typeof AdminOrganizationsListPermissionsEnum];
/**
 * @export
 */
export const AdminOrganizationsValuesRetrieveFieldEnum = {
    NAME: 'name'
} as const;
export type AdminOrganizationsValuesRetrieveFieldEnum = typeof AdminOrganizationsValuesRetrieveFieldEnum[keyof typeof AdminOrganizationsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminOrganizationsValuesRetrieveLoginTypeEnum = {
    GOOGLE_SSO: 'GOOGLE_SSO',
    PASSWORD: 'PASSWORD'
} as const;
export type AdminOrganizationsValuesRetrieveLoginTypeEnum = typeof AdminOrganizationsValuesRetrieveLoginTypeEnum[keyof typeof AdminOrganizationsValuesRetrieveLoginTypeEnum];
/**
 * @export
 */
export const AdminOrganizationsValuesRetrieveOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    HAS_SC_BANKING_DESC: '-has_sc_banking',
    HAS_SC_BANKING_ASC: 'has_sc_banking',
    HAS_SC_CORE_DESC: '-has_sc_core',
    HAS_SC_CORE_ASC: 'has_sc_core',
    HAS_SC_LAUNCHPAD_DESC: '-has_sc_launchpad',
    HAS_SC_LAUNCHPAD_ASC: 'has_sc_launchpad',
    HAS_SC_DISTRIBUTION_HUB_DESC: '-has_sc_distribution_hub',
    HAS_SC_DISTRIBUTION_HUB_ASC: 'has_sc_distribution_hub',
    ID_DESC: '-id',
    ID_ASC: 'id',
    LOGIN_TYPE_DESC: '-login_type',
    LOGIN_TYPE_ASC: 'login_type',
    NAME_DESC: '-name',
    NAME_ASC: 'name'
} as const;
export type AdminOrganizationsValuesRetrieveOrderingEnum = typeof AdminOrganizationsValuesRetrieveOrderingEnum[keyof typeof AdminOrganizationsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminOrganizationsValuesRetrievePermissionsEnum = {
    CAN_USE_ISSUER_API: 'can_use_issuer_api',
    CREATE_ISSUERS_VIA_CASHLINK_STUDIO: 'create_issuers_via_cashlink_studio',
    CREATE_ISSUERS_VIA_ISSUER_API: 'create_issuers_via_issuer_api',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    MANAGE_ORGANIZATION_USERS_AND_GROUPS: 'manage_organization_users_and_groups',
    ORGANIZATION_CREATE_INVESTOR_AND_INVESTMENT: 'organization_create_investor_and_investment',
    ORGANIZATION_CREATE_PRODUCT_CASHLINK_STUDIO: 'organization_create_product_cashlink_studio',
    ORGANIZATION_DOWNLOAD_PLATFORM_STATISTICS: 'organization_download_platform_statistics',
    ORGANIZATION_DOWNLOAD_STATISTICS: 'organization_download_statistics',
    ORGANIZATION_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_edit_distribution_information_and_investment_documents',
    ORGANIZATION_MANAGE_APPROVALS: 'organization_manage_approvals',
    ORGANIZATION_MANAGE_CREDIT_DIGITAL_SECURITIES: 'organization_manage_credit_digital_securities',
    ORGANIZATION_MANAGE_DISTRIBUTION: 'organization_manage_distribution',
    ORGANIZATION_MANAGE_IDENTIFICATION_DATA: 'organization_manage_identification_data',
    ORGANIZATION_MANAGE_INCOMING_PAYMENTS: 'organization_manage_incoming_payments',
    ORGANIZATION_MANAGE_INVESTMENTS: 'organization_manage_investments',
    ORGANIZATION_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'organization_manage_investor_and_investment_data',
    ORGANIZATION_MANAGE_INVESTOR_DOCUMENTS: 'organization_manage_investor_documents',
    ORGANIZATION_MANAGE_ISSUER_CASHLINK_STUDIO: 'organization_manage_issuer_cashlink_studio',
    ORGANIZATION_MANAGE_LISTINGS: 'organization_manage_listings',
    ORGANIZATION_MANAGE_MARKET_PRICES: 'organization_manage_market_prices',
    ORGANIZATION_MANAGE_PAYOUT_EVENTS: 'organization_manage_payout_events',
    ORGANIZATION_MANAGE_PRODUCT_DATA: 'organization_manage_product_data',
    ORGANIZATION_MANAGE_REDEMPTIONS: 'organization_manage_redemptions',
    ORGANIZATION_MANAGE_VOUCHERS: 'organization_manage_vouchers',
    ORGANIZATION_TRIGGER_SOLUTION: 'organization_trigger_solution',
    ORGANIZATION_USE_ISSUER_API: 'organization_use_issuer_api',
    ORGANIZATION_VIEW_DATA: 'organization_view_data',
    ORGANIZATION_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_view_distribution_information_and_investment_documents',
    ORGANIZATION_VIEW_FRIEND_REFERRALS: 'organization_view_friend_referrals',
    ORGANIZATION_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'organization_view_investor_and_investment_data',
    ORGANIZATION_VIEW_ISSUER_CASHLINK_STUDIO: 'organization_view_issuer_cashlink_studio',
    VIEW_ORGANIZATION_DATA: 'view_organization_data'
} as const;
export type AdminOrganizationsValuesRetrievePermissionsEnum = typeof AdminOrganizationsValuesRetrievePermissionsEnum[keyof typeof AdminOrganizationsValuesRetrievePermissionsEnum];
/**
 * @export
 */
export const AdminPayoutEventsDropdownListFieldEnum = {
    ISSUER: 'issuer',
    PRODUCT_NAME: 'product_name'
} as const;
export type AdminPayoutEventsDropdownListFieldEnum = typeof AdminPayoutEventsDropdownListFieldEnum[keyof typeof AdminPayoutEventsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminPayoutEventsDropdownListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    ISSUER_DESC: '-issuer',
    ISSUER_ASC: 'issuer',
    PAYMENT_DATE_DESC: '-payment_date',
    PAYMENT_DATE_ASC: 'payment_date',
    PAYOUT_EVENT_TYPE_DESC: '-payout_event_type',
    PAYOUT_EVENT_TYPE_ASC: 'payout_event_type',
    PRODUCT_NAME_DESC: '-product_name',
    PRODUCT_NAME_ASC: 'product_name'
} as const;
export type AdminPayoutEventsDropdownListOrderingEnum = typeof AdminPayoutEventsDropdownListOrderingEnum[keyof typeof AdminPayoutEventsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminPayoutEventsDropdownListPayoutEventTypeEnum = {
    DIVIDEND_PAYMENT: 'dividend_payment',
    INTEREST_PAYMENT: 'interest_payment',
    LIQUIDATION: 'liquidation',
    MATURITY_REDEMPTION: 'maturity_redemption'
} as const;
export type AdminPayoutEventsDropdownListPayoutEventTypeEnum = typeof AdminPayoutEventsDropdownListPayoutEventTypeEnum[keyof typeof AdminPayoutEventsDropdownListPayoutEventTypeEnum];
/**
 * @export
 */
export const AdminPayoutEventsListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    ISSUER_DESC: '-issuer',
    ISSUER_ASC: 'issuer',
    PAYMENT_DATE_DESC: '-payment_date',
    PAYMENT_DATE_ASC: 'payment_date',
    PAYOUT_EVENT_TYPE_DESC: '-payout_event_type',
    PAYOUT_EVENT_TYPE_ASC: 'payout_event_type',
    PRODUCT_NAME_DESC: '-product_name',
    PRODUCT_NAME_ASC: 'product_name'
} as const;
export type AdminPayoutEventsListOrderingEnum = typeof AdminPayoutEventsListOrderingEnum[keyof typeof AdminPayoutEventsListOrderingEnum];
/**
 * @export
 */
export const AdminPayoutEventsListPayoutEventTypeEnum = {
    DIVIDEND_PAYMENT: 'dividend_payment',
    INTEREST_PAYMENT: 'interest_payment',
    LIQUIDATION: 'liquidation',
    MATURITY_REDEMPTION: 'maturity_redemption'
} as const;
export type AdminPayoutEventsListPayoutEventTypeEnum = typeof AdminPayoutEventsListPayoutEventTypeEnum[keyof typeof AdminPayoutEventsListPayoutEventTypeEnum];
/**
 * @export
 */
export const AdminPayoutEventsValuesRetrieveFieldEnum = {
    ISSUER: 'issuer',
    PRODUCT_NAME: 'product_name'
} as const;
export type AdminPayoutEventsValuesRetrieveFieldEnum = typeof AdminPayoutEventsValuesRetrieveFieldEnum[keyof typeof AdminPayoutEventsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminPayoutEventsValuesRetrieveOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    ISSUER_DESC: '-issuer',
    ISSUER_ASC: 'issuer',
    PAYMENT_DATE_DESC: '-payment_date',
    PAYMENT_DATE_ASC: 'payment_date',
    PAYOUT_EVENT_TYPE_DESC: '-payout_event_type',
    PAYOUT_EVENT_TYPE_ASC: 'payout_event_type',
    PRODUCT_NAME_DESC: '-product_name',
    PRODUCT_NAME_ASC: 'product_name'
} as const;
export type AdminPayoutEventsValuesRetrieveOrderingEnum = typeof AdminPayoutEventsValuesRetrieveOrderingEnum[keyof typeof AdminPayoutEventsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminPayoutEventsValuesRetrievePayoutEventTypeEnum = {
    DIVIDEND_PAYMENT: 'dividend_payment',
    INTEREST_PAYMENT: 'interest_payment',
    LIQUIDATION: 'liquidation',
    MATURITY_REDEMPTION: 'maturity_redemption'
} as const;
export type AdminPayoutEventsValuesRetrievePayoutEventTypeEnum = typeof AdminPayoutEventsValuesRetrievePayoutEventTypeEnum[keyof typeof AdminPayoutEventsValuesRetrievePayoutEventTypeEnum];
/**
 * @export
 */
export const AdminProductPricesListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    PRICE_AT_DESC: '-price_at',
    PRICE_AT_ASC: 'price_at',
    PRICE_DESC: '-price',
    PRICE_ASC: 'price'
} as const;
export type AdminProductPricesListOrderingEnum = typeof AdminProductPricesListOrderingEnum[keyof typeof AdminProductPricesListOrderingEnum];
/**
 * @export
 */
export const AdminProductsDropdownListFieldEnum = {
    ISSUER_NAME: 'issuer_name',
    NAME: 'name'
} as const;
export type AdminProductsDropdownListFieldEnum = typeof AdminProductsDropdownListFieldEnum[keyof typeof AdminProductsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminProductsDropdownListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    ISSUER_NAME_DESC: '-issuer_name',
    ISSUER_NAME_ASC: 'issuer_name',
    MAX_ISSUABLE_AMOUNT_DESC: '-max_issuable_amount',
    MAX_ISSUABLE_AMOUNT_ASC: 'max_issuable_amount',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    PRODUCT_TYPE_DESC: '-product_type',
    PRODUCT_TYPE_ASC: 'product_type',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status'
} as const;
export type AdminProductsDropdownListOrderingEnum = typeof AdminProductsDropdownListOrderingEnum[keyof typeof AdminProductsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminProductsDropdownListPermissionEnum = {
    DOWNLOAD_STATISTICS: 'download_statistics',
    MANAGE_APPROVALS: 'manage_approvals',
    MANAGE_CREDIT_DIGITAL_SECURITIES: 'manage_credit_digital_securities',
    MANAGE_DISTRIBUTION: 'manage_distribution',
    MANAGE_INCOMING_PAYMENTS: 'manage_incoming_payments',
    MANAGE_INVESTMENTS: 'manage_investments',
    MANAGE_INVESTOR_DOCUMENTS: 'manage_investor_documents',
    MANAGE_MARKET_PRICES: 'manage_market_prices',
    MANAGE_PAYOUT_EVENTS: 'manage_payout_events',
    MANAGE_PRODUCT_DATA: 'manage_product_data',
    MANAGE_REDEMPTIONS: 'manage_redemptions',
    TRIGGER_SOLUTION: 'trigger_solution',
    VIEW_DATA: 'view_data'
} as const;
export type AdminProductsDropdownListPermissionEnum = typeof AdminProductsDropdownListPermissionEnum[keyof typeof AdminProductsDropdownListPermissionEnum];
/**
 * @export
 */
export const AdminProductsDropdownListPermissionOnIssuerEnum = {
    CREATE_PRODUCT_CASHLINK_STUDIO: 'create_product_cashlink_studio',
    MANAGE_ISSUER_CASHLINK_STUDIO: 'manage_issuer_cashlink_studio',
    MANAGE_LISTINGS: 'manage_listings',
    USE_ISSUER_API: 'use_issuer_api',
    VIEW_ISSUER_CASHLINK_STUDIO: 'view_issuer_cashlink_studio'
} as const;
export type AdminProductsDropdownListPermissionOnIssuerEnum = typeof AdminProductsDropdownListPermissionOnIssuerEnum[keyof typeof AdminProductsDropdownListPermissionOnIssuerEnum];
/**
 * @export
 */
export const AdminProductsDropdownListPermissionOnOrganizationEnum = {
    CAN_USE_ISSUER_API: 'can_use_issuer_api',
    CREATE_ISSUERS_VIA_CASHLINK_STUDIO: 'create_issuers_via_cashlink_studio',
    CREATE_ISSUERS_VIA_ISSUER_API: 'create_issuers_via_issuer_api',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    MANAGE_ORGANIZATION_USERS_AND_GROUPS: 'manage_organization_users_and_groups',
    ORGANIZATION_CREATE_INVESTOR_AND_INVESTMENT: 'organization_create_investor_and_investment',
    ORGANIZATION_CREATE_PRODUCT_CASHLINK_STUDIO: 'organization_create_product_cashlink_studio',
    ORGANIZATION_DOWNLOAD_PLATFORM_STATISTICS: 'organization_download_platform_statistics',
    ORGANIZATION_DOWNLOAD_STATISTICS: 'organization_download_statistics',
    ORGANIZATION_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_edit_distribution_information_and_investment_documents',
    ORGANIZATION_MANAGE_APPROVALS: 'organization_manage_approvals',
    ORGANIZATION_MANAGE_CREDIT_DIGITAL_SECURITIES: 'organization_manage_credit_digital_securities',
    ORGANIZATION_MANAGE_DISTRIBUTION: 'organization_manage_distribution',
    ORGANIZATION_MANAGE_IDENTIFICATION_DATA: 'organization_manage_identification_data',
    ORGANIZATION_MANAGE_INCOMING_PAYMENTS: 'organization_manage_incoming_payments',
    ORGANIZATION_MANAGE_INVESTMENTS: 'organization_manage_investments',
    ORGANIZATION_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'organization_manage_investor_and_investment_data',
    ORGANIZATION_MANAGE_INVESTOR_DOCUMENTS: 'organization_manage_investor_documents',
    ORGANIZATION_MANAGE_ISSUER_CASHLINK_STUDIO: 'organization_manage_issuer_cashlink_studio',
    ORGANIZATION_MANAGE_LISTINGS: 'organization_manage_listings',
    ORGANIZATION_MANAGE_MARKET_PRICES: 'organization_manage_market_prices',
    ORGANIZATION_MANAGE_PAYOUT_EVENTS: 'organization_manage_payout_events',
    ORGANIZATION_MANAGE_PRODUCT_DATA: 'organization_manage_product_data',
    ORGANIZATION_MANAGE_REDEMPTIONS: 'organization_manage_redemptions',
    ORGANIZATION_MANAGE_VOUCHERS: 'organization_manage_vouchers',
    ORGANIZATION_TRIGGER_SOLUTION: 'organization_trigger_solution',
    ORGANIZATION_USE_ISSUER_API: 'organization_use_issuer_api',
    ORGANIZATION_VIEW_DATA: 'organization_view_data',
    ORGANIZATION_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_view_distribution_information_and_investment_documents',
    ORGANIZATION_VIEW_FRIEND_REFERRALS: 'organization_view_friend_referrals',
    ORGANIZATION_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'organization_view_investor_and_investment_data',
    ORGANIZATION_VIEW_ISSUER_CASHLINK_STUDIO: 'organization_view_issuer_cashlink_studio',
    VIEW_ORGANIZATION_DATA: 'view_organization_data'
} as const;
export type AdminProductsDropdownListPermissionOnOrganizationEnum = typeof AdminProductsDropdownListPermissionOnOrganizationEnum[keyof typeof AdminProductsDropdownListPermissionOnOrganizationEnum];
/**
 * @export
 */
export const AdminProductsDropdownListProductTypeEnum = {
    AIF: 'AIF',
    BOND: 'BOND',
    CONVERTIBLE_BOND: 'CONVERTIBLE_BOND',
    DEBT_SECURITY: 'DEBT_SECURITY',
    DIGITAL_COMPANY_SHARE: 'DIGITAL_COMPANY_SHARE',
    FUND_SHARE: 'FUND_SHARE',
    PARTICIPATION_PAPER: 'PARTICIPATION_PAPER',
    PARTICIPATION_RIGHT: 'PARTICIPATION_RIGHT',
    REGISTERED_BOND: 'REGISTERED_BOND',
    SUBORDINATED_LOAN: 'SUBORDINATED_LOAN',
    TOKENIZED_ARTWORK: 'TOKENIZED_ARTWORK',
    TOKENIZED_LIMITED_PARTNER_SHARES: 'TOKENIZED_LIMITED_PARTNER_SHARES'
} as const;
export type AdminProductsDropdownListProductTypeEnum = typeof AdminProductsDropdownListProductTypeEnum[keyof typeof AdminProductsDropdownListProductTypeEnum];
/**
 * @export
 */
export const AdminProductsDropdownListStatusEnum = {
    CREATED: 'created',
    FAILED: 'failed',
    PROCESSING: 'processing',
    QUEUED: 'queued',
    SUCCEEDED: 'succeeded',
    UNKNOWN: 'unknown',
    VALIDATION_PENDING: 'validation_pending',
    VALIDATION_REJECTED: 'validation_rejected',
    VALIDATION_SUCCESS: 'validation_success',
    WAITING: 'waiting'
} as const;
export type AdminProductsDropdownListStatusEnum = typeof AdminProductsDropdownListStatusEnum[keyof typeof AdminProductsDropdownListStatusEnum];
/**
 * @export
 */
export const AdminProductsInvitationRulesListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    ISSUER_NAME_DESC: '-issuer_name',
    ISSUER_NAME_ASC: 'issuer_name',
    MAX_ISSUABLE_AMOUNT_DESC: '-max_issuable_amount',
    MAX_ISSUABLE_AMOUNT_ASC: 'max_issuable_amount',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    PRODUCT_TYPE_DESC: '-product_type',
    PRODUCT_TYPE_ASC: 'product_type',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status'
} as const;
export type AdminProductsInvitationRulesListOrderingEnum = typeof AdminProductsInvitationRulesListOrderingEnum[keyof typeof AdminProductsInvitationRulesListOrderingEnum];
/**
 * @export
 */
export const AdminProductsListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    ISSUER_NAME_DESC: '-issuer_name',
    ISSUER_NAME_ASC: 'issuer_name',
    MAX_ISSUABLE_AMOUNT_DESC: '-max_issuable_amount',
    MAX_ISSUABLE_AMOUNT_ASC: 'max_issuable_amount',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    PRODUCT_TYPE_DESC: '-product_type',
    PRODUCT_TYPE_ASC: 'product_type',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status'
} as const;
export type AdminProductsListOrderingEnum = typeof AdminProductsListOrderingEnum[keyof typeof AdminProductsListOrderingEnum];
/**
 * @export
 */
export const AdminProductsListPermissionEnum = {
    DOWNLOAD_STATISTICS: 'download_statistics',
    MANAGE_APPROVALS: 'manage_approvals',
    MANAGE_CREDIT_DIGITAL_SECURITIES: 'manage_credit_digital_securities',
    MANAGE_DISTRIBUTION: 'manage_distribution',
    MANAGE_INCOMING_PAYMENTS: 'manage_incoming_payments',
    MANAGE_INVESTMENTS: 'manage_investments',
    MANAGE_INVESTOR_DOCUMENTS: 'manage_investor_documents',
    MANAGE_MARKET_PRICES: 'manage_market_prices',
    MANAGE_PAYOUT_EVENTS: 'manage_payout_events',
    MANAGE_PRODUCT_DATA: 'manage_product_data',
    MANAGE_REDEMPTIONS: 'manage_redemptions',
    TRIGGER_SOLUTION: 'trigger_solution',
    VIEW_DATA: 'view_data'
} as const;
export type AdminProductsListPermissionEnum = typeof AdminProductsListPermissionEnum[keyof typeof AdminProductsListPermissionEnum];
/**
 * @export
 */
export const AdminProductsListPermissionOnIssuerEnum = {
    CREATE_PRODUCT_CASHLINK_STUDIO: 'create_product_cashlink_studio',
    MANAGE_ISSUER_CASHLINK_STUDIO: 'manage_issuer_cashlink_studio',
    MANAGE_LISTINGS: 'manage_listings',
    USE_ISSUER_API: 'use_issuer_api',
    VIEW_ISSUER_CASHLINK_STUDIO: 'view_issuer_cashlink_studio'
} as const;
export type AdminProductsListPermissionOnIssuerEnum = typeof AdminProductsListPermissionOnIssuerEnum[keyof typeof AdminProductsListPermissionOnIssuerEnum];
/**
 * @export
 */
export const AdminProductsListPermissionOnOrganizationEnum = {
    CAN_USE_ISSUER_API: 'can_use_issuer_api',
    CREATE_ISSUERS_VIA_CASHLINK_STUDIO: 'create_issuers_via_cashlink_studio',
    CREATE_ISSUERS_VIA_ISSUER_API: 'create_issuers_via_issuer_api',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    MANAGE_ORGANIZATION_USERS_AND_GROUPS: 'manage_organization_users_and_groups',
    ORGANIZATION_CREATE_INVESTOR_AND_INVESTMENT: 'organization_create_investor_and_investment',
    ORGANIZATION_CREATE_PRODUCT_CASHLINK_STUDIO: 'organization_create_product_cashlink_studio',
    ORGANIZATION_DOWNLOAD_PLATFORM_STATISTICS: 'organization_download_platform_statistics',
    ORGANIZATION_DOWNLOAD_STATISTICS: 'organization_download_statistics',
    ORGANIZATION_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_edit_distribution_information_and_investment_documents',
    ORGANIZATION_MANAGE_APPROVALS: 'organization_manage_approvals',
    ORGANIZATION_MANAGE_CREDIT_DIGITAL_SECURITIES: 'organization_manage_credit_digital_securities',
    ORGANIZATION_MANAGE_DISTRIBUTION: 'organization_manage_distribution',
    ORGANIZATION_MANAGE_IDENTIFICATION_DATA: 'organization_manage_identification_data',
    ORGANIZATION_MANAGE_INCOMING_PAYMENTS: 'organization_manage_incoming_payments',
    ORGANIZATION_MANAGE_INVESTMENTS: 'organization_manage_investments',
    ORGANIZATION_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'organization_manage_investor_and_investment_data',
    ORGANIZATION_MANAGE_INVESTOR_DOCUMENTS: 'organization_manage_investor_documents',
    ORGANIZATION_MANAGE_ISSUER_CASHLINK_STUDIO: 'organization_manage_issuer_cashlink_studio',
    ORGANIZATION_MANAGE_LISTINGS: 'organization_manage_listings',
    ORGANIZATION_MANAGE_MARKET_PRICES: 'organization_manage_market_prices',
    ORGANIZATION_MANAGE_PAYOUT_EVENTS: 'organization_manage_payout_events',
    ORGANIZATION_MANAGE_PRODUCT_DATA: 'organization_manage_product_data',
    ORGANIZATION_MANAGE_REDEMPTIONS: 'organization_manage_redemptions',
    ORGANIZATION_MANAGE_VOUCHERS: 'organization_manage_vouchers',
    ORGANIZATION_TRIGGER_SOLUTION: 'organization_trigger_solution',
    ORGANIZATION_USE_ISSUER_API: 'organization_use_issuer_api',
    ORGANIZATION_VIEW_DATA: 'organization_view_data',
    ORGANIZATION_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_view_distribution_information_and_investment_documents',
    ORGANIZATION_VIEW_FRIEND_REFERRALS: 'organization_view_friend_referrals',
    ORGANIZATION_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'organization_view_investor_and_investment_data',
    ORGANIZATION_VIEW_ISSUER_CASHLINK_STUDIO: 'organization_view_issuer_cashlink_studio',
    VIEW_ORGANIZATION_DATA: 'view_organization_data'
} as const;
export type AdminProductsListPermissionOnOrganizationEnum = typeof AdminProductsListPermissionOnOrganizationEnum[keyof typeof AdminProductsListPermissionOnOrganizationEnum];
/**
 * @export
 */
export const AdminProductsListProductTypeEnum = {
    AIF: 'AIF',
    BOND: 'BOND',
    CONVERTIBLE_BOND: 'CONVERTIBLE_BOND',
    DEBT_SECURITY: 'DEBT_SECURITY',
    DIGITAL_COMPANY_SHARE: 'DIGITAL_COMPANY_SHARE',
    FUND_SHARE: 'FUND_SHARE',
    PARTICIPATION_PAPER: 'PARTICIPATION_PAPER',
    PARTICIPATION_RIGHT: 'PARTICIPATION_RIGHT',
    REGISTERED_BOND: 'REGISTERED_BOND',
    SUBORDINATED_LOAN: 'SUBORDINATED_LOAN',
    TOKENIZED_ARTWORK: 'TOKENIZED_ARTWORK',
    TOKENIZED_LIMITED_PARTNER_SHARES: 'TOKENIZED_LIMITED_PARTNER_SHARES'
} as const;
export type AdminProductsListProductTypeEnum = typeof AdminProductsListProductTypeEnum[keyof typeof AdminProductsListProductTypeEnum];
/**
 * @export
 */
export const AdminProductsListStatusEnum = {
    CREATED: 'created',
    FAILED: 'failed',
    PROCESSING: 'processing',
    QUEUED: 'queued',
    SUCCEEDED: 'succeeded',
    UNKNOWN: 'unknown',
    VALIDATION_PENDING: 'validation_pending',
    VALIDATION_REJECTED: 'validation_rejected',
    VALIDATION_SUCCESS: 'validation_success',
    WAITING: 'waiting'
} as const;
export type AdminProductsListStatusEnum = typeof AdminProductsListStatusEnum[keyof typeof AdminProductsListStatusEnum];
/**
 * @export
 */
export const AdminProductsValuesRetrieveFieldEnum = {
    ISSUER_NAME: 'issuer_name',
    NAME: 'name'
} as const;
export type AdminProductsValuesRetrieveFieldEnum = typeof AdminProductsValuesRetrieveFieldEnum[keyof typeof AdminProductsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminProductsValuesRetrieveOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    ISSUER_NAME_DESC: '-issuer_name',
    ISSUER_NAME_ASC: 'issuer_name',
    MAX_ISSUABLE_AMOUNT_DESC: '-max_issuable_amount',
    MAX_ISSUABLE_AMOUNT_ASC: 'max_issuable_amount',
    NAME_DESC: '-name',
    NAME_ASC: 'name',
    PRODUCT_TYPE_DESC: '-product_type',
    PRODUCT_TYPE_ASC: 'product_type',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status'
} as const;
export type AdminProductsValuesRetrieveOrderingEnum = typeof AdminProductsValuesRetrieveOrderingEnum[keyof typeof AdminProductsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminProductsValuesRetrievePermissionEnum = {
    DOWNLOAD_STATISTICS: 'download_statistics',
    MANAGE_APPROVALS: 'manage_approvals',
    MANAGE_CREDIT_DIGITAL_SECURITIES: 'manage_credit_digital_securities',
    MANAGE_DISTRIBUTION: 'manage_distribution',
    MANAGE_INCOMING_PAYMENTS: 'manage_incoming_payments',
    MANAGE_INVESTMENTS: 'manage_investments',
    MANAGE_INVESTOR_DOCUMENTS: 'manage_investor_documents',
    MANAGE_MARKET_PRICES: 'manage_market_prices',
    MANAGE_PAYOUT_EVENTS: 'manage_payout_events',
    MANAGE_PRODUCT_DATA: 'manage_product_data',
    MANAGE_REDEMPTIONS: 'manage_redemptions',
    TRIGGER_SOLUTION: 'trigger_solution',
    VIEW_DATA: 'view_data'
} as const;
export type AdminProductsValuesRetrievePermissionEnum = typeof AdminProductsValuesRetrievePermissionEnum[keyof typeof AdminProductsValuesRetrievePermissionEnum];
/**
 * @export
 */
export const AdminProductsValuesRetrievePermissionOnIssuerEnum = {
    CREATE_PRODUCT_CASHLINK_STUDIO: 'create_product_cashlink_studio',
    MANAGE_ISSUER_CASHLINK_STUDIO: 'manage_issuer_cashlink_studio',
    MANAGE_LISTINGS: 'manage_listings',
    USE_ISSUER_API: 'use_issuer_api',
    VIEW_ISSUER_CASHLINK_STUDIO: 'view_issuer_cashlink_studio'
} as const;
export type AdminProductsValuesRetrievePermissionOnIssuerEnum = typeof AdminProductsValuesRetrievePermissionOnIssuerEnum[keyof typeof AdminProductsValuesRetrievePermissionOnIssuerEnum];
/**
 * @export
 */
export const AdminProductsValuesRetrievePermissionOnOrganizationEnum = {
    CAN_USE_ISSUER_API: 'can_use_issuer_api',
    CREATE_ISSUERS_VIA_CASHLINK_STUDIO: 'create_issuers_via_cashlink_studio',
    CREATE_ISSUERS_VIA_ISSUER_API: 'create_issuers_via_issuer_api',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    MANAGE_ORGANIZATION_USERS_AND_GROUPS: 'manage_organization_users_and_groups',
    ORGANIZATION_CREATE_INVESTOR_AND_INVESTMENT: 'organization_create_investor_and_investment',
    ORGANIZATION_CREATE_PRODUCT_CASHLINK_STUDIO: 'organization_create_product_cashlink_studio',
    ORGANIZATION_DOWNLOAD_PLATFORM_STATISTICS: 'organization_download_platform_statistics',
    ORGANIZATION_DOWNLOAD_STATISTICS: 'organization_download_statistics',
    ORGANIZATION_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_edit_distribution_information_and_investment_documents',
    ORGANIZATION_MANAGE_APPROVALS: 'organization_manage_approvals',
    ORGANIZATION_MANAGE_CREDIT_DIGITAL_SECURITIES: 'organization_manage_credit_digital_securities',
    ORGANIZATION_MANAGE_DISTRIBUTION: 'organization_manage_distribution',
    ORGANIZATION_MANAGE_IDENTIFICATION_DATA: 'organization_manage_identification_data',
    ORGANIZATION_MANAGE_INCOMING_PAYMENTS: 'organization_manage_incoming_payments',
    ORGANIZATION_MANAGE_INVESTMENTS: 'organization_manage_investments',
    ORGANIZATION_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'organization_manage_investor_and_investment_data',
    ORGANIZATION_MANAGE_INVESTOR_DOCUMENTS: 'organization_manage_investor_documents',
    ORGANIZATION_MANAGE_ISSUER_CASHLINK_STUDIO: 'organization_manage_issuer_cashlink_studio',
    ORGANIZATION_MANAGE_LISTINGS: 'organization_manage_listings',
    ORGANIZATION_MANAGE_MARKET_PRICES: 'organization_manage_market_prices',
    ORGANIZATION_MANAGE_PAYOUT_EVENTS: 'organization_manage_payout_events',
    ORGANIZATION_MANAGE_PRODUCT_DATA: 'organization_manage_product_data',
    ORGANIZATION_MANAGE_REDEMPTIONS: 'organization_manage_redemptions',
    ORGANIZATION_MANAGE_VOUCHERS: 'organization_manage_vouchers',
    ORGANIZATION_TRIGGER_SOLUTION: 'organization_trigger_solution',
    ORGANIZATION_USE_ISSUER_API: 'organization_use_issuer_api',
    ORGANIZATION_VIEW_DATA: 'organization_view_data',
    ORGANIZATION_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_view_distribution_information_and_investment_documents',
    ORGANIZATION_VIEW_FRIEND_REFERRALS: 'organization_view_friend_referrals',
    ORGANIZATION_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'organization_view_investor_and_investment_data',
    ORGANIZATION_VIEW_ISSUER_CASHLINK_STUDIO: 'organization_view_issuer_cashlink_studio',
    VIEW_ORGANIZATION_DATA: 'view_organization_data'
} as const;
export type AdminProductsValuesRetrievePermissionOnOrganizationEnum = typeof AdminProductsValuesRetrievePermissionOnOrganizationEnum[keyof typeof AdminProductsValuesRetrievePermissionOnOrganizationEnum];
/**
 * @export
 */
export const AdminProductsValuesRetrieveProductTypeEnum = {
    AIF: 'AIF',
    BOND: 'BOND',
    CONVERTIBLE_BOND: 'CONVERTIBLE_BOND',
    DEBT_SECURITY: 'DEBT_SECURITY',
    DIGITAL_COMPANY_SHARE: 'DIGITAL_COMPANY_SHARE',
    FUND_SHARE: 'FUND_SHARE',
    PARTICIPATION_PAPER: 'PARTICIPATION_PAPER',
    PARTICIPATION_RIGHT: 'PARTICIPATION_RIGHT',
    REGISTERED_BOND: 'REGISTERED_BOND',
    SUBORDINATED_LOAN: 'SUBORDINATED_LOAN',
    TOKENIZED_ARTWORK: 'TOKENIZED_ARTWORK',
    TOKENIZED_LIMITED_PARTNER_SHARES: 'TOKENIZED_LIMITED_PARTNER_SHARES'
} as const;
export type AdminProductsValuesRetrieveProductTypeEnum = typeof AdminProductsValuesRetrieveProductTypeEnum[keyof typeof AdminProductsValuesRetrieveProductTypeEnum];
/**
 * @export
 */
export const AdminProductsValuesRetrieveStatusEnum = {
    CREATED: 'created',
    FAILED: 'failed',
    PROCESSING: 'processing',
    QUEUED: 'queued',
    SUCCEEDED: 'succeeded',
    UNKNOWN: 'unknown',
    VALIDATION_PENDING: 'validation_pending',
    VALIDATION_REJECTED: 'validation_rejected',
    VALIDATION_SUCCESS: 'validation_success',
    WAITING: 'waiting'
} as const;
export type AdminProductsValuesRetrieveStatusEnum = typeof AdminProductsValuesRetrieveStatusEnum[keyof typeof AdminProductsValuesRetrieveStatusEnum];
/**
 * @export
 */
export const AdminRedemptionsDropdownListFieldEnum = {
    PRODUCT_NAME: 'product_name',
    STATUS: 'status',
    WALLET_ADDRESS: 'wallet_address'
} as const;
export type AdminRedemptionsDropdownListFieldEnum = typeof AdminRedemptionsDropdownListFieldEnum[keyof typeof AdminRedemptionsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminRedemptionsDropdownListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    PRODUCT_NAME_DESC: '-product_name',
    PRODUCT_NAME_ASC: 'product_name',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status',
    TRANSACTION_TIMESTAMP_DESC: '-transaction_timestamp',
    TRANSACTION_TIMESTAMP_ASC: 'transaction_timestamp',
    UNITS_DESC: '-units',
    UNITS_ASC: 'units',
    WALLET_ADDRESS_DESC: '-wallet_address',
    WALLET_ADDRESS_ASC: 'wallet_address'
} as const;
export type AdminRedemptionsDropdownListOrderingEnum = typeof AdminRedemptionsDropdownListOrderingEnum[keyof typeof AdminRedemptionsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminRedemptionsDropdownListStatusEnum = {
    CREATED: 'created',
    FAILED: 'failed',
    PROCESSING: 'processing',
    SUCCESS: 'success',
    UNKNOWN: 'unknown'
} as const;
export type AdminRedemptionsDropdownListStatusEnum = typeof AdminRedemptionsDropdownListStatusEnum[keyof typeof AdminRedemptionsDropdownListStatusEnum];
/**
 * @export
 */
export const AdminRedemptionsListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    PRODUCT_NAME_DESC: '-product_name',
    PRODUCT_NAME_ASC: 'product_name',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status',
    TRANSACTION_TIMESTAMP_DESC: '-transaction_timestamp',
    TRANSACTION_TIMESTAMP_ASC: 'transaction_timestamp',
    UNITS_DESC: '-units',
    UNITS_ASC: 'units',
    WALLET_ADDRESS_DESC: '-wallet_address',
    WALLET_ADDRESS_ASC: 'wallet_address'
} as const;
export type AdminRedemptionsListOrderingEnum = typeof AdminRedemptionsListOrderingEnum[keyof typeof AdminRedemptionsListOrderingEnum];
/**
 * @export
 */
export const AdminRedemptionsListStatusEnum = {
    CREATED: 'created',
    FAILED: 'failed',
    PROCESSING: 'processing',
    SUCCESS: 'success',
    UNKNOWN: 'unknown'
} as const;
export type AdminRedemptionsListStatusEnum = typeof AdminRedemptionsListStatusEnum[keyof typeof AdminRedemptionsListStatusEnum];
/**
 * @export
 */
export const AdminRedemptionsValuesRetrieveFieldEnum = {
    PRODUCT_NAME: 'product_name',
    STATUS: 'status',
    WALLET_ADDRESS: 'wallet_address'
} as const;
export type AdminRedemptionsValuesRetrieveFieldEnum = typeof AdminRedemptionsValuesRetrieveFieldEnum[keyof typeof AdminRedemptionsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminRedemptionsValuesRetrieveOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    PRODUCT_NAME_DESC: '-product_name',
    PRODUCT_NAME_ASC: 'product_name',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status',
    TRANSACTION_TIMESTAMP_DESC: '-transaction_timestamp',
    TRANSACTION_TIMESTAMP_ASC: 'transaction_timestamp',
    UNITS_DESC: '-units',
    UNITS_ASC: 'units',
    WALLET_ADDRESS_DESC: '-wallet_address',
    WALLET_ADDRESS_ASC: 'wallet_address'
} as const;
export type AdminRedemptionsValuesRetrieveOrderingEnum = typeof AdminRedemptionsValuesRetrieveOrderingEnum[keyof typeof AdminRedemptionsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminRedemptionsValuesRetrieveStatusEnum = {
    CREATED: 'created',
    FAILED: 'failed',
    PROCESSING: 'processing',
    SUCCESS: 'success',
    UNKNOWN: 'unknown'
} as const;
export type AdminRedemptionsValuesRetrieveStatusEnum = typeof AdminRedemptionsValuesRetrieveStatusEnum[keyof typeof AdminRedemptionsValuesRetrieveStatusEnum];
/**
 * @export
 */
export const AdminServiceContractsDropdownListFieldEnum = {
    DISPLAY_NAME: 'display_name',
    TECHNICAL_NAME: 'technical_name'
} as const;
export type AdminServiceContractsDropdownListFieldEnum = typeof AdminServiceContractsDropdownListFieldEnum[keyof typeof AdminServiceContractsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminServiceContractsDropdownListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISPLAY_NAME_DESC: '-display_name',
    DISPLAY_NAME_ASC: 'display_name',
    ID_DESC: '-id',
    ID_ASC: 'id',
    TECHNICAL_NAME_DESC: '-technical_name',
    TECHNICAL_NAME_ASC: 'technical_name'
} as const;
export type AdminServiceContractsDropdownListOrderingEnum = typeof AdminServiceContractsDropdownListOrderingEnum[keyof typeof AdminServiceContractsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminServiceContractsListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISPLAY_NAME_DESC: '-display_name',
    DISPLAY_NAME_ASC: 'display_name',
    ID_DESC: '-id',
    ID_ASC: 'id',
    TECHNICAL_NAME_DESC: '-technical_name',
    TECHNICAL_NAME_ASC: 'technical_name'
} as const;
export type AdminServiceContractsListOrderingEnum = typeof AdminServiceContractsListOrderingEnum[keyof typeof AdminServiceContractsListOrderingEnum];
/**
 * @export
 */
export const AdminServiceContractsValuesRetrieveFieldEnum = {
    DISPLAY_NAME: 'display_name',
    TECHNICAL_NAME: 'technical_name'
} as const;
export type AdminServiceContractsValuesRetrieveFieldEnum = typeof AdminServiceContractsValuesRetrieveFieldEnum[keyof typeof AdminServiceContractsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminServiceContractsValuesRetrieveOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DISPLAY_NAME_DESC: '-display_name',
    DISPLAY_NAME_ASC: 'display_name',
    ID_DESC: '-id',
    ID_ASC: 'id',
    TECHNICAL_NAME_DESC: '-technical_name',
    TECHNICAL_NAME_ASC: 'technical_name'
} as const;
export type AdminServiceContractsValuesRetrieveOrderingEnum = typeof AdminServiceContractsValuesRetrieveOrderingEnum[keyof typeof AdminServiceContractsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminStatisticsReportRetrieveReportTypeEnum = {
    DISTRIBUTION_PLATFORM_EXPORT: 'DISTRIBUTION_PLATFORM_EXPORT',
    ISSUER_EXPORT: 'ISSUER_EXPORT'
} as const;
export type AdminStatisticsReportRetrieveReportTypeEnum = typeof AdminStatisticsReportRetrieveReportTypeEnum[keyof typeof AdminStatisticsReportRetrieveReportTypeEnum];
/**
 * @export
 */
export const AdminUserPermissionsDropdownListFieldEnum = {
    VALID_FOR_NAME: 'valid_for_name'
} as const;
export type AdminUserPermissionsDropdownListFieldEnum = typeof AdminUserPermissionsDropdownListFieldEnum[keyof typeof AdminUserPermissionsDropdownListFieldEnum];
/**
 * @export
 */
export const AdminUserPermissionsDropdownListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    OBJECT_ID_DESC: '-object_id',
    OBJECT_ID_ASC: 'object_id',
    PERMISSION_CODE_DESC: '-permission_code',
    PERMISSION_CODE_ASC: 'permission_code',
    PERMISSION_TYPE_DESC: '-permission_type',
    PERMISSION_TYPE_ASC: 'permission_type',
    USER_DESC: '-user',
    USER_ASC: 'user',
    VALID_FOR_NAME_DESC: '-valid_for_name',
    VALID_FOR_NAME_ASC: 'valid_for_name'
} as const;
export type AdminUserPermissionsDropdownListOrderingEnum = typeof AdminUserPermissionsDropdownListOrderingEnum[keyof typeof AdminUserPermissionsDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminUserPermissionsDropdownListPermissionCodeEnum = {
    CAN_USE_ISSUER_API: 'can_use_issuer_api',
    CREATE_INVESTOR_AND_INVESTMENT: 'create_investor_and_investment',
    CREATE_ISSUER: 'create_issuer',
    CREATE_ISSUERS_VIA_CASHLINK_STUDIO: 'create_issuers_via_cashlink_studio',
    CREATE_ISSUERS_VIA_ISSUER_API: 'create_issuers_via_issuer_api',
    CREATE_PRODUCT_CASHLINK_STUDIO: 'create_product_cashlink_studio',
    DOWNLOAD_PLATFORM_STATISTICS: 'download_platform_statistics',
    DOWNLOAD_STATISTICS: 'download_statistics',
    EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'edit_distribution_information_and_investment_documents',
    ENVIRONMENT_CREATE_INVESTOR_AND_INVESTMENT: 'environment_create_investor_and_investment',
    ENVIRONMENT_CREATE_PRODUCT_CASHLINK_STUDIO: 'environment_create_product_cashlink_studio',
    ENVIRONMENT_DOWNLOAD_PLATFORM_STATISTICS: 'environment_download_platform_statistics',
    ENVIRONMENT_DOWNLOAD_STATISTICS: 'environment_download_statistics',
    ENVIRONMENT_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'environment_edit_distribution_information_and_investment_documents',
    ENVIRONMENT_MANAGE_APPROVALS: 'environment_manage_approvals',
    ENVIRONMENT_MANAGE_CREDIT_DIGITAL_SECURITIES: 'environment_manage_credit_digital_securities',
    ENVIRONMENT_MANAGE_DISTRIBUTION: 'environment_manage_distribution',
    ENVIRONMENT_MANAGE_IDENTIFICATION_DATA: 'environment_manage_identification_data',
    ENVIRONMENT_MANAGE_INCOMING_PAYMENTS: 'environment_manage_incoming_payments',
    ENVIRONMENT_MANAGE_INVESTMENTS: 'environment_manage_investments',
    ENVIRONMENT_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'environment_manage_investor_and_investment_data',
    ENVIRONMENT_MANAGE_INVESTOR_DOCUMENTS: 'environment_manage_investor_documents',
    ENVIRONMENT_MANAGE_ISSUER_CASHLINK_STUDIO: 'environment_manage_issuer_cashlink_studio',
    ENVIRONMENT_MANAGE_LISTINGS: 'environment_manage_listings',
    ENVIRONMENT_MANAGE_MARKET_PRICES: 'environment_manage_market_prices',
    ENVIRONMENT_MANAGE_PAYOUT_EVENTS: 'environment_manage_payout_events',
    ENVIRONMENT_MANAGE_PRODUCT_DATA: 'environment_manage_product_data',
    ENVIRONMENT_MANAGE_REDEMPTIONS: 'environment_manage_redemptions',
    ENVIRONMENT_MANAGE_VOUCHERS: 'environment_manage_vouchers',
    ENVIRONMENT_TRIGGER_SOLUTION: 'environment_trigger_solution',
    ENVIRONMENT_USE_ISSUER_API: 'environment_use_issuer_api',
    ENVIRONMENT_VIEW_DATA: 'environment_view_data',
    ENVIRONMENT_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'environment_view_distribution_information_and_investment_documents',
    ENVIRONMENT_VIEW_FRIEND_REFERRALS: 'environment_view_friend_referrals',
    ENVIRONMENT_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'environment_view_investor_and_investment_data',
    ENVIRONMENT_VIEW_ISSUER_CASHLINK_STUDIO: 'environment_view_issuer_cashlink_studio',
    MANAGE_APPROVALS: 'manage_approvals',
    MANAGE_CREDIT_DIGITAL_SECURITIES: 'manage_credit_digital_securities',
    MANAGE_DISTRIBUTION: 'manage_distribution',
    MANAGE_ENVIRONMENT_PERMISSIONS: 'manage_environment_permissions',
    MANAGE_ENVIRONMENT_USERS_AND_GROUPS: 'manage_environment_users_and_groups',
    MANAGE_FLAG_FOR_CRYPTO_SECURITY_CREATION_AND_VALIDATE_CRYPTO_SECURITIES: 'manage_flag_for_crypto_security_creation_and_validate_crypto_securities',
    MANAGE_IDENTIFICATION_DATA: 'manage_identification_data',
    MANAGE_INCOMING_PAYMENTS: 'manage_incoming_payments',
    MANAGE_INVESTMENTS: 'manage_investments',
    MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'manage_investor_and_investment_data',
    MANAGE_INVESTOR_DOCUMENTS: 'manage_investor_documents',
    MANAGE_ISSUANCE_DOCUMENTS: 'manage_issuance_documents',
    MANAGE_ISSUER_CASHLINK_STUDIO: 'manage_issuer_cashlink_studio',
    MANAGE_LISTINGS: 'manage_listings',
    MANAGE_MARKET_PRICES: 'manage_market_prices',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    MANAGE_ORGANIZATION_USERS_AND_GROUPS: 'manage_organization_users_and_groups',
    MANAGE_ORGANIZATIONS: 'manage_organizations',
    MANAGE_PAYOUT_EVENTS: 'manage_payout_events',
    MANAGE_PRODUCT_DATA: 'manage_product_data',
    MANAGE_REDEMPTIONS: 'manage_redemptions',
    MANAGE_VOUCHERS: 'manage_vouchers',
    ORGANIZATION_CREATE_INVESTOR_AND_INVESTMENT: 'organization_create_investor_and_investment',
    ORGANIZATION_CREATE_PRODUCT_CASHLINK_STUDIO: 'organization_create_product_cashlink_studio',
    ORGANIZATION_DOWNLOAD_PLATFORM_STATISTICS: 'organization_download_platform_statistics',
    ORGANIZATION_DOWNLOAD_STATISTICS: 'organization_download_statistics',
    ORGANIZATION_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_edit_distribution_information_and_investment_documents',
    ORGANIZATION_MANAGE_APPROVALS: 'organization_manage_approvals',
    ORGANIZATION_MANAGE_CREDIT_DIGITAL_SECURITIES: 'organization_manage_credit_digital_securities',
    ORGANIZATION_MANAGE_DISTRIBUTION: 'organization_manage_distribution',
    ORGANIZATION_MANAGE_IDENTIFICATION_DATA: 'organization_manage_identification_data',
    ORGANIZATION_MANAGE_INCOMING_PAYMENTS: 'organization_manage_incoming_payments',
    ORGANIZATION_MANAGE_INVESTMENTS: 'organization_manage_investments',
    ORGANIZATION_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'organization_manage_investor_and_investment_data',
    ORGANIZATION_MANAGE_INVESTOR_DOCUMENTS: 'organization_manage_investor_documents',
    ORGANIZATION_MANAGE_ISSUER_CASHLINK_STUDIO: 'organization_manage_issuer_cashlink_studio',
    ORGANIZATION_MANAGE_LISTINGS: 'organization_manage_listings',
    ORGANIZATION_MANAGE_MARKET_PRICES: 'organization_manage_market_prices',
    ORGANIZATION_MANAGE_PAYOUT_EVENTS: 'organization_manage_payout_events',
    ORGANIZATION_MANAGE_PRODUCT_DATA: 'organization_manage_product_data',
    ORGANIZATION_MANAGE_REDEMPTIONS: 'organization_manage_redemptions',
    ORGANIZATION_MANAGE_VOUCHERS: 'organization_manage_vouchers',
    ORGANIZATION_TRIGGER_SOLUTION: 'organization_trigger_solution',
    ORGANIZATION_USE_ISSUER_API: 'organization_use_issuer_api',
    ORGANIZATION_VIEW_DATA: 'organization_view_data',
    ORGANIZATION_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_view_distribution_information_and_investment_documents',
    ORGANIZATION_VIEW_FRIEND_REFERRALS: 'organization_view_friend_referrals',
    ORGANIZATION_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'organization_view_investor_and_investment_data',
    ORGANIZATION_VIEW_ISSUER_CASHLINK_STUDIO: 'organization_view_issuer_cashlink_studio',
    TRIGGER_SOLUTION: 'trigger_solution',
    USE_ISSUER_API: 'use_issuer_api',
    VIEW_DATA: 'view_data',
    VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'view_distribution_information_and_investment_documents',
    VIEW_FRIEND_REFERRALS: 'view_friend_referrals',
    VIEW_INVESTOR_AND_INVESTMENT_DATA: 'view_investor_and_investment_data',
    VIEW_ISSUER_CASHLINK_STUDIO: 'view_issuer_cashlink_studio',
    VIEW_ORGANIZATION_DATA: 'view_organization_data'
} as const;
export type AdminUserPermissionsDropdownListPermissionCodeEnum = typeof AdminUserPermissionsDropdownListPermissionCodeEnum[keyof typeof AdminUserPermissionsDropdownListPermissionCodeEnum];
/**
 * @export
 */
export const AdminUserPermissionsDropdownListPermissionTypeEnum = {
    DISTRIBUTION_PLATFORM: 'DISTRIBUTION_PLATFORM',
    ENVIRONMENT: 'ENVIRONMENT',
    ISSUER: 'ISSUER',
    ORGANIZATION: 'ORGANIZATION',
    PRODUCT: 'PRODUCT'
} as const;
export type AdminUserPermissionsDropdownListPermissionTypeEnum = typeof AdminUserPermissionsDropdownListPermissionTypeEnum[keyof typeof AdminUserPermissionsDropdownListPermissionTypeEnum];
/**
 * @export
 */
export const AdminUserPermissionsListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    OBJECT_ID_DESC: '-object_id',
    OBJECT_ID_ASC: 'object_id',
    PERMISSION_CODE_DESC: '-permission_code',
    PERMISSION_CODE_ASC: 'permission_code',
    PERMISSION_TYPE_DESC: '-permission_type',
    PERMISSION_TYPE_ASC: 'permission_type',
    USER_DESC: '-user',
    USER_ASC: 'user',
    VALID_FOR_NAME_DESC: '-valid_for_name',
    VALID_FOR_NAME_ASC: 'valid_for_name'
} as const;
export type AdminUserPermissionsListOrderingEnum = typeof AdminUserPermissionsListOrderingEnum[keyof typeof AdminUserPermissionsListOrderingEnum];
/**
 * @export
 */
export const AdminUserPermissionsListPermissionCodeEnum = {
    CAN_USE_ISSUER_API: 'can_use_issuer_api',
    CREATE_INVESTOR_AND_INVESTMENT: 'create_investor_and_investment',
    CREATE_ISSUER: 'create_issuer',
    CREATE_ISSUERS_VIA_CASHLINK_STUDIO: 'create_issuers_via_cashlink_studio',
    CREATE_ISSUERS_VIA_ISSUER_API: 'create_issuers_via_issuer_api',
    CREATE_PRODUCT_CASHLINK_STUDIO: 'create_product_cashlink_studio',
    DOWNLOAD_PLATFORM_STATISTICS: 'download_platform_statistics',
    DOWNLOAD_STATISTICS: 'download_statistics',
    EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'edit_distribution_information_and_investment_documents',
    ENVIRONMENT_CREATE_INVESTOR_AND_INVESTMENT: 'environment_create_investor_and_investment',
    ENVIRONMENT_CREATE_PRODUCT_CASHLINK_STUDIO: 'environment_create_product_cashlink_studio',
    ENVIRONMENT_DOWNLOAD_PLATFORM_STATISTICS: 'environment_download_platform_statistics',
    ENVIRONMENT_DOWNLOAD_STATISTICS: 'environment_download_statistics',
    ENVIRONMENT_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'environment_edit_distribution_information_and_investment_documents',
    ENVIRONMENT_MANAGE_APPROVALS: 'environment_manage_approvals',
    ENVIRONMENT_MANAGE_CREDIT_DIGITAL_SECURITIES: 'environment_manage_credit_digital_securities',
    ENVIRONMENT_MANAGE_DISTRIBUTION: 'environment_manage_distribution',
    ENVIRONMENT_MANAGE_IDENTIFICATION_DATA: 'environment_manage_identification_data',
    ENVIRONMENT_MANAGE_INCOMING_PAYMENTS: 'environment_manage_incoming_payments',
    ENVIRONMENT_MANAGE_INVESTMENTS: 'environment_manage_investments',
    ENVIRONMENT_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'environment_manage_investor_and_investment_data',
    ENVIRONMENT_MANAGE_INVESTOR_DOCUMENTS: 'environment_manage_investor_documents',
    ENVIRONMENT_MANAGE_ISSUER_CASHLINK_STUDIO: 'environment_manage_issuer_cashlink_studio',
    ENVIRONMENT_MANAGE_LISTINGS: 'environment_manage_listings',
    ENVIRONMENT_MANAGE_MARKET_PRICES: 'environment_manage_market_prices',
    ENVIRONMENT_MANAGE_PAYOUT_EVENTS: 'environment_manage_payout_events',
    ENVIRONMENT_MANAGE_PRODUCT_DATA: 'environment_manage_product_data',
    ENVIRONMENT_MANAGE_REDEMPTIONS: 'environment_manage_redemptions',
    ENVIRONMENT_MANAGE_VOUCHERS: 'environment_manage_vouchers',
    ENVIRONMENT_TRIGGER_SOLUTION: 'environment_trigger_solution',
    ENVIRONMENT_USE_ISSUER_API: 'environment_use_issuer_api',
    ENVIRONMENT_VIEW_DATA: 'environment_view_data',
    ENVIRONMENT_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'environment_view_distribution_information_and_investment_documents',
    ENVIRONMENT_VIEW_FRIEND_REFERRALS: 'environment_view_friend_referrals',
    ENVIRONMENT_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'environment_view_investor_and_investment_data',
    ENVIRONMENT_VIEW_ISSUER_CASHLINK_STUDIO: 'environment_view_issuer_cashlink_studio',
    MANAGE_APPROVALS: 'manage_approvals',
    MANAGE_CREDIT_DIGITAL_SECURITIES: 'manage_credit_digital_securities',
    MANAGE_DISTRIBUTION: 'manage_distribution',
    MANAGE_ENVIRONMENT_PERMISSIONS: 'manage_environment_permissions',
    MANAGE_ENVIRONMENT_USERS_AND_GROUPS: 'manage_environment_users_and_groups',
    MANAGE_FLAG_FOR_CRYPTO_SECURITY_CREATION_AND_VALIDATE_CRYPTO_SECURITIES: 'manage_flag_for_crypto_security_creation_and_validate_crypto_securities',
    MANAGE_IDENTIFICATION_DATA: 'manage_identification_data',
    MANAGE_INCOMING_PAYMENTS: 'manage_incoming_payments',
    MANAGE_INVESTMENTS: 'manage_investments',
    MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'manage_investor_and_investment_data',
    MANAGE_INVESTOR_DOCUMENTS: 'manage_investor_documents',
    MANAGE_ISSUANCE_DOCUMENTS: 'manage_issuance_documents',
    MANAGE_ISSUER_CASHLINK_STUDIO: 'manage_issuer_cashlink_studio',
    MANAGE_LISTINGS: 'manage_listings',
    MANAGE_MARKET_PRICES: 'manage_market_prices',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    MANAGE_ORGANIZATION_USERS_AND_GROUPS: 'manage_organization_users_and_groups',
    MANAGE_ORGANIZATIONS: 'manage_organizations',
    MANAGE_PAYOUT_EVENTS: 'manage_payout_events',
    MANAGE_PRODUCT_DATA: 'manage_product_data',
    MANAGE_REDEMPTIONS: 'manage_redemptions',
    MANAGE_VOUCHERS: 'manage_vouchers',
    ORGANIZATION_CREATE_INVESTOR_AND_INVESTMENT: 'organization_create_investor_and_investment',
    ORGANIZATION_CREATE_PRODUCT_CASHLINK_STUDIO: 'organization_create_product_cashlink_studio',
    ORGANIZATION_DOWNLOAD_PLATFORM_STATISTICS: 'organization_download_platform_statistics',
    ORGANIZATION_DOWNLOAD_STATISTICS: 'organization_download_statistics',
    ORGANIZATION_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_edit_distribution_information_and_investment_documents',
    ORGANIZATION_MANAGE_APPROVALS: 'organization_manage_approvals',
    ORGANIZATION_MANAGE_CREDIT_DIGITAL_SECURITIES: 'organization_manage_credit_digital_securities',
    ORGANIZATION_MANAGE_DISTRIBUTION: 'organization_manage_distribution',
    ORGANIZATION_MANAGE_IDENTIFICATION_DATA: 'organization_manage_identification_data',
    ORGANIZATION_MANAGE_INCOMING_PAYMENTS: 'organization_manage_incoming_payments',
    ORGANIZATION_MANAGE_INVESTMENTS: 'organization_manage_investments',
    ORGANIZATION_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'organization_manage_investor_and_investment_data',
    ORGANIZATION_MANAGE_INVESTOR_DOCUMENTS: 'organization_manage_investor_documents',
    ORGANIZATION_MANAGE_ISSUER_CASHLINK_STUDIO: 'organization_manage_issuer_cashlink_studio',
    ORGANIZATION_MANAGE_LISTINGS: 'organization_manage_listings',
    ORGANIZATION_MANAGE_MARKET_PRICES: 'organization_manage_market_prices',
    ORGANIZATION_MANAGE_PAYOUT_EVENTS: 'organization_manage_payout_events',
    ORGANIZATION_MANAGE_PRODUCT_DATA: 'organization_manage_product_data',
    ORGANIZATION_MANAGE_REDEMPTIONS: 'organization_manage_redemptions',
    ORGANIZATION_MANAGE_VOUCHERS: 'organization_manage_vouchers',
    ORGANIZATION_TRIGGER_SOLUTION: 'organization_trigger_solution',
    ORGANIZATION_USE_ISSUER_API: 'organization_use_issuer_api',
    ORGANIZATION_VIEW_DATA: 'organization_view_data',
    ORGANIZATION_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_view_distribution_information_and_investment_documents',
    ORGANIZATION_VIEW_FRIEND_REFERRALS: 'organization_view_friend_referrals',
    ORGANIZATION_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'organization_view_investor_and_investment_data',
    ORGANIZATION_VIEW_ISSUER_CASHLINK_STUDIO: 'organization_view_issuer_cashlink_studio',
    TRIGGER_SOLUTION: 'trigger_solution',
    USE_ISSUER_API: 'use_issuer_api',
    VIEW_DATA: 'view_data',
    VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'view_distribution_information_and_investment_documents',
    VIEW_FRIEND_REFERRALS: 'view_friend_referrals',
    VIEW_INVESTOR_AND_INVESTMENT_DATA: 'view_investor_and_investment_data',
    VIEW_ISSUER_CASHLINK_STUDIO: 'view_issuer_cashlink_studio',
    VIEW_ORGANIZATION_DATA: 'view_organization_data'
} as const;
export type AdminUserPermissionsListPermissionCodeEnum = typeof AdminUserPermissionsListPermissionCodeEnum[keyof typeof AdminUserPermissionsListPermissionCodeEnum];
/**
 * @export
 */
export const AdminUserPermissionsListPermissionTypeEnum = {
    DISTRIBUTION_PLATFORM: 'DISTRIBUTION_PLATFORM',
    ENVIRONMENT: 'ENVIRONMENT',
    ISSUER: 'ISSUER',
    ORGANIZATION: 'ORGANIZATION',
    PRODUCT: 'PRODUCT'
} as const;
export type AdminUserPermissionsListPermissionTypeEnum = typeof AdminUserPermissionsListPermissionTypeEnum[keyof typeof AdminUserPermissionsListPermissionTypeEnum];
/**
 * @export
 */
export const AdminUserPermissionsValuesRetrieveFieldEnum = {
    VALID_FOR_NAME: 'valid_for_name'
} as const;
export type AdminUserPermissionsValuesRetrieveFieldEnum = typeof AdminUserPermissionsValuesRetrieveFieldEnum[keyof typeof AdminUserPermissionsValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminUserPermissionsValuesRetrieveOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    OBJECT_ID_DESC: '-object_id',
    OBJECT_ID_ASC: 'object_id',
    PERMISSION_CODE_DESC: '-permission_code',
    PERMISSION_CODE_ASC: 'permission_code',
    PERMISSION_TYPE_DESC: '-permission_type',
    PERMISSION_TYPE_ASC: 'permission_type',
    USER_DESC: '-user',
    USER_ASC: 'user',
    VALID_FOR_NAME_DESC: '-valid_for_name',
    VALID_FOR_NAME_ASC: 'valid_for_name'
} as const;
export type AdminUserPermissionsValuesRetrieveOrderingEnum = typeof AdminUserPermissionsValuesRetrieveOrderingEnum[keyof typeof AdminUserPermissionsValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminUserPermissionsValuesRetrievePermissionCodeEnum = {
    CAN_USE_ISSUER_API: 'can_use_issuer_api',
    CREATE_INVESTOR_AND_INVESTMENT: 'create_investor_and_investment',
    CREATE_ISSUER: 'create_issuer',
    CREATE_ISSUERS_VIA_CASHLINK_STUDIO: 'create_issuers_via_cashlink_studio',
    CREATE_ISSUERS_VIA_ISSUER_API: 'create_issuers_via_issuer_api',
    CREATE_PRODUCT_CASHLINK_STUDIO: 'create_product_cashlink_studio',
    DOWNLOAD_PLATFORM_STATISTICS: 'download_platform_statistics',
    DOWNLOAD_STATISTICS: 'download_statistics',
    EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'edit_distribution_information_and_investment_documents',
    ENVIRONMENT_CREATE_INVESTOR_AND_INVESTMENT: 'environment_create_investor_and_investment',
    ENVIRONMENT_CREATE_PRODUCT_CASHLINK_STUDIO: 'environment_create_product_cashlink_studio',
    ENVIRONMENT_DOWNLOAD_PLATFORM_STATISTICS: 'environment_download_platform_statistics',
    ENVIRONMENT_DOWNLOAD_STATISTICS: 'environment_download_statistics',
    ENVIRONMENT_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'environment_edit_distribution_information_and_investment_documents',
    ENVIRONMENT_MANAGE_APPROVALS: 'environment_manage_approvals',
    ENVIRONMENT_MANAGE_CREDIT_DIGITAL_SECURITIES: 'environment_manage_credit_digital_securities',
    ENVIRONMENT_MANAGE_DISTRIBUTION: 'environment_manage_distribution',
    ENVIRONMENT_MANAGE_IDENTIFICATION_DATA: 'environment_manage_identification_data',
    ENVIRONMENT_MANAGE_INCOMING_PAYMENTS: 'environment_manage_incoming_payments',
    ENVIRONMENT_MANAGE_INVESTMENTS: 'environment_manage_investments',
    ENVIRONMENT_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'environment_manage_investor_and_investment_data',
    ENVIRONMENT_MANAGE_INVESTOR_DOCUMENTS: 'environment_manage_investor_documents',
    ENVIRONMENT_MANAGE_ISSUER_CASHLINK_STUDIO: 'environment_manage_issuer_cashlink_studio',
    ENVIRONMENT_MANAGE_LISTINGS: 'environment_manage_listings',
    ENVIRONMENT_MANAGE_MARKET_PRICES: 'environment_manage_market_prices',
    ENVIRONMENT_MANAGE_PAYOUT_EVENTS: 'environment_manage_payout_events',
    ENVIRONMENT_MANAGE_PRODUCT_DATA: 'environment_manage_product_data',
    ENVIRONMENT_MANAGE_REDEMPTIONS: 'environment_manage_redemptions',
    ENVIRONMENT_MANAGE_VOUCHERS: 'environment_manage_vouchers',
    ENVIRONMENT_TRIGGER_SOLUTION: 'environment_trigger_solution',
    ENVIRONMENT_USE_ISSUER_API: 'environment_use_issuer_api',
    ENVIRONMENT_VIEW_DATA: 'environment_view_data',
    ENVIRONMENT_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'environment_view_distribution_information_and_investment_documents',
    ENVIRONMENT_VIEW_FRIEND_REFERRALS: 'environment_view_friend_referrals',
    ENVIRONMENT_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'environment_view_investor_and_investment_data',
    ENVIRONMENT_VIEW_ISSUER_CASHLINK_STUDIO: 'environment_view_issuer_cashlink_studio',
    MANAGE_APPROVALS: 'manage_approvals',
    MANAGE_CREDIT_DIGITAL_SECURITIES: 'manage_credit_digital_securities',
    MANAGE_DISTRIBUTION: 'manage_distribution',
    MANAGE_ENVIRONMENT_PERMISSIONS: 'manage_environment_permissions',
    MANAGE_ENVIRONMENT_USERS_AND_GROUPS: 'manage_environment_users_and_groups',
    MANAGE_FLAG_FOR_CRYPTO_SECURITY_CREATION_AND_VALIDATE_CRYPTO_SECURITIES: 'manage_flag_for_crypto_security_creation_and_validate_crypto_securities',
    MANAGE_IDENTIFICATION_DATA: 'manage_identification_data',
    MANAGE_INCOMING_PAYMENTS: 'manage_incoming_payments',
    MANAGE_INVESTMENTS: 'manage_investments',
    MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'manage_investor_and_investment_data',
    MANAGE_INVESTOR_DOCUMENTS: 'manage_investor_documents',
    MANAGE_ISSUANCE_DOCUMENTS: 'manage_issuance_documents',
    MANAGE_ISSUER_CASHLINK_STUDIO: 'manage_issuer_cashlink_studio',
    MANAGE_LISTINGS: 'manage_listings',
    MANAGE_MARKET_PRICES: 'manage_market_prices',
    MANAGE_ORGANIZATION_PERMISSIONS: 'manage_organization_permissions',
    MANAGE_ORGANIZATION_USERS_AND_GROUPS: 'manage_organization_users_and_groups',
    MANAGE_ORGANIZATIONS: 'manage_organizations',
    MANAGE_PAYOUT_EVENTS: 'manage_payout_events',
    MANAGE_PRODUCT_DATA: 'manage_product_data',
    MANAGE_REDEMPTIONS: 'manage_redemptions',
    MANAGE_VOUCHERS: 'manage_vouchers',
    ORGANIZATION_CREATE_INVESTOR_AND_INVESTMENT: 'organization_create_investor_and_investment',
    ORGANIZATION_CREATE_PRODUCT_CASHLINK_STUDIO: 'organization_create_product_cashlink_studio',
    ORGANIZATION_DOWNLOAD_PLATFORM_STATISTICS: 'organization_download_platform_statistics',
    ORGANIZATION_DOWNLOAD_STATISTICS: 'organization_download_statistics',
    ORGANIZATION_EDIT_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_edit_distribution_information_and_investment_documents',
    ORGANIZATION_MANAGE_APPROVALS: 'organization_manage_approvals',
    ORGANIZATION_MANAGE_CREDIT_DIGITAL_SECURITIES: 'organization_manage_credit_digital_securities',
    ORGANIZATION_MANAGE_DISTRIBUTION: 'organization_manage_distribution',
    ORGANIZATION_MANAGE_IDENTIFICATION_DATA: 'organization_manage_identification_data',
    ORGANIZATION_MANAGE_INCOMING_PAYMENTS: 'organization_manage_incoming_payments',
    ORGANIZATION_MANAGE_INVESTMENTS: 'organization_manage_investments',
    ORGANIZATION_MANAGE_INVESTOR_AND_INVESTMENT_DATA: 'organization_manage_investor_and_investment_data',
    ORGANIZATION_MANAGE_INVESTOR_DOCUMENTS: 'organization_manage_investor_documents',
    ORGANIZATION_MANAGE_ISSUER_CASHLINK_STUDIO: 'organization_manage_issuer_cashlink_studio',
    ORGANIZATION_MANAGE_LISTINGS: 'organization_manage_listings',
    ORGANIZATION_MANAGE_MARKET_PRICES: 'organization_manage_market_prices',
    ORGANIZATION_MANAGE_PAYOUT_EVENTS: 'organization_manage_payout_events',
    ORGANIZATION_MANAGE_PRODUCT_DATA: 'organization_manage_product_data',
    ORGANIZATION_MANAGE_REDEMPTIONS: 'organization_manage_redemptions',
    ORGANIZATION_MANAGE_VOUCHERS: 'organization_manage_vouchers',
    ORGANIZATION_TRIGGER_SOLUTION: 'organization_trigger_solution',
    ORGANIZATION_USE_ISSUER_API: 'organization_use_issuer_api',
    ORGANIZATION_VIEW_DATA: 'organization_view_data',
    ORGANIZATION_VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'organization_view_distribution_information_and_investment_documents',
    ORGANIZATION_VIEW_FRIEND_REFERRALS: 'organization_view_friend_referrals',
    ORGANIZATION_VIEW_INVESTOR_AND_INVESTMENT_DATA: 'organization_view_investor_and_investment_data',
    ORGANIZATION_VIEW_ISSUER_CASHLINK_STUDIO: 'organization_view_issuer_cashlink_studio',
    TRIGGER_SOLUTION: 'trigger_solution',
    USE_ISSUER_API: 'use_issuer_api',
    VIEW_DATA: 'view_data',
    VIEW_DISTRIBUTION_INFORMATION_AND_INVESTMENT_DOCUMENTS: 'view_distribution_information_and_investment_documents',
    VIEW_FRIEND_REFERRALS: 'view_friend_referrals',
    VIEW_INVESTOR_AND_INVESTMENT_DATA: 'view_investor_and_investment_data',
    VIEW_ISSUER_CASHLINK_STUDIO: 'view_issuer_cashlink_studio',
    VIEW_ORGANIZATION_DATA: 'view_organization_data'
} as const;
export type AdminUserPermissionsValuesRetrievePermissionCodeEnum = typeof AdminUserPermissionsValuesRetrievePermissionCodeEnum[keyof typeof AdminUserPermissionsValuesRetrievePermissionCodeEnum];
/**
 * @export
 */
export const AdminUserPermissionsValuesRetrievePermissionTypeEnum = {
    DISTRIBUTION_PLATFORM: 'DISTRIBUTION_PLATFORM',
    ENVIRONMENT: 'ENVIRONMENT',
    ISSUER: 'ISSUER',
    ORGANIZATION: 'ORGANIZATION',
    PRODUCT: 'PRODUCT'
} as const;
export type AdminUserPermissionsValuesRetrievePermissionTypeEnum = typeof AdminUserPermissionsValuesRetrievePermissionTypeEnum[keyof typeof AdminUserPermissionsValuesRetrievePermissionTypeEnum];
/**
 * @export
 */
export const AdminUsersDropdownListFieldEnum = {
    EMAIL: 'email',
    ORGANIZATION_NAME: 'organization_name'
} as const;
export type AdminUsersDropdownListFieldEnum = typeof AdminUsersDropdownListFieldEnum[keyof typeof AdminUsersDropdownListFieldEnum];
/**
 * @export
 */
export const AdminUsersDropdownListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DATE_JOINED_DESC: '-date_joined',
    DATE_JOINED_ASC: 'date_joined',
    EMAIL_DESC: '-email',
    EMAIL_ASC: 'email',
    ID_DESC: '-id',
    ID_ASC: 'id',
    LAST_LOGIN_DESC: '-last_login',
    LAST_LOGIN_ASC: 'last_login',
    ORGANIZATION_NAME_DESC: '-organization_name',
    ORGANIZATION_NAME_ASC: 'organization_name',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status'
} as const;
export type AdminUsersDropdownListOrderingEnum = typeof AdminUsersDropdownListOrderingEnum[keyof typeof AdminUsersDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminUsersDropdownListStatusEnum = {
    ACTIVE: 'ACTIVE',
    DEACTIVATED: 'DEACTIVATED',
    INVITATION_PENDING: 'INVITATION_PENDING'
} as const;
export type AdminUsersDropdownListStatusEnum = typeof AdminUsersDropdownListStatusEnum[keyof typeof AdminUsersDropdownListStatusEnum];
/**
 * @export
 */
export const AdminUsersListOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DATE_JOINED_DESC: '-date_joined',
    DATE_JOINED_ASC: 'date_joined',
    EMAIL_DESC: '-email',
    EMAIL_ASC: 'email',
    ID_DESC: '-id',
    ID_ASC: 'id',
    LAST_LOGIN_DESC: '-last_login',
    LAST_LOGIN_ASC: 'last_login',
    ORGANIZATION_NAME_DESC: '-organization_name',
    ORGANIZATION_NAME_ASC: 'organization_name',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status'
} as const;
export type AdminUsersListOrderingEnum = typeof AdminUsersListOrderingEnum[keyof typeof AdminUsersListOrderingEnum];
/**
 * @export
 */
export const AdminUsersListStatusEnum = {
    ACTIVE: 'ACTIVE',
    DEACTIVATED: 'DEACTIVATED',
    INVITATION_PENDING: 'INVITATION_PENDING'
} as const;
export type AdminUsersListStatusEnum = typeof AdminUsersListStatusEnum[keyof typeof AdminUsersListStatusEnum];
/**
 * @export
 */
export const AdminUsersValuesRetrieveFieldEnum = {
    EMAIL: 'email',
    ORGANIZATION_NAME: 'organization_name'
} as const;
export type AdminUsersValuesRetrieveFieldEnum = typeof AdminUsersValuesRetrieveFieldEnum[keyof typeof AdminUsersValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminUsersValuesRetrieveOrderingEnum = {
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    DATE_JOINED_DESC: '-date_joined',
    DATE_JOINED_ASC: 'date_joined',
    EMAIL_DESC: '-email',
    EMAIL_ASC: 'email',
    ID_DESC: '-id',
    ID_ASC: 'id',
    LAST_LOGIN_DESC: '-last_login',
    LAST_LOGIN_ASC: 'last_login',
    ORGANIZATION_NAME_DESC: '-organization_name',
    ORGANIZATION_NAME_ASC: 'organization_name',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status'
} as const;
export type AdminUsersValuesRetrieveOrderingEnum = typeof AdminUsersValuesRetrieveOrderingEnum[keyof typeof AdminUsersValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const AdminUsersValuesRetrieveStatusEnum = {
    ACTIVE: 'ACTIVE',
    DEACTIVATED: 'DEACTIVATED',
    INVITATION_PENDING: 'INVITATION_PENDING'
} as const;
export type AdminUsersValuesRetrieveStatusEnum = typeof AdminUsersValuesRetrieveStatusEnum[keyof typeof AdminUsersValuesRetrieveStatusEnum];
/**
 * @export
 */
export const AdminVouchersDropdownListFieldEnum = {
    CODE: 'code',
    NAME: 'name'
} as const;
export type AdminVouchersDropdownListFieldEnum = typeof AdminVouchersDropdownListFieldEnum[keyof typeof AdminVouchersDropdownListFieldEnum];
/**
 * @export
 */
export const AdminVouchersDropdownListOrderingEnum = {
    ACTIVE_DESC: '-active',
    ACTIVE_ASC: 'active',
    ALREADY_USED_DESC: '-already_used',
    ALREADY_USED_ASC: 'already_used',
    CODE_DESC: '-code',
    CODE_ASC: 'code',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NAME_DESC: '-name',
    NAME_ASC: 'name'
} as const;
export type AdminVouchersDropdownListOrderingEnum = typeof AdminVouchersDropdownListOrderingEnum[keyof typeof AdminVouchersDropdownListOrderingEnum];
/**
 * @export
 */
export const AdminVouchersListOrderingEnum = {
    ACTIVE_DESC: '-active',
    ACTIVE_ASC: 'active',
    ALREADY_USED_DESC: '-already_used',
    ALREADY_USED_ASC: 'already_used',
    CODE_DESC: '-code',
    CODE_ASC: 'code',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NAME_DESC: '-name',
    NAME_ASC: 'name'
} as const;
export type AdminVouchersListOrderingEnum = typeof AdminVouchersListOrderingEnum[keyof typeof AdminVouchersListOrderingEnum];
/**
 * @export
 */
export const AdminVouchersValuesRetrieveFieldEnum = {
    CODE: 'code',
    NAME: 'name'
} as const;
export type AdminVouchersValuesRetrieveFieldEnum = typeof AdminVouchersValuesRetrieveFieldEnum[keyof typeof AdminVouchersValuesRetrieveFieldEnum];
/**
 * @export
 */
export const AdminVouchersValuesRetrieveOrderingEnum = {
    ACTIVE_DESC: '-active',
    ACTIVE_ASC: 'active',
    ALREADY_USED_DESC: '-already_used',
    ALREADY_USED_ASC: 'already_used',
    CODE_DESC: '-code',
    CODE_ASC: 'code',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    ID_DESC: '-id',
    ID_ASC: 'id',
    NAME_DESC: '-name',
    NAME_ASC: 'name'
} as const;
export type AdminVouchersValuesRetrieveOrderingEnum = typeof AdminVouchersValuesRetrieveOrderingEnum[keyof typeof AdminVouchersValuesRetrieveOrderingEnum];
